var _slicedToArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _inherits = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _defineProperty = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/regenerator/index.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128, _templateObject129, _templateObject130, _templateObject131, _templateObject132, _templateObject133, _templateObject134, _templateObject135, _templateObject136, _templateObject137, _templateObject138, _templateObject139, _templateObject140, _templateObject141, _templateObject142, _templateObject143, _templateObject144, _templateObject145, _templateObject146, _templateObject147, _templateObject148, _templateObject149, _templateObject150, _templateObject151, _templateObject152, _templateObject153, _templateObject154, _templateObject155, _templateObject156, _templateObject157, _templateObject158, _templateObject159, _templateObject160, _templateObject161, _templateObject162, _templateObject163, _templateObject164, _templateObject165;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.string.trim-end.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e75) { throw _e75; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e76) { didErr = true; err = _e76; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*! For license information please see redoc.browser.lib.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Redoc = t() : e.Redoc = t();
}(this, function () {
  return function () {
    var e = {
      295: function _(e, t, r) {
        "use strict";

        var n = r(15),
            o = r.n(n),
            i = r(645),
            s = r.n(i)()(o());
        s.push([e.id, ".ps{overflow:hidden!important;overflow-anchor:none;-ms-overflow-style:none;touch-action:auto;-ms-touch-action:auto}.ps__rail-x{display:none;opacity:0;transition:background-color .2s linear,opacity .2s linear;-webkit-transition:background-color .2s linear,opacity .2s linear;height:15px;bottom:0;position:absolute}.ps__rail-y{display:none;opacity:0;transition:background-color .2s linear,opacity .2s linear;-webkit-transition:background-color .2s linear,opacity .2s linear;width:15px;right:0;position:absolute}.ps--active-x>.ps__rail-x,.ps--active-y>.ps__rail-y{display:block;background-color:transparent}.ps:hover>.ps__rail-x,.ps:hover>.ps__rail-y,.ps--focus>.ps__rail-x,.ps--focus>.ps__rail-y,.ps--scrolling-x>.ps__rail-x,.ps--scrolling-y>.ps__rail-y{opacity:.6}.ps .ps__rail-x:hover,.ps .ps__rail-y:hover,.ps .ps__rail-x:focus,.ps .ps__rail-y:focus,.ps .ps__rail-x.ps--clicking,.ps .ps__rail-y.ps--clicking{background-color:#eee;opacity:.9}.ps__thumb-x{background-color:#aaa;border-radius:6px;transition:background-color .2s linear,height .2s ease-in-out;-webkit-transition:background-color .2s linear,height .2s ease-in-out;height:6px;bottom:2px;position:absolute}.ps__thumb-y{background-color:#aaa;border-radius:6px;transition:background-color .2s linear,width .2s ease-in-out;-webkit-transition:background-color .2s linear,width .2s ease-in-out;width:6px;right:2px;position:absolute}.ps__rail-x:hover>.ps__thumb-x,.ps__rail-x:focus>.ps__thumb-x,.ps__rail-x.ps--clicking .ps__thumb-x{background-color:#999;height:11px}.ps__rail-y:hover>.ps__thumb-y,.ps__rail-y:focus>.ps__thumb-y,.ps__rail-y.ps--clicking .ps__thumb-y{background-color:#999;width:11px}@supports (-ms-overflow-style: none){.ps{overflow:auto!important}}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.ps{overflow:auto!important}}\n", "", {
          version: 3,
          sources: ["webpack://./node_modules/perfect-scrollbar/css/perfect-scrollbar.css"],
          names: [],
          mappings: "AAGA,IACE,yBAAA,CACA,oBAAA,CACA,uBAAA,CACA,iBAAA,CACA,qBAAA,CAMF,YACE,YAAA,CACA,SAAA,CACA,yDAAA,CACA,iEAAA,CACA,WAAA,CAEA,QAAA,CAEA,iBAAA,CAGF,YACE,YAAA,CACA,SAAA,CACA,yDAAA,CACA,iEAAA,CACA,UAAA,CAEA,OAAA,CAEA,iBAAA,CAGF,oDAEE,aAAA,CACA,4BAAA,CAGF,oJAME,UAAA,CAGF,kJAME,qBAAA,CACA,UAAA,CAMF,aACE,qBAAA,CAnEF,iBAAA,CAqEE,6DAAA,CACA,qEAAA,CACA,UAAA,CAEA,UAAA,CAEA,iBAAA,CAGF,aACE,qBAAA,CA/EF,iBAAA,CAiFE,4DAAA,CACA,oEAAA,CACA,SAAA,CAEA,SAAA,CAEA,iBAAA,CAGF,oGAGE,qBAAA,CACA,WAAA,CAGF,oGAGE,qBAAA,CACA,UAAA,CAIF,qCACE,IACE,uBAAA,CAAA,CAIJ,wEACE,IACE,uBAAA,CAAA",
          sourcesContent: ["/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  -ms-overflow-style: none;\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  background-color: #999;\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n"],
          sourceRoot: ""
        }]), t.Z = s;
      },
      645: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var r = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(r, "}") : r;
            }).join("");
          }, t.i = function (e, r, n) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var o = {};
            if (n) for (var i = 0; i < this.length; i++) {
              var s = this[i][0];
              null != s && (o[s] = !0);
            }

            for (var a = 0; a < e.length; a++) {
              var l = [].concat(e[a]);
              n && o[l[0]] || (r && (l[2] ? l[2] = "".concat(r, " and ").concat(l[2]) : l[2] = r), t.push(l));
            }
          }, t;
        };
      },
      15: function _(e) {
        "use strict";

        function t(e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var r = 0, n = new Array(t); r < t; r++) {
            n[r] = e[r];
          }

          return n;
        }

        e.exports = function (e) {
          var r,
              n,
              o = (n = 4, function (e) {
            if (Array.isArray(e)) return e;
          }(r = e) || function (e, t) {
            var r = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);

            if (null != r) {
              var n,
                  o,
                  i = [],
                  s = !0,
                  a = !1;

              try {
                for (r = r.call(e); !(s = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); s = !0) {
                  ;
                }
              } catch (e) {
                a = !0, o = e;
              } finally {
                try {
                  s || null == r.return || r.return();
                } finally {
                  if (a) throw o;
                }
              }

              return i;
            }
          }(r, n) || function (e, r) {
            if (e) {
              if ("string" == typeof e) return t(e, r);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, r) : void 0;
            }
          }(r, n) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }()),
              i = o[1],
              s = o[3];

          if ("function" == typeof btoa) {
            var a = btoa(unescape(encodeURIComponent(JSON.stringify(s)))),
                l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a),
                c = "/*# ".concat(l, " */"),
                p = s.sources.map(function (e) {
              return "/*# sourceURL=".concat(s.sourceRoot || "").concat(e, " */");
            });
            return [i].concat(p).concat([c]).join("\n");
          }

          return [i].join("\n");
        };
      },
      45: function _(e) {
        e.exports = {};
      },
      657: function _(e, t, r) {
        "use strict";

        r.d(t, {
          ZP: function ZP() {
            return i;
          }
        });

        var n = require("lunr"),
            o = function o(e, t, r) {
          return new Promise(function (n, o) {
            var i = function i(e) {
              try {
                a(r.next(e));
              } catch (e) {
                o(e);
              }
            },
                s = function s(e) {
              try {
                a(r.throw(e));
              } catch (e) {
                o(e);
              }
            },
                a = function a(e) {
              return e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
            };

            a((r = r.apply(e, t)).next());
          });
        };

        var i = /*#__PURE__*/_createClass(function i() {
          _classCallCheck(this, i);

          this.add = u, this.done = d, this.search = y, this.toJS = h, this.load = f, this.dispose = g, this.fromExternalJS = m;
        });

        var s,
            a,
            l,
            c = [];

        function p() {
          s = new n.Builder(), s.field("title"), s.field("description"), s.ref("ref"), s.pipeline.add(n.trimmer, n.stopWordFilter, n.stemmer), l = new Promise(function (e) {
            a = e;
          });
        }

        function u(e, t, r) {
          var n = c.push(r) - 1,
              o = {
            title: e.toLowerCase(),
            description: t.toLowerCase(),
            ref: n
          };
          s.add(o);
        }

        function d() {
          return o(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    a(s.build());

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        }

        function h() {
          return o(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.t0 = c;
                    _context2.next = 3;
                    return l;

                  case 3:
                    _context2.t1 = _context2.sent.toJSON();
                    return _context2.abrupt("return", {
                      store: _context2.t0,
                      index: _context2.t1
                    });

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
        }

        function m(e, t) {
          return o(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;

                    if (!(importScripts(e), !self[t])) {
                      _context3.next = 3;
                      break;
                    }

                    throw new Error("Broken index file format");

                  case 3:
                    f(self[t]);
                    _context3.next = 9;
                    break;

                  case 6:
                    _context3.prev = 6;
                    _context3.t0 = _context3["catch"](0);
                    console.error("Failed to load search index: " + _context3.t0.message);

                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[0, 6]]);
          }));
        }

        function f(e) {
          return o(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    c = e.store, a(n.Index.load(e.index));

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
        }

        function g() {
          return o(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    c = [], p();

                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));
        }

        function y(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return o(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            var r;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    if (!(0 === e.trim().length)) {
                      _context6.next = 2;
                      break;
                    }

                    return _context6.abrupt("return", []);

                  case 2:
                    _context6.next = 4;
                    return l;

                  case 4:
                    r = _context6.sent.query(function (t) {
                      e.trim().toLowerCase().split(/\s+/).forEach(function (e) {
                        if (1 === e.length) return;

                        var r = function (e) {
                          var t = n.trimmer(new n.Token(e, {}));
                          return "*" + n.stemmer(t) + "*";
                        }(e);

                        t.term(r, {});
                      });
                    });
                    return _context6.abrupt("return", (t > 0 && (r = r.slice(0, t)), r.map(function (e) {
                      return {
                        meta: c[e.ref],
                        score: e.score
                      };
                    })));

                  case 6:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));
        }

        n.tokenizer.separator = /\s+/, p();
      },
      342: function _(e, t, r) {
        "use strict";

        var n = r(376),
            o = {}.NODE_DISABLE_COLORS ? {
          red: "",
          yellow: "",
          green: "",
          normal: ""
        } : {
          red: "[31m",
          yellow: "[33;1m",
          green: "[32m",
          normal: "[0m"
        };

        function i(e, t) {
          function r(e, t) {
            return n.stringify(e) === n.stringify(Object.assign({}, e, t));
          }

          return r(e, t) && r(t, e);
        }

        function s(e) {
          var t = (e = e.replace("[]", "Array")).split("/");
          return t[0] = t[0].replace(/[^A-Za-z0-9_\-\.]+|\s+/gm, "_"), t.join("/");
        }

        String.prototype.toCamelCase = function () {
          return this.toLowerCase().replace(/[-_ \/\.](.)/g, function (e, t) {
            return t.toUpperCase();
          });
        }, e.exports = {
          colour: o,
          uniqueOnly: function uniqueOnly(e, t, r) {
            return r.indexOf(e) === t;
          },
          hasDuplicates: function hasDuplicates(e) {
            return new Set(e).size !== e.length;
          },
          allSame: function allSame(e) {
            return new Set(e).size <= 1;
          },
          distinctArray: function distinctArray(e) {
            return e.length === function (e) {
              var t = [];

              var _iterator = _createForOfIteratorHelper(e),
                  _step;

              try {
                var _loop = function _loop() {
                  var r = _step.value;
                  t.find(function (e, t, n) {
                    return i(e, r);
                  }) || t.push(r);
                };

                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return t;
            }(e).length;
          },
          firstDupe: function firstDupe(e) {
            return e.find(function (t, r, n) {
              return e.indexOf(t) < r;
            });
          },
          hash: function hash(e) {
            var t,
                r = 0;
            if (0 === e.length) return r;

            for (var _n2 = 0; _n2 < e.length; _n2++) {
              t = e.charCodeAt(_n2), r = (r << 5) - r + t, r |= 0;
            }

            return r;
          },
          parameterTypeProperties: ["format", "minimum", "maximum", "exclusiveMinimum", "exclusiveMaximum", "minLength", "maxLength", "multipleOf", "minItems", "maxItems", "uniqueItems", "minProperties", "maxProperties", "additionalProperties", "pattern", "enum", "default"],
          arrayProperties: ["items", "minItems", "maxItems", "uniqueItems"],
          httpMethods: ["get", "post", "put", "delete", "patch", "head", "options", "trace"],
          sanitise: s,
          sanitiseAll: function sanitiseAll(e) {
            return s(e.split("/").join("_"));
          }
        };
      },
      856: function _(e, t, r) {
        "use strict";

        var n = r(45),
            o = r(470),
            i = r(416),
            s = r(416),
            a = r(66),
            l = r(53).jptr,
            c = r(401).recurse,
            p = r(683).clone,
            u = r(593).dereference,
            d = r(592).isRef,
            h = r(342);

        function m(e, t, r, n, o, s) {
          var a = s.externalRefs[r + n].paths[0],
              u = i.parse(o),
              m = {},
              f = 1;

          for (; f;) {
            f = 0, c(e, {
              identityDetection: !0
            }, function (e, r, n) {
              if (d(e, r)) if (e[r].startsWith("#")) {
                if (m[e[r]] || e.$fixed) {
                  if (!e.$fixed) {
                    var _t2 = (a + "/" + m[e[r]]).split("/#/").join("/");

                    n.parent[n.pkey] = {
                      $ref: _t2,
                      "x-miro": e[r],
                      $fixed: !0
                    }, s.verbose > 1 && console.warn("Replacing with", _t2), f++;
                  }
                } else {
                  var _o2 = p(l(t, e[r]));

                  if (s.verbose > 1 && console.warn((!1 === _o2 ? h.colour.red : h.colour.green) + "Fragment resolution", e[r], h.colour.normal), !1 === _o2) {
                    if (n.parent[n.pkey] = {}, s.fatal) {
                      var _t3 = new Error("Fragment $ref resolution failed " + e[r]);

                      if (!s.promise) throw _t3;
                      s.promise.reject(_t3);
                    }
                  } else f++, n.parent[n.pkey] = _o2, m[e[r]] = n.path.replace("/%24ref", "");
                }
              } else if (u.protocol) {
                var _t4 = i.resolve(o, e[r]).toString();

                s.verbose > 1 && console.warn(h.colour.yellow + "Rewriting external url ref", e[r], "as", _t4, h.colour.normal), e["x-miro"] = e[r], s.externalRefs[e[r]] && (s.externalRefs[_t4] || (s.externalRefs[_t4] = s.externalRefs[e[r]]), s.externalRefs[_t4].failed = s.externalRefs[e[r]].failed), e[r] = _t4;
              } else if (!e["x-miro"]) {
                var _t5 = i.resolve(o, e[r]).toString(),
                    _n3 = !1;

                s.externalRefs[e[r]] && (_n3 = s.externalRefs[e[r]].failed), _n3 || (s.verbose > 1 && console.warn(h.colour.yellow + "Rewriting external ref", e[r], "as", _t5, h.colour.normal), e["x-miro"] = e[r], e[r] = _t5);
              }
            });
          }

          return c(e, {}, function (e, t, r) {
            d(e, t) && void 0 !== e.$fixed && delete e.$fixed;
          }), s.verbose > 1 && console.warn("Finished fragment resolution"), e;
        }

        function f(e, t) {
          if (!t.filters || !t.filters.length) return e;

          var _iterator2 = _createForOfIteratorHelper(t.filters),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _r2 = _step2.value;
              e = _r2(e, t);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return e;
        }

        function g(e, t, r, s) {
          var c = i.parse(r.source),
              u = r.source.split("\\").join("/").split("/");
          u.pop() || u.pop();
          var d = "",
              h = t.split("#");
          h.length > 1 && (d = "#" + h[1], t = h[0]), u = u.join("/");
          var g = (y = i.parse(t).protocol, b = c.protocol, y && y.length > 2 ? y : b && b.length > 2 ? b : "file:");
          var y, b;
          var x;

          if (x = "file:" === g ? o.resolve(u ? u + "/" : "", t) : i.resolve(u ? u + "/" : "", t), r.cache[x]) {
            r.verbose && console.warn("CACHED", x, d);

            var _e2 = p(r.cache[x]),
                _n4 = r.externalRef = _e2;

            if (d && (_n4 = l(_n4, d), !1 === _n4 && (_n4 = {}, r.fatal))) {
              var _e3 = new Error("Cached $ref resolution failed " + x + d);

              if (!r.promise) throw _e3;
              r.promise.reject(_e3);
            }

            return _n4 = m(_n4, _e2, t, d, x, r), _n4 = f(_n4, r), s(p(_n4), x, r), Promise.resolve(_n4);
          }

          if (r.verbose && console.warn("GET", x, d), r.handlers && r.handlers[g]) return r.handlers[g](u, t, d, r).then(function (e) {
            return r.externalRef = e, e = f(e, r), r.cache[x] = e, s(e, x, r), e;
          }).catch(function (e) {
            throw r.verbose && console.warn(e), e;
          });

          if (g && g.startsWith("http")) {
            var _e4 = Object.assign({}, r.fetchOptions, {
              agent: r.agent
            });

            return r.fetch(x, _e4).then(function (e) {
              if (200 !== e.status) {
                if (r.ignoreIOErrors) return r.verbose && console.warn("FAILED", t), r.externalRefs[t].failed = !0, '{"$ref":"' + t + '"}';
                throw new Error("Received status code ".concat(e.status, ": ").concat(x));
              }

              return e.text();
            }).then(function (e) {
              try {
                var _n5 = a.parse(e, {
                  schema: "core",
                  prettyErrors: !0
                });

                if (e = r.externalRef = _n5, r.cache[x] = p(e), d && !1 === (e = l(e, d)) && (e = {}, r.fatal)) {
                  var _e5 = new Error("Remote $ref resolution failed " + x + d);

                  if (!r.promise) throw _e5;
                  r.promise.reject(_e5);
                }

                e = f(e = m(e, _n5, t, d, x, r), r);
              } catch (e) {
                if (r.verbose && console.warn(e), !r.promise || !r.fatal) throw e;
                r.promise.reject(e);
              }

              return s(e, x, r), e;
            }).catch(function (e) {
              if (r.verbose && console.warn(e), r.cache[x] = {}, !r.promise || !r.fatal) throw e;
              r.promise.reject(e);
            });
          }

          {
            var _e6 = '{"$ref":"' + t + '"}';

            return function (e, t, r, o, i) {
              return new Promise(function (s, a) {
                n.readFile(e, t, function (e, t) {
                  e ? r.ignoreIOErrors && i ? (r.verbose && console.warn("FAILED", o), r.externalRefs[o].failed = !0, s(i)) : a(e) : s(t);
                });
              });
            }(x, r.encoding || "utf8", r, t, _e6).then(function (e) {
              try {
                var _n6 = a.parse(e, {
                  schema: "core",
                  prettyErrors: !0
                });

                if (e = r.externalRef = _n6, r.cache[x] = p(e), d && !1 === (e = l(e, d)) && (e = {}, r.fatal)) {
                  var _e7 = new Error("File $ref resolution failed " + x + d);

                  if (!r.promise) throw _e7;
                  r.promise.reject(_e7);
                }

                e = f(e = m(e, _n6, t, d, x, r), r);
              } catch (e) {
                if (r.verbose && console.warn(e), !r.promise || !r.fatal) throw e;
                r.promise.reject(e);
              }

              return s(e, x, r), e;
            }).catch(function (e) {
              if (r.verbose && console.warn(e), !r.promise || !r.fatal) throw e;
              r.promise.reject(e);
            });
          }
        }

        function y(e) {
          return new Promise(function (t, r) {
            (function (e) {
              return new Promise(function (t, r) {
                function n(t, r, n) {
                  if (t[r] && d(t[r], "$ref")) {
                    var _i2 = t[r].$ref;

                    if (!_i2.startsWith("#")) {
                      var _s2 = "";

                      if (!o[_i2]) {
                        var _t6 = Object.keys(o).find(function (e, t, r) {
                          return _i2.startsWith(e + "/");
                        });

                        _t6 && (e.verbose && console.warn("Found potential subschema at", _t6), _s2 = "/" + (_i2.split("#")[1] || "").replace(_t6.split("#")[1] || ""), _s2 = _s2.split("/undefined").join(""), _i2 = _t6);
                      }

                      if (o[_i2] || (o[_i2] = {
                        resolved: !1,
                        paths: [],
                        extras: {},
                        description: t[r].description
                      }), o[_i2].resolved) {
                        if (o[_i2].failed) ;else if (e.rewriteRefs) {
                          var _n7 = o[_i2].resolvedAt;
                          e.verbose > 1 && console.warn("Rewriting ref", _i2, _n7), t[r]["x-miro"] = _i2, t[r].$ref = _n7 + _s2;
                        } else t[r] = p(o[_i2].data);
                      } else o[_i2].paths.push(n.path), o[_i2].extras[n.path] = _s2;
                    }
                  }
                }

                var o = e.externalRefs;
                if (e.resolver.depth > 0 && e.source === e.resolver.base) return t(o);
                c(e.openapi.definitions, {
                  identityDetection: !0,
                  path: "#/definitions"
                }, n), c(e.openapi.components, {
                  identityDetection: !0,
                  path: "#/components"
                }, n), c(e.openapi, {
                  identityDetection: !0
                }, n), t(o);
              });
            })(e).then(function (t) {
              var _loop2 = function _loop2(_r3) {
                if (!t[_r3].resolved) {
                  var _n8 = e.resolver.depth;
                  _n8 > 0 && _n8++, e.resolver.actions[_n8].push(function () {
                    return g(e.openapi, _r3, e, function (e, n, o) {
                      if (!t[_r3].resolved) {
                        var _i3 = {};
                        _i3.context = t[_r3], _i3.$ref = _r3, _i3.original = p(e), _i3.updated = e, _i3.source = n, o.externals.push(_i3), t[_r3].resolved = !0;
                      }

                      var i = Object.assign({}, o, {
                        source: "",
                        resolver: {
                          actions: o.resolver.actions,
                          depth: o.resolver.actions.length - 1,
                          base: o.resolver.base
                        }
                      });
                      o.patch && t[_r3].description && !e.description && "object" == typeof e && (e.description = t[_r3].description), t[_r3].data = e;
                      var s = (a = t[_r3].paths, _toConsumableArray(new Set(a)));
                      var a;
                      s = s.sort(function (e, t) {
                        var r = e.startsWith("#/components/") || e.startsWith("#/definitions/"),
                            n = t.startsWith("#/components/") || t.startsWith("#/definitions/");
                        return r && !n ? -1 : n && !r ? 1 : 0;
                      });

                      var _iterator3 = _createForOfIteratorHelper(s),
                          _step3;

                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var _n9 = _step3.value;
                          if (t[_r3].resolvedAt && _n9 !== t[_r3].resolvedAt && _n9.indexOf("x-ms-examples/") < 0) o.verbose > 1 && console.warn("Creating pointer to data at", _n9), l(o.openapi, _n9, {
                            $ref: t[_r3].resolvedAt + t[_r3].extras[_n9],
                            "x-miro": _r3 + t[_r3].extras[_n9]
                          });else {
                            t[_r3].resolvedAt ? o.verbose > 1 && console.warn("Avoiding circular reference") : (t[_r3].resolvedAt = _n9, o.verbose > 1 && console.warn("Creating initial clone of data at", _n9));

                            var _i4 = p(e);

                            l(o.openapi, _n9, _i4);
                          }
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }

                      0 === o.resolver.actions[i.resolver.depth].length && o.resolver.actions[i.resolver.depth].push(function () {
                        return y(i);
                      });
                    });
                  });
                }
              };

              for (var _r3 in t) {
                _loop2(_r3);
              }
            }).catch(function (t) {
              e.verbose && console.warn(t), r(t);
            });
            var n = {
              options: e
            };
            n.actions = e.resolver.actions[e.resolver.depth], t(n);
          });
        }

        function b(e, t, r) {
          e.resolver.actions.push([]), y(e).then(function (n) {
            var o;
            (o = n.actions, o.reduce(function (e, t) {
              return e.then(function (e) {
                return t().then(Array.prototype.concat.bind(e));
              });
            }, Promise.resolve([]))).then(function () {
              if (e.resolver.depth >= e.resolver.actions.length) return console.warn("Ran off the end of resolver actions"), t(!0);
              e.resolver.depth++, e.resolver.actions[e.resolver.depth].length ? setTimeout(function () {
                b(n.options, t, r);
              }, 0) : (e.verbose > 1 && console.warn(h.colour.yellow + "Finished external resolution!", h.colour.normal), e.resolveInternal && (e.verbose > 1 && console.warn(h.colour.yellow + "Starting internal resolution!", h.colour.normal), e.openapi = u(e.openapi, e.original, {
                verbose: e.verbose - 1
              }), e.verbose > 1 && console.warn(h.colour.yellow + "Finished internal resolution!", h.colour.normal)), c(e.openapi, {}, function (t, r, n) {
                d(t, r) && (e.preserveMiro || delete t["x-miro"]);
              }), t(e));
            }).catch(function (t) {
              e.verbose && console.warn(t), r(t);
            });
          }).catch(function (t) {
            e.verbose && console.warn(t), r(t);
          });
        }

        function x(e) {
          if (e.cache || (e.cache = {}), e.fetch || (e.fetch = s), e.source) {
            var _t7 = i.parse(e.source);

            (!_t7.protocol || _t7.protocol.length <= 2) && (e.source = o.resolve(e.source));
          }

          e.externals = [], e.externalRefs = {}, e.rewriteRefs = !0, e.resolver = {}, e.resolver.depth = 0, e.resolver.base = e.source, e.resolver.actions = [[]];
        }

        e.exports = {
          optionalResolve: function optionalResolve(e) {
            return x(e), new Promise(function (t, r) {
              e.resolve ? b(e, t, r) : t(e);
            });
          },
          resolve: function resolve(e, t, r) {
            return r || (r = {}), r.openapi = e, r.source = t, r.resolve = !0, x(r), new Promise(function (e, t) {
              b(r, e, t);
            });
          }
        };
      },
      804: function _(e) {
        "use strict";

        function t() {
          return {
            depth: 0,
            seen: new WeakMap(),
            top: !0,
            combine: !1,
            allowRefSiblings: !1
          };
        }

        e.exports = {
          getDefaultState: t,
          walkSchema: function e(r, n, o, i) {
            if (void 0 === o.depth && (o = t()), null == r) return r;

            if (void 0 !== r.$ref) {
              var _e8 = {
                $ref: r.$ref
              };
              return o.allowRefSiblings && r.description && (_e8.description = r.description), i(_e8, n, o), _e8;
            }

            if (o.combine && (r.allOf && Array.isArray(r.allOf) && 1 === r.allOf.length && delete (r = Object.assign({}, r.allOf[0], r)).allOf, r.anyOf && Array.isArray(r.anyOf) && 1 === r.anyOf.length && delete (r = Object.assign({}, r.anyOf[0], r)).anyOf, r.oneOf && Array.isArray(r.oneOf) && 1 === r.oneOf.length && delete (r = Object.assign({}, r.oneOf[0], r)).oneOf), i(r, n, o), o.seen.has(r)) return r;
            if ("object" == typeof r && null !== r && o.seen.set(r, !0), o.top = !1, o.depth++, void 0 !== r.items && (o.property = "items", e(r.items, r, o, i)), r.additionalItems && "object" == typeof r.additionalItems && (o.property = "additionalItems", e(r.additionalItems, r, o, i)), r.additionalProperties && "object" == typeof r.additionalProperties && (o.property = "additionalProperties", e(r.additionalProperties, r, o, i)), r.properties) for (var _t8 in r.properties) {
              var _n10 = r.properties[_t8];
              o.property = "properties/" + _t8, e(_n10, r, o, i);
            }
            if (r.patternProperties) for (var _t9 in r.patternProperties) {
              var _n11 = r.patternProperties[_t9];
              o.property = "patternProperties/" + _t9, e(_n11, r, o, i);
            }
            if (r.allOf) for (var _t10 in r.allOf) {
              var _n12 = r.allOf[_t10];
              o.property = "allOf/" + _t10, e(_n12, r, o, i);
            }
            if (r.anyOf) for (var _t11 in r.anyOf) {
              var _n13 = r.anyOf[_t11];
              o.property = "anyOf/" + _t11, e(_n13, r, o, i);
            }
            if (r.oneOf) for (var _t12 in r.oneOf) {
              var _n14 = r.oneOf[_t12];
              o.property = "oneOf/" + _t12, e(_n14, r, o, i);
            }
            return r.not && (o.property = "not", e(r.not, r, o, i)), o.depth--, r;
          }
        };
      },
      470: function _(e) {
        "use strict";

        function t(e) {
          if ("string" != typeof e) throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
        }

        function r(e, t) {
          for (var r, n = "", o = 0, i = -1, s = 0, a = 0; a <= e.length; ++a) {
            if (a < e.length) r = e.charCodeAt(a);else {
              if (47 === r) break;
              r = 47;
            }

            if (47 === r) {
              if (i === a - 1 || 1 === s) ;else if (i !== a - 1 && 2 === s) {
                if (n.length < 2 || 2 !== o || 46 !== n.charCodeAt(n.length - 1) || 46 !== n.charCodeAt(n.length - 2)) if (n.length > 2) {
                  var l = n.lastIndexOf("/");

                  if (l !== n.length - 1) {
                    -1 === l ? (n = "", o = 0) : o = (n = n.slice(0, l)).length - 1 - n.lastIndexOf("/"), i = a, s = 0;
                    continue;
                  }
                } else if (2 === n.length || 1 === n.length) {
                  n = "", o = 0, i = a, s = 0;
                  continue;
                }
                t && (n.length > 0 ? n += "/.." : n = "..", o = 2);
              } else n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), o = a - i - 1;
              i = a, s = 0;
            } else 46 === r && -1 !== s ? ++s : s = -1;
          }

          return n;
        }

        var n = {
          resolve: function resolve() {
            for (var e, n = "", o = !1, i = arguments.length - 1; i >= -1 && !o; i--) {
              var s;
              i >= 0 ? s = arguments[i] : (void 0 === e && (e = process.cwd()), s = e), t(s), 0 !== s.length && (n = s + "/" + n, o = 47 === s.charCodeAt(0));
            }

            return n = r(n, !o), o ? n.length > 0 ? "/" + n : "/" : n.length > 0 ? n : ".";
          },
          normalize: function normalize(e) {
            if (t(e), 0 === e.length) return ".";
            var n = 47 === e.charCodeAt(0),
                o = 47 === e.charCodeAt(e.length - 1);
            return 0 !== (e = r(e, !n)).length || n || (e = "."), e.length > 0 && o && (e += "/"), n ? "/" + e : e;
          },
          isAbsolute: function isAbsolute(e) {
            return t(e), e.length > 0 && 47 === e.charCodeAt(0);
          },
          join: function join() {
            if (0 === arguments.length) return ".";

            for (var e, r = 0; r < arguments.length; ++r) {
              var o = arguments[r];
              t(o), o.length > 0 && (void 0 === e ? e = o : e += "/" + o);
            }

            return void 0 === e ? "." : n.normalize(e);
          },
          relative: function relative(e, r) {
            if (t(e), t(r), e === r) return "";
            if ((e = n.resolve(e)) === (r = n.resolve(r))) return "";

            for (var o = 1; o < e.length && 47 === e.charCodeAt(o); ++o) {
              ;
            }

            for (var i = e.length, s = i - o, a = 1; a < r.length && 47 === r.charCodeAt(a); ++a) {
              ;
            }

            for (var l = r.length - a, c = s < l ? s : l, p = -1, u = 0; u <= c; ++u) {
              if (u === c) {
                if (l > c) {
                  if (47 === r.charCodeAt(a + u)) return r.slice(a + u + 1);
                  if (0 === u) return r.slice(a + u);
                } else s > c && (47 === e.charCodeAt(o + u) ? p = u : 0 === u && (p = 0));

                break;
              }

              var d = e.charCodeAt(o + u);
              if (d !== r.charCodeAt(a + u)) break;
              47 === d && (p = u);
            }

            var h = "";

            for (u = o + p + 1; u <= i; ++u) {
              u !== i && 47 !== e.charCodeAt(u) || (0 === h.length ? h += ".." : h += "/..");
            }

            return h.length > 0 ? h + r.slice(a + p) : (a += p, 47 === r.charCodeAt(a) && ++a, r.slice(a));
          },
          _makeLong: function _makeLong(e) {
            return e;
          },
          dirname: function dirname(e) {
            if (t(e), 0 === e.length) return ".";

            for (var r = e.charCodeAt(0), n = 47 === r, o = -1, i = !0, s = e.length - 1; s >= 1; --s) {
              if (47 === (r = e.charCodeAt(s))) {
                if (!i) {
                  o = s;
                  break;
                }
              } else i = !1;
            }

            return -1 === o ? n ? "/" : "." : n && 1 === o ? "//" : e.slice(0, o);
          },
          basename: function basename(e, r) {
            if (void 0 !== r && "string" != typeof r) throw new TypeError('"ext" argument must be a string');
            t(e);
            var n,
                o = 0,
                i = -1,
                s = !0;

            if (void 0 !== r && r.length > 0 && r.length <= e.length) {
              if (r.length === e.length && r === e) return "";
              var a = r.length - 1,
                  l = -1;

              for (n = e.length - 1; n >= 0; --n) {
                var c = e.charCodeAt(n);

                if (47 === c) {
                  if (!s) {
                    o = n + 1;
                    break;
                  }
                } else -1 === l && (s = !1, l = n + 1), a >= 0 && (c === r.charCodeAt(a) ? -1 == --a && (i = n) : (a = -1, i = l));
              }

              return o === i ? i = l : -1 === i && (i = e.length), e.slice(o, i);
            }

            for (n = e.length - 1; n >= 0; --n) {
              if (47 === e.charCodeAt(n)) {
                if (!s) {
                  o = n + 1;
                  break;
                }
              } else -1 === i && (s = !1, i = n + 1);
            }

            return -1 === i ? "" : e.slice(o, i);
          },
          extname: function extname(e) {
            t(e);

            for (var r = -1, n = 0, o = -1, i = !0, s = 0, a = e.length - 1; a >= 0; --a) {
              var l = e.charCodeAt(a);
              if (47 !== l) -1 === o && (i = !1, o = a + 1), 46 === l ? -1 === r ? r = a : 1 !== s && (s = 1) : -1 !== r && (s = -1);else if (!i) {
                n = a + 1;
                break;
              }
            }

            return -1 === r || -1 === o || 0 === s || 1 === s && r === o - 1 && r === n + 1 ? "" : e.slice(r, o);
          },
          format: function format(e) {
            if (null === e || "object" != typeof e) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
            return function (e, t) {
              var r = t.dir || t.root,
                  n = t.base || (t.name || "") + (t.ext || "");
              return r ? r === t.root ? r + n : r + "/" + n : n;
            }(0, e);
          },
          parse: function parse(e) {
            t(e);
            var r = {
              root: "",
              dir: "",
              base: "",
              ext: "",
              name: ""
            };
            if (0 === e.length) return r;
            var n,
                o = e.charCodeAt(0),
                i = 47 === o;
            i ? (r.root = "/", n = 1) : n = 0;

            for (var s = -1, a = 0, l = -1, c = !0, p = e.length - 1, u = 0; p >= n; --p) {
              if (47 !== (o = e.charCodeAt(p))) -1 === l && (c = !1, l = p + 1), 46 === o ? -1 === s ? s = p : 1 !== u && (u = 1) : -1 !== s && (u = -1);else if (!c) {
                a = p + 1;
                break;
              }
            }

            return -1 === s || -1 === l || 0 === u || 1 === u && s === l - 1 && s === a + 1 ? -1 !== l && (r.base = r.name = 0 === a && i ? e.slice(1, l) : e.slice(a, l)) : (0 === a && i ? (r.name = e.slice(1, s), r.base = e.slice(1, l)) : (r.name = e.slice(a, s), r.base = e.slice(a, l)), r.ext = e.slice(s, l)), a > 0 ? r.dir = e.slice(0, a - 1) : i && (r.dir = "/"), r;
          },
          sep: "/",
          delimiter: ":",
          win32: null,
          posix: null
        };
        n.posix = n, e.exports = n;
      },
      683: function _(e) {
        "use strict";

        e.exports = {
          nop: function nop(e) {
            return e;
          },
          clone: function clone(e) {
            return JSON.parse(JSON.stringify(e));
          },
          shallowClone: function shallowClone(e) {
            var t = {};

            for (var _r4 in e) {
              e.hasOwnProperty(_r4) && (t[_r4] = e[_r4]);
            }

            return t;
          },
          deepClone: function e(t) {
            var r = Array.isArray(t) ? [] : {};

            for (var _n15 in t) {
              (t.hasOwnProperty(_n15) || Array.isArray(t)) && (r[_n15] = "object" == typeof t[_n15] ? e(t[_n15]) : t[_n15]);
            }

            return r;
          },
          fastClone: function fastClone(e) {
            return Object.assign({}, e);
          },
          circularClone: function e(t, r) {
            if (r || (r = new WeakMap()), Object(t) !== t || t instanceof Function) return t;
            if (r.has(t)) return r.get(t);

            try {
              var n = new t.constructor();
            } catch (e) {
              n = Object.create(Object.getPrototypeOf(t));
            }

            return r.set(t, n), Object.assign.apply(Object, [n].concat(_toConsumableArray(Object.keys(t).map(function (n) {
              return _defineProperty({}, n, e(t[n], r));
            }))));
          }
        };
      },
      593: function _(e, t, r) {
        "use strict";

        var n = r(401).recurse,
            o = r(683).shallowClone,
            i = r(53).jptr,
            s = r(592).isRef;
        e.exports = {
          dereference: function e(t, r, a) {
            a || (a = {}), a.cache || (a.cache = {}), a.state || (a.state = {}), a.state.identityDetection = !0, a.depth = a.depth ? a.depth + 1 : 1;
            var l = a.depth > 1 ? t : o(t),
                c = {
              data: l
            },
                p = a.depth > 1 ? r : o(r);
            a.master || (a.master = l);

            var u = function (e) {
              return e && e.verbose ? {
                warn: function warn() {
                  var e = Array.prototype.slice.call(arguments);
                  console.warn.apply(console, e);
                }
              } : {
                warn: function warn() {}
              };
            }(a),
                d = 1;

            for (; d > 0;) {
              d = 0, n(c, a.state, function (t, r, n) {
                if (s(t, r)) {
                  var _o3 = t[r];

                  if (d++, a.cache[_o3]) {
                    var _e9 = a.cache[_o3];
                    if (_e9.resolved) u.warn("Patching %s for %s", _o3, _e9.path), n.parent[n.pkey] = _e9.data, a.$ref && "object" == typeof n.parent[n.pkey] && (n.parent[n.pkey][a.$ref] = _o3);else {
                      if (_o3 === _e9.path) throw new Error("Tight circle at ".concat(_e9.path));
                      u.warn("Unresolved ref"), n.parent[n.pkey] = i(_e9.source, _e9.path), !1 === n.parent[n.pkey] && (n.parent[n.pkey] = i(_e9.source, _e9.key)), a.$ref && "object" == typeof n.parent[n.pkey] && (n.parent[a.$ref] = _o3);
                    }
                  } else {
                    var _t13 = {};
                    _t13.path = n.path.split("/$ref")[0], _t13.key = _o3, u.warn("Dereffing %s at %s", _o3, _t13.path), _t13.source = p, _t13.data = i(_t13.source, _t13.key), !1 === _t13.data && (_t13.data = i(a.master, _t13.key), _t13.source = a.master), !1 === _t13.data && u.warn("Missing $ref target", _t13.key), a.cache[_o3] = _t13, _t13.data = n.parent[n.pkey] = e(i(_t13.source, _t13.key), _t13.source, a), a.$ref && "object" == typeof n.parent[n.pkey] && (n.parent[n.pkey][a.$ref] = _o3), _t13.resolved = !0;
                  }
                }
              });
            }

            return c.data;
          }
        };
      },
      592: function _(e) {
        "use strict";

        e.exports = {
          isRef: function isRef(e, t) {
            return "$ref" === t && !!e && "string" == typeof e[t];
          }
        };
      },
      53: function _(e) {
        "use strict";

        function t(e) {
          return e.replace(/\~1/g, "/").replace(/~0/g, "~");
        }

        e.exports = {
          jptr: function jptr(e, r, n) {
            if (void 0 === e) return !1;
            if (!r || "string" != typeof r || "#" === r) return void 0 !== n ? n : e;

            if (r.indexOf("#") >= 0) {
              var _e10 = r.split("#");

              if (_e10[0]) return !1;
              r = _e10[1], r = decodeURIComponent(r.slice(1).split("+").join(" "));
            }

            r.startsWith("/") && (r = r.slice(1));
            var o = r.split("/");

            for (var _r5 = 0; _r5 < o.length; _r5++) {
              o[_r5] = t(o[_r5]);
              var i = void 0 !== n && _r5 == o.length - 1,
                  s = parseInt(o[_r5], 10);
              if (!Array.isArray(e) || isNaN(s) || s.toString() !== o[_r5] ? s = Array.isArray(e) && "-" === o[_r5] ? -2 : -1 : o[_r5] = _r5 > 0 ? o[_r5 - 1] : "", -1 != s || e && e.hasOwnProperty(o[_r5])) {
                if (s >= 0) i && (e[s] = n), e = e[s];else {
                  if (-2 === s) return i ? (Array.isArray(e) && e.push(n), n) : void 0;
                  i && (e[o[_r5]] = n), e = e[o[_r5]];
                }
              } else {
                if (void 0 === n || "object" != typeof e || Array.isArray(e)) return !1;
                e[o[_r5]] = i ? n : "0" === o[_r5 + 1] || "-" === o[_r5 + 1] ? [] : {}, e = e[o[_r5]];
              }
            }

            return e;
          },
          jpescape: function jpescape(e) {
            return e.replace(/\~/g, "~0").replace(/\//g, "~1");
          },
          jpunescape: t
        };
      },
      401: function _(e, t, r) {
        "use strict";

        var n = r(53).jpescape;
        e.exports = {
          recurse: function e(t, r, o) {
            if (r || (r = {
              depth: 0
            }), r.depth || (r = Object.assign({}, {
              path: "#",
              depth: 0,
              pkey: "",
              parent: {},
              payload: {},
              seen: new WeakMap(),
              identity: !1,
              identityDetection: !1
            }, r)), "object" != typeof t) return;
            var i = r.path;

            for (var s in t) {
              if (r.key = s, r.path = r.path + "/" + encodeURIComponent(n(s)), r.identityPath = r.seen.get(t[s]), r.identity = void 0 !== r.identityPath, t.hasOwnProperty(s) && o(t, s, r), "object" == typeof t[s] && !r.identity) {
                r.identityDetection && !Array.isArray(t[s]) && null !== t[s] && r.seen.set(t[s], r.path);
                var _n16 = {};
                _n16.parent = t, _n16.path = r.path, _n16.depth = r.depth ? r.depth + 1 : 1, _n16.pkey = s, _n16.payload = r.payload, _n16.seen = r.seen, _n16.identity = !1, _n16.identityDetection = r.identityDetection, e(t[s], _n16, o);
              }

              r.path = i;
            }
          }
        };
      },
      433: function _(e, t, r) {
        "use strict";

        r.r(t);
        var n = r(379),
            o = r.n(n),
            i = r(795),
            s = r.n(i),
            a = r(569),
            l = r.n(a),
            c = r(565),
            p = r.n(c),
            u = r(216),
            d = r.n(u),
            h = r(589),
            m = r.n(h),
            f = r(295),
            g = {};
        g.styleTagTransform = m(), g.setAttributes = p(), g.insert = l().bind(null, "head"), g.domAPI = s(), g.insertStyleElement = d(), o()(f.Z, g), t.default = f.Z && f.Z.locals ? f.Z.locals : void 0;
      },
      379: function _(e) {
        "use strict";

        var t = [];

        function r(e) {
          for (var r = -1, n = 0; n < t.length; n++) {
            if (t[n].identifier === e) {
              r = n;
              break;
            }
          }

          return r;
        }

        function n(e, n) {
          for (var i = {}, s = [], a = 0; a < e.length; a++) {
            var l = e[a],
                c = n.base ? l[0] + n.base : l[0],
                p = i[c] || 0,
                u = "".concat(c, " ").concat(p);
            i[c] = p + 1;
            var d = r(u),
                h = {
              css: l[1],
              media: l[2],
              sourceMap: l[3],
              supports: l[4],
              layer: l[5]
            };
            if (-1 !== d) t[d].references++, t[d].updater(h);else {
              var m = o(h, n);
              n.byIndex = a, t.splice(a, 0, {
                identifier: u,
                updater: m,
                references: 1
              });
            }
            s.push(u);
          }

          return s;
        }

        function o(e, t) {
          var r = t.domAPI(t);
          return r.update(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              r.update(e = t);
            } else r.remove();
          };
        }

        e.exports = function (e, o) {
          var i = n(e = e || [], o = o || {});
          return function (e) {
            e = e || [];

            for (var s = 0; s < i.length; s++) {
              var a = r(i[s]);
              t[a].references--;
            }

            for (var l = n(e, o), c = 0; c < i.length; c++) {
              var p = r(i[c]);
              0 === t[p].references && (t[p].updater(), t.splice(p, 1));
            }

            i = l;
          };
        };
      },
      569: function _(e) {
        "use strict";

        var t = {};

        e.exports = function (e, r) {
          var n = function (e) {
            if (void 0 === t[e]) {
              var r = document.querySelector(e);
              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (e) {
                r = null;
              }
              t[e] = r;
            }

            return t[e];
          }(e);

          if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          n.appendChild(r);
        };
      },
      216: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      565: function _(e, t, r) {
        "use strict";

        e.exports = function (e) {
          var t = r.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      795: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = e.insertStyleElement(e);
          return {
            update: function update(r) {
              !function (e, t, r) {
                var n = "";
                r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
                var o = void 0 !== r.layer;
                o && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, o && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
                var i = r.sourceMap;
                i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(n, e, t.options);
              }(t, e, r);
            },
            remove: function remove() {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      589: function _(e) {
        "use strict";

        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) {
              t.removeChild(t.firstChild);
            }

            t.appendChild(document.createTextNode(e));
          }
        };
      },
      925: function _(e, t, r) {
        "use strict";

        var n = r(45),
            o = r(416),
            i = (r(470), r(766)),
            s = r(416),
            a = r(66),
            l = r(53),
            c = l.jptr,
            p = r(592).isRef,
            u = r(683).clone,
            d = r(683).circularClone,
            h = r(401).recurse,
            m = r(856),
            f = r(804),
            g = r(342),
            y = r(711).statusCodes,
            b = r(109).i8,
            x = "3.0.0";
        var v;

        var w = /*#__PURE__*/function (_Error) {
          _inherits(w, _Error);

          var _super = _createSuper(w);

          function w(e) {
            var _this;

            _classCallCheck(this, w);

            _this = _super.call(this, e), _this.name = "S2OError";
            return _this;
          }

          return _createClass(w);
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        function k(e, t) {
          var r = new w(e);
          if (r.options = t, !t.promise) throw r;
          t.promise.reject(r);
        }

        function O(e, t, r) {
          r.warnOnly ? t[r.warnProperty || "x-s2o-warning"] = e : k(e, r);
        }

        function E(e, t) {
          f.walkSchema(e, {}, {}, function (e, r, n) {
            !function (e, t) {
              if (e["x-required"] && Array.isArray(e["x-required"]) && (e.required || (e.required = []), e.required = e.required.concat(e["x-required"]), delete e["x-required"]), e["x-anyOf"] && (e.anyOf = e["x-anyOf"], delete e["x-anyOf"]), e["x-oneOf"] && (e.oneOf = e["x-oneOf"], delete e["x-oneOf"]), e["x-not"] && (e.not = e["x-not"], delete e["x-not"]), "boolean" == typeof e["x-nullable"] && (e.nullable = e["x-nullable"], delete e["x-nullable"]), "object" == typeof e["x-discriminator"] && "string" == typeof e["x-discriminator"].propertyName) {
                e.discriminator = e["x-discriminator"], delete e["x-discriminator"];

                for (var _t14 in e.discriminator.mapping) {
                  var _r6 = e.discriminator.mapping[_t14];
                  _r6.startsWith("#/definitions/") && (e.discriminator.mapping[_t14] = _r6.replace("#/definitions/", "#/components/schemas/"));
                }
              }
            }(e), function (e, t, r) {
              if (e.nullable && r.patches++, e.discriminator && "string" == typeof e.discriminator && (e.discriminator = {
                propertyName: e.discriminator
              }), e.items && Array.isArray(e.items) && (0 === e.items.length ? e.items = {} : 1 === e.items.length ? e.items = e.items[0] : e.items = {
                anyOf: e.items
              }), e.type && Array.isArray(e.type)) if (r.patch) {
                if (r.patches++, 0 === e.type.length) delete e.type;else {
                  e.oneOf || (e.oneOf = []);

                  var _iterator4 = _createForOfIteratorHelper(e.type),
                      _step4;

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var _t15 = _step4.value;
                      var _r7 = {};
                      if ("null" === _t15) e.nullable = !0;else {
                        _r7.type = _t15;

                        var _iterator5 = _createForOfIteratorHelper(g.arrayProperties),
                            _step5;

                        try {
                          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                            var _t16 = _step5.value;
                            void 0 !== e.prop && (_r7[_t16] = e[_t16], delete e[_t16]);
                          }
                        } catch (err) {
                          _iterator5.e(err);
                        } finally {
                          _iterator5.f();
                        }
                      }
                      _r7.type && e.oneOf.push(_r7);
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }

                  delete e.type, 0 === e.oneOf.length ? delete e.oneOf : e.oneOf.length < 2 && (e.type = e.oneOf[0].type, Object.keys(e.oneOf[0]).length > 1 && O("Lost properties from oneOf", e, r), delete e.oneOf);
                }
                e.type && Array.isArray(e.type) && 1 === e.type.length && (e.type = e.type[0]);
              } else k("(Patchable) schema type must not be an array", r);
              e.type && "null" === e.type && (delete e.type, e.nullable = !0), "array" !== e.type || e.items || (e.items = {}), "file" === e.type && (e.type = "string", e.format = "binary"), "boolean" == typeof e.required && (e.required && e.name && (void 0 === t.required && (t.required = []), Array.isArray(t.required) && t.required.push(e.name)), delete e.required), e.xml && "string" == typeof e.xml.namespace && (e.xml.namespace || delete e.xml.namespace), void 0 !== e.allowEmptyValue && (r.patches++, delete e.allowEmptyValue);
            }(e, r, t);
          });
        }

        function S(e, t, r) {
          var n = r.payload.options;

          if (p(e, t)) {
            if (e[t].startsWith("#/components/")) ;else if ("#/consumes" === e[t]) delete e[t], r.parent[r.pkey] = u(n.openapi.consumes);else if ("#/produces" === e[t]) delete e[t], r.parent[r.pkey] = u(n.openapi.produces);else if (e[t].startsWith("#/definitions/")) {
              var _r8 = e[t].replace("#/definitions/", "").split("/");

              var _o4 = l.jpunescape(_r8[0]);

              var _i5 = v.schemas[decodeURIComponent(_o4)];
              _i5 ? _r8[0] = _i5 : O("Could not resolve reference " + e[t], e, n), e[t] = "#/components/schemas/" + _r8.join("/");
            } else if (e[t].startsWith("#/parameters/")) e[t] = "#/components/parameters/" + g.sanitise(e[t].replace("#/parameters/", ""));else if (e[t].startsWith("#/responses/")) e[t] = "#/components/responses/" + g.sanitise(e[t].replace("#/responses/", ""));else if (e[t].startsWith("#")) {
              var _r9 = u(l.jptr(n.openapi, e[t]));

              if (!1 === _r9) O("direct $ref not found " + e[t], e, n);else if (n.refmap[e[t]]) e[t] = n.refmap[e[t]];else {
                var _i6 = e[t];
                _i6 = _i6.replace("/properties/headers/", ""), _i6 = _i6.replace("/properties/responses/", ""), _i6 = _i6.replace("/properties/parameters/", ""), _i6 = _i6.replace("/properties/schemas/", "");

                var _s3 = "schemas",
                    _a2 = _i6.lastIndexOf("/schema");

                if (_s3 = _i6.indexOf("/headers/") > _a2 ? "headers" : _i6.indexOf("/responses/") > _a2 ? "responses" : _i6.indexOf("/example") > _a2 ? "examples" : _i6.indexOf("/x-") > _a2 ? "extensions" : _i6.indexOf("/parameters/") > _a2 ? "parameters" : "schemas", "schemas" === _s3 && E(_r9, n), "responses" !== _s3 && "extensions" !== _s3) {
                  var _i7 = _s3.substr(0, _s3.length - 1);

                  "parameter" === _i7 && _r9.name && _r9.name === g.sanitise(_r9.name) && (_i7 = encodeURIComponent(_r9.name));
                  var _a3 = 1;

                  for (e["x-miro"] && (o = (o = e["x-miro"]).indexOf("#") >= 0 ? o.split("#")[1].split("/").pop() : o.split("/").pop().split(".")[0], _i7 = encodeURIComponent(g.sanitise(o)), _a3 = ""); l.jptr(n.openapi, "#/components/" + _s3 + "/" + _i7 + _a3);) {
                    _a3 = "" === _a3 ? 2 : ++_a3;
                  }

                  var _c2 = "#/components/" + _s3 + "/" + _i7 + _a3,
                      _p2 = "";

                  "examples" === _s3 && (_r9 = {
                    value: _r9
                  }, _p2 = "/value"), l.jptr(n.openapi, _c2, _r9), n.refmap[e[t]] = _c2 + _p2, e[t] = _c2 + _p2;
                }
              }
            }

            if (delete e["x-miro"], Object.keys(e).length > 1) {
              var _o5 = e[t],
                  _i8 = r.path.indexOf("/schema") >= 0;

              "preserve" === n.refSiblings || (_i8 && "allOf" === n.refSiblings ? (delete e.$ref, r.parent[r.pkey] = {
                allOf: [{
                  $ref: _o5
                }, e]
              }) : r.parent[r.pkey] = {
                $ref: _o5
              });
            }
          }

          var o;

          if ("x-ms-odata" === t && "string" == typeof e[t] && e[t].startsWith("#/")) {
            var _r10 = e[t].replace("#/definitions/", "").replace("#/components/schemas/", "").split("/"),
                _o6 = v.schemas[decodeURIComponent(_r10[0])];

            _o6 ? _r10[0] = _o6 : O("Could not resolve reference " + e[t], e, n), e[t] = "#/components/schemas/" + _r10.join("/");
          }
        }

        function $(e) {
          for (var _t17 in e) {
            for (var _r11 in e[_t17]) {
              var _n17 = g.sanitise(_r11);

              _r11 !== _n17 && (e[_t17][_n17] = e[_t17][_r11], delete e[_t17][_r11]);
            }
          }
        }

        function R(e, t) {
          if ("basic" === e.type && (e.type = "http", e.scheme = "basic"), "oauth2" === e.type) {
            var _r12 = {},
                _n18 = e.flow;
            "application" === e.flow && (_n18 = "clientCredentials"), "accessCode" === e.flow && (_n18 = "authorizationCode"), void 0 !== e.authorizationUrl && (_r12.authorizationUrl = e.authorizationUrl.split("?")[0].trim() || "/"), "string" == typeof e.tokenUrl && (_r12.tokenUrl = e.tokenUrl.split("?")[0].trim() || "/"), _r12.scopes = e.scopes || {}, e.flows = {}, e.flows[_n18] = _r12, delete e.flow, delete e.authorizationUrl, delete e.tokenUrl, delete e.scopes, void 0 !== e.name && (t.patch ? (t.patches++, delete e.name) : k("(Patchable) oauth2 securitySchemes should not have name property", t));
          }
        }

        function j(e) {
          return e && !e["x-s2o-delete"];
        }

        function C(e, t) {
          if (e.$ref) e.$ref = e.$ref.replace("#/responses/", "#/components/responses/");else {
            e.type && !e.schema && (e.schema = {}), e.type && (e.schema.type = e.type), e.items && "array" !== e.items.type && (e.items.collectionFormat !== e.collectionFormat && O("Nested collectionFormats are not supported", e, t), delete e.items.collectionFormat), "array" === e.type ? ("ssv" === e.collectionFormat ? O("collectionFormat:ssv is no longer supported for headers", e, t) : "pipes" === e.collectionFormat ? O("collectionFormat:pipes is no longer supported for headers", e, t) : "multi" === e.collectionFormat ? e.explode = !0 : "tsv" === e.collectionFormat ? (O("collectionFormat:tsv is no longer supported", e, t), e["x-collectionFormat"] = "tsv") : e.style = "simple", delete e.collectionFormat) : e.collectionFormat && (t.patch ? (t.patches++, delete e.collectionFormat) : k("(Patchable) collectionFormat is only applicable to header.type array", t)), delete e.type;

            var _iterator6 = _createForOfIteratorHelper(g.parameterTypeProperties),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _t18 = _step6.value;
                void 0 !== e[_t18] && (e.schema[_t18] = e[_t18], delete e[_t18]);
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            var _iterator7 = _createForOfIteratorHelper(g.arrayProperties),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _t19 = _step7.value;
                void 0 !== e[_t19] && (e.schema[_t19] = e[_t19], delete e[_t19]);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        }

        function A(e, t) {
          if (e.$ref.indexOf("#/parameters/") >= 0) {
            var _t20 = e.$ref.split("#/parameters/");

            e.$ref = _t20[0] + "#/components/parameters/" + g.sanitise(_t20[1]);
          }

          e.$ref.indexOf("#/definitions/") >= 0 && O("Definition used as parameter", e, t);
        }

        function P(e, t, r, n, o, i, s) {
          var a,
              l = {},
              p = !0;

          if (t && t.consumes && "string" == typeof t.consumes) {
            if (!s.patch) return k("(Patchable) operation.consumes must be an array", s);
            s.patches++, t.consumes = [t.consumes];
          }

          Array.isArray(i.consumes) || delete i.consumes;
          var d = ((t ? t.consumes : null) || i.consumes || []).filter(g.uniqueOnly);

          if (e && e.$ref && "string" == typeof e.$ref) {
            A(e, s);

            var _t21 = decodeURIComponent(e.$ref.replace("#/components/parameters/", "")),
                _r13 = !1,
                _n19 = i.components.parameters[_t21];

            if (_n19 && !_n19["x-s2o-delete"] || !e.$ref.startsWith("#/") || (e["x-s2o-delete"] = !0, _r13 = !0), _r13) {
              var _t22 = e.$ref,
                  _r14 = c(i, e.$ref);

              !_r14 && _t22.startsWith("#/") ? O("Could not resolve reference " + _t22, e, s) : _r14 && (e = _r14);
            }
          }

          if (e && (e.name || e.in)) {
            "boolean" == typeof e["x-deprecated"] && (e.deprecated = e["x-deprecated"], delete e["x-deprecated"]), void 0 !== e["x-example"] && (e.example = e["x-example"], delete e["x-example"]), "body" === e.in || e.type || (s.patch ? (s.patches++, e.type = "string") : k("(Patchable) parameter.type is mandatory for non-body parameters", s)), e.type && "object" == typeof e.type && e.type.$ref && (e.type = c(i, e.type.$ref)), "file" === e.type && (e["x-s2o-originalType"] = e.type, a = e.type), e.description && "object" == typeof e.description && e.description.$ref && (e.description = c(i, e.description.$ref)), null === e.description && delete e.description;
            var _t23 = e.collectionFormat;
            if ("array" !== e.type || _t23 || (_t23 = "csv"), _t23 && ("array" !== e.type && (s.patch ? (s.patches++, delete e.collectionFormat) : k("(Patchable) collectionFormat is only applicable to param.type array", s)), "csv" !== _t23 || "query" !== e.in && "cookie" !== e.in || (e.style = "form", e.explode = !1), "csv" !== _t23 || "path" !== e.in && "header" !== e.in || (e.style = "simple"), "ssv" === _t23 && ("query" === e.in ? e.style = "spaceDelimited" : O("collectionFormat:ssv is no longer supported except for in:query parameters", e, s)), "pipes" === _t23 && ("query" === e.in ? e.style = "pipeDelimited" : O("collectionFormat:pipes is no longer supported except for in:query parameters", e, s)), "multi" === _t23 && (e.explode = !0), "tsv" === _t23 && (O("collectionFormat:tsv is no longer supported", e, s), e["x-collectionFormat"] = "tsv"), delete e.collectionFormat), e.type && "body" !== e.type && "formData" !== e.in) if (e.items && e.schema) O("parameter has array,items and schema", e, s);else {
              e.schema && s.patches++, e.schema && "object" == typeof e.schema || (e.schema = {}), e.schema.type = e.type, e.items && (e.schema.items = e.items, delete e.items, h(e.schema.items, null, function (r, n, o) {
                "collectionFormat" === n && "string" == typeof r[n] && (_t23 && r[n] !== _t23 && O("Nested collectionFormats are not supported", e, s), delete r[n]);
              }));

              var _iterator8 = _createForOfIteratorHelper(g.parameterTypeProperties),
                  _step8;

              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var _t24 = _step8.value;
                  void 0 !== e[_t24] && (e.schema[_t24] = e[_t24]), delete e[_t24];
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            }
            e.schema && E(e.schema, s), e["x-ms-skip-url-encoding"] && "query" === e.in && (e.allowReserved = !0, delete e["x-ms-skip-url-encoding"]);
          }

          if (e && "formData" === e.in) {
            p = !1, l.content = {};
            var _t25 = "application/x-www-form-urlencoded";
            if (d.length && d.indexOf("multipart/form-data") >= 0 && (_t25 = "multipart/form-data"), l.content[_t25] = {}, e.schema) l.content[_t25].schema = e.schema, e.schema.$ref && (l["x-s2o-name"] = decodeURIComponent(e.schema.$ref.replace("#/components/schemas/", "")));else {
              l.content[_t25].schema = {}, l.content[_t25].schema.type = "object", l.content[_t25].schema.properties = {}, l.content[_t25].schema.properties[e.name] = {};
              var _r15 = l.content[_t25].schema,
                  _n20 = l.content[_t25].schema.properties[e.name];
              e.description && (_n20.description = e.description), e.example && (_n20.example = e.example), e.type && (_n20.type = e.type);

              var _iterator9 = _createForOfIteratorHelper(g.parameterTypeProperties),
                  _step9;

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _t26 = _step9.value;
                  void 0 !== e[_t26] && (_n20[_t26] = e[_t26]);
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }

              !0 === e.required && (_r15.required || (_r15.required = []), _r15.required.push(e.name), l.required = !0), void 0 !== e.default && (_n20.default = e.default), _n20.properties && (_n20.properties = e.properties), e.allOf && (_n20.allOf = e.allOf), "array" === e.type && e.items && (_n20.items = e.items, _n20.items.collectionFormat && delete _n20.items.collectionFormat), "file" !== a && "file" !== e["x-s2o-originalType"] || (_n20.type = "string", _n20.format = "binary"), I(e, _n20);
            }
          } else e && "file" === e.type && (e.required && (l.required = e.required), l.content = {}, l.content["application/octet-stream"] = {}, l.content["application/octet-stream"].schema = {}, l.content["application/octet-stream"].schema.type = "string", l.content["application/octet-stream"].schema.format = "binary", I(e, l));

          if (e && "body" === e.in) {
            l.content = {}, e.name && (l["x-s2o-name"] = (t && t.operationId ? g.sanitiseAll(t.operationId) : "") + ("_" + e.name).toCamelCase()), e.description && (l.description = e.description), e.required && (l.required = e.required), t && s.rbname && e.name && (t[s.rbname] = e.name), e.schema && e.schema.$ref ? l["x-s2o-name"] = decodeURIComponent(e.schema.$ref.replace("#/components/schemas/", "")) : e.schema && "array" === e.schema.type && e.schema.items && e.schema.items.$ref && (l["x-s2o-name"] = decodeURIComponent(e.schema.items.$ref.replace("#/components/schemas/", "")) + "Array"), d.length || d.push("application/json");

            var _iterator10 = _createForOfIteratorHelper(d),
                _step10;

            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var _t27 = _step10.value;
                l.content[_t27] = {}, l.content[_t27].schema = u(e.schema || {}), E(l.content[_t27].schema, s);
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }

            I(e, l);
          }

          if (Object.keys(l).length > 0 && (e["x-s2o-delete"] = !0, t) && (t.requestBody && p ? (t.requestBody["x-s2o-overloaded"] = !0, O("Operation " + (t.operationId || o) + " has multiple requestBodies", t, s)) : (t.requestBody || (t = r[n] = function (e, t) {
            var r = {};

            for (var _i9 = 0, _Object$keys = Object.keys(e); _i9 < _Object$keys.length; _i9++) {
              var _n21 = _Object$keys[_i9];
              r[_n21] = e[_n21], "parameters" === _n21 && (r.requestBody = {}, t.rbname && (r[t.rbname] = ""));
            }

            return r.requestBody = {}, r;
          }(t, s)), t.requestBody.content && t.requestBody.content["multipart/form-data"] && t.requestBody.content["multipart/form-data"].schema && t.requestBody.content["multipart/form-data"].schema.properties && l.content["multipart/form-data"] && l.content["multipart/form-data"].schema && l.content["multipart/form-data"].schema.properties ? (t.requestBody.content["multipart/form-data"].schema.properties = Object.assign(t.requestBody.content["multipart/form-data"].schema.properties, l.content["multipart/form-data"].schema.properties), t.requestBody.content["multipart/form-data"].schema.required = (t.requestBody.content["multipart/form-data"].schema.required || []).concat(l.content["multipart/form-data"].schema.required || []), t.requestBody.content["multipart/form-data"].schema.required.length || delete t.requestBody.content["multipart/form-data"].schema.required) : t.requestBody.content && t.requestBody.content["application/x-www-form-urlencoded"] && t.requestBody.content["application/x-www-form-urlencoded"].schema && t.requestBody.content["application/x-www-form-urlencoded"].schema.properties && l.content["application/x-www-form-urlencoded"] && l.content["application/x-www-form-urlencoded"].schema && l.content["application/x-www-form-urlencoded"].schema.properties ? (t.requestBody.content["application/x-www-form-urlencoded"].schema.properties = Object.assign(t.requestBody.content["application/x-www-form-urlencoded"].schema.properties, l.content["application/x-www-form-urlencoded"].schema.properties), t.requestBody.content["application/x-www-form-urlencoded"].schema.required = (t.requestBody.content["application/x-www-form-urlencoded"].schema.required || []).concat(l.content["application/x-www-form-urlencoded"].schema.required || []), t.requestBody.content["application/x-www-form-urlencoded"].schema.required.length || delete t.requestBody.content["application/x-www-form-urlencoded"].schema.required) : (t.requestBody = Object.assign(t.requestBody, l), t.requestBody["x-s2o-name"] || (t.requestBody.schema && t.requestBody.schema.$ref ? t.requestBody["x-s2o-name"] = decodeURIComponent(t.requestBody.schema.$ref.replace("#/components/schemas/", "")).split("/").join("") : t.operationId && (t.requestBody["x-s2o-name"] = g.sanitiseAll(t.operationId)))))), e && !e["x-s2o-delete"]) {
            delete e.type;

            var _iterator11 = _createForOfIteratorHelper(g.parameterTypeProperties),
                _step11;

            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var _t28 = _step11.value;
                delete e[_t28];
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }

            "path" !== e.in || void 0 !== e.required && !0 === e.required || (s.patch ? (s.patches++, e.required = !0) : k("(Patchable) path parameters must be required:true [" + e.name + " in " + o + "]", s));
          }

          return t;
        }

        function I(e, t) {
          for (var _r16 in e) {
            _r16.startsWith("x-") && !_r16.startsWith("x-s2o") && (t[_r16] = e[_r16]);
          }
        }

        function T(e, t, r, n, o) {
          if (!e) return !1;
          if (e.$ref && "string" == typeof e.$ref) e.$ref.indexOf("#/definitions/") >= 0 ? O("definition used as response: " + e.$ref, e, o) : e.$ref.startsWith("#/responses/") && (e.$ref = "#/components/responses/" + g.sanitise(decodeURIComponent(e.$ref.replace("#/responses/", ""))));else {
            if ((void 0 === e.description || null === e.description || "" === e.description && o.patch) && (o.patch ? "object" != typeof e || Array.isArray(e) || (o.patches++, e.description = y[e] || "") : k("(Patchable) response.description is mandatory", o)), void 0 !== e.schema) {
              if (E(e.schema, o), e.schema.$ref && "string" == typeof e.schema.$ref && e.schema.$ref.startsWith("#/responses/") && (e.schema.$ref = "#/components/responses/" + g.sanitise(decodeURIComponent(e.schema.$ref.replace("#/responses/", "")))), r && r.produces && "string" == typeof r.produces) {
                if (!o.patch) return k("(Patchable) operation.produces must be an array", o);
                o.patches++, r.produces = [r.produces];
              }

              n.produces && !Array.isArray(n.produces) && delete n.produces;

              var _t29 = ((r ? r.produces : null) || n.produces || []).filter(g.uniqueOnly);

              _t29.length || _t29.push("*/*"), e.content = {};

              var _iterator12 = _createForOfIteratorHelper(_t29),
                  _step12;

              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  var _r17 = _step12.value;

                  if (e.content[_r17] = {}, e.content[_r17].schema = u(e.schema), e.examples && e.examples[_r17]) {
                    var _t30 = {};
                    _t30.value = e.examples[_r17], e.content[_r17].examples = {}, e.content[_r17].examples.response = _t30, delete e.examples[_r17];
                  }

                  "file" === e.content[_r17].schema.type && (e.content[_r17].schema = {
                    type: "string",
                    format: "binary"
                  });
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }

              delete e.schema;
            }

            for (var _t31 in e.examples) {
              e.content || (e.content = {}), e.content[_t31] || (e.content[_t31] = {}), e.content[_t31].examples = {}, e.content[_t31].examples.response = {}, e.content[_t31].examples.response.value = e.examples[_t31];
            }

            if (delete e.examples, e.headers) for (var _t32 in e.headers) {
              "status code" === _t32.toLowerCase() ? o.patch ? (o.patches++, delete e.headers[_t32]) : k('(Patchable) "Status Code" is not a valid header', o) : C(e.headers[_t32], o);
            }
          }
        }

        function _(e, t, r, n, i) {
          for (var _s4 in e) {
            var _a4 = e[_s4];
            _a4 && _a4["x-trace"] && "object" == typeof _a4["x-trace"] && (_a4.trace = _a4["x-trace"], delete _a4["x-trace"]), _a4 && _a4["x-summary"] && "string" == typeof _a4["x-summary"] && (_a4.summary = _a4["x-summary"], delete _a4["x-summary"]), _a4 && _a4["x-description"] && "string" == typeof _a4["x-description"] && (_a4.description = _a4["x-description"], delete _a4["x-description"]), _a4 && _a4["x-servers"] && Array.isArray(_a4["x-servers"]) && (_a4.servers = _a4["x-servers"], delete _a4["x-servers"]);

            for (var _e11 in _a4) {
              if (g.httpMethods.indexOf(_e11) >= 0 || "x-amazon-apigateway-any-method" === _e11) {
                var _p3 = _a4[_e11];

                if (_p3 && _p3.parameters && Array.isArray(_p3.parameters)) {
                  if (_a4.parameters) {
                    var _iterator13 = _createForOfIteratorHelper(_a4.parameters),
                        _step13;

                    try {
                      var _loop3 = function _loop3() {
                        var t = _step13.value;
                        "string" == typeof t.$ref && (A(t, r), t = c(i, t.$ref)), _p3.parameters.find(function (e, r, n) {
                          return e.name === t.name && e.in === t.in;
                        }) || "formData" !== t.in && "body" !== t.in && "file" !== t.type || (_p3 = P(t, _p3, _a4, _e11, _s4, i, r), r.rbname && "" === _p3[r.rbname] && delete _p3[r.rbname]);
                      };

                      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                        _loop3();
                      }
                    } catch (err) {
                      _iterator13.e(err);
                    } finally {
                      _iterator13.f();
                    }
                  }

                  var _iterator14 = _createForOfIteratorHelper(_p3.parameters),
                      _step14;

                  try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      var _t33 = _step14.value;
                      _p3 = P(_t33, _p3, _a4, _e11, _e11 + ":" + _s4, i, r);
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }

                  r.rbname && "" === _p3[r.rbname] && delete _p3[r.rbname], r.debug || _p3.parameters && (_p3.parameters = _p3.parameters.filter(j));
                }

                if (_p3 && _p3.security && $(_p3.security), "object" == typeof _p3) {
                  if (!_p3.responses) {
                    var _e12 = {
                      description: "Default response"
                    };
                    _p3.responses = {
                      default: _e12
                    };
                  }

                  for (var _e13 in _p3.responses) {
                    T(_p3.responses[_e13], 0, _p3, i, r);
                  }
                }

                if (_p3 && _p3["x-servers"] && Array.isArray(_p3["x-servers"])) _p3.servers = _p3["x-servers"], delete _p3["x-servers"];else if (_p3 && _p3.schemes && _p3.schemes.length) {
                  var _iterator15 = _createForOfIteratorHelper(_p3.schemes),
                      _step15;

                  try {
                    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                      var _e14 = _step15.value;

                      if ((!i.schemes || i.schemes.indexOf(_e14) < 0) && (_p3.servers || (_p3.servers = []), Array.isArray(i.servers))) {
                        var _iterator16 = _createForOfIteratorHelper(i.servers),
                            _step16;

                        try {
                          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                            var _t34 = _step16.value;

                            var _r18 = u(_t34),
                                _n22 = o.parse(_r18.url);

                            _n22.protocol = _e14, _r18.url = _n22.format(), _p3.servers.push(_r18);
                          }
                        } catch (err) {
                          _iterator16.e(err);
                        } finally {
                          _iterator16.f();
                        }
                      }
                    }
                  } catch (err) {
                    _iterator15.e(err);
                  } finally {
                    _iterator15.f();
                  }
                }

                if (r.debug && (_p3["x-s2o-consumes"] = _p3.consumes || [], _p3["x-s2o-produces"] = _p3.produces || []), _p3) {
                  if (delete _p3.consumes, delete _p3.produces, delete _p3.schemes, _p3["x-ms-examples"]) {
                    for (var _e15 in _p3["x-ms-examples"]) {
                      var _t35 = _p3["x-ms-examples"][_e15],
                          _r19 = g.sanitiseAll(_e15);

                      if (_t35.parameters) for (var _r20 in _t35.parameters) {
                        var _n23 = _t35.parameters[_r20];

                        var _iterator17 = _createForOfIteratorHelper((_p3.parameters || []).concat(_a4.parameters || [])),
                            _step17;

                        try {
                          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                            var _t36 = _step17.value;
                            _t36.$ref && (_t36 = l.jptr(i, _t36.$ref)), _t36.name !== _r20 || _t36.example || (_t36.examples || (_t36.examples = {}), _t36.examples[_e15] = {
                              value: _n23
                            });
                          }
                        } catch (err) {
                          _iterator17.e(err);
                        } finally {
                          _iterator17.f();
                        }
                      }
                      if (_t35.responses) for (var _n24 in _t35.responses) {
                        if (_t35.responses[_n24].headers) for (var _e16 in _t35.responses[_n24].headers) {
                          var _r21 = _t35.responses[_n24].headers[_e16];

                          for (var _t37 in _p3.responses[_n24].headers) {
                            _t37 === _e16 && (_p3.responses[_n24].headers[_t37].example = _r21);
                          }
                        }
                        if (_t35.responses[_n24].body && (i.components.examples[_r19] = {
                          value: u(_t35.responses[_n24].body)
                        }, _p3.responses[_n24] && _p3.responses[_n24].content)) for (var _t38 in _p3.responses[_n24].content) {
                          var _o7 = _p3.responses[_n24].content[_t38];
                          _o7.examples || (_o7.examples = {}), _o7.examples[_e15] = {
                            $ref: "#/components/examples/" + _r19
                          };
                        }
                      }
                    }

                    delete _p3["x-ms-examples"];
                  }

                  if (_p3.parameters && 0 === _p3.parameters.length && delete _p3.parameters, _p3.requestBody) {
                    var _r22 = _p3.operationId ? g.sanitiseAll(_p3.operationId) : g.sanitiseAll(_e11 + _s4).toCamelCase(),
                        _o8 = g.sanitise(_p3.requestBody["x-s2o-name"] || _r22 || "");

                    delete _p3.requestBody["x-s2o-name"];

                    var _i10 = JSON.stringify(_p3.requestBody),
                        _a5 = g.hash(_i10);

                    if (!n[_a5]) {
                      var _e17 = {};
                      _e17.name = _o8, _e17.body = _p3.requestBody, _e17.refs = [], n[_a5] = _e17;
                    }

                    var _c3 = "#/" + t + "/" + encodeURIComponent(l.jpescape(_s4)) + "/" + _e11 + "/requestBody";

                    n[_a5].refs.push(_c3);
                  }
                }
              }
            }

            if (_a4 && _a4.parameters) {
              for (var _e18 in _a4.parameters) {
                P(_a4.parameters[_e18], null, _a4, null, _s4, i, r);
              }

              !r.debug && Array.isArray(_a4.parameters) && (_a4.parameters = _a4.parameters.filter(j));
            }
          }
        }

        function L(e) {
          return e && e.url && "string" == typeof e.url ? (e.url = e.url.split("{{").join("{"), e.url = e.url.split("}}").join("}"), e.url.replace(/\{(.+?)\}/g, function (t, r) {
            e.variables || (e.variables = {}), e.variables[r] = {
              default: "unknown"
            };
          }), e) : e;
        }

        function D(e, t, r) {
          if (void 0 === e.info || null === e.info) {
            if (!t.patch) return r(new w("(Patchable) info object is mandatory"));
            t.patches++, e.info = {
              version: "",
              title: ""
            };
          }

          if ("object" != typeof e.info || Array.isArray(e.info)) return r(new w("info must be an object"));

          if (void 0 === e.info.title || null === e.info.title) {
            if (!t.patch) return r(new w("(Patchable) info.title cannot be null"));
            t.patches++, e.info.title = "";
          }

          if (void 0 === e.info.version || null === e.info.version) {
            if (!t.patch) return r(new w("(Patchable) info.version cannot be null"));
            t.patches++, e.info.version = "";
          }

          if ("string" != typeof e.info.version) {
            if (!t.patch) return r(new w("(Patchable) info.version must be a string"));
            t.patches++, e.info.version = e.info.version.toString();
          }

          if (void 0 !== e.info.logo) {
            if (!t.patch) return r(new w("(Patchable) info should not have logo property"));
            t.patches++, e.info["x-logo"] = e.info.logo, delete e.info.logo;
          }

          if (void 0 !== e.info.termsOfService) {
            if (null === e.info.termsOfService) {
              if (!t.patch) return r(new w("(Patchable) info.termsOfService cannot be null"));
              t.patches++, e.info.termsOfService = "";
            }

            try {
              new URL(e.info.termsOfService);
            } catch (n) {
              if (!t.patch) return r(new w("(Patchable) info.termsOfService must be a URL"));
              t.patches++, delete e.info.termsOfService;
            }
          }
        }

        function z(e, t, r) {
          if (void 0 === e.paths) {
            if (!t.patch) return r(new w("(Patchable) paths object is mandatory"));
            t.patches++, e.paths = {};
          }
        }

        function M(e, t, r) {
          return i(r, new Promise(function (r, n) {
            if (e || (e = {}), t.original = e, t.text || (t.text = a.stringify(e)), t.externals = [], t.externalRefs = {}, t.rewriteRefs = !0, t.preserveMiro = !0, t.promise = {}, t.promise.resolve = r, t.promise.reject = n, t.patches = 0, t.cache || (t.cache = {}), t.source && (t.cache[t.source] = t.original), function (e, t) {
              var r = new WeakSet();
              h(e, {
                identityDetection: !0
              }, function (e, n, o) {
                "object" == typeof e[n] && null !== e[n] && (r.has(e[n]) ? t.anchors ? e[n] = u(e[n]) : k("YAML anchor or merge key at " + o.path, t) : r.add(e[n]));
              });
            }(e, t), e.openapi && "string" == typeof e.openapi && e.openapi.startsWith("3.")) return t.openapi = d(e), D(t.openapi, t, n), z(t.openapi, t, n), void m.optionalResolve(t).then(function () {
              return t.direct ? r(t.openapi) : r(t);
            }).catch(function (e) {
              console.warn(e), n(e);
            });
            if (!e.swagger || "2.0" != e.swagger) return n(new w("Unsupported swagger/OpenAPI version: " + (e.openapi ? e.openapi : e.swagger)));
            var o = t.openapi = {};

            if (o.openapi = "string" == typeof t.targetVersion && t.targetVersion.startsWith("3.") ? t.targetVersion : x, t.origin) {
              o["x-origin"] || (o["x-origin"] = []);
              var _r23 = {};
              _r23.url = t.source || t.origin, _r23.format = "swagger", _r23.version = e.swagger, _r23.converter = {}, _r23.converter.url = "https://github.com/mermade/oas-kit", _r23.converter.version = b, o["x-origin"].push(_r23);
            }

            if (o = Object.assign(o, d(e)), delete o.swagger, h(o, {}, function (e, t, r) {
              null === e[t] && !t.startsWith("x-") && "default" !== t && r.path.indexOf("/example") < 0 && delete e[t];
            }), e.host) {
              var _iterator18 = _createForOfIteratorHelper(Array.isArray(e.schemes) ? e.schemes : [""]),
                  _step18;

              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var _t39 = _step18.value;

                  var _r24 = {},
                      _n25 = (e.basePath || "").replace(/\/$/, "");

                  _r24.url = (_t39 ? _t39 + ":" : "") + "//" + e.host + _n25, L(_r24), o.servers || (o.servers = []), o.servers.push(_r24);
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
            } else if (e.basePath) {
              var _t40 = {};
              _t40.url = e.basePath, L(_t40), o.servers || (o.servers = []), o.servers.push(_t40);
            }

            if (delete o.host, delete o.basePath, o["x-servers"] && Array.isArray(o["x-servers"]) && (o.servers = o["x-servers"], delete o["x-servers"]), e["x-ms-parameterized-host"]) {
              var _t41 = e["x-ms-parameterized-host"],
                  _r25 = {};
              _r25.url = _t41.hostTemplate + (e.basePath ? e.basePath : ""), _r25.variables = {};

              var _n26 = _r25.url.match(/\{\w+\}/g);

              for (var _e19 in _t41.parameters) {
                var _i11 = _t41.parameters[_e19];
                _i11.$ref && (_i11 = u(c(o, _i11.$ref))), _e19.startsWith("x-") || (delete _i11.required, delete _i11.type, delete _i11.in, void 0 === _i11.default && (_i11.enum ? _i11.default = _i11.enum[0] : _i11.default = "none"), _i11.name || (_i11.name = _n26[_e19].replace("{", "").replace("}", "")), _r25.variables[_i11.name] = _i11, delete _i11.name);
              }

              o.servers || (o.servers = []), !1 === _t41.useSchemePrefix ? o.servers.push(_r25) : e.schemes.forEach(function (e) {
                o.servers.push(Object.assign({}, _r25, {
                  url: e + "://" + _r25.url
                }));
              }), delete o["x-ms-parameterized-host"];
            }

            D(o, t, n), z(o, t, n), "string" == typeof o.consumes && (o.consumes = [o.consumes]), "string" == typeof o.produces && (o.produces = [o.produces]), o.components = {}, o["x-callbacks"] && (o.components.callbacks = o["x-callbacks"], delete o["x-callbacks"]), o.components.examples = {}, o.components.headers = {}, o["x-links"] && (o.components.links = o["x-links"], delete o["x-links"]), o.components.parameters = o.parameters || {}, o.components.responses = o.responses || {}, o.components.requestBodies = {}, o.components.securitySchemes = o.securityDefinitions || {}, o.components.schemas = o.definitions || {}, delete o.definitions, delete o.responses, delete o.parameters, delete o.securityDefinitions, m.optionalResolve(t).then(function () {
              (function (e, t) {
                var r = {};
                v = {
                  schemas: {}
                }, e.security && $(e.security);

                for (var _r26 in e.components.securitySchemes) {
                  var _n27 = g.sanitise(_r26);

                  _r26 !== _n27 && (e.components.securitySchemes[_n27] && k("Duplicate sanitised securityScheme name " + _n27, t), e.components.securitySchemes[_n27] = e.components.securitySchemes[_r26], delete e.components.securitySchemes[_r26]), R(e.components.securitySchemes[_n27], t);
                }

                for (var _r27 in e.components.schemas) {
                  var _n28 = g.sanitiseAll(_r27),
                      _o9 = "";

                  if (_r27 !== _n28) {
                    for (; e.components.schemas[_n28 + _o9];) {
                      _o9 = _o9 ? ++_o9 : 2;
                    }

                    e.components.schemas[_n28 + _o9] = e.components.schemas[_r27], delete e.components.schemas[_r27];
                  }

                  v.schemas[_r27] = _n28 + _o9, E(e.components.schemas[_n28 + _o9], t);
                }

                t.refmap = {}, h(e, {
                  payload: {
                    options: t
                  }
                }, S), function (e, t) {
                  for (var _r28 in t.refmap) {
                    l.jptr(e, _r28, {
                      $ref: t.refmap[_r28]
                    });
                  }
                }(e, t);

                for (var _r29 in e.components.parameters) {
                  var _n29 = g.sanitise(_r29);

                  _r29 !== _n29 && (e.components.parameters[_n29] && k("Duplicate sanitised parameter name " + _n29, t), e.components.parameters[_n29] = e.components.parameters[_r29], delete e.components.parameters[_r29]), P(e.components.parameters[_n29], null, null, null, _n29, e, t);
                }

                for (var _r30 in e.components.responses) {
                  var _n30 = g.sanitise(_r30);

                  _r30 !== _n30 && (e.components.responses[_n30] && k("Duplicate sanitised response name " + _n30, t), e.components.responses[_n30] = e.components.responses[_r30], delete e.components.responses[_r30]);
                  var _o10 = e.components.responses[_n30];
                  if (T(_o10, 0, null, e, t), _o10.headers) for (var _e20 in _o10.headers) {
                    "status code" === _e20.toLowerCase() ? t.patch ? (t.patches++, delete _o10.headers[_e20]) : k('(Patchable) "Status Code" is not a valid header', t) : C(_o10.headers[_e20], t);
                  }
                }

                for (var _t42 in e.components.requestBodies) {
                  var _n31 = e.components.requestBodies[_t42],
                      _o11 = JSON.stringify(_n31),
                      _i12 = g.hash(_o11),
                      _s5 = {};

                  _s5.name = _t42, _s5.body = _n31, _s5.refs = [], r[_i12] = _s5;
                }

                if (_(e.paths, "paths", t, r, e), e["x-ms-paths"] && _(e["x-ms-paths"], "x-ms-paths", t, r, e), !t.debug) for (var _t43 in e.components.parameters) {
                  e.components.parameters[_t43]["x-s2o-delete"] && delete e.components.parameters[_t43];
                }
                t.debug && (e["x-s2o-consumes"] = e.consumes || [], e["x-s2o-produces"] = e.produces || []), delete e.consumes, delete e.produces, delete e.schemes;
                var n = [];

                if (e.components.requestBodies = {}, !t.resolveInternal) {
                  var _t44 = 1;

                  for (var _o12 in r) {
                    var _i13 = r[_o12];

                    if (_i13.refs.length > 1) {
                      var _r31 = "";

                      for (_i13.name || (_i13.name = "requestBody", _r31 = _t44++); n.indexOf(_i13.name + _r31) >= 0;) {
                        _r31 = _r31 ? ++_r31 : 2;
                      }

                      _i13.name = _i13.name + _r31, n.push(_i13.name), e.components.requestBodies[_i13.name] = u(_i13.body);

                      for (var _t45 in _i13.refs) {
                        var _r32 = {};
                        _r32.$ref = "#/components/requestBodies/" + _i13.name, l.jptr(e, _i13.refs[_t45], _r32);
                      }
                    }
                  }
                }

                e.components.responses && 0 === Object.keys(e.components.responses).length && delete e.components.responses, e.components.parameters && 0 === Object.keys(e.components.parameters).length && delete e.components.parameters, e.components.examples && 0 === Object.keys(e.components.examples).length && delete e.components.examples, e.components.requestBodies && 0 === Object.keys(e.components.requestBodies).length && delete e.components.requestBodies, e.components.securitySchemes && 0 === Object.keys(e.components.securitySchemes).length && delete e.components.securitySchemes, e.components.headers && 0 === Object.keys(e.components.headers).length && delete e.components.headers, e.components.schemas && 0 === Object.keys(e.components.schemas).length && delete e.components.schemas, e.components && 0 === Object.keys(e.components).length && delete e.components;
              })(t.openapi, t), t.direct ? r(t.openapi) : r(t);
            }).catch(function (e) {
              console.warn(e), n(e);
            });
          }));
        }

        function N(e, t, r) {
          return i(r, new Promise(function (r, n) {
            var o = null,
                i = null;

            try {
              o = JSON.parse(e), t.text = JSON.stringify(o, null, 2);
            } catch (r) {
              i = r;

              try {
                o = a.parse(e, {
                  schema: "core",
                  prettyErrors: !0
                }), t.sourceYaml = !0, t.text = e;
              } catch (e) {
                i = e;
              }
            }

            o ? M(o, t).then(function (e) {
              return r(e);
            }).catch(function (e) {
              return n(e);
            }) : n(new w(i ? i.message : "Could not parse string"));
          }));
        }

        e.exports = {
          S2OError: w,
          targetVersion: x,
          convert: M,
          convertObj: M,
          convertUrl: function convertUrl(e, t, r) {
            return i(r, new Promise(function (r, n) {
              t.origin = !0, t.source || (t.source = e), t.verbose && console.warn("GET " + e), t.fetch || (t.fetch = s);
              var o = Object.assign({}, t.fetchOptions, {
                agent: t.agent
              });
              t.fetch(e, o).then(function (t) {
                if (200 !== t.status) throw new w("Received status code ".concat(t.status, ": ").concat(e));
                return t.text();
              }).then(function (e) {
                N(e, t).then(function (e) {
                  return r(e);
                }).catch(function (e) {
                  return n(e);
                });
              }).catch(function (e) {
                n(e);
              });
            }));
          },
          convertStr: N,
          convertFile: function convertFile(e, t, r) {
            return i(r, new Promise(function (r, o) {
              n.readFile(e, t.encoding || "utf8", function (n, i) {
                n ? o(n) : (t.sourceFile = e, N(i, t).then(function (e) {
                  return r(e);
                }).catch(function (e) {
                  return o(e);
                }));
              });
            }));
          },
          convertStream: function convertStream(e, t, r) {
            return i(r, new Promise(function (r, n) {
              var o = "";
              e.on("data", function (e) {
                o += e;
              }).on("end", function () {
                N(o, t).then(function (e) {
                  return r(e);
                }).catch(function (e) {
                  return n(e);
                });
              });
            }));
          }
        };
      },
      711: function _(e, t, r) {
        "use strict";

        var n = r(177);
        e.exports = {
          statusCodes: Object.assign({}, {
            default: "Default response",
            "1XX": "Informational",
            103: "Early hints",
            "2XX": "Successful",
            "3XX": "Redirection",
            "4XX": "Client Error",
            "5XX": "Server Error",
            "7XX": "Developer Error"
          }, n.STATUS_CODES)
        };
      },
      980: function _(e, t, r) {
        var n = r(314),
            o = ["add", "done", "toJS", "fromExternalJS", "load", "dispose", "search", "Worker"];

        e.exports = function () {
          var e = new Worker(URL.createObjectURL(new Blob(['/*! For license information please see 0a6ad30060afff00cb34.worker.js.LICENSE.txt */\n!function(){var e={336:function(e,t,r){var n,i;!function(){var s,o,a,u,l,c,h,d,f,p,y,m,g,x,v,w,Q,k,S,E,L,P,b,T,O,I,R=function(e){var t=new R.Builder;return t.pipeline.add(R.trimmer,R.stopWordFilter,R.stemmer),t.searchPipeline.add(R.stemmer),e.call(t,t),t.build()};R.version="2.3.9",R.utils={},R.utils.warn=(s=this,function(e){s.console&&console.warn&&console.warn(e)}),R.utils.asString=function(e){return null==e?"":e.toString()},R.utils.clone=function(e){if(null==e)return e;for(var t=Object.create(null),r=Object.keys(e),n=0;n<r.length;n++){var i=r[n],s=e[i];if(Array.isArray(s))t[i]=s.slice();else{if("string"!=typeof s&&"number"!=typeof s&&"boolean"!=typeof s)throw new TypeError("clone is not deep and does not support nested objects");t[i]=s}}return t},R.FieldRef=function(e,t,r){this.docRef=e,this.fieldName=t,this._stringValue=r},R.FieldRef.joiner="/",R.FieldRef.fromString=function(e){var t=e.indexOf(R.FieldRef.joiner);if(-1===t)throw"malformed field ref string";var r=e.slice(0,t),n=e.slice(t+1);return new R.FieldRef(n,r,e)},R.FieldRef.prototype.toString=function(){return null==this._stringValue&&(this._stringValue=this.fieldName+R.FieldRef.joiner+this.docRef),this._stringValue},R.Set=function(e){if(this.elements=Object.create(null),e){this.length=e.length;for(var t=0;t<this.length;t++)this.elements[e[t]]=!0}else this.length=0},R.Set.complete={intersect:function(e){return e},union:function(){return this},contains:function(){return!0}},R.Set.empty={intersect:function(){return this},union:function(e){return e},contains:function(){return!1}},R.Set.prototype.contains=function(e){return!!this.elements[e]},R.Set.prototype.intersect=function(e){var t,r,n,i=[];if(e===R.Set.complete)return this;if(e===R.Set.empty)return e;this.length<e.length?(t=this,r=e):(t=e,r=this),n=Object.keys(t.elements);for(var s=0;s<n.length;s++){var o=n[s];o in r.elements&&i.push(o)}return new R.Set(i)},R.Set.prototype.union=function(e){return e===R.Set.complete?R.Set.complete:e===R.Set.empty?this:new R.Set(Object.keys(this.elements).concat(Object.keys(e.elements)))},R.idf=function(e,t){var r=0;for(var n in e)"_index"!=n&&(r+=Object.keys(e[n]).length);var i=(t-r+.5)/(r+.5);return Math.log(1+Math.abs(i))},R.Token=function(e,t){this.str=e||"",this.metadata=t||{}},R.Token.prototype.toString=function(){return this.str},R.Token.prototype.update=function(e){return this.str=e(this.str,this.metadata),this},R.Token.prototype.clone=function(e){return e=e||function(e){return e},new R.Token(e(this.str,this.metadata),this.metadata)},R.tokenizer=function(e,t){if(null==e||null==e)return[];if(Array.isArray(e))return e.map((function(e){return new R.Token(R.utils.asString(e).toLowerCase(),R.utils.clone(t))}));for(var r=e.toString().toLowerCase(),n=r.length,i=[],s=0,o=0;s<=n;s++){var a=s-o;if(r.charAt(s).match(R.tokenizer.separator)||s==n){if(a>0){var u=R.utils.clone(t)||{};u.position=[o,a],u.index=i.length,i.push(new R.Token(r.slice(o,s),u))}o=s+1}}return i},R.tokenizer.separator=/[\\s\\-]+/,R.Pipeline=function(){this._stack=[]},R.Pipeline.registeredFunctions=Object.create(null),R.Pipeline.registerFunction=function(e,t){t in this.registeredFunctions&&R.utils.warn("Overwriting existing registered function: "+t),e.label=t,R.Pipeline.registeredFunctions[e.label]=e},R.Pipeline.warnIfFunctionNotRegistered=function(e){e.label&&e.label in this.registeredFunctions||R.utils.warn("Function is not registered with pipeline. This may cause problems when serialising the index.\\n",e)},R.Pipeline.load=function(e){var t=new R.Pipeline;return e.forEach((function(e){var r=R.Pipeline.registeredFunctions[e];if(!r)throw new Error("Cannot load unregistered function: "+e);t.add(r)})),t},R.Pipeline.prototype.add=function(){var e=Array.prototype.slice.call(arguments);e.forEach((function(e){R.Pipeline.warnIfFunctionNotRegistered(e),this._stack.push(e)}),this)},R.Pipeline.prototype.after=function(e,t){R.Pipeline.warnIfFunctionNotRegistered(t);var r=this._stack.indexOf(e);if(-1==r)throw new Error("Cannot find existingFn");r+=1,this._stack.splice(r,0,t)},R.Pipeline.prototype.before=function(e,t){R.Pipeline.warnIfFunctionNotRegistered(t);var r=this._stack.indexOf(e);if(-1==r)throw new Error("Cannot find existingFn");this._stack.splice(r,0,t)},R.Pipeline.prototype.remove=function(e){var t=this._stack.indexOf(e);-1!=t&&this._stack.splice(t,1)},R.Pipeline.prototype.run=function(e){for(var t=this._stack.length,r=0;r<t;r++){for(var n=this._stack[r],i=[],s=0;s<e.length;s++){var o=n(e[s],s,e);if(null!=o&&""!==o)if(Array.isArray(o))for(var a=0;a<o.length;a++)i.push(o[a]);else i.push(o)}e=i}return e},R.Pipeline.prototype.runString=function(e,t){var r=new R.Token(e,t);return this.run([r]).map((function(e){return e.toString()}))},R.Pipeline.prototype.reset=function(){this._stack=[]},R.Pipeline.prototype.toJSON=function(){return this._stack.map((function(e){return R.Pipeline.warnIfFunctionNotRegistered(e),e.label}))},R.Vector=function(e){this._magnitude=0,this.elements=e||[]},R.Vector.prototype.positionForIndex=function(e){if(0==this.elements.length)return 0;for(var t=0,r=this.elements.length/2,n=r-t,i=Math.floor(n/2),s=this.elements[2*i];n>1&&(s<e&&(t=i),s>e&&(r=i),s!=e);)n=r-t,i=t+Math.floor(n/2),s=this.elements[2*i];return s==e||s>e?2*i:s<e?2*(i+1):void 0},R.Vector.prototype.insert=function(e,t){this.upsert(e,t,(function(){throw"duplicate index"}))},R.Vector.prototype.upsert=function(e,t,r){this._magnitude=0;var n=this.positionForIndex(e);this.elements[n]==e?this.elements[n+1]=r(this.elements[n+1],t):this.elements.splice(n,0,e,t)},R.Vector.prototype.magnitude=function(){if(this._magnitude)return this._magnitude;for(var e=0,t=this.elements.length,r=1;r<t;r+=2){var n=this.elements[r];e+=n*n}return this._magnitude=Math.sqrt(e)},R.Vector.prototype.dot=function(e){for(var t=0,r=this.elements,n=e.elements,i=r.length,s=n.length,o=0,a=0,u=0,l=0;u<i&&l<s;)(o=r[u])<(a=n[l])?u+=2:o>a?l+=2:o==a&&(t+=r[u+1]*n[l+1],u+=2,l+=2);return t},R.Vector.prototype.similarity=function(e){return this.dot(e)/this.magnitude()||0},R.Vector.prototype.toArray=function(){for(var e=new Array(this.elements.length/2),t=1,r=0;t<this.elements.length;t+=2,r++)e[r]=this.elements[t];return e},R.Vector.prototype.toJSON=function(){return this.elements},R.stemmer=(o={ational:"ate",tional:"tion",enci:"ence",anci:"ance",izer:"ize",bli:"ble",alli:"al",entli:"ent",eli:"e",ousli:"ous",ization:"ize",ation:"ate",ator:"ate",alism:"al",iveness:"ive",fulness:"ful",ousness:"ous",aliti:"al",iviti:"ive",biliti:"ble",logi:"log"},a={icate:"ic",ative:"",alize:"al",iciti:"ic",ical:"ic",ful:"",ness:""},u="[aeiouy]",l="[^aeiou][^aeiouy]*",c=new RegExp("^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*"),h=new RegExp("^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*[aeiouy][aeiou]*[^aeiou][^aeiouy]*"),d=new RegExp("^([^aeiou][^aeiouy]*)?[aeiouy][aeiou]*[^aeiou][^aeiouy]*([aeiouy][aeiou]*)?$"),f=new RegExp("^([^aeiou][^aeiouy]*)?[aeiouy]"),p=/^(.+?)(ss|i)es$/,y=/^(.+?)([^s])s$/,m=/^(.+?)eed$/,g=/^(.+?)(ed|ing)$/,x=/.$/,v=/(at|bl|iz)$/,w=new RegExp("([^aeiouylsz])\\\\1$"),Q=new RegExp("^"+l+u+"[^aeiouwxy]$"),k=/^(.+?[^aeiou])y$/,S=/^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/,E=/^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/,L=/^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/,P=/^(.+?)(s|t)(ion)$/,b=/^(.+?)e$/,T=/ll$/,O=new RegExp("^"+l+u+"[^aeiouwxy]$"),I=function(e){var t,r,n,i,s,u,l;if(e.length<3)return e;if("y"==(n=e.substr(0,1))&&(e=n.toUpperCase()+e.substr(1)),s=y,(i=p).test(e)?e=e.replace(i,"$1$2"):s.test(e)&&(e=e.replace(s,"$1$2")),s=g,(i=m).test(e)){var I=i.exec(e);(i=c).test(I[1])&&(i=x,e=e.replace(i,""))}else s.test(e)&&(t=(I=s.exec(e))[1],(s=f).test(t)&&(u=w,l=Q,(s=v).test(e=t)?e+="e":u.test(e)?(i=x,e=e.replace(i,"")):l.test(e)&&(e+="e")));return(i=k).test(e)&&(e=(t=(I=i.exec(e))[1])+"i"),(i=S).test(e)&&(t=(I=i.exec(e))[1],r=I[2],(i=c).test(t)&&(e=t+o[r])),(i=E).test(e)&&(t=(I=i.exec(e))[1],r=I[2],(i=c).test(t)&&(e=t+a[r])),s=P,(i=L).test(e)?(t=(I=i.exec(e))[1],(i=h).test(t)&&(e=t)):s.test(e)&&(t=(I=s.exec(e))[1]+I[2],(s=h).test(t)&&(e=t)),(i=b).test(e)&&(t=(I=i.exec(e))[1],s=d,u=O,((i=h).test(t)||s.test(t)&&!u.test(t))&&(e=t)),s=h,(i=T).test(e)&&s.test(e)&&(i=x,e=e.replace(i,"")),"y"==n&&(e=n.toLowerCase()+e.substr(1)),e},function(e){return e.update(I)}),R.Pipeline.registerFunction(R.stemmer,"stemmer"),R.generateStopWordFilter=function(e){var t=e.reduce((function(e,t){return e[t]=t,e}),{});return function(e){if(e&&t[e.toString()]!==e.toString())return e}},R.stopWordFilter=R.generateStopWordFilter(["a","able","about","across","after","all","almost","also","am","among","an","and","any","are","as","at","be","because","been","but","by","can","cannot","could","dear","did","do","does","either","else","ever","every","for","from","get","got","had","has","have","he","her","hers","him","his","how","however","i","if","in","into","is","it","its","just","least","let","like","likely","may","me","might","most","must","my","neither","no","nor","not","of","off","often","on","only","or","other","our","own","rather","said","say","says","she","should","since","so","some","than","that","the","their","them","then","there","these","they","this","tis","to","too","twas","us","wants","was","we","were","what","when","where","which","while","who","whom","why","will","with","would","yet","you","your"]),R.Pipeline.registerFunction(R.stopWordFilter,"stopWordFilter"),R.trimmer=function(e){return e.update((function(e){return e.replace(/^\\W+/,"").replace(/\\W+$/,"")}))},R.Pipeline.registerFunction(R.trimmer,"trimmer"),R.TokenSet=function(){this.final=!1,this.edges={},this.id=R.TokenSet._nextId,R.TokenSet._nextId+=1},R.TokenSet._nextId=1,R.TokenSet.fromArray=function(e){for(var t=new R.TokenSet.Builder,r=0,n=e.length;r<n;r++)t.insert(e[r]);return t.finish(),t.root},R.TokenSet.fromClause=function(e){return"editDistance"in e?R.TokenSet.fromFuzzyString(e.term,e.editDistance):R.TokenSet.fromString(e.term)},R.TokenSet.fromFuzzyString=function(e,t){for(var r=new R.TokenSet,n=[{node:r,editsRemaining:t,str:e}];n.length;){var i=n.pop();if(i.str.length>0){var s,o=i.str.charAt(0);o in i.node.edges?s=i.node.edges[o]:(s=new R.TokenSet,i.node.edges[o]=s),1==i.str.length&&(s.final=!0),n.push({node:s,editsRemaining:i.editsRemaining,str:i.str.slice(1)})}if(0!=i.editsRemaining){if("*"in i.node.edges)var a=i.node.edges["*"];else a=new R.TokenSet,i.node.edges["*"]=a;if(0==i.str.length&&(a.final=!0),n.push({node:a,editsRemaining:i.editsRemaining-1,str:i.str}),i.str.length>1&&n.push({node:i.node,editsRemaining:i.editsRemaining-1,str:i.str.slice(1)}),1==i.str.length&&(i.node.final=!0),i.str.length>=1){if("*"in i.node.edges)var u=i.node.edges["*"];else u=new R.TokenSet,i.node.edges["*"]=u;1==i.str.length&&(u.final=!0),n.push({node:u,editsRemaining:i.editsRemaining-1,str:i.str.slice(1)})}if(i.str.length>1){var l,c=i.str.charAt(0),h=i.str.charAt(1);h in i.node.edges?l=i.node.edges[h]:(l=new R.TokenSet,i.node.edges[h]=l),1==i.str.length&&(l.final=!0),n.push({node:l,editsRemaining:i.editsRemaining-1,str:c+i.str.slice(2)})}}}return r},R.TokenSet.fromString=function(e){for(var t=new R.TokenSet,r=t,n=0,i=e.length;n<i;n++){var s=e[n],o=n==i-1;if("*"==s)t.edges[s]=t,t.final=o;else{var a=new R.TokenSet;a.final=o,t.edges[s]=a,t=a}}return r},R.TokenSet.prototype.toArray=function(){for(var e=[],t=[{prefix:"",node:this}];t.length;){var r=t.pop(),n=Object.keys(r.node.edges),i=n.length;r.node.final&&(r.prefix.charAt(0),e.push(r.prefix));for(var s=0;s<i;s++){var o=n[s];t.push({prefix:r.prefix.concat(o),node:r.node.edges[o]})}}return e},R.TokenSet.prototype.toString=function(){if(this._str)return this._str;for(var e=this.final?"1":"0",t=Object.keys(this.edges).sort(),r=t.length,n=0;n<r;n++){var i=t[n];e=e+i+this.edges[i].id}return e},R.TokenSet.prototype.intersect=function(e){for(var t=new R.TokenSet,r=void 0,n=[{qNode:e,output:t,node:this}];n.length;){r=n.pop();for(var i=Object.keys(r.qNode.edges),s=i.length,o=Object.keys(r.node.edges),a=o.length,u=0;u<s;u++)for(var l=i[u],c=0;c<a;c++){var h=o[c];if(h==l||"*"==l){var d=r.node.edges[h],f=r.qNode.edges[l],p=d.final&&f.final,y=void 0;h in r.output.edges?(y=r.output.edges[h]).final=y.final||p:((y=new R.TokenSet).final=p,r.output.edges[h]=y),n.push({qNode:f,output:y,node:d})}}}return t},R.TokenSet.Builder=function(){this.previousWord="",this.root=new R.TokenSet,this.uncheckedNodes=[],this.minimizedNodes={}},R.TokenSet.Builder.prototype.insert=function(e){var t,r=0;if(e<this.previousWord)throw new Error("Out of order word insertion");for(var n=0;n<e.length&&n<this.previousWord.length&&e[n]==this.previousWord[n];n++)r++;for(this.minimize(r),t=0==this.uncheckedNodes.length?this.root:this.uncheckedNodes[this.uncheckedNodes.length-1].child,n=r;n<e.length;n++){var i=new R.TokenSet,s=e[n];t.edges[s]=i,this.uncheckedNodes.push({parent:t,char:s,child:i}),t=i}t.final=!0,this.previousWord=e},R.TokenSet.Builder.prototype.finish=function(){this.minimize(0)},R.TokenSet.Builder.prototype.minimize=function(e){for(var t=this.uncheckedNodes.length-1;t>=e;t--){var r=this.uncheckedNodes[t],n=r.child.toString();n in this.minimizedNodes?r.parent.edges[r.char]=this.minimizedNodes[n]:(r.child._str=n,this.minimizedNodes[n]=r.child),this.uncheckedNodes.pop()}},R.Index=function(e){this.invertedIndex=e.invertedIndex,this.fieldVectors=e.fieldVectors,this.tokenSet=e.tokenSet,this.fields=e.fields,this.pipeline=e.pipeline},R.Index.prototype.search=function(e){return this.query((function(t){new R.QueryParser(e,t).parse()}))},R.Index.prototype.query=function(e){for(var t=new R.Query(this.fields),r=Object.create(null),n=Object.create(null),i=Object.create(null),s=Object.create(null),o=Object.create(null),a=0;a<this.fields.length;a++)n[this.fields[a]]=new R.Vector;for(e.call(t,t),a=0;a<t.clauses.length;a++){var u,l=t.clauses[a],c=R.Set.empty;u=l.usePipeline?this.pipeline.runString(l.term,{fields:l.fields}):[l.term];for(var h=0;h<u.length;h++){var d=u[h];l.term=d;var f=R.TokenSet.fromClause(l),p=this.tokenSet.intersect(f).toArray();if(0===p.length&&l.presence===R.Query.presence.REQUIRED){for(var y=0;y<l.fields.length;y++)s[F=l.fields[y]]=R.Set.empty;break}for(var m=0;m<p.length;m++){var g=p[m],x=this.invertedIndex[g],v=x._index;for(y=0;y<l.fields.length;y++){var w=x[F=l.fields[y]],Q=Object.keys(w),k=g+"/"+F,S=new R.Set(Q);if(l.presence==R.Query.presence.REQUIRED&&(c=c.union(S),void 0===s[F]&&(s[F]=R.Set.complete)),l.presence!=R.Query.presence.PROHIBITED){if(n[F].upsert(v,l.boost,(function(e,t){return e+t})),!i[k]){for(var E=0;E<Q.length;E++){var L,P=Q[E],b=new R.FieldRef(P,F),T=w[P];void 0===(L=r[b])?r[b]=new R.MatchData(g,F,T):L.add(g,F,T)}i[k]=!0}}else void 0===o[F]&&(o[F]=R.Set.empty),o[F]=o[F].union(S)}}}if(l.presence===R.Query.presence.REQUIRED)for(y=0;y<l.fields.length;y++)s[F=l.fields[y]]=s[F].intersect(c)}var O=R.Set.complete,I=R.Set.empty;for(a=0;a<this.fields.length;a++){var F;s[F=this.fields[a]]&&(O=O.intersect(s[F])),o[F]&&(I=I.union(o[F]))}var C=Object.keys(r),N=[],j=Object.create(null);if(t.isNegated())for(C=Object.keys(this.fieldVectors),a=0;a<C.length;a++){b=C[a];var _=R.FieldRef.fromString(b);r[b]=new R.MatchData}for(a=0;a<C.length;a++){var D=(_=R.FieldRef.fromString(C[a])).docRef;if(O.contains(D)&&!I.contains(D)){var A,B=this.fieldVectors[_],z=n[_.fieldName].similarity(B);if(void 0!==(A=j[D]))A.score+=z,A.matchData.combine(r[_]);else{var V={ref:D,score:z,matchData:r[_]};j[D]=V,N.push(V)}}}return N.sort((function(e,t){return t.score-e.score}))},R.Index.prototype.toJSON=function(){var e=Object.keys(this.invertedIndex).sort().map((function(e){return[e,this.invertedIndex[e]]}),this),t=Object.keys(this.fieldVectors).map((function(e){return[e,this.fieldVectors[e].toJSON()]}),this);return{version:R.version,fields:this.fields,fieldVectors:t,invertedIndex:e,pipeline:this.pipeline.toJSON()}},R.Index.load=function(e){var t={},r={},n=e.fieldVectors,i=Object.create(null),s=e.invertedIndex,o=new R.TokenSet.Builder,a=R.Pipeline.load(e.pipeline);e.version!=R.version&&R.utils.warn("Version mismatch when loading serialised index. Current version of lunr \'"+R.version+"\' does not match serialized index \'"+e.version+"\'");for(var u=0;u<n.length;u++){var l=(h=n[u])[0],c=h[1];r[l]=new R.Vector(c)}for(u=0;u<s.length;u++){var h,d=(h=s[u])[0],f=h[1];o.insert(d),i[d]=f}return o.finish(),t.fields=e.fields,t.fieldVectors=r,t.invertedIndex=i,t.tokenSet=o.root,t.pipeline=a,new R.Index(t)},R.Builder=function(){this._ref="id",this._fields=Object.create(null),this._documents=Object.create(null),this.invertedIndex=Object.create(null),this.fieldTermFrequencies={},this.fieldLengths={},this.tokenizer=R.tokenizer,this.pipeline=new R.Pipeline,this.searchPipeline=new R.Pipeline,this.documentCount=0,this._b=.75,this._k1=1.2,this.termIndex=0,this.metadataWhitelist=[]},R.Builder.prototype.ref=function(e){this._ref=e},R.Builder.prototype.field=function(e,t){if(/\\//.test(e))throw new RangeError("Field \'"+e+"\' contains illegal character \'/\'");this._fields[e]=t||{}},R.Builder.prototype.b=function(e){this._b=e<0?0:e>1?1:e},R.Builder.prototype.k1=function(e){this._k1=e},R.Builder.prototype.add=function(e,t){var r=e[this._ref],n=Object.keys(this._fields);this._documents[r]=t||{},this.documentCount+=1;for(var i=0;i<n.length;i++){var s=n[i],o=this._fields[s].extractor,a=o?o(e):e[s],u=this.tokenizer(a,{fields:[s]}),l=this.pipeline.run(u),c=new R.FieldRef(r,s),h=Object.create(null);this.fieldTermFrequencies[c]=h,this.fieldLengths[c]=0,this.fieldLengths[c]+=l.length;for(var d=0;d<l.length;d++){var f=l[d];if(null==h[f]&&(h[f]=0),h[f]+=1,null==this.invertedIndex[f]){var p=Object.create(null);p._index=this.termIndex,this.termIndex+=1;for(var y=0;y<n.length;y++)p[n[y]]=Object.create(null);this.invertedIndex[f]=p}null==this.invertedIndex[f][s][r]&&(this.invertedIndex[f][s][r]=Object.create(null));for(var m=0;m<this.metadataWhitelist.length;m++){var g=this.metadataWhitelist[m],x=f.metadata[g];null==this.invertedIndex[f][s][r][g]&&(this.invertedIndex[f][s][r][g]=[]),this.invertedIndex[f][s][r][g].push(x)}}}},R.Builder.prototype.calculateAverageFieldLengths=function(){for(var e=Object.keys(this.fieldLengths),t=e.length,r={},n={},i=0;i<t;i++){var s=R.FieldRef.fromString(e[i]),o=s.fieldName;n[o]||(n[o]=0),n[o]+=1,r[o]||(r[o]=0),r[o]+=this.fieldLengths[s]}var a=Object.keys(this._fields);for(i=0;i<a.length;i++){var u=a[i];r[u]=r[u]/n[u]}this.averageFieldLength=r},R.Builder.prototype.createFieldVectors=function(){for(var e={},t=Object.keys(this.fieldTermFrequencies),r=t.length,n=Object.create(null),i=0;i<r;i++){for(var s=R.FieldRef.fromString(t[i]),o=s.fieldName,a=this.fieldLengths[s],u=new R.Vector,l=this.fieldTermFrequencies[s],c=Object.keys(l),h=c.length,d=this._fields[o].boost||1,f=this._documents[s.docRef].boost||1,p=0;p<h;p++){var y,m,g,x=c[p],v=l[x],w=this.invertedIndex[x]._index;void 0===n[x]?(y=R.idf(this.invertedIndex[x],this.documentCount),n[x]=y):y=n[x],m=y*((this._k1+1)*v)/(this._k1*(1-this._b+this._b*(a/this.averageFieldLength[o]))+v),m*=d,m*=f,g=Math.round(1e3*m)/1e3,u.insert(w,g)}e[s]=u}this.fieldVectors=e},R.Builder.prototype.createTokenSet=function(){this.tokenSet=R.TokenSet.fromArray(Object.keys(this.invertedIndex).sort())},R.Builder.prototype.build=function(){return this.calculateAverageFieldLengths(),this.createFieldVectors(),this.createTokenSet(),new R.Index({invertedIndex:this.invertedIndex,fieldVectors:this.fieldVectors,tokenSet:this.tokenSet,fields:Object.keys(this._fields),pipeline:this.searchPipeline})},R.Builder.prototype.use=function(e){var t=Array.prototype.slice.call(arguments,1);t.unshift(this),e.apply(this,t)},R.MatchData=function(e,t,r){for(var n=Object.create(null),i=Object.keys(r||{}),s=0;s<i.length;s++){var o=i[s];n[o]=r[o].slice()}this.metadata=Object.create(null),void 0!==e&&(this.metadata[e]=Object.create(null),this.metadata[e][t]=n)},R.MatchData.prototype.combine=function(e){for(var t=Object.keys(e.metadata),r=0;r<t.length;r++){var n=t[r],i=Object.keys(e.metadata[n]);null==this.metadata[n]&&(this.metadata[n]=Object.create(null));for(var s=0;s<i.length;s++){var o=i[s],a=Object.keys(e.metadata[n][o]);null==this.metadata[n][o]&&(this.metadata[n][o]=Object.create(null));for(var u=0;u<a.length;u++){var l=a[u];null==this.metadata[n][o][l]?this.metadata[n][o][l]=e.metadata[n][o][l]:this.metadata[n][o][l]=this.metadata[n][o][l].concat(e.metadata[n][o][l])}}}},R.MatchData.prototype.add=function(e,t,r){if(!(e in this.metadata))return this.metadata[e]=Object.create(null),void(this.metadata[e][t]=r);if(t in this.metadata[e])for(var n=Object.keys(r),i=0;i<n.length;i++){var s=n[i];s in this.metadata[e][t]?this.metadata[e][t][s]=this.metadata[e][t][s].concat(r[s]):this.metadata[e][t][s]=r[s]}else this.metadata[e][t]=r},R.Query=function(e){this.clauses=[],this.allFields=e},R.Query.wildcard=new String("*"),R.Query.wildcard.NONE=0,R.Query.wildcard.LEADING=1,R.Query.wildcard.TRAILING=2,R.Query.presence={OPTIONAL:1,REQUIRED:2,PROHIBITED:3},R.Query.prototype.clause=function(e){return"fields"in e||(e.fields=this.allFields),"boost"in e||(e.boost=1),"usePipeline"in e||(e.usePipeline=!0),"wildcard"in e||(e.wildcard=R.Query.wildcard.NONE),e.wildcard&R.Query.wildcard.LEADING&&e.term.charAt(0)!=R.Query.wildcard&&(e.term="*"+e.term),e.wildcard&R.Query.wildcard.TRAILING&&e.term.slice(-1)!=R.Query.wildcard&&(e.term=e.term+"*"),"presence"in e||(e.presence=R.Query.presence.OPTIONAL),this.clauses.push(e),this},R.Query.prototype.isNegated=function(){for(var e=0;e<this.clauses.length;e++)if(this.clauses[e].presence!=R.Query.presence.PROHIBITED)return!1;return!0},R.Query.prototype.term=function(e,t){if(Array.isArray(e))return e.forEach((function(e){this.term(e,R.utils.clone(t))}),this),this;var r=t||{};return r.term=e.toString(),this.clause(r),this},R.QueryParseError=function(e,t,r){this.name="QueryParseError",this.message=e,this.start=t,this.end=r},R.QueryParseError.prototype=new Error,R.QueryLexer=function(e){this.lexemes=[],this.str=e,this.length=e.length,this.pos=0,this.start=0,this.escapeCharPositions=[]},R.QueryLexer.prototype.run=function(){for(var e=R.QueryLexer.lexText;e;)e=e(this)},R.QueryLexer.prototype.sliceString=function(){for(var e=[],t=this.start,r=this.pos,n=0;n<this.escapeCharPositions.length;n++)r=this.escapeCharPositions[n],e.push(this.str.slice(t,r)),t=r+1;return e.push(this.str.slice(t,this.pos)),this.escapeCharPositions.length=0,e.join("")},R.QueryLexer.prototype.emit=function(e){this.lexemes.push({type:e,str:this.sliceString(),start:this.start,end:this.pos}),this.start=this.pos},R.QueryLexer.prototype.escapeCharacter=function(){this.escapeCharPositions.push(this.pos-1),this.pos+=1},R.QueryLexer.prototype.next=function(){if(this.pos>=this.length)return R.QueryLexer.EOS;var e=this.str.charAt(this.pos);return this.pos+=1,e},R.QueryLexer.prototype.width=function(){return this.pos-this.start},R.QueryLexer.prototype.ignore=function(){this.start==this.pos&&(this.pos+=1),this.start=this.pos},R.QueryLexer.prototype.backup=function(){this.pos-=1},R.QueryLexer.prototype.acceptDigitRun=function(){var e,t;do{t=(e=this.next()).charCodeAt(0)}while(t>47&&t<58);e!=R.QueryLexer.EOS&&this.backup()},R.QueryLexer.prototype.more=function(){return this.pos<this.length},R.QueryLexer.EOS="EOS",R.QueryLexer.FIELD="FIELD",R.QueryLexer.TERM="TERM",R.QueryLexer.EDIT_DISTANCE="EDIT_DISTANCE",R.QueryLexer.BOOST="BOOST",R.QueryLexer.PRESENCE="PRESENCE",R.QueryLexer.lexField=function(e){return e.backup(),e.emit(R.QueryLexer.FIELD),e.ignore(),R.QueryLexer.lexText},R.QueryLexer.lexTerm=function(e){if(e.width()>1&&(e.backup(),e.emit(R.QueryLexer.TERM)),e.ignore(),e.more())return R.QueryLexer.lexText},R.QueryLexer.lexEditDistance=function(e){return e.ignore(),e.acceptDigitRun(),e.emit(R.QueryLexer.EDIT_DISTANCE),R.QueryLexer.lexText},R.QueryLexer.lexBoost=function(e){return e.ignore(),e.acceptDigitRun(),e.emit(R.QueryLexer.BOOST),R.QueryLexer.lexText},R.QueryLexer.lexEOS=function(e){e.width()>0&&e.emit(R.QueryLexer.TERM)},R.QueryLexer.termSeparator=R.tokenizer.separator,R.QueryLexer.lexText=function(e){for(;;){var t=e.next();if(t==R.QueryLexer.EOS)return R.QueryLexer.lexEOS;if(92!=t.charCodeAt(0)){if(":"==t)return R.QueryLexer.lexField;if("~"==t)return e.backup(),e.width()>0&&e.emit(R.QueryLexer.TERM),R.QueryLexer.lexEditDistance;if("^"==t)return e.backup(),e.width()>0&&e.emit(R.QueryLexer.TERM),R.QueryLexer.lexBoost;if("+"==t&&1===e.width())return e.emit(R.QueryLexer.PRESENCE),R.QueryLexer.lexText;if("-"==t&&1===e.width())return e.emit(R.QueryLexer.PRESENCE),R.QueryLexer.lexText;if(t.match(R.QueryLexer.termSeparator))return R.QueryLexer.lexTerm}else e.escapeCharacter()}},R.QueryParser=function(e,t){this.lexer=new R.QueryLexer(e),this.query=t,this.currentClause={},this.lexemeIdx=0},R.QueryParser.prototype.parse=function(){this.lexer.run(),this.lexemes=this.lexer.lexemes;for(var e=R.QueryParser.parseClause;e;)e=e(this);return this.query},R.QueryParser.prototype.peekLexeme=function(){return this.lexemes[this.lexemeIdx]},R.QueryParser.prototype.consumeLexeme=function(){var e=this.peekLexeme();return this.lexemeIdx+=1,e},R.QueryParser.prototype.nextClause=function(){var e=this.currentClause;this.query.clause(e),this.currentClause={}},R.QueryParser.parseClause=function(e){var t=e.peekLexeme();if(null!=t)switch(t.type){case R.QueryLexer.PRESENCE:return R.QueryParser.parsePresence;case R.QueryLexer.FIELD:return R.QueryParser.parseField;case R.QueryLexer.TERM:return R.QueryParser.parseTerm;default:var r="expected either a field or a term, found "+t.type;throw t.str.length>=1&&(r+=" with value \'"+t.str+"\'"),new R.QueryParseError(r,t.start,t.end)}},R.QueryParser.parsePresence=function(e){var t=e.consumeLexeme();if(null!=t){switch(t.str){case"-":e.currentClause.presence=R.Query.presence.PROHIBITED;break;case"+":e.currentClause.presence=R.Query.presence.REQUIRED;break;default:var r="unrecognised presence operator\'"+t.str+"\'";throw new R.QueryParseError(r,t.start,t.end)}var n=e.peekLexeme();if(null==n)throw r="expecting term or field, found nothing",new R.QueryParseError(r,t.start,t.end);switch(n.type){case R.QueryLexer.FIELD:return R.QueryParser.parseField;case R.QueryLexer.TERM:return R.QueryParser.parseTerm;default:throw r="expecting term or field, found \'"+n.type+"\'",new R.QueryParseError(r,n.start,n.end)}}},R.QueryParser.parseField=function(e){var t=e.consumeLexeme();if(null!=t){if(-1==e.query.allFields.indexOf(t.str)){var r=e.query.allFields.map((function(e){return"\'"+e+"\'"})).join(", "),n="unrecognised field \'"+t.str+"\', possible fields: "+r;throw new R.QueryParseError(n,t.start,t.end)}e.currentClause.fields=[t.str];var i=e.peekLexeme();if(null==i)throw n="expecting term, found nothing",new R.QueryParseError(n,t.start,t.end);if(i.type===R.QueryLexer.TERM)return R.QueryParser.parseTerm;throw n="expecting term, found \'"+i.type+"\'",new R.QueryParseError(n,i.start,i.end)}},R.QueryParser.parseTerm=function(e){var t=e.consumeLexeme();if(null!=t){e.currentClause.term=t.str.toLowerCase(),-1!=t.str.indexOf("*")&&(e.currentClause.usePipeline=!1);var r=e.peekLexeme();if(null!=r)switch(r.type){case R.QueryLexer.TERM:return e.nextClause(),R.QueryParser.parseTerm;case R.QueryLexer.FIELD:return e.nextClause(),R.QueryParser.parseField;case R.QueryLexer.EDIT_DISTANCE:return R.QueryParser.parseEditDistance;case R.QueryLexer.BOOST:return R.QueryParser.parseBoost;case R.QueryLexer.PRESENCE:return e.nextClause(),R.QueryParser.parsePresence;default:var n="Unexpected lexeme type \'"+r.type+"\'";throw new R.QueryParseError(n,r.start,r.end)}else e.nextClause()}},R.QueryParser.parseEditDistance=function(e){var t=e.consumeLexeme();if(null!=t){var r=parseInt(t.str,10);if(isNaN(r)){var n="edit distance must be numeric";throw new R.QueryParseError(n,t.start,t.end)}e.currentClause.editDistance=r;var i=e.peekLexeme();if(null!=i)switch(i.type){case R.QueryLexer.TERM:return e.nextClause(),R.QueryParser.parseTerm;case R.QueryLexer.FIELD:return e.nextClause(),R.QueryParser.parseField;case R.QueryLexer.EDIT_DISTANCE:return R.QueryParser.parseEditDistance;case R.QueryLexer.BOOST:return R.QueryParser.parseBoost;case R.QueryLexer.PRESENCE:return e.nextClause(),R.QueryParser.parsePresence;default:throw n="Unexpected lexeme type \'"+i.type+"\'",new R.QueryParseError(n,i.start,i.end)}else e.nextClause()}},R.QueryParser.parseBoost=function(e){var t=e.consumeLexeme();if(null!=t){var r=parseInt(t.str,10);if(isNaN(r)){var n="boost must be numeric";throw new R.QueryParseError(n,t.start,t.end)}e.currentClause.boost=r;var i=e.peekLexeme();if(null!=i)switch(i.type){case R.QueryLexer.TERM:return e.nextClause(),R.QueryParser.parseTerm;case R.QueryLexer.FIELD:return e.nextClause(),R.QueryParser.parseField;case R.QueryLexer.EDIT_DISTANCE:return R.QueryParser.parseEditDistance;case R.QueryLexer.BOOST:return R.QueryParser.parseBoost;case R.QueryLexer.PRESENCE:return e.nextClause(),R.QueryParser.parsePresence;default:throw n="Unexpected lexeme type \'"+i.type+"\'",new R.QueryParseError(n,i.start,i.end)}else e.nextClause()}},void 0===(i="function"==typeof(n=function(){return R})?n.call(t,r,t,e):n)||(e.exports=i)}()}},t={};function r(n){var i=t[n];if(void 0!==i)return i.exports;var s=t[n]={exports:{}};return e[n](s,s.exports,r),s.exports}r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,{a:t}),t},r.d=function(e,t){for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)};var n={};!function(){"use strict";r.d(n,{add:function(){return l},dispose:function(){return p},done:function(){return c},fromExternalJS:function(){return d},load:function(){return f},search:function(){return y},toJS:function(){return h}});var e=r(336),t=(e,t,r)=>new Promise(((n,i)=>{var s=e=>{try{a(r.next(e))}catch(e){i(e)}},o=e=>{try{a(r.throw(e))}catch(e){i(e)}},a=e=>e.done?n(e.value):Promise.resolve(e.value).then(s,o);a((r=r.apply(e,t)).next())}));let i,s,o,a=[];function u(){i=new e.Builder,i.field("title"),i.field("description"),i.ref("ref"),i.pipeline.add(e.trimmer,e.stopWordFilter,e.stemmer),o=new Promise((e=>{s=e}))}function l(e,t,r){const n=a.push(r)-1,s={title:e.toLowerCase(),description:t.toLowerCase(),ref:n};i.add(s)}function c(){return t(this,null,(function*(){s(i.build())}))}function h(){return t(this,null,(function*(){return{store:a,index:(yield o).toJSON()}}))}function d(e,r){return t(this,null,(function*(){try{if(importScripts(e),!self[r])throw new Error("Broken index file format");f(self[r])}catch(e){console.error("Failed to load search index: "+e.message)}}))}function f(r){return t(this,null,(function*(){a=r.store,s(e.Index.load(r.index))}))}function p(){return t(this,null,(function*(){a=[],u()}))}function y(r,n=0){return t(this,null,(function*(){if(0===r.trim().length)return[];let t=(yield o).query((t=>{r.trim().toLowerCase().split(/\\s+/).forEach((r=>{if(1===r.length)return;const n=(t=>{const r=e.trimmer(new e.Token(t,{}));return"*"+e.stemmer(r)+"*"})(r);t.term(n,{})}))}));return n>0&&(t=t.slice(0,n)),t.map((e=>({meta:a[e.ref],score:e.score})))}))}e.tokenizer.separator=/\\s+/,u(),addEventListener("message",(function(e){var t,r=e.data,i=r.type,s=r.method,o=r.id,a=r.params;"RPC"===i&&s&&((t=n[s])?Promise.resolve().then((function(){return t.apply(n,a)})):Promise.reject("No such method")).then((function(e){postMessage({type:"RPC",id:o,result:e})})).catch((function(e){var t={message:e};e.stack&&(t.message=e.message,t.stack=e.stack,t.name=e.name),postMessage({type:"RPC",id:o,error:t})}))})),postMessage({type:"RPC",method:"ready"})}()}();\n//# sourceMappingURL=0a6ad30060afff00cb34.worker.js.map'])), {
            name: "[fullhash].worker.js"
          });
          return n(e, o), e;
        };
      },
      314: function _(e) {
        e.exports = function (e, t) {
          var r = 0,
              n = {};
          e.addEventListener("message", function (t) {
            var r = t.data;
            if ("RPC" === r.type) if (r.id) {
              var o = n[r.id];
              o && (delete n[r.id], r.error ? o[1](Object.assign(Error(r.error.message), r.error)) : o[0](r.result));
            } else {
              var i = document.createEvent("Event");
              i.initEvent(r.method, !1, !1), i.data = r.params, e.dispatchEvent(i);
            }
          }), t.forEach(function (t) {
            e[t] = function () {
              var o = arguments;
              return new Promise(function (i, s) {
                var a = ++r;
                n[a] = [i, s], e.postMessage({
                  type: "RPC",
                  id: a,
                  method: t,
                  params: [].slice.call(o)
                });
              });
            };
          });
        };
      },
      766: function _(e) {
        "use strict";

        e.exports = require("call-me-maybe");
      },
      376: function _(e) {
        "use strict";

        e.exports = require("fast-safe-stringify");
      },
      322: function _(e) {
        "use strict";

        e.exports = require("stickyfill");
      },
      66: function _(e) {
        "use strict";

        e.exports = require("yaml");
      },
      416: function _(e) {
        "use strict";

        e.exports = void 0;
      },
      177: function _() {},
      109: function _(e) {
        "use strict";

        e.exports = {
          i8: "7.0.6"
        };
      }
    },
        t = {};

    function r(n) {
      var o = t[n];
      if (void 0 !== o) return o.exports;
      var i = t[n] = {
        id: n,
        exports: {}
      };
      return e[n](i, i.exports, r), i.exports;
    }

    r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var n in t) {
        r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, r.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.nc = void 0;
    var n = {};
    return function () {
      "use strict";

      var _allowedMdComponents;

      r.r(n), r.d(n, {
        AUTH_TYPES: function AUTH_TYPES() {
          return Xl;
        },
        ApiContentWrap: function ApiContentWrap() {
          return Bu;
        },
        ApiInfo: function ApiInfo() {
          return cc;
        },
        ApiInfoModel: function ApiInfoModel() {
          return Ur;
        },
        ApiLogo: function ApiLogo() {
          return hc;
        },
        AppStore: function AppStore() {
          return rc;
        },
        ArraySchema: function ArraySchema() {
          return il;
        },
        BackgroundStub: function BackgroundStub() {
          return Qu;
        },
        BodyContent: function BodyContent() {
          return tp;
        },
        COMPONENT_REGEXP: function COMPONENT_REGEXP() {
          return Fr;
        },
        CallbackModel: function CallbackModel() {
          return pn;
        },
        ClipboardService: function ClipboardService() {
          return Ls;
        },
        ContentItem: function ContentItem() {
          return du;
        },
        ContentItems: function ContentItems() {
          return uu;
        },
        DiscriminatorDropdown: function DiscriminatorDropdown() {
          return Ha;
        },
        Dropdown: function Dropdown() {
          return ls;
        },
        DropdownLabel: function DropdownLabel() {
          return Ks;
        },
        DropdownOrLabel: function DropdownOrLabel() {
          return gs;
        },
        DropdownWrapper: function DropdownWrapper() {
          return ea;
        },
        ErrorBoundary: function ErrorBoundary() {
          return ne;
        },
        Example: function Example() {
          return Zs;
        },
        ExampleModel: function ExampleModel() {
          return Fn;
        },
        ExternalExample: function ExternalExample() {
          return Gs;
        },
        FieldModel: function FieldModel() {
          return Wn;
        },
        GROUP_DEPTH: function GROUP_DEPTH() {
          return Ho;
        },
        GroupModel: function GroupModel() {
          return zo;
        },
        HistoryService: function HistoryService() {
          return Bt;
        },
        IS_BROWSER: function IS_BROWSER() {
          return s;
        },
        InvertedSimpleDropdown: function InvertedSimpleDropdown() {
          return ta;
        },
        JsonPointer: function JsonPointer() {
          return ke;
        },
        JsonViewer: function JsonViewer() {
          return Vs;
        },
        LEGACY_REGEXP: function LEGACY_REGEXP() {
          return Mr;
        },
        Loading: function Loading() {
          return ae;
        },
        MDX_COMPONENT_REGEXP: function MDX_COMPONENT_REGEXP() {
          return Nr;
        },
        Markdown: function Markdown() {
          return Rs;
        },
        MarkdownRenderer: function MarkdownRenderer() {
          return Br;
        },
        MarkerService: function MarkerService() {
          return Wt;
        },
        MediaContentModel: function MediaContentModel() {
          return Gn;
        },
        MediaTypeModel: function MediaTypeModel() {
          return Hn;
        },
        MediaTypesSwitch: function MediaTypesSwitch() {
          return Vc;
        },
        MenuBuilder: function MenuBuilder() {
          return Jo;
        },
        MenuItem: function MenuItem() {
          return Ou;
        },
        MenuItemLabel: function MenuItemLabel() {
          return jc;
        },
        MenuItemLi: function MenuItemLi() {
          return $c;
        },
        MenuItemTitle: function MenuItemTitle() {
          return Cc;
        },
        MenuItemUl: function MenuItemUl() {
          return Sc;
        },
        MenuItems: function MenuItems() {
          return Au;
        },
        MenuStore: function MenuStore() {
          return Ko;
        },
        MiddlePanel: function MiddlePanel() {
          return ii;
        },
        MimeLabel: function MimeLabel() {
          return Xs;
        },
        NoSampleLabel: function NoSampleLabel() {
          return ra;
        },
        OLD_SECURITY_DEFINITIONS_JSX_NAME: function OLD_SECURITY_DEFINITIONS_JSX_NAME() {
          return dt;
        },
        ObjectSchema: function ObjectSchema() {
          return Ja;
        },
        OneOfButton: function OneOfButton() {
          return fl;
        },
        OneOfSchema: function OneOfSchema() {
          return gl;
        },
        OpenAPIParser: function OpenAPIParser() {
          return On;
        },
        Operation: function Operation() {
          return nu;
        },
        OperationBadge: function OperationBadge() {
          return Oc;
        },
        OperationItem: function OperationItem() {
          return fu;
        },
        OperationMenuItemContent: function OperationMenuItemContent() {
          return Eu;
        },
        OperationModel: function OperationModel() {
          return fo;
        },
        OptionsConsumer: function OptionsConsumer() {
          return ue;
        },
        OptionsContext: function OptionsContext() {
          return ce;
        },
        OptionsProvider: function OptionsProvider() {
          return pe;
        },
        Parameters: function Parameters() {
          return Kc;
        },
        PayloadSamples: function PayloadSamples() {
          return Lp;
        },
        Redoc: function Redoc() {
          return Xu;
        },
        RedocAttribution: function RedocAttribution() {
          return Ac;
        },
        RedocNormalizedOptions: function RedocNormalizedOptions() {
          return W;
        },
        RedocStandalone: function RedocStandalone() {
          return Ku;
        },
        RedocWrap: function RedocWrap() {
          return qu;
        },
        RequestBodyModel: function RequestBodyModel() {
          return Xn;
        },
        ResponseDetails: function ResponseDetails() {
          return hp;
        },
        ResponseHeaders: function ResponseHeaders() {
          return ap;
        },
        ResponseModel: function ResponseModel() {
          return lo;
        },
        ResponseSamples: function ResponseSamples() {
          return Jp;
        },
        ResponseTitle: function ResponseTitle() {
          return rp;
        },
        ResponseView: function ResponseView() {
          return mp;
        },
        ResponsesList: function ResponsesList() {
          return gp;
        },
        RightPanel: function RightPanel() {
          return ai;
        },
        Row: function Row() {
          return ci;
        },
        SCHEMA_DEFINITION_JSX_NAME: function SCHEMA_DEFINITION_JSX_NAME() {
          return ht;
        },
        SECTION_ATTR: function SECTION_ATTR() {
          return Xo;
        },
        SECURITY_DEFINITIONS_JSX_NAME: function SECURITY_DEFINITIONS_JSX_NAME() {
          return ut;
        },
        SECURITY_SCHEMES_SECTION_PREFIX: function SECURITY_SCHEMES_SECTION_PREFIX() {
          return mt;
        },
        Schema: function Schema() {
          return Rl;
        },
        SchemaDefinition: function SchemaDefinition() {
          return Ll;
        },
        SchemaModel: function SchemaModel() {
          return Dn;
        },
        ScrollService: function ScrollService() {
          return ni;
        },
        SearchBox: function SearchBox() {
          return Gu;
        },
        SearchStore: function SearchStore() {
          return oi;
        },
        Section: function Section() {
          return si;
        },
        SectionItem: function SectionItem() {
          return mu;
        },
        SecurityDefs: function SecurityDefs() {
          return Kl;
        },
        SecuritySchemeModel: function SecuritySchemeModel() {
          return So;
        },
        SecuritySchemesModel: function SecuritySchemesModel() {
          return $o;
        },
        SideMenu: function SideMenu() {
          return Iu;
        },
        SideNavStyleEnum: function SideNavStyleEnum() {
          return _;
        },
        SimpleDropdown: function SimpleDropdown() {
          return cs;
        },
        SourceCode: function SourceCode() {
          return Hs;
        },
        SourceCodeWithCopy: function SourceCodeWithCopy() {
          return Js;
        },
        SpecStore: function SpecStore() {
          return To;
        },
        StickyResponsiveSidebar: function StickyResponsiveSidebar() {
          return Fu;
        },
        StoreBuilder: function StoreBuilder() {
          return xi;
        },
        StoreConsumer: function StoreConsumer() {
          return bi;
        },
        StoreContext: function StoreContext() {
          return gi;
        },
        StoreProvider: function StoreProvider() {
          return yi;
        },
        StyledMarkdownBlock: function StyledMarkdownBlock() {
          return xs;
        },
        ThemeProvider: function ThemeProvider() {
          return X;
        },
        Throttle: function Throttle() {
          return Et;
        },
        alphabeticallyByProp: function alphabeticallyByProp() {
          return Mt;
        },
        appendToMdHeading: function appendToMdHeading() {
          return y;
        },
        argValueToBoolean: function argValueToBoolean() {
          return Q;
        },
        buildComponentComment: function buildComponentComment() {
          return qr;
        },
        concatRefStacks: function concatRefStacks() {
          return kn;
        },
        convertSwagger2OpenAPI: function convertSwagger2OpenAPI() {
          return ye;
        },
        createGlobalStyle: function createGlobalStyle() {
          return Z;
        },
        createStore: function createStore() {
          return tc;
        },
        css: function css() {
          return Y;
        },
        debugTime: function debugTime() {
          return St;
        },
        debugTimeEnd: function debugTimeEnd() {
          return $t;
        },
        detectType: function detectType() {
          return qe;
        },
        escapeHTMLAttrChars: function escapeHTMLAttrChars() {
          return j;
        },
        expandDefaultServerVariables: function expandDefaultServerVariables() {
          return ct;
        },
        extensionsHook: function extensionsHook() {
          return te;
        },
        extractExtensions: function extractExtensions() {
          return bt;
        },
        flattenByProp: function flattenByProp() {
          return m;
        },
        getBasePath: function getBasePath() {
          return E;
        },
        getContentWithLegacyExamples: function getContentWithLegacyExamples() {
          return vt;
        },
        getDefinitionName: function getDefinitionName() {
          return tt;
        },
        getOperationSummary: function getOperationSummary() {
          return Ne;
        },
        getSerializedValue: function getSerializedValue() {
          return Ge;
        },
        getStatusCodeType: function getStatusCodeType() {
          return De;
        },
        highlight: function highlight() {
          return Ot;
        },
        history: function history() {
          return Qt;
        },
        html2Str: function html2Str() {
          return l;
        },
        humanizeConstraints: function humanizeConstraints() {
          return ot;
        },
        humanizeNumberRange: function humanizeNumberRange() {
          return nt;
        },
        isAbsoluteUrl: function isAbsoluteUrl() {
          return k;
        },
        isArray: function isArray() {
          return A;
        },
        isBoolean: function isBoolean() {
          return P;
        },
        isFormUrlEncoded: function isFormUrlEncoded() {
          return Ue;
        },
        isJsonLike: function isJsonLike() {
          return Qe;
        },
        isNamedDefinition: function isNamedDefinition() {
          return et;
        },
        isNumeric: function isNumeric() {
          return g;
        },
        isObject: function isObject() {
          return x;
        },
        isOperationName: function isOperationName() {
          return Me;
        },
        isPayloadSample: function isPayloadSample() {
          return ho;
        },
        isPrimitiveType: function isPrimitiveType() {
          return Be;
        },
        isRedocExtension: function isRedocExtension() {
          return yt;
        },
        isStatusCode: function isStatusCode() {
          return Le;
        },
        keyframes: function keyframes() {
          return G;
        },
        langFromMime: function langFromMime() {
          return Xe;
        },
        loadAndBundleSpec: function loadAndBundleSpec() {
          return ge;
        },
        mapLang: function mapLang() {
          return kt;
        },
        mapValues: function mapValues() {
          return h;
        },
        mapWithLast: function mapWithLast() {
          return d;
        },
        media: function media() {
          return K;
        },
        memoize: function memoize() {
          return zt;
        },
        menuItemDepth: function menuItemDepth() {
          return Rc;
        },
        mergeObjects: function mergeObjects() {
          return b;
        },
        mergeParams: function mergeParams() {
          return at;
        },
        mergeSimilarMediaTypes: function mergeSimilarMediaTypes() {
          return lt;
        },
        normalizeServers: function normalizeServers() {
          return pt;
        },
        pluralizeType: function pluralizeType() {
          return xt;
        },
        pushRef: function pushRef() {
          return wn;
        },
        querySelector: function querySelector() {
          return a;
        },
        removeQueryStringAndHash: function removeQueryStringAndHash() {
          return $;
        },
        resolveUrl: function resolveUrl() {
          return O;
        },
        safeSlugify: function safeSlugify() {
          return w;
        },
        scrollIntoViewIfNeeded: function scrollIntoViewIfNeeded() {
          return c;
        },
        serializeParameterValue: function serializeParameterValue() {
          return Ze;
        },
        serializeParameterValueWithMime: function serializeParameterValueWithMime() {
          return Ye;
        },
        setSecuritySchemePrefix: function setSecuritySchemePrefix() {
          return ft;
        },
        shortenHTTPVerb: function shortenHTTPVerb() {
          return gt;
        },
        sortByField: function sortByField() {
          return st;
        },
        sortByRequired: function sortByRequired() {
          return it;
        },
        stripTrailingSlash: function stripTrailingSlash() {
          return f;
        },
        styled: function styled() {
          return ee;
        },
        titleize: function titleize() {
          return S;
        },
        unescapeHTMLChars: function unescapeHTMLChars() {
          return C;
        },
        urlFormEncodePayload: function urlFormEncodePayload() {
          return Je;
        },
        useStore: function useStore() {
          return vi;
        }
      });

      var e = require("react"),
          t = require("polished");

      var o = {
        spacing: {
          unit: 5,
          sectionHorizontal: function sectionHorizontal(_ref2) {
            var e = _ref2.spacing;
            return 8 * e.unit;
          },
          sectionVertical: function sectionVertical(_ref3) {
            var e = _ref3.spacing;
            return 8 * e.unit;
          }
        },
        breakpoints: {
          small: "50rem",
          medium: "75rem",
          large: "105rem"
        },
        colors: {
          tonalOffset: .2,
          primary: {
            main: "#32329f",
            light: function light(_ref4) {
              var e = _ref4.colors;
              return (0, t.lighten)(e.tonalOffset, e.primary.main);
            },
            dark: function dark(_ref5) {
              var e = _ref5.colors;
              return (0, t.darken)(e.tonalOffset, e.primary.main);
            },
            contrastText: function contrastText(_ref6) {
              var e = _ref6.colors;
              return (0, t.readableColor)(e.primary.main);
            }
          },
          success: {
            main: "#1d8127",
            light: function light(_ref7) {
              var e = _ref7.colors;
              return (0, t.lighten)(2 * e.tonalOffset, e.success.main);
            },
            dark: function dark(_ref8) {
              var e = _ref8.colors;
              return (0, t.darken)(e.tonalOffset, e.success.main);
            },
            contrastText: function contrastText(_ref9) {
              var e = _ref9.colors;
              return (0, t.readableColor)(e.success.main);
            }
          },
          warning: {
            main: "#ffa500",
            light: function light(_ref10) {
              var e = _ref10.colors;
              return (0, t.lighten)(e.tonalOffset, e.warning.main);
            },
            dark: function dark(_ref11) {
              var e = _ref11.colors;
              return (0, t.darken)(e.tonalOffset, e.warning.main);
            },
            contrastText: "#ffffff"
          },
          error: {
            main: "#d41f1c",
            light: function light(_ref12) {
              var e = _ref12.colors;
              return (0, t.lighten)(e.tonalOffset, e.error.main);
            },
            dark: function dark(_ref13) {
              var e = _ref13.colors;
              return (0, t.darken)(e.tonalOffset, e.error.main);
            },
            contrastText: function contrastText(_ref14) {
              var e = _ref14.colors;
              return (0, t.readableColor)(e.error.main);
            }
          },
          gray: {
            50: "#FAFAFA",
            100: "#F5F5F5"
          },
          text: {
            primary: "#333333",
            secondary: function secondary(_ref15) {
              var e = _ref15.colors;
              return (0, t.lighten)(e.tonalOffset, e.text.primary);
            }
          },
          border: {
            dark: "rgba(0,0,0, 0.1)",
            light: "#ffffff"
          },
          responses: {
            success: {
              color: function color(_ref16) {
                var e = _ref16.colors;
                return e.success.main;
              },
              backgroundColor: function backgroundColor(_ref17) {
                var e = _ref17.colors;
                return (0, t.transparentize)(.93, e.success.main);
              },
              tabTextColor: function tabTextColor(_ref18) {
                var e = _ref18.colors;
                return e.responses.success.color;
              }
            },
            error: {
              color: function color(_ref19) {
                var e = _ref19.colors;
                return e.error.main;
              },
              backgroundColor: function backgroundColor(_ref20) {
                var e = _ref20.colors;
                return (0, t.transparentize)(.93, e.error.main);
              },
              tabTextColor: function tabTextColor(_ref21) {
                var e = _ref21.colors;
                return e.responses.error.color;
              }
            },
            redirect: {
              color: function color(_ref22) {
                var e = _ref22.colors;
                return e.warning.main;
              },
              backgroundColor: function backgroundColor(_ref23) {
                var e = _ref23.colors;
                return (0, t.transparentize)(.9, e.responses.redirect.color);
              },
              tabTextColor: function tabTextColor(_ref24) {
                var e = _ref24.colors;
                return e.responses.redirect.color;
              }
            },
            info: {
              color: "#87ceeb",
              backgroundColor: function backgroundColor(_ref25) {
                var e = _ref25.colors;
                return (0, t.transparentize)(.9, e.responses.info.color);
              },
              tabTextColor: function tabTextColor(_ref26) {
                var e = _ref26.colors;
                return e.responses.info.color;
              }
            }
          },
          http: {
            get: "#2F8132",
            post: "#186FAF",
            put: "#95507c",
            options: "#947014",
            patch: "#bf581d",
            delete: "#cc3333",
            basic: "#707070",
            link: "#07818F",
            head: "#A23DAD"
          }
        },
        schema: {
          linesColor: function linesColor(e) {
            return (0, t.lighten)(e.colors.tonalOffset, (0, t.desaturate)(e.colors.tonalOffset, e.colors.primary.main));
          },
          defaultDetailsWidth: "75%",
          typeNameColor: function typeNameColor(e) {
            return e.colors.text.secondary;
          },
          typeTitleColor: function typeTitleColor(e) {
            return e.schema.typeNameColor;
          },
          requireLabelColor: function requireLabelColor(e) {
            return e.colors.error.main;
          },
          labelsTextSize: "0.9em",
          nestingSpacing: "1em",
          nestedBackground: "#fafafa",
          arrow: {
            size: "1.1em",
            color: function color(e) {
              return e.colors.text.secondary;
            }
          }
        },
        typography: {
          fontSize: "14px",
          lineHeight: "1.5em",
          fontWeightRegular: "400",
          fontWeightBold: "600",
          fontWeightLight: "300",
          fontFamily: "Roboto, sans-serif",
          smoothing: "antialiased",
          optimizeSpeed: !0,
          headings: {
            fontFamily: "Montserrat, sans-serif",
            fontWeight: "400",
            lineHeight: "1.6em"
          },
          code: {
            fontSize: "13px",
            fontFamily: "Courier, monospace",
            lineHeight: function lineHeight(_ref27) {
              var e = _ref27.typography;
              return e.lineHeight;
            },
            fontWeight: function fontWeight(_ref28) {
              var e = _ref28.typography;
              return e.fontWeightRegular;
            },
            color: "#e53935",
            backgroundColor: "rgba(38, 50, 56, 0.05)",
            wrap: !1
          },
          links: {
            color: function color(_ref29) {
              var e = _ref29.colors;
              return e.primary.main;
            },
            visited: function visited(_ref30) {
              var e = _ref30.typography;
              return e.links.color;
            },
            hover: function hover(_ref31) {
              var e = _ref31.typography;
              return (0, t.lighten)(.2, e.links.color);
            },
            textDecoration: "auto",
            hoverTextDecoration: "auto"
          }
        },
        sidebar: {
          width: "260px",
          backgroundColor: "#fafafa",
          textColor: "#333333",
          activeTextColor: function activeTextColor(e) {
            return e.sidebar.textColor !== o.sidebar.textColor ? e.sidebar.textColor : e.colors.primary.main;
          },
          groupItems: {
            activeBackgroundColor: function activeBackgroundColor(e) {
              return (0, t.darken)(.1, e.sidebar.backgroundColor);
            },
            activeTextColor: function activeTextColor(e) {
              return e.sidebar.activeTextColor;
            },
            textTransform: "uppercase"
          },
          level1Items: {
            activeBackgroundColor: function activeBackgroundColor(e) {
              return (0, t.darken)(.05, e.sidebar.backgroundColor);
            },
            activeTextColor: function activeTextColor(e) {
              return e.sidebar.activeTextColor;
            },
            textTransform: "none"
          },
          arrow: {
            size: "1.5em",
            color: function color(e) {
              return e.sidebar.textColor;
            }
          }
        },
        logo: {
          maxHeight: function maxHeight(_ref32) {
            var e = _ref32.sidebar;
            return e.width;
          },
          maxWidth: function maxWidth(_ref33) {
            var e = _ref33.sidebar;
            return e.width;
          },
          gutter: "2px"
        },
        rightPanel: {
          backgroundColor: "#263238",
          width: "40%",
          textColor: "#ffffff",
          servers: {
            overlay: {
              backgroundColor: "#fafafa",
              textColor: "#263238"
            },
            url: {
              backgroundColor: "#fff"
            }
          }
        },
        codeBlock: {
          backgroundColor: function backgroundColor(_ref34) {
            var e = _ref34.rightPanel;
            return (0, t.darken)(.1, e.backgroundColor);
          }
        },
        fab: {
          backgroundColor: "#f2f2f2",
          color: "#0065FB"
        }
      };
      var i = o;
      var s = "undefined" != typeof window && "HTMLElement" in window;

      function a(e) {
        return "undefined" != typeof document ? document.querySelector(e) : null;
      }

      function l(e) {
        return e.split(/<[^>]+>/).map(function (e) {
          return e.trim();
        }).filter(function (e) {
          return e.length > 0;
        }).join(" ");
      }

      function c(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        var r = e.parentNode;
        if (!r) return;
        var n = window.getComputedStyle(r, void 0),
            o = parseInt(n.getPropertyValue("border-top-width"), 10),
            i = parseInt(n.getPropertyValue("border-left-width"), 10),
            s = e.offsetTop - r.offsetTop < r.scrollTop,
            a = e.offsetTop - r.offsetTop + e.clientHeight - o > r.scrollTop + r.clientHeight,
            l = e.offsetLeft - r.offsetLeft < r.scrollLeft,
            c = e.offsetLeft - r.offsetLeft + e.clientWidth - i > r.scrollLeft + r.clientWidth,
            p = s && !a;
        (s || a) && t && (r.scrollTop = e.offsetTop - r.offsetTop - r.clientHeight / 2 - o + e.clientHeight / 2), (l || c) && t && (r.scrollLeft = e.offsetLeft - r.offsetLeft - r.clientWidth / 2 - i + e.clientWidth / 2), (s || a || l || c) && !t && e.scrollIntoView(p);
      }

      var p = require("slugify"),
          u = r.n(p);

      function d(e, t) {
        var r = [];

        for (var _n32 = 0; _n32 < e.length - 1; _n32++) {
          r.push(t(e[_n32], !1));
        }

        return 0 !== e.length && r.push(t(e[e.length - 1], !0)), r;
      }

      function h(e, t) {
        var r = {};

        for (var _n33 in e) {
          e.hasOwnProperty(_n33) && (r[_n33] = t(e[_n33], _n33, e));
        }

        return r;
      }

      function m(e, t) {
        var r = [],
            n = function n(e) {
          var _iterator19 = _createForOfIteratorHelper(e),
              _step19;

          try {
            for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
              var _o13 = _step19.value;
              r.push(_o13), _o13[t] && n(_o13[t]);
            }
          } catch (err) {
            _iterator19.e(err);
          } finally {
            _iterator19.f();
          }
        };

        return n(e), r;
      }

      function f(e) {
        return e.endsWith("/") ? e.substring(0, e.length - 1) : e;
      }

      function g(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
      }

      function y(e, t, r) {
        var n = new RegExp("(^|\\n)#\\s?".concat(t, "\\s*\\n"), "i"),
            o = new RegExp("((\\n|^)#\\s*".concat(t, "\\s*(\\n|$)(?:.|\\n)*?)(\\n#|$)"), "i");
        if (n.test(e)) return e.replace(o, "$1\n\n".concat(r, "\n$4"));
        {
          var _n34 = "" === e || e.endsWith("\n\n") ? "" : e.endsWith("\n") ? "\n" : "\n\n";

          return "".concat(e).concat(_n34, "# ").concat(t, "\n\n").concat(r);
        }
      }

      var b = function b(e) {
        for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          t[_key - 1] = arguments[_key];
        }

        if (!t.length) return e;
        var r = t.shift();
        return void 0 === r ? e : (v(e) && v(r) && Object.keys(r).forEach(function (t) {
          v(r[t]) ? (e[t] || (e[t] = {}), b(e[t], r[t])) : e[t] = r[t];
        }), b.apply(void 0, [e].concat(t)));
      },
          x = function x(e) {
        return null !== e && "object" == typeof e;
      },
          v = function v(e) {
        return x(e) && !A(e);
      };

      function w(e) {
        return u()(e) || e.toString().toLowerCase().replace(/\s+/g, "-").replace(/&/g, "-and-").replace(/\--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
      }

      function k(e) {
        return /(?:^[a-z][a-z0-9+.-]*:|\/\/)/i.test(e);
      }

      function O(e, t) {
        var r;
        if (t.startsWith("//")) try {
          r = "".concat(new URL(e).protocol || "https:").concat(t);
        } catch (e) {
          r = "https:".concat(t);
        } else if (k(t)) r = t;else if (t.startsWith("/")) try {
          var _n35 = new URL(e);

          _n35.pathname = t, r = _n35.href;
        } catch (e) {
          r = t;
        } else r = f(e) + "/" + t;
        return f(r);
      }

      function E(e) {
        try {
          return R(e).pathname;
        } catch (t) {
          return e;
        }
      }

      function S(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }

      function $(e) {
        try {
          var _t46 = R(e);

          return _t46.search = "", _t46.hash = "", _t46.toString();
        } catch (t) {
          return e;
        }
      }

      function R(e) {
        return "undefined" == typeof URL ? new (r(416).URL)(e) : new URL(e);
      }

      function j(e) {
        return e.replace(/["\\]/g, "\\$&");
      }

      function C(e) {
        return e.replace(/&#(\d+);/g, function (e, t) {
          return String.fromCharCode(parseInt(t, 10));
        }).replace(/&amp;/g, "&").replace(/&quot;/g, '"');
      }

      function A(e) {
        return Array.isArray(e);
      }

      function P(e) {
        return "boolean" == typeof e;
      }

      var I = {
        enum: "Enum",
        enumSingleValue: "Value",
        enumArray: "Items",
        default: "Default",
        deprecated: "Deprecated",
        example: "Example",
        examples: "Examples",
        recursive: "Recursive",
        arrayOf: "Array of ",
        webhook: "Event",
        const: "Value",
        noResultsFound: "No results found",
        download: "Download",
        downloadSpecification: "Download OpenAPI specification",
        responses: "Responses",
        callbackResponses: "Callback responses",
        requestSamples: "Request samples",
        responseSamples: "Response samples"
      };

      function T(e, t) {
        var r = I[e];
        return void 0 !== t ? r[t] : r;
      }

      var _ = function (e) {
        return e.SummaryOnly = "summary-only", e.PathOnly = "path-only", e.IdOnly = "id-only", e;
      }(_ || {}),
          L = Object.defineProperty,
          D = Object.defineProperties,
          z = Object.getOwnPropertyDescriptors,
          M = Object.getOwnPropertySymbols,
          N = Object.prototype.hasOwnProperty,
          F = Object.prototype.propertyIsEnumerable,
          q = function q(e, t, r) {
        return t in e ? L(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          B = function B(e, t) {
        for (var r in t || (t = {})) {
          N.call(t, r) && q(e, r, t[r]);
        }

        if (M) {
          var _iterator20 = _createForOfIteratorHelper(M(t)),
              _step20;

          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var r = _step20.value;
              F.call(t, r) && q(e, r, t[r]);
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }

        return e;
      };

      function Q(e, t) {
        return void 0 === e ? t || !1 : "string" == typeof e ? "false" !== e : e;
      }

      function U(e) {
        return "string" == typeof e ? parseInt(e, 10) : "number" == typeof e ? e : void 0;
      }

      var W = /*#__PURE__*/function () {
        function W(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, W);

          var r, n, o, s, a;
          var l = (e = B(B({}, t), e)).theme && e.theme.extensionsHook;
          var c, p;
          (null == (r = e.theme) ? void 0 : r.menu) && !(null == (n = e.theme) ? void 0 : n.sidebar) && (console.warn('Theme setting "menu" is deprecated. Rename to "sidebar"'), e.theme.sidebar = e.theme.menu), (null == (o = e.theme) ? void 0 : o.codeSample) && !(null == (s = e.theme) ? void 0 : s.codeBlock) && (console.warn('Theme setting "codeSample" is deprecated. Rename to "codeBlock"'), e.theme.codeBlock = e.theme.codeSample), this.theme = function (e) {
            var t = {};
            var r = 0;

            var n = function n(o, i) {
              Object.keys(o).forEach(function (s) {
                var a = (i ? i + "." : "") + s,
                    l = o[s];
                "function" == typeof l ? Object.defineProperty(o, s, {
                  get: function get() {
                    if (!t[a]) {
                      if (r++, r > 1e3) throw new Error("Theme probably contains circular dependency at ".concat(a, ": ").concat(l.toString()));
                      t[a] = l(e);
                    }

                    return t[a];
                  },
                  enumerable: !0
                }) : "object" == typeof l && n(l, a);
              });
            };

            return n(e, ""), JSON.parse(JSON.stringify(e));
          }(b({}, i, (c = B({}, e.theme), D(c, z({
            extensionsHook: void 0
          }))))), this.theme.extensionsHook = l, p = e.labels, Object.assign(I, p), this.scrollYOffset = W.normalizeScrollYOffset(e.scrollYOffset), this.hideHostname = W.normalizeHideHostname(e.hideHostname), this.expandResponses = W.normalizeExpandResponses(e.expandResponses), this.requiredPropsFirst = Q(e.requiredPropsFirst), this.sortPropsAlphabetically = Q(e.sortPropsAlphabetically), this.sortEnumValuesAlphabetically = Q(e.sortEnumValuesAlphabetically), this.sortOperationsAlphabetically = Q(e.sortOperationsAlphabetically), this.sortTagsAlphabetically = Q(e.sortTagsAlphabetically), this.nativeScrollbars = Q(e.nativeScrollbars), this.pathInMiddlePanel = Q(e.pathInMiddlePanel), this.untrustedSpec = Q(e.untrustedSpec), this.hideDownloadButton = Q(e.hideDownloadButton), this.downloadFileName = e.downloadFileName, this.downloadDefinitionUrl = e.downloadDefinitionUrl, this.disableSearch = Q(e.disableSearch), this.onlyRequiredInSamples = Q(e.onlyRequiredInSamples), this.showExtensions = W.normalizeShowExtensions(e.showExtensions), this.sideNavStyle = W.normalizeSideNavStyle(e.sideNavStyle), this.hideSingleRequestSampleTab = Q(e.hideSingleRequestSampleTab), this.menuToggle = Q(e.menuToggle, !0), this.jsonSampleExpandLevel = W.normalizeJsonSampleExpandLevel(e.jsonSampleExpandLevel), this.enumSkipQuotes = Q(e.enumSkipQuotes), this.hideSchemaTitles = Q(e.hideSchemaTitles), this.simpleOneOfTypeLabel = Q(e.simpleOneOfTypeLabel), this.payloadSampleIdx = W.normalizePayloadSampleIdx(e.payloadSampleIdx), this.expandSingleSchemaField = Q(e.expandSingleSchemaField), this.schemaExpansionLevel = function (e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return "all" === e ? 1 / 0 : U(e) || t;
          }(e.schemaExpansionLevel), this.showObjectSchemaExamples = Q(e.showObjectSchemaExamples), this.showSecuritySchemeType = Q(e.showSecuritySchemeType), this.hideSecuritySection = Q(e.hideSecuritySection), this.unstable_ignoreMimeParameters = Q(e.unstable_ignoreMimeParameters), this.allowedMdComponents = e.allowedMdComponents || {}, this.expandDefaultServerVariables = Q(e.expandDefaultServerVariables), this.maxDisplayedEnumValues = U(e.maxDisplayedEnumValues);
          var u = A(e.ignoreNamedSchemas) ? e.ignoreNamedSchemas : null == (a = e.ignoreNamedSchemas) ? void 0 : a.split(",").map(function (e) {
            return e.trim();
          });
          this.ignoreNamedSchemas = new Set(u), this.hideSchemaPattern = Q(e.hideSchemaPattern), this.generatedPayloadSamplesMaxDepth = W.normalizeGeneratedPayloadSamplesMaxDepth(e.generatedPayloadSamplesMaxDepth), this.nonce = e.nonce, this.hideFab = Q(e.hideFab), this.minCharacterLengthToInitSearch = U(e.minCharacterLengthToInitSearch) || 3, this.showWebhookVerb = Q(e.showWebhookVerb);
        }

        _createClass(W, null, [{
          key: "normalizeExpandResponses",
          value: function normalizeExpandResponses(e) {
            if ("all" === e) return "all";

            if ("string" == typeof e) {
              var _t47 = {};
              return e.split(",").forEach(function (e) {
                _t47[e.trim()] = !0;
              }), _t47;
            }

            return void 0 !== e && console.warn("expandResponses must be a string but received value \"".concat(e, "\" of type ").concat(typeof e)), {};
          }
        }, {
          key: "normalizeHideHostname",
          value: function normalizeHideHostname(e) {
            return !!e;
          }
        }, {
          key: "normalizeScrollYOffset",
          value: function normalizeScrollYOffset(e) {
            if ("string" == typeof e && !g(e)) {
              var _t48 = a(e);

              _t48 || console.warn("scrollYOffset value is a selector to non-existing element. Using offset 0 by default");

              var _r33 = _t48 && _t48.getBoundingClientRect().bottom || 0;

              return function () {
                return _r33;
              };
            }

            return "number" == typeof e || g(e) ? function () {
              return "number" == typeof e ? e : parseFloat(e);
            } : "function" == typeof e ? function () {
              var t = e();
              return "number" != typeof t && console.warn("scrollYOffset should return number but returned value \"".concat(t, "\" of type ").concat(typeof t)), t;
            } : (void 0 !== e && console.warn("Wrong value for scrollYOffset ReDoc option: should be string, number or function"), function () {
              return 0;
            });
          }
        }, {
          key: "normalizeShowExtensions",
          value: function normalizeShowExtensions(e) {
            if (void 0 === e) return !1;
            if ("" === e) return !0;
            if ("string" != typeof e) return e;

            switch (e) {
              case "true":
                return !0;

              case "false":
                return !1;

              default:
                return e.split(",").map(function (e) {
                  return e.trim();
                });
            }
          }
        }, {
          key: "normalizeSideNavStyle",
          value: function normalizeSideNavStyle(e) {
            var t = _.SummaryOnly;
            if ("string" != typeof e) return t;

            switch (e) {
              case t:
                return e;

              case _.PathOnly:
                return _.PathOnly;

              case _.IdOnly:
                return _.IdOnly;

              default:
                return t;
            }
          }
        }, {
          key: "normalizePayloadSampleIdx",
          value: function normalizePayloadSampleIdx(e) {
            return "number" == typeof e ? Math.max(0, e) : "string" == typeof e && isFinite(e) ? parseInt(e, 10) : 0;
          }
        }, {
          key: "normalizeJsonSampleExpandLevel",
          value: function normalizeJsonSampleExpandLevel(e) {
            return "all" === e ? 1 / 0 : isNaN(Number(e)) ? 2 : Math.ceil(Number(e));
          }
        }, {
          key: "normalizeGeneratedPayloadSamplesMaxDepth",
          value: function normalizeGeneratedPayloadSamplesMaxDepth(e) {
            return isNaN(Number(e)) ? 10 : Math.max(0, Number(e));
          }
        }]);

        return W;
      }();

      var V = require("styled-components"),
          H = r.n(V);

      var J = V.default,
          Y = V.css,
          Z = V.createGlobalStyle,
          G = V.keyframes,
          X = V.ThemeProvider,
          K = {
        lessThan: function lessThan(e, t, r) {
          return function () {
            return Y(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      @media ", " screen and (max-width: ", ") ", " {\n        ", ";\n      }\n    "])), t ? "print, " : "", function (t) {
              return t.theme.breakpoints[e];
            }, r || "", Y.apply(void 0, arguments));
          };
        },
        greaterThan: function greaterThan(e) {
          return function () {
            return Y(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      @media (min-width: ", ") {\n        ", ";\n      }\n    "])), function (t) {
              return t.theme.breakpoints[e];
            }, Y.apply(void 0, arguments));
          };
        },
        between: function between(e, t) {
          return function () {
            return Y(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      @media (min-width: ", ") and (max-width: ", ") {\n        ", ";\n      }\n    "])), function (t) {
              return t.theme.breakpoints[e];
            }, function (e) {
              return e.theme.breakpoints[t];
            }, Y.apply(void 0, arguments));
          };
        }
      };
      var ee = J;

      function te(e) {
        return function (t) {
          if (t.theme.extensionsHook) return t.theme.extensionsHook(e, t);
        };
      }

      var re = ee.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 20px;\n  color: red;\n"])));

      var ne = /*#__PURE__*/function (_e$Component) {
        _inherits(ne, _e$Component);

        var _super2 = _createSuper(ne);

        function ne(e) {
          var _this2;

          _classCallCheck(this, ne);

          _this2 = _super2.call(this, e), _this2.state = {
            error: void 0
          };
          return _this2;
        }

        _createClass(ne, [{
          key: "componentDidCatch",
          value: function componentDidCatch(e) {
            return this.setState({
              error: e
            }), !1;
          }
        }, {
          key: "render",
          value: function render() {
            return this.state.error ? e.createElement(re, null, e.createElement("h1", null, "Something went wrong..."), e.createElement("small", null, " ", this.state.error.message, " "), e.createElement("p", null, e.createElement("details", null, e.createElement("summary", null, "Stack trace"), e.createElement("pre", null, this.state.error.stack))), e.createElement("small", null, " ReDoc Version: ", "2.0.0"), " ", e.createElement("br", null), e.createElement("small", null, " Commit: ", "5fb4daa")) : e.createElement(e.Fragment, null, e.Children.only(this.props.children));
          }
        }]);

        return ne;
      }(e.Component);

      var oe = G(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg);\n  }\n"]))),
          ie = ee(function (t) {
        return e.createElement("svg", {
          className: t.className,
          version: "1.1",
          width: "512",
          height: "512",
          viewBox: "0 0 512 512"
        }, e.createElement("path", {
          d: "M275.682 147.999c0 10.864-8.837 19.661-19.682 19.661v0c-10.875 0-19.681-8.796-19.681-19.661v-96.635c0-10.885 8.806-19.661 19.681-19.661v0c10.844 0 19.682 8.776 19.682 19.661v96.635z"
        }), e.createElement("path", {
          d: "M275.682 460.615c0 10.865-8.837 19.682-19.682 19.682v0c-10.875 0-19.681-8.817-19.681-19.682v-96.604c0-10.885 8.806-19.681 19.681-19.681v0c10.844 0 19.682 8.796 19.682 19.682v96.604z"
        }), e.createElement("path", {
          d: "M147.978 236.339c10.885 0 19.681 8.755 19.681 19.641v0c0 10.885-8.796 19.702-19.681 19.702h-96.624c-10.864 0-19.661-8.817-19.661-19.702v0c0-10.885 8.796-19.641 19.661-19.641h96.624z"
        }), e.createElement("path", {
          d: "M460.615 236.339c10.865 0 19.682 8.755 19.682 19.641v0c0 10.885-8.817 19.702-19.682 19.702h-96.584c-10.885 0-19.722-8.817-19.722-19.702v0c0-10.885 8.837-19.641 19.722-19.641h96.584z"
        }), e.createElement("path", {
          d: "M193.546 165.703c7.69 7.66 7.68 20.142 0 27.822v0c-7.701 7.701-20.162 7.701-27.853 0.020l-68.311-68.322c-7.68-7.701-7.68-20.142 0-27.863v0c7.68-7.68 20.121-7.68 27.822 0l68.342 68.342z"
        }), e.createElement("path", {
          d: "M414.597 386.775c7.7 7.68 7.7 20.163 0.021 27.863v0c-7.7 7.659-20.142 7.659-27.843-0.062l-68.311-68.26c-7.68-7.7-7.68-20.204 0-27.863v0c7.68-7.7 20.163-7.7 27.842 0l68.291 68.322z"
        }), e.createElement("path", {
          d: "M165.694 318.464c7.69-7.7 20.153-7.7 27.853 0v0c7.68 7.659 7.69 20.163 0 27.863l-68.342 68.322c-7.67 7.659-20.142 7.659-27.822-0.062v0c-7.68-7.68-7.68-20.122 0-27.801l68.311-68.322z"
        }), e.createElement("path", {
          d: "M386.775 97.362c7.7-7.68 20.142-7.68 27.822 0v0c7.7 7.68 7.7 20.183 0.021 27.863l-68.322 68.311c-7.68 7.68-20.163 7.68-27.843-0.020v0c-7.68-7.68-7.68-20.162 0-27.822l68.322-68.332z"
        }));
      })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  animation: 2s ", " linear infinite;\n  width: 50px;\n  height: 50px;\n  content: '';\n  display: inline-block;\n  margin-left: -25px;\n\n  path {\n    fill: ", ";\n  }\n"])), oe, function (e) {
        return e.color;
      }),
          se = ee.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: helvetica, sans;\n  width: 100%;\n  text-align: center;\n  font-size: 25px;\n  margin: 30px 0 20px 0;\n  color: ", ";\n"])), function (e) {
        return e.color;
      });

      var ae = /*#__PURE__*/function (_e$PureComponent) {
        _inherits(ae, _e$PureComponent);

        var _super3 = _createSuper(ae);

        function ae() {
          _classCallCheck(this, ae);

          return _super3.apply(this, arguments);
        }

        _createClass(ae, [{
          key: "render",
          value: function render() {
            return e.createElement("div", {
              style: {
                textAlign: "center"
              }
            }, e.createElement(se, {
              color: this.props.color
            }, "Loading ..."), e.createElement(ie, {
              color: this.props.color
            }));
          }
        }]);

        return ae;
      }(e.PureComponent);

      var le = require("prop-types");

      var ce = e.createContext(new W({})),
          pe = ce.Provider,
          ue = ce.Consumer;

      var de = require("mobx"),
          he = require("@redocly/openapi-core/lib/bundle"),
          me = require("@redocly/openapi-core/lib/config/config"),
          fe = r(925);

      function ge(e) {
        return t = this, null, n = /*#__PURE__*/_regeneratorRuntime.mark(function n() {
          var t, n, _yield, o;

          return _regeneratorRuntime.wrap(function n$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  t = new me.Config({}), n = {
                    config: t,
                    base: s ? window.location.href : process.cwd()
                  };
                  s && (t.resolve.http.customFetch = r.g.fetch), "object" == typeof e && null !== e ? n.doc = {
                    source: {
                      absoluteRef: ""
                    },
                    parsed: e
                  } : n.ref = e;
                  _context7.next = 4;
                  return (0, he.bundle)(n);

                case 4:
                  _yield = _context7.sent;
                  o = _yield.bundle.parsed;
                  return _context7.abrupt("return", void 0 !== o.swagger ? ye(o) : o);

                case 7:
                case "end":
                  return _context7.stop();
              }
            }
          }, n);
        }), new Promise(function (e, r) {
          var o = function o(e) {
            try {
              s(n.next(e));
            } catch (e) {
              r(e);
            }
          },
              i = function i(e) {
            try {
              s(n.throw(e));
            } catch (e) {
              r(e);
            }
          },
              s = function s(t) {
            return t.done ? e(t.value) : Promise.resolve(t.value).then(o, i);
          };

          s((n = n.apply(t, null)).next());
        });
        var t, n;
      }

      function ye(e) {
        return console.warn("[ReDoc Compatibility mode]: Converting OpenAPI 2.0 to OpenAPI 3.0"), new Promise(function (t, r) {
          return (0, fe.convertObj)(e, {
            patch: !0,
            warnOnly: !0,
            text: "{}",
            anchors: !0
          }, function (e, n) {
            if (e) return r(e);
            t(n && n.openapi);
          });
        });
      }

      var be = require("decko"),
          xe = require("eventemitter3"),
          ve = require("json-pointer");

      var we = ve.parse;

      var ke = /*#__PURE__*/function () {
        function ke() {
          _classCallCheck(this, ke);
        }

        _createClass(ke, null, [{
          key: "baseName",
          value: function baseName(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var r = ke.parse(e);
            return r[r.length - t];
          }
        }, {
          key: "dirName",
          value: function dirName(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var r = ke.parse(e);
            return ve.compile(r.slice(0, r.length - t));
          }
        }, {
          key: "relative",
          value: function relative(e, t) {
            var r = ke.parse(e);
            return ke.parse(t).slice(r.length);
          }
        }, {
          key: "parse",
          value: function parse(e) {
            var t = e;
            return "#" === t.charAt(0) && (t = t.substring(1)), we(t);
          }
        }, {
          key: "join",
          value: function join(e, t) {
            var r = ke.parse(e).concat(t);
            return ve.compile(r);
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return ve.get(e, t);
          }
        }, {
          key: "compile",
          value: function compile(e) {
            return ve.compile(e);
          }
        }, {
          key: "escape",
          value: function escape(e) {
            return ve.escape(e);
          }
        }]);

        return ke;
      }();

      ve.parse = ke.parse, Object.assign(ke, ve);

      var Oe = r(470),
          Ee = require("url-template"),
          Se = Object.defineProperty,
          $e = Object.defineProperties,
          Re = Object.getOwnPropertyDescriptors,
          je = Object.getOwnPropertySymbols,
          Ce = Object.prototype.hasOwnProperty,
          Ae = Object.prototype.propertyIsEnumerable,
          Pe = function Pe(e, t, r) {
        return t in e ? Se(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Ie = function Ie(e, t) {
        for (var r in t || (t = {})) {
          Ce.call(t, r) && Pe(e, r, t[r]);
        }

        if (je) {
          var _iterator21 = _createForOfIteratorHelper(je(t)),
              _step21;

          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var r = _step21.value;
              Ae.call(t, r) && Pe(e, r, t[r]);
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }
        }

        return e;
      },
          Te = function Te(e, t) {
        return $e(e, Re(t));
      };

      function _e(e) {
        return "string" == typeof e && /\dxx/i.test(e);
      }

      function Le(e) {
        return "default" === e || g(e) || _e(e);
      }

      function De(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        if ("default" === e) return t ? "error" : "success";
        var r = "string" == typeof e ? parseInt(e, 10) : e;
        if (_e(e) && (r *= 100), r < 100 || r > 599) throw new Error("invalid HTTP code");
        var n = "success";
        return r >= 300 && r < 400 ? n = "redirect" : r >= 400 ? n = "error" : r < 200 && (n = "info"), n;
      }

      var ze = {
        get: !0,
        post: !0,
        put: !0,
        head: !0,
        patch: !0,
        delete: !0,
        options: !0,
        $ref: !0
      };

      function Me(e) {
        return e in ze;
      }

      function Ne(e) {
        return e.summary || e.operationId || e.description && e.description.substring(0, 50) || e.pathName || "<no summary>";
      }

      var Fe = {
        multipleOf: "number",
        maximum: "number",
        exclusiveMaximum: "number",
        minimum: "number",
        exclusiveMinimum: "number",
        maxLength: "string",
        minLength: "string",
        pattern: "string",
        contentEncoding: "string",
        contentMediaType: "string",
        items: "array",
        maxItems: "array",
        minItems: "array",
        uniqueItems: "array",
        maxProperties: "object",
        minProperties: "object",
        required: "object",
        additionalProperties: "object",
        unevaluatedProperties: "object",
        properties: "object",
        patternProperties: "object"
      };

      function qe(e) {
        if (void 0 !== e.type && !A(e.type)) return e.type;
        var t = Object.keys(Fe);

        for (var _i14 = 0, _t49 = t; _i14 < _t49.length; _i14++) {
          var _r34 = _t49[_i14];
          var _t50 = Fe[_r34];
          if (void 0 !== e[_r34]) return _t50;
        }

        return "any";
      }

      function Be(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.type;
        if (e["x-circular-ref"]) return !0;
        if (void 0 !== e.oneOf || void 0 !== e.anyOf) return !1;
        if (e.if && e.then || e.if && e.else) return !1;
        var r = !0;
        var n = A(t);
        return ("object" === t || n && (null == t ? void 0 : t.includes("object"))) && (r = void 0 !== e.properties ? 0 === Object.keys(e.properties).length : void 0 === e.additionalProperties && void 0 === e.unevaluatedProperties && void 0 === e.patternProperties), !A(e.items) && !A(e.prefixItems) && (void 0 !== e.items && !P(e.items) && ("array" === t || n && (null == t ? void 0 : t.includes("array"))) && (r = Be(e.items, e.items.type)), r);
      }

      function Qe(e) {
        return -1 !== e.search(/json/i);
      }

      function Ue(e) {
        return "application/x-www-form-urlencoded" === e;
      }

      function We(e, t, r) {
        return A(e) ? e.map(function (e) {
          return e.toString();
        }).join(r) : "object" == typeof e ? Object.keys(e).map(function (t) {
          return "".concat(t).concat(r).concat(e[t]);
        }).join(r) : t + "=" + e.toString();
      }

      function Ve(e, t) {
        return A(e) ? (console.warn("deepObject style cannot be used with array value:" + e.toString()), "") : "object" == typeof e ? Object.keys(e).map(function (r) {
          return "".concat(t, "[").concat(r, "]=").concat(e[r]);
        }).join("&") : (console.warn("deepObject style cannot be used with non-object value:" + e.toString()), "");
      }

      function He(e, t, r) {
        var n = "__redoc_param_name__",
            o = t ? "*" : "";
        return Ee.parse("{?".concat(n).concat(o, "}")).expand(_defineProperty({}, n, r)).substring(1).replace(/__redoc_param_name__/g, e);
      }

      function Je(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (A(e)) throw new Error("Payload must have fields: " + e.toString());
        return Object.keys(e).map(function (r) {
          var n = e[r],
              _ref35 = t[r] || {},
              _ref35$style = _ref35.style,
              o = _ref35$style === void 0 ? "form" : _ref35$style,
              _ref35$explode = _ref35.explode,
              i = _ref35$explode === void 0 ? !0 : _ref35$explode;

          switch (o) {
            case "form":
              return He(r, i, n);

            case "spaceDelimited":
              return We(n, r, "%20");

            case "pipeDelimited":
              return We(n, r, "|");

            case "deepObject":
              return Ve(n, r);

            default:
              return console.warn("Incorrect or unsupported encoding style: " + o), "";
          }
        }).join("&");
      }

      function Ye(e, t) {
        return Qe(t) ? JSON.stringify(e) : (console.warn("Parameter serialization as ".concat(t, " is not supported")), "");
      }

      function Ze(e, t) {
        var r = e.name,
            n = e.style,
            _e$explode = e.explode,
            o = _e$explode === void 0 ? !1 : _e$explode,
            i = e.serializationMime;
        if (i) switch (e.in) {
          case "path":
          case "header":
            return Ye(t, i);

          case "cookie":
          case "query":
            return "".concat(r, "=").concat(Ye(t, i));

          default:
            return console.warn("Unexpected parameter location: " + e.in), "";
        }
        if (!n) return console.warn("Missing style attribute or content for parameter ".concat(r)), "";

        switch (e.in) {
          case "path":
            return function (e, t, r, n) {
              var o = r ? "*" : "";
              var i = "";
              "label" === t ? i = "." : "matrix" === t && (i = ";");
              var s = "__redoc_param_name__";
              return Ee.parse("{".concat(i).concat(s).concat(o, "}")).expand(_defineProperty({}, s, n)).replace(/__redoc_param_name__/g, e);
            }(r, n, o, t);

          case "query":
            return function (e, t, r, n) {
              switch (t) {
                case "form":
                  return He(e, r, n);

                case "spaceDelimited":
                  return A(n) ? r ? He(e, r, n) : "".concat(e, "=").concat(n.join("%20")) : (console.warn("The style spaceDelimited is only applicable to arrays"), "");

                case "pipeDelimited":
                  return A(n) ? r ? He(e, r, n) : "".concat(e, "=").concat(n.join("|")) : (console.warn("The style pipeDelimited is only applicable to arrays"), "");

                case "deepObject":
                  return !r || A(n) || "object" != typeof n ? (console.warn("The style deepObject is only applicable for objects with explode=true"), "") : Ve(n, e);

                default:
                  return console.warn("Unexpected style for query: " + t), "";
              }
            }(r, n, o, t);

          case "header":
            return function (e, t, r) {
              if ("simple" === e) {
                var _e21 = t ? "*" : "",
                    _n36 = "__redoc_param_name__",
                    _o14 = Ee.parse("{".concat(_n36).concat(_e21, "}"));

                return decodeURIComponent(_o14.expand(_defineProperty({}, _n36, r)));
              }

              return console.warn("Unexpected style for header: " + e), "";
            }(n, o, t);

          case "cookie":
            return function (e, t, r, n) {
              return "form" === t ? He(e, r, n) : (console.warn("Unexpected style for cookie: " + t), "");
            }(r, n, o, t);

          default:
            return console.warn("Unexpected parameter location: " + e.in), "";
        }
      }

      function Ge(e, t) {
        return e.in ? decodeURIComponent(Ze(e, t)) : t;
      }

      function Xe(e) {
        return -1 !== e.search(/xml/i) ? "xml" : -1 !== e.search(/csv/i) ? "csv" : -1 !== e.search(/plain/i) ? "tex" : "clike";
      }

      var Ke = /^#\/components\/(schemas|pathItems)\/([^/]+)$/;

      function et(e) {
        return Ke.test(e || "");
      }

      function tt(e) {
        var t;

        var _ref36 = (null == (t = null == e ? void 0 : e.match(Ke)) ? void 0 : t.reverse()) || [],
            _ref37 = _slicedToArray(_ref36, 1),
            r = _ref37[0];

        return r;
      }

      function rt(e, t, r) {
        var n;
        return void 0 !== t && void 0 !== r ? n = t === r ? "= ".concat(t, " ").concat(e) : "[ ".concat(t, " .. ").concat(r, " ] ").concat(e) : void 0 !== r ? n = "<= ".concat(r, " ").concat(e) : void 0 !== t && (n = 1 === t ? "non-empty" : ">= ".concat(t, " ").concat(e)), n;
      }

      function nt(e) {
        var t, r;
        var n = "number" == typeof e.exclusiveMinimum ? Math.min(e.exclusiveMinimum, null != (t = e.minimum) ? t : 1 / 0) : e.minimum,
            o = "number" == typeof e.exclusiveMaximum ? Math.max(e.exclusiveMaximum, null != (r = e.maximum) ? r : -1 / 0) : e.maximum,
            i = "number" == typeof e.exclusiveMinimum || e.exclusiveMinimum,
            s = "number" == typeof e.exclusiveMaximum || e.exclusiveMaximum;
        return void 0 !== n && void 0 !== o ? "".concat(i ? "( " : "[ ").concat(n, " .. ").concat(o).concat(s ? " )" : " ]") : void 0 !== o ? "".concat(s ? "< " : "<= ").concat(o) : void 0 !== n ? "".concat(i ? "> " : ">= ").concat(n) : void 0;
      }

      function ot(e) {
        var t = [],
            r = rt("characters", e.minLength, e.maxLength);
        void 0 !== r && t.push(r);
        var n = rt("items", e.minItems, e.maxItems);
        void 0 !== n && t.push(n);
        var o = rt("properties", e.minProperties, e.maxProperties);
        void 0 !== o && t.push(o);

        var i = function (e) {
          if (void 0 === e) return;
          var t = e.toString(10);
          return /^0\.0*1$/.test(t) ? "decimal places <= ".concat(t.split(".")[1].length) : "multiple of ".concat(t);
        }(e.multipleOf);

        void 0 !== i && t.push(i);
        var s = nt(e);
        return void 0 !== s && t.push(s), e.uniqueItems && t.push("unique"), t;
      }

      function it(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var r = [],
            n = [],
            o = [];
        return e.forEach(function (e) {
          e.required ? t.includes(e.name) ? n.push(e) : o.push(e) : r.push(e);
        }), n.sort(function (e, r) {
          return t.indexOf(e.name) - t.indexOf(r.name);
        }), [].concat(n, o, r);
      }

      function st(e, t) {
        return _toConsumableArray(e).sort(function (e, r) {
          return e[t].localeCompare(r[t]);
        });
      }

      function at(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var n = {};
        return r.forEach(function (t) {
          var _e$deref;

          (_e$deref = e.deref(t), t = _e$deref.resolved), n[t.name + "_" + t.in] = !0;
        }), (t = t.filter(function (t) {
          var _e$deref2;

          return (_e$deref2 = e.deref(t), t = _e$deref2.resolved), !n[t.name + "_" + t.in];
        })).concat(r);
      }

      function lt(e) {
        var t = {};
        return Object.keys(e).forEach(function (r) {
          var n = e[r],
              o = r.split(";")[0].trim();
          t[o] ? t[o] = Ie(Ie({}, t[o]), n) : t[o] = n;
        }), t;
      }

      function ct(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return e.replace(/(?:{)([\w-.]+)(?:})/g, function (e, r) {
          return t[r] && t[r].default || e;
        });
      }

      function pt(e, t) {
        var r = void 0 === e ? $(function () {
          if (!s) return "";
          var e = window.location.href;
          return e.endsWith(".html") ? (0, Oe.dirname)(e) : e;
        }()) : (0, Oe.dirname)(e);
        return 0 === t.length && (t = [{
          url: "/"
        }]), t.map(function (e) {
          return Te(Ie({}, e), {
            url: (t = e.url, O(r, t)),
            description: e.description || ""
          });
          var t;
        });
      }

      var ut = "SecurityDefinitions",
          dt = "security-definitions",
          ht = "SchemaDefinition";
      var mt = "section/Authentication/";

      function ft(e) {
        mt = e;
      }

      var gt = function gt(e) {
        return {
          delete: "del",
          options: "opts"
        }[e] || e;
      };

      function yt(e) {
        return e in {
          "x-circular-ref": !0,
          "x-parentRefs": !0,
          "x-refsStack": !0,
          "x-code-samples": !0,
          "x-codeSamples": !0,
          "x-displayName": !0,
          "x-examples": !0,
          "x-ignoredHeaderParameters": !0,
          "x-logo": !0,
          "x-nullable": !0,
          "x-servers": !0,
          "x-tagGroups": !0,
          "x-traitTag": !0,
          "x-additionalPropertiesName": !0,
          "x-explicitMappingOnly": !0
        };
      }

      function bt(e, t) {
        return Object.keys(e).filter(function (e) {
          return !0 === t ? e.startsWith("x-") && !yt(e) : e.startsWith("x-") && t.indexOf(e) > -1;
        }).reduce(function (t, r) {
          return t[r] = e[r], t;
        }, {});
      }

      function xt(e) {
        return e.split(" or ").map(function (e) {
          return e.replace(/^(string|object|number|integer|array|boolean)s?( ?.*)/, "$1s$2");
        }).join(" or ");
      }

      function vt(e) {
        var t = e.content;
        var r = e["x-examples"],
            n = e["x-example"];

        if (r) {
          t = Ie({}, t);

          for (var _i15 = 0, _Object$keys2 = Object.keys(r); _i15 < _Object$keys2.length; _i15++) {
            var _e22 = _Object$keys2[_i15];
            var _n37 = r[_e22];
            t[_e22] = Te(Ie({}, t[_e22]), {
              examples: _n37
            });
          }
        } else if (n) {
          t = Ie({}, t);

          for (var _i16 = 0, _Object$keys3 = Object.keys(n); _i16 < _Object$keys3.length; _i16++) {
            var _e23 = _Object$keys3[_i16];
            var _r35 = n[_e23];
            t[_e23] = Te(Ie({}, t[_e23]), {
              example: _r35
            });
          }
        }

        return t;
      }

      var wt = require("prismjs");

      require("prismjs/components/prism-bash.js"), require("prismjs/components/prism-c.js"), require("prismjs/components/prism-clike.js"), require("prismjs/components/prism-coffeescript.js"), require("prismjs/components/prism-cpp.js"), require("prismjs/components/prism-csharp.js"), require("prismjs/components/prism-go.js"), require("prismjs/components/prism-http.js"), require("prismjs/components/prism-java.js"), require("prismjs/components/prism-lua.js"), require("prismjs/components/prism-markup-templating.js"), require("prismjs/components/prism-markup.js"), require("prismjs/components/prism-objectivec.js"), require("prismjs/components/prism-perl.js"), require("prismjs/components/prism-php.js"), require("prismjs/components/prism-python.js"), require("prismjs/components/prism-q.js"), require("prismjs/components/prism-ruby.js"), require("prismjs/components/prism-scala.js"), require("prismjs/components/prism-sql.js"), require("prismjs/components/prism-swift.js"), require("prismjs/components/prism-yaml.js"), require("prismjs/components/prism-csv.js");

      function kt(e) {
        return {
          json: "js",
          "c++": "cpp",
          "c#": "csharp",
          "objective-c": "objectivec",
          shell: "bash",
          viml: "vim"
        }[e] || "clike";
      }

      function Ot(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "clike";
        t = t.toLowerCase();
        var r = wt.languages[t];
        return r || (r = wt.languages[kt(t)]), wt.highlight(e.toString(), r, t);
      }

      function Et(e) {
        return function (t, r, n) {
          n.value = function (e, t) {
            var r,
                n,
                o,
                i = null,
                s = 0;

            var a = function a() {
              s = new Date().getTime(), i = null, o = e.apply(r, n), i || (r = n = null);
            };

            return function () {
              var l = new Date().getTime(),
                  c = t - (l - s);
              return r = this, n = arguments, c <= 0 || c > t ? (i && (clearTimeout(i), i = null), s = l, o = e.apply(r, n), i || (r = n = null)) : i || (i = setTimeout(a, c)), o;
            };
          }(n.value, e);
        };
      }

      function St(e) {}

      function $t(e) {}

      wt.languages.insertBefore("javascript", "string", {
        "property string": {
          pattern: /([{,]\s*)"(?:\\.|[^\\"\r\n])*"(?=\s*:)/i,
          lookbehind: !0
        }
      }, void 0), wt.languages.insertBefore("javascript", "punctuation", {
        property: {
          pattern: /([{,]\s*)[a-z]\w*(?=\s*:)/i,
          lookbehind: !0
        }
      }, void 0);

      var Rt = Object.defineProperty,
          jt = Object.defineProperties,
          Ct = Object.getOwnPropertyDescriptors,
          At = Object.getOwnPropertySymbols,
          Pt = Object.prototype.hasOwnProperty,
          It = Object.prototype.propertyIsEnumerable,
          Tt = function Tt(e, t, r) {
        return t in e ? Rt(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          _t = function _t(e, t) {
        for (var r in t || (t = {})) {
          Pt.call(t, r) && Tt(e, r, t[r]);
        }

        if (At) {
          var _iterator22 = _createForOfIteratorHelper(At(t)),
              _step22;

          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var r = _step22.value;
              It.call(t, r) && Tt(e, r, t[r]);
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }
        }

        return e;
      },
          Lt = function Lt(e, t) {
        return jt(e, Ct(t));
      };

      var Dt = {};

      function zt(e, t, r) {
        if ("function" == typeof r.value) return function (e, t, r) {
          if (!r.value || r.value.length > 0) throw new Error("@memoize decorator can only be applied to methods of zero arguments");
          var n = "_memoized_".concat(t),
              o = r.value;
          return e[n] = Dt, Lt(_t({}, r), {
            value: function value() {
              return this[n] === Dt && (this[n] = o.call(this)), this[n];
            }
          });
        }(e, t, r);
        if ("function" == typeof r.get) return function (e, t, r) {
          var n = "_memoized_".concat(t),
              o = r.get;
          return e[n] = Dt, Lt(_t({}, r), {
            get: function get() {
              return this[n] === Dt && (this[n] = o.call(this)), this[n];
            }
          });
        }(e, t, r);
        throw new Error("@memoize decorator can be applied to methods or getters, got " + String(r.value) + " instead");
      }

      function Mt(e) {
        var t = 1;
        return "-" === e[0] && (t = -1, e = e.substr(1)), function (r, n) {
          return -1 == t ? n[e].localeCompare(r[e]) : r[e].localeCompare(n[e]);
        };
      }

      var Nt = Object.defineProperty,
          Ft = Object.getOwnPropertyDescriptor;
      var qt = "hashchange";

      var Bt = /*#__PURE__*/function () {
        function Bt() {
          var _this3 = this;

          _classCallCheck(this, Bt);

          this.emit = function () {
            _this3._emiter.emit(qt, _this3.currentId);
          }, this._emiter = new xe.EventEmitter(), this.bind();
        }

        _createClass(Bt, [{
          key: "currentId",
          get: function get() {
            return s ? decodeURIComponent(window.location.hash.substring(1)) : "";
          }
        }, {
          key: "linkForId",
          value: function linkForId(e) {
            return e ? "#" + e : "";
          }
        }, {
          key: "subscribe",
          value: function subscribe(e) {
            var t = this._emiter.addListener(qt, e);

            return function () {
              return t.removeListener(qt, e);
            };
          }
        }, {
          key: "bind",
          value: function bind() {
            s && window.addEventListener("hashchange", this.emit, !1);
          }
        }, {
          key: "dispose",
          value: function dispose() {
            s && window.removeEventListener("hashchange", this.emit);
          }
        }, {
          key: "replace",
          value: function replace(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            s && null != e && e !== this.currentId && (t ? window.history.replaceState(null, "", window.location.href.split("#")[0] + this.linkForId(e)) : (window.history.pushState(null, "", window.location.href.split("#")[0] + this.linkForId(e)), this.emit()));
          }
        }]);

        return Bt;
      }();

      (function (e, t, r, n) {
        for (var o, i = Ft(t, r), s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(t, r, i) || i);
        }

        i && Nt(t, r, i);
      })([be.bind, be.debounce], Bt.prototype, "replace");

      var Qt = new Bt();

      var Ut = require("mark.js");

      var Wt = /*#__PURE__*/function () {
        function Wt() {
          _classCallCheck(this, Wt);

          this.map = new Map(), this.prevTerm = "";
        }

        _createClass(Wt, [{
          key: "add",
          value: function add(e) {
            this.map.set(e, new Ut(e));
          }
        }, {
          key: "delete",
          value: function _delete(e) {
            this.map.delete(e);
          }
        }, {
          key: "addOnly",
          value: function addOnly(e) {
            var _this4 = this;

            this.map.forEach(function (t, r) {
              -1 === e.indexOf(r) && (t.unmark(), _this4.map.delete(r));
            });

            var _iterator23 = _createForOfIteratorHelper(e),
                _step23;

            try {
              for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                var _t51 = _step23.value;
                this.map.has(_t51) || this.map.set(_t51, new Ut(_t51));
              }
            } catch (err) {
              _iterator23.e(err);
            } finally {
              _iterator23.f();
            }
          }
        }, {
          key: "clearAll",
          value: function clearAll() {
            this.unmark(), this.map.clear();
          }
        }, {
          key: "mark",
          value: function mark(e) {
            var _this5 = this;

            (e || this.prevTerm) && (this.map.forEach(function (t) {
              t.unmark(), t.mark(e || _this5.prevTerm);
            }), this.prevTerm = e || this.prevTerm);
          }
        }, {
          key: "unmark",
          value: function unmark() {
            this.map.forEach(function (e) {
              return e.unmark();
            }), this.prevTerm = "";
          }
        }]);

        return Wt;
      }();

      var Vt = {
        baseUrl: null,
        breaks: !1,
        extensions: null,
        gfm: !0,
        headerIds: !0,
        headerPrefix: "",
        highlight: null,
        langPrefix: "language-",
        mangle: !0,
        pedantic: !1,
        renderer: null,
        sanitize: !1,
        sanitizer: null,
        silent: !1,
        smartLists: !1,
        smartypants: !1,
        tokenizer: null,
        walkTokens: null,
        xhtml: !1
      };

      var Ht = /[&<>"']/,
          Jt = /[&<>"']/g,
          Yt = /[<>"']|&(?!#?\w+;)/,
          Zt = /[<>"']|&(?!#?\w+;)/g,
          Gt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      },
          Xt = function Xt(e) {
        return Gt[e];
      };

      function Kt(e, t) {
        if (t) {
          if (Ht.test(e)) return e.replace(Jt, Xt);
        } else if (Yt.test(e)) return e.replace(Zt, Xt);

        return e;
      }

      var er = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;

      function tr(e) {
        return e.replace(er, function (e, t) {
          return "colon" === (t = t.toLowerCase()) ? ":" : "#" === t.charAt(0) ? "x" === t.charAt(1) ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : "";
        });
      }

      var rr = /(^|[^\[])\^/g;

      function nr(e, t) {
        e = "string" == typeof e ? e : e.source, t = t || "";
        var r = {
          replace: function replace(t, n) {
            return n = (n = n.source || n).replace(rr, "$1"), e = e.replace(t, n), r;
          },
          getRegex: function getRegex() {
            return new RegExp(e, t);
          }
        };
        return r;
      }

      var or = /[^\w:]/g,
          ir = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

      function sr(e, t, r) {
        if (e) {
          var _e24;

          try {
            _e24 = decodeURIComponent(tr(r)).replace(or, "").toLowerCase();
          } catch (e) {
            return null;
          }

          if (0 === _e24.indexOf("javascript:") || 0 === _e24.indexOf("vbscript:") || 0 === _e24.indexOf("data:")) return null;
        }

        t && !ir.test(r) && (r = function (e, t) {
          ar[" " + e] || (lr.test(e) ? ar[" " + e] = e + "/" : ar[" " + e] = mr(e, "/", !0));
          var r = -1 === (e = ar[" " + e]).indexOf(":");
          return "//" === t.substring(0, 2) ? r ? t : e.replace(cr, "$1") + t : "/" === t.charAt(0) ? r ? t : e.replace(pr, "$1") + t : e + t;
        }(t, r));

        try {
          r = encodeURI(r).replace(/%25/g, "%");
        } catch (e) {
          return null;
        }

        return r;
      }

      var ar = {},
          lr = /^[^:]+:\/*[^/]*$/,
          cr = /^([^:]+:)[\s\S]*$/,
          pr = /^([^:]+:\/*[^/]*)[\s\S]*$/,
          ur = {
        exec: function exec() {}
      };

      function dr(e) {
        var t,
            r,
            n = 1;

        for (; n < arguments.length; n++) {
          for (r in t = arguments[n], t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }

        return e;
      }

      function hr(e, t) {
        var r = e.replace(/\|/g, function (e, t, r) {
          var n = !1,
              o = t;

          for (; --o >= 0 && "\\" === r[o];) {
            n = !n;
          }

          return n ? "|" : " |";
        }).split(/ \|/);
        var n = 0;
        if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), r.length > t) r.splice(t);else for (; r.length < t;) {
          r.push("");
        }

        for (; n < r.length; n++) {
          r[n] = r[n].trim().replace(/\\\|/g, "|");
        }

        return r;
      }

      function mr(e, t, r) {
        var n = e.length;
        if (0 === n) return "";
        var o = 0;

        for (; o < n;) {
          var _i17 = e.charAt(n - o - 1);

          if (_i17 !== t || r) {
            if (_i17 === t || !r) break;
            o++;
          } else o++;
        }

        return e.slice(0, n - o);
      }

      function fr(e) {
        e && e.sanitize && !e.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
      }

      function gr(e, t) {
        if (t < 1) return "";
        var r = "";

        for (; t > 1;) {
          1 & t && (r += e), t >>= 1, e += e;
        }

        return r + e;
      }

      function yr(e, t, r, n) {
        var o = t.href,
            i = t.title ? Kt(t.title) : null,
            s = e[1].replace(/\\([\[\]])/g, "$1");

        if ("!" !== e[0].charAt(0)) {
          n.state.inLink = !0;
          var _e25 = {
            type: "link",
            raw: r,
            href: o,
            title: i,
            text: s,
            tokens: n.inlineTokens(s, [])
          };
          return n.state.inLink = !1, _e25;
        }

        return {
          type: "image",
          raw: r,
          href: o,
          title: i,
          text: Kt(s)
        };
      }

      var br = /*#__PURE__*/function () {
        function br(e) {
          _classCallCheck(this, br);

          this.options = e || Vt;
        }

        _createClass(br, [{
          key: "space",
          value: function space(e) {
            var t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
              type: "space",
              raw: t[0]
            };
          }
        }, {
          key: "code",
          value: function code(e) {
            var t = this.rules.block.code.exec(e);

            if (t) {
              var _e26 = t[0].replace(/^ {1,4}/gm, "");

              return {
                type: "code",
                raw: t[0],
                codeBlockStyle: "indented",
                text: this.options.pedantic ? _e26 : mr(_e26, "\n")
              };
            }
          }
        }, {
          key: "fences",
          value: function fences(e) {
            var t = this.rules.block.fences.exec(e);

            if (t) {
              var _e27 = t[0],
                  _r36 = function (e, t) {
                var r = e.match(/^(\s+)(?:```)/);
                if (null === r) return t;
                var n = r[1];
                return t.split("\n").map(function (e) {
                  var t = e.match(/^\s+/);
                  if (null === t) return e;

                  var _t52 = _slicedToArray(t, 1),
                      r = _t52[0];

                  return r.length >= n.length ? e.slice(n.length) : e;
                }).join("\n");
              }(_e27, t[3] || "");

              return {
                type: "code",
                raw: _e27,
                lang: t[2] ? t[2].trim() : t[2],
                text: _r36
              };
            }
          }
        }, {
          key: "heading",
          value: function heading(e) {
            var t = this.rules.block.heading.exec(e);

            if (t) {
              var _e28 = t[2].trim();

              if (/#$/.test(_e28)) {
                var _t53 = mr(_e28, "#");

                this.options.pedantic ? _e28 = _t53.trim() : _t53 && !/ $/.test(_t53) || (_e28 = _t53.trim());
              }

              var _r37 = {
                type: "heading",
                raw: t[0],
                depth: t[1].length,
                text: _e28,
                tokens: []
              };
              return this.lexer.inline(_r37.text, _r37.tokens), _r37;
            }
          }
        }, {
          key: "hr",
          value: function hr(e) {
            var t = this.rules.block.hr.exec(e);
            if (t) return {
              type: "hr",
              raw: t[0]
            };
          }
        }, {
          key: "blockquote",
          value: function blockquote(e) {
            var t = this.rules.block.blockquote.exec(e);

            if (t) {
              var _e29 = t[0].replace(/^ *>[ \t]?/gm, "");

              return {
                type: "blockquote",
                raw: t[0],
                tokens: this.lexer.blockTokens(_e29, []),
                text: _e29
              };
            }
          }
        }, {
          key: "list",
          value: function list(e) {
            var t = this.rules.block.list.exec(e);

            if (t) {
              var _r38,
                  _n38,
                  _o15,
                  _i18,
                  _s6,
                  _a6,
                  _l2,
                  _c4,
                  _p4,
                  _u2,
                  _d,
                  _h,
                  _m = t[1].trim();

              var _f = _m.length > 1,
                  _g = {
                type: "list",
                raw: "",
                ordered: _f,
                start: _f ? +_m.slice(0, -1) : "",
                loose: !1,
                items: []
              };

              _m = _f ? "\\d{1,9}\\".concat(_m.slice(-1)) : "\\".concat(_m), this.options.pedantic && (_m = _f ? _m : "[*+-]");

              var _y = new RegExp("^( {0,3}".concat(_m, ")((?:[\t ][^\\n]*)?(?:\\n|$))"));

              for (; e && (_h = !1, t = _y.exec(e)) && !this.rules.block.hr.test(e);) {
                if (_r38 = t[0], e = e.substring(_r38.length), _c4 = t[2].split("\n", 1)[0], _p4 = e.split("\n", 1)[0], this.options.pedantic ? (_i18 = 2, _d = _c4.trimLeft()) : (_i18 = t[2].search(/[^ ]/), _i18 = _i18 > 4 ? 1 : _i18, _d = _c4.slice(_i18), _i18 += t[1].length), _a6 = !1, !_c4 && /^ *$/.test(_p4) && (_r38 += _p4 + "\n", e = e.substring(_p4.length + 1), _h = !0), !_h) {
                  var _t54 = new RegExp("^ {0,".concat(Math.min(3, _i18 - 1), "}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))")),
                      _n39 = new RegExp("^ {0,".concat(Math.min(3, _i18 - 1), "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"));

                  for (; e && (_u2 = e.split("\n", 1)[0], _c4 = _u2, this.options.pedantic && (_c4 = _c4.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !_t54.test(_c4)) && !_n39.test(e);) {
                    if (_c4.search(/[^ ]/) >= _i18 || !_c4.trim()) _d += "\n" + _c4.slice(_i18);else {
                      if (_a6) break;
                      _d += "\n" + _c4;
                    }
                    _a6 || _c4.trim() || (_a6 = !0), _r38 += _u2 + "\n", e = e.substring(_u2.length + 1);
                  }
                }

                _g.loose || (_l2 ? _g.loose = !0 : /\n *\n *$/.test(_r38) && (_l2 = !0)), this.options.gfm && (_n38 = /^\[[ xX]\] /.exec(_d), _n38 && (_o15 = "[ ] " !== _n38[0], _d = _d.replace(/^\[[ xX]\] +/, ""))), _g.items.push({
                  type: "list_item",
                  raw: _r38,
                  task: !!_n38,
                  checked: _o15,
                  loose: !1,
                  text: _d
                }), _g.raw += _r38;
              }

              _g.items[_g.items.length - 1].raw = _r38.trimRight(), _g.items[_g.items.length - 1].text = _d.trimRight(), _g.raw = _g.raw.trimRight();
              var _b = _g.items.length;

              for (_s6 = 0; _s6 < _b; _s6++) {
                this.lexer.state.top = !1, _g.items[_s6].tokens = this.lexer.blockTokens(_g.items[_s6].text, []);

                var _e30 = _g.items[_s6].tokens.filter(function (e) {
                  return "space" === e.type;
                }),
                    _t55 = _e30.every(function (e) {
                  var t = e.raw.split("");
                  var r = 0;

                  var _iterator24 = _createForOfIteratorHelper(t),
                      _step24;

                  try {
                    for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                      var _e31 = _step24.value;
                      if ("\n" === _e31 && (r += 1), r > 1) return !0;
                    }
                  } catch (err) {
                    _iterator24.e(err);
                  } finally {
                    _iterator24.f();
                  }

                  return !1;
                });

                !_g.loose && _e30.length && _t55 && (_g.loose = !0, _g.items[_s6].loose = !0);
              }

              return _g;
            }
          }
        }, {
          key: "html",
          value: function html(e) {
            var t = this.rules.block.html.exec(e);

            if (t) {
              var _e32 = {
                type: "html",
                raw: t[0],
                pre: !this.options.sanitizer && ("pre" === t[1] || "script" === t[1] || "style" === t[1]),
                text: t[0]
              };
              return this.options.sanitize && (_e32.type = "paragraph", _e32.text = this.options.sanitizer ? this.options.sanitizer(t[0]) : Kt(t[0]), _e32.tokens = [], this.lexer.inline(_e32.text, _e32.tokens)), _e32;
            }
          }
        }, {
          key: "def",
          value: function def(e) {
            var t = this.rules.block.def.exec(e);
            if (t) return t[3] && (t[3] = t[3].substring(1, t[3].length - 1)), {
              type: "def",
              tag: t[1].toLowerCase().replace(/\s+/g, " "),
              raw: t[0],
              href: t[2],
              title: t[3]
            };
          }
        }, {
          key: "table",
          value: function table(e) {
            var t = this.rules.block.table.exec(e);

            if (t) {
              var _e33 = {
                type: "table",
                header: hr(t[1]).map(function (e) {
                  return {
                    text: e
                  };
                }),
                align: t[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                rows: t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split("\n") : []
              };

              if (_e33.header.length === _e33.align.length) {
                _e33.raw = t[0];

                var _r39,
                    _n40,
                    _o16,
                    _i19,
                    _s7 = _e33.align.length;

                for (_r39 = 0; _r39 < _s7; _r39++) {
                  /^ *-+: *$/.test(_e33.align[_r39]) ? _e33.align[_r39] = "right" : /^ *:-+: *$/.test(_e33.align[_r39]) ? _e33.align[_r39] = "center" : /^ *:-+ *$/.test(_e33.align[_r39]) ? _e33.align[_r39] = "left" : _e33.align[_r39] = null;
                }

                for (_s7 = _e33.rows.length, _r39 = 0; _r39 < _s7; _r39++) {
                  _e33.rows[_r39] = hr(_e33.rows[_r39], _e33.header.length).map(function (e) {
                    return {
                      text: e
                    };
                  });
                }

                for (_s7 = _e33.header.length, _n40 = 0; _n40 < _s7; _n40++) {
                  _e33.header[_n40].tokens = [], this.lexer.inlineTokens(_e33.header[_n40].text, _e33.header[_n40].tokens);
                }

                for (_s7 = _e33.rows.length, _n40 = 0; _n40 < _s7; _n40++) {
                  for (_i19 = _e33.rows[_n40], _o16 = 0; _o16 < _i19.length; _o16++) {
                    _i19[_o16].tokens = [], this.lexer.inlineTokens(_i19[_o16].text, _i19[_o16].tokens);
                  }
                }

                return _e33;
              }
            }
          }
        }, {
          key: "lheading",
          value: function lheading(e) {
            var t = this.rules.block.lheading.exec(e);

            if (t) {
              var _e34 = {
                type: "heading",
                raw: t[0],
                depth: "=" === t[2].charAt(0) ? 1 : 2,
                text: t[1],
                tokens: []
              };
              return this.lexer.inline(_e34.text, _e34.tokens), _e34;
            }
          }
        }, {
          key: "paragraph",
          value: function paragraph(e) {
            var t = this.rules.block.paragraph.exec(e);

            if (t) {
              var _e35 = {
                type: "paragraph",
                raw: t[0],
                text: "\n" === t[1].charAt(t[1].length - 1) ? t[1].slice(0, -1) : t[1],
                tokens: []
              };
              return this.lexer.inline(_e35.text, _e35.tokens), _e35;
            }
          }
        }, {
          key: "text",
          value: function text(e) {
            var t = this.rules.block.text.exec(e);

            if (t) {
              var _e36 = {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: []
              };
              return this.lexer.inline(_e36.text, _e36.tokens), _e36;
            }
          }
        }, {
          key: "escape",
          value: function escape(e) {
            var t = this.rules.inline.escape.exec(e);
            if (t) return {
              type: "escape",
              raw: t[0],
              text: Kt(t[1])
            };
          }
        }, {
          key: "tag",
          value: function tag(e) {
            var t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
              type: this.options.sanitize ? "text" : "html",
              raw: t[0],
              inLink: this.lexer.state.inLink,
              inRawBlock: this.lexer.state.inRawBlock,
              text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(t[0]) : Kt(t[0]) : t[0]
            };
          }
        }, {
          key: "link",
          value: function link(e) {
            var t = this.rules.inline.link.exec(e);

            if (t) {
              var _e37 = t[2].trim();

              if (!this.options.pedantic && /^</.test(_e37)) {
                if (!/>$/.test(_e37)) return;

                var _t56 = mr(_e37.slice(0, -1), "\\");

                if ((_e37.length - _t56.length) % 2 == 0) return;
              } else {
                var _e38 = function (e, t) {
                  if (-1 === e.indexOf(t[1])) return -1;
                  var r = e.length;
                  var n = 0,
                      o = 0;

                  for (; o < r; o++) {
                    if ("\\" === e[o]) o++;else if (e[o] === t[0]) n++;else if (e[o] === t[1] && (n--, n < 0)) return o;
                  }

                  return -1;
                }(t[2], "()");

                if (_e38 > -1) {
                  var _r41 = (0 === t[0].indexOf("!") ? 5 : 4) + t[1].length + _e38;

                  t[2] = t[2].substring(0, _e38), t[0] = t[0].substring(0, _r41).trim(), t[3] = "";
                }
              }

              var _r40 = t[2],
                  _n41 = "";

              if (this.options.pedantic) {
                var _e39 = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(_r40);

                _e39 && (_r40 = _e39[1], _n41 = _e39[3]);
              } else _n41 = t[3] ? t[3].slice(1, -1) : "";

              return _r40 = _r40.trim(), /^</.test(_r40) && (_r40 = this.options.pedantic && !/>$/.test(_e37) ? _r40.slice(1) : _r40.slice(1, -1)), yr(t, {
                href: _r40 ? _r40.replace(this.rules.inline._escapes, "$1") : _r40,
                title: _n41 ? _n41.replace(this.rules.inline._escapes, "$1") : _n41
              }, t[0], this.lexer);
            }
          }
        }, {
          key: "reflink",
          value: function reflink(e, t) {
            var r;

            if ((r = this.rules.inline.reflink.exec(e)) || (r = this.rules.inline.nolink.exec(e))) {
              var _e40 = (r[2] || r[1]).replace(/\s+/g, " ");

              if (_e40 = t[_e40.toLowerCase()], !_e40 || !_e40.href) {
                var _e41 = r[0].charAt(0);

                return {
                  type: "text",
                  raw: _e41,
                  text: _e41
                };
              }

              return yr(r, _e40, r[0], this.lexer);
            }
          }
        }, {
          key: "emStrong",
          value: function emStrong(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
            var n = this.rules.inline.emStrong.lDelim.exec(e);
            if (!n) return;
            if (n[3] && r.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var o = n[1] || n[2] || "";

            if (!o || o && ("" === r || this.rules.inline.punctuation.exec(r))) {
              var _r42 = n[0].length - 1;

              var _o17,
                  _i20,
                  _s8 = _r42,
                  _a7 = 0;

              var _l3 = "*" === n[0][0] ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;

              for (_l3.lastIndex = 0, t = t.slice(-1 * e.length + _r42); null != (n = _l3.exec(t));) {
                if (_o17 = n[1] || n[2] || n[3] || n[4] || n[5] || n[6], !_o17) continue;

                if (_i20 = _o17.length, n[3] || n[4]) {
                  _s8 += _i20;
                  continue;
                }

                if ((n[5] || n[6]) && _r42 % 3 && !((_r42 + _i20) % 3)) {
                  _a7 += _i20;
                  continue;
                }

                if (_s8 -= _i20, _s8 > 0) continue;

                if (_i20 = Math.min(_i20, _i20 + _s8 + _a7), Math.min(_r42, _i20) % 2) {
                  var _t58 = e.slice(1, _r42 + n.index + _i20);

                  return {
                    type: "em",
                    raw: e.slice(0, _r42 + n.index + _i20 + 1),
                    text: _t58,
                    tokens: this.lexer.inlineTokens(_t58, [])
                  };
                }

                var _t57 = e.slice(2, _r42 + n.index + _i20 - 1);

                return {
                  type: "strong",
                  raw: e.slice(0, _r42 + n.index + _i20 + 1),
                  text: _t57,
                  tokens: this.lexer.inlineTokens(_t57, [])
                };
              }
            }
          }
        }, {
          key: "codespan",
          value: function codespan(e) {
            var t = this.rules.inline.code.exec(e);

            if (t) {
              var _e42 = t[2].replace(/\n/g, " ");

              var _r43 = /[^ ]/.test(_e42),
                  _n42 = /^ /.test(_e42) && / $/.test(_e42);

              return _r43 && _n42 && (_e42 = _e42.substring(1, _e42.length - 1)), _e42 = Kt(_e42, !0), {
                type: "codespan",
                raw: t[0],
                text: _e42
              };
            }
          }
        }, {
          key: "br",
          value: function br(e) {
            var t = this.rules.inline.br.exec(e);
            if (t) return {
              type: "br",
              raw: t[0]
            };
          }
        }, {
          key: "del",
          value: function del(e) {
            var t = this.rules.inline.del.exec(e);
            if (t) return {
              type: "del",
              raw: t[0],
              text: t[2],
              tokens: this.lexer.inlineTokens(t[2], [])
            };
          }
        }, {
          key: "autolink",
          value: function autolink(e, t) {
            var r = this.rules.inline.autolink.exec(e);

            if (r) {
              var _e43, _n43;

              return "@" === r[2] ? (_e43 = Kt(this.options.mangle ? t(r[1]) : r[1]), _n43 = "mailto:" + _e43) : (_e43 = Kt(r[1]), _n43 = _e43), {
                type: "link",
                raw: r[0],
                text: _e43,
                href: _n43,
                tokens: [{
                  type: "text",
                  raw: _e43,
                  text: _e43
                }]
              };
            }
          }
        }, {
          key: "url",
          value: function url(e, t) {
            var r;

            if (r = this.rules.inline.url.exec(e)) {
              var _e44, _n44;

              if ("@" === r[2]) _e44 = Kt(this.options.mangle ? t(r[0]) : r[0]), _n44 = "mailto:" + _e44;else {
                var _t59;

                do {
                  _t59 = r[0], r[0] = this.rules.inline._backpedal.exec(r[0])[0];
                } while (_t59 !== r[0]);

                _e44 = Kt(r[0]), _n44 = "www." === r[1] ? "http://" + _e44 : _e44;
              }
              return {
                type: "link",
                raw: r[0],
                text: _e44,
                href: _n44,
                tokens: [{
                  type: "text",
                  raw: _e44,
                  text: _e44
                }]
              };
            }
          }
        }, {
          key: "inlineText",
          value: function inlineText(e, t) {
            var r = this.rules.inline.text.exec(e);

            if (r) {
              var _e45;

              return _e45 = this.lexer.state.inRawBlock ? this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(r[0]) : Kt(r[0]) : r[0] : Kt(this.options.smartypants ? t(r[0]) : r[0]), {
                type: "text",
                raw: r[0],
                text: _e45
              };
            }
          }
        }]);

        return br;
      }();

      var xr = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: ur,
        lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/,
        _label: /(?!\s*\])(?:\\.|[^\[\]\\])+/,
        _title: /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/
      };
      xr.def = nr(xr.def).replace("label", xr._label).replace("title", xr._title).getRegex(), xr.bullet = /(?:[*+-]|\d{1,9}[.)])/, xr.listItemStart = nr(/^( *)(bull) */).replace("bull", xr.bullet).getRegex(), xr.list = nr(xr.list).replace(/bull/g, xr.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + xr.def.source + ")").getRegex(), xr._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", xr._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, xr.html = nr(xr.html, "i").replace("comment", xr._comment).replace("tag", xr._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), xr.paragraph = nr(xr._paragraph).replace("hr", xr.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xr._tag).getRegex(), xr.blockquote = nr(xr.blockquote).replace("paragraph", xr.paragraph).getRegex(), xr.normal = dr({}, xr), xr.gfm = dr({}, xr.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
      }), xr.gfm.table = nr(xr.gfm.table).replace("hr", xr.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xr._tag).getRegex(), xr.gfm.paragraph = nr(xr._paragraph).replace("hr", xr.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", xr.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xr._tag).getRegex(), xr.pedantic = dr({}, xr.normal, {
        html: nr("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", xr._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: ur,
        paragraph: nr(xr.normal._paragraph).replace("hr", xr.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", xr.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
      });
      var vr = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: ur,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: "reflink|nolink(?!\\()",
        emStrong: {
          lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
          rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
          rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: ur,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
      };

      function wr(e) {
        return e.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
      }

      function kr(e) {
        var t,
            r,
            n = "";
        var o = e.length;

        for (t = 0; t < o; t++) {
          r = e.charCodeAt(t), Math.random() > .5 && (r = "x" + r.toString(16)), n += "&#" + r + ";";
        }

        return n;
      }

      vr._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", vr.punctuation = nr(vr.punctuation).replace(/punctuation/g, vr._punctuation).getRegex(), vr.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, vr.escapedEmSt = /\\\*|\\_/g, vr._comment = nr(xr._comment).replace("(?:--\x3e|$)", "--\x3e").getRegex(), vr.emStrong.lDelim = nr(vr.emStrong.lDelim).replace(/punct/g, vr._punctuation).getRegex(), vr.emStrong.rDelimAst = nr(vr.emStrong.rDelimAst, "g").replace(/punct/g, vr._punctuation).getRegex(), vr.emStrong.rDelimUnd = nr(vr.emStrong.rDelimUnd, "g").replace(/punct/g, vr._punctuation).getRegex(), vr._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, vr._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, vr._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, vr.autolink = nr(vr.autolink).replace("scheme", vr._scheme).replace("email", vr._email).getRegex(), vr._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, vr.tag = nr(vr.tag).replace("comment", vr._comment).replace("attribute", vr._attribute).getRegex(), vr._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, vr._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, vr._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, vr.link = nr(vr.link).replace("label", vr._label).replace("href", vr._href).replace("title", vr._title).getRegex(), vr.reflink = nr(vr.reflink).replace("label", vr._label).replace("ref", xr._label).getRegex(), vr.nolink = nr(vr.nolink).replace("ref", xr._label).getRegex(), vr.reflinkSearch = nr(vr.reflinkSearch, "g").replace("reflink", vr.reflink).replace("nolink", vr.nolink).getRegex(), vr.normal = dr({}, vr), vr.pedantic = dr({}, vr.normal, {
        strong: {
          start: /^__|\*\*/,
          middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
          endAst: /\*\*(?!\*)/g,
          endUnd: /__(?!_)/g
        },
        em: {
          start: /^_|\*/,
          middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
          endAst: /\*(?!\*)/g,
          endUnd: /_(?!_)/g
        },
        link: nr(/^!?\[(label)\]\((.*?)\)/).replace("label", vr._label).getRegex(),
        reflink: nr(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", vr._label).getRegex()
      }), vr.gfm = dr({}, vr.normal, {
        escape: nr(vr.escape).replace("])", "~|])").getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
      }), vr.gfm.url = nr(vr.gfm.url, "i").replace("email", vr.gfm._extended_email).getRegex(), vr.breaks = dr({}, vr.gfm, {
        br: nr(vr.br).replace("{2,}", "*").getRegex(),
        text: nr(vr.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
      });

      var Or = /*#__PURE__*/function () {
        function Or(e) {
          _classCallCheck(this, Or);

          this.tokens = [], this.tokens.links = Object.create(null), this.options = e || Vt, this.options.tokenizer = this.options.tokenizer || new br(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
            inLink: !1,
            inRawBlock: !1,
            top: !0
          };
          var t = {
            block: xr.normal,
            inline: vr.normal
          };
          this.options.pedantic ? (t.block = xr.pedantic, t.inline = vr.pedantic) : this.options.gfm && (t.block = xr.gfm, this.options.breaks ? t.inline = vr.breaks : t.inline = vr.gfm), this.tokenizer.rules = t;
        }

        _createClass(Or, [{
          key: "lex",
          value: function lex(e) {
            var t;

            for (e = e.replace(/\r\n|\r/g, "\n"), this.blockTokens(e, this.tokens); t = this.inlineQueue.shift();) {
              this.inlineTokens(t.src, t.tokens);
            }

            return this.tokens;
          }
        }, {
          key: "blockTokens",
          value: function blockTokens(e) {
            var _this6 = this;

            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var r, n, o, i;

            for (e = this.options.pedantic ? e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e.replace(/^( *)(\t+)/gm, function (e, t, r) {
              return t + "    ".repeat(r.length);
            }); e;) {
              if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (n) {
                return !!(r = n.call({
                  lexer: _this6
                }, e, t)) && (e = e.substring(r.raw.length), t.push(r), !0);
              }))) if (r = this.tokenizer.space(e)) e = e.substring(r.raw.length), 1 === r.raw.length && t.length > 0 ? t[t.length - 1].raw += "\n" : t.push(r);else if (r = this.tokenizer.code(e)) e = e.substring(r.raw.length), n = t[t.length - 1], !n || "paragraph" !== n.type && "text" !== n.type ? t.push(r) : (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = n.text);else if (r = this.tokenizer.fences(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.heading(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.hr(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.blockquote(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.list(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.html(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.def(e)) e = e.substring(r.raw.length), n = t[t.length - 1], !n || "paragraph" !== n.type && "text" !== n.type ? this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                href: r.href,
                title: r.title
              }) : (n.raw += "\n" + r.raw, n.text += "\n" + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = n.text);else if (r = this.tokenizer.table(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.lheading(e)) e = e.substring(r.raw.length), t.push(r);else {
                if (o = e, this.options.extensions && this.options.extensions.startBlock) {
                  (function () {
                    var t = 1 / 0;
                    var r = e.slice(1);
                    var n = void 0;
                    _this6.options.extensions.startBlock.forEach(function (e) {
                      n = e.call({
                        lexer: this
                      }, r), "number" == typeof n && n >= 0 && (t = Math.min(t, n));
                    }), t < 1 / 0 && t >= 0 && (o = e.substring(0, t + 1));
                  })();
                }

                if (this.state.top && (r = this.tokenizer.paragraph(o))) n = t[t.length - 1], i && "paragraph" === n.type ? (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : t.push(r), i = o.length !== e.length, e = e.substring(r.raw.length);else if (r = this.tokenizer.text(e)) e = e.substring(r.raw.length), n = t[t.length - 1], n && "text" === n.type ? (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : t.push(r);else if (e) {
                  var _t60 = "Infinite loop on byte: " + e.charCodeAt(0);

                  if (this.options.silent) {
                    console.error(_t60);
                    break;
                  }

                  throw new Error(_t60);
                }
              }
            }

            return this.state.top = !0, t;
          }
        }, {
          key: "inline",
          value: function inline(e, t) {
            this.inlineQueue.push({
              src: e,
              tokens: t
            });
          }
        }, {
          key: "inlineTokens",
          value: function inlineTokens(e) {
            var _this7 = this;

            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var r,
                n,
                o,
                i,
                s,
                a,
                l = e;

            if (this.tokens.links) {
              var _e46 = Object.keys(this.tokens.links);

              if (_e46.length > 0) for (; null != (i = this.tokenizer.rules.inline.reflinkSearch.exec(l));) {
                _e46.includes(i[0].slice(i[0].lastIndexOf("[") + 1, -1)) && (l = l.slice(0, i.index) + "[" + gr("a", i[0].length - 2) + "]" + l.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
              }
            }

            for (; null != (i = this.tokenizer.rules.inline.blockSkip.exec(l));) {
              l = l.slice(0, i.index) + "[" + gr("a", i[0].length - 2) + "]" + l.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            }

            for (; null != (i = this.tokenizer.rules.inline.escapedEmSt.exec(l));) {
              l = l.slice(0, i.index) + "++" + l.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
            }

            for (; e;) {
              if (s || (a = ""), s = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (n) {
                return !!(r = n.call({
                  lexer: _this7
                }, e, t)) && (e = e.substring(r.raw.length), t.push(r), !0);
              }))) if (r = this.tokenizer.escape(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.tag(e)) e = e.substring(r.raw.length), n = t[t.length - 1], n && "text" === r.type && "text" === n.type ? (n.raw += r.raw, n.text += r.text) : t.push(r);else if (r = this.tokenizer.link(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.reflink(e, this.tokens.links)) e = e.substring(r.raw.length), n = t[t.length - 1], n && "text" === r.type && "text" === n.type ? (n.raw += r.raw, n.text += r.text) : t.push(r);else if (r = this.tokenizer.emStrong(e, l, a)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.codespan(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.br(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.del(e)) e = e.substring(r.raw.length), t.push(r);else if (r = this.tokenizer.autolink(e, kr)) e = e.substring(r.raw.length), t.push(r);else if (this.state.inLink || !(r = this.tokenizer.url(e, kr))) {
                if (o = e, this.options.extensions && this.options.extensions.startInline) {
                  (function () {
                    var t = 1 / 0;
                    var r = e.slice(1);
                    var n = void 0;
                    _this7.options.extensions.startInline.forEach(function (e) {
                      n = e.call({
                        lexer: this
                      }, r), "number" == typeof n && n >= 0 && (t = Math.min(t, n));
                    }), t < 1 / 0 && t >= 0 && (o = e.substring(0, t + 1));
                  })();
                }

                if (r = this.tokenizer.inlineText(o, wr)) e = e.substring(r.raw.length), "_" !== r.raw.slice(-1) && (a = r.raw.slice(-1)), s = !0, n = t[t.length - 1], n && "text" === n.type ? (n.raw += r.raw, n.text += r.text) : t.push(r);else if (e) {
                  var _t61 = "Infinite loop on byte: " + e.charCodeAt(0);

                  if (this.options.silent) {
                    console.error(_t61);
                    break;
                  }

                  throw new Error(_t61);
                }
              } else e = e.substring(r.raw.length), t.push(r);
            }

            return t;
          }
        }], [{
          key: "rules",
          get: function get() {
            return {
              block: xr,
              inline: vr
            };
          }
        }, {
          key: "lex",
          value: function lex(e, t) {
            return new Or(t).lex(e);
          }
        }, {
          key: "lexInline",
          value: function lexInline(e, t) {
            return new Or(t).inlineTokens(e);
          }
        }]);

        return Or;
      }();

      var Er = /*#__PURE__*/function () {
        function Er(e) {
          _classCallCheck(this, Er);

          this.options = e || Vt;
        }

        _createClass(Er, [{
          key: "code",
          value: function code(e, t, r) {
            var n = (t || "").match(/\S*/)[0];

            if (this.options.highlight) {
              var _t62 = this.options.highlight(e, n);

              null != _t62 && _t62 !== e && (r = !0, e = _t62);
            }

            return e = e.replace(/\n$/, "") + "\n", n ? '<pre><code class="' + this.options.langPrefix + Kt(n, !0) + '">' + (r ? e : Kt(e, !0)) + "</code></pre>\n" : "<pre><code>" + (r ? e : Kt(e, !0)) + "</code></pre>\n";
          }
        }, {
          key: "blockquote",
          value: function blockquote(e) {
            return "<blockquote>\n".concat(e, "</blockquote>\n");
          }
        }, {
          key: "html",
          value: function html(e) {
            return e;
          }
        }, {
          key: "heading",
          value: function heading(e, t, r, n) {
            return this.options.headerIds ? "<h".concat(t, " id=\"").concat(this.options.headerPrefix + n.slug(r), "\">").concat(e, "</h").concat(t, ">\n") : "<h".concat(t, ">").concat(e, "</h").concat(t, ">\n");
          }
        }, {
          key: "hr",
          value: function hr() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
          }
        }, {
          key: "list",
          value: function list(e, t, r) {
            var n = t ? "ol" : "ul";
            return "<" + n + (t && 1 !== r ? ' start="' + r + '"' : "") + ">\n" + e + "</" + n + ">\n";
          }
        }, {
          key: "listitem",
          value: function listitem(e) {
            return "<li>".concat(e, "</li>\n");
          }
        }, {
          key: "checkbox",
          value: function checkbox(e) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
          }
        }, {
          key: "paragraph",
          value: function paragraph(e) {
            return "<p>".concat(e, "</p>\n");
          }
        }, {
          key: "table",
          value: function table(e, t) {
            return t && (t = "<tbody>".concat(t, "</tbody>")), "<table>\n<thead>\n" + e + "</thead>\n" + t + "</table>\n";
          }
        }, {
          key: "tablerow",
          value: function tablerow(e) {
            return "<tr>\n".concat(e, "</tr>\n");
          }
        }, {
          key: "tablecell",
          value: function tablecell(e, t) {
            var r = t.header ? "th" : "td";
            return (t.align ? "<".concat(r, " align=\"").concat(t.align, "\">") : "<".concat(r, ">")) + e + "</".concat(r, ">\n");
          }
        }, {
          key: "strong",
          value: function strong(e) {
            return "<strong>".concat(e, "</strong>");
          }
        }, {
          key: "em",
          value: function em(e) {
            return "<em>".concat(e, "</em>");
          }
        }, {
          key: "codespan",
          value: function codespan(e) {
            return "<code>".concat(e, "</code>");
          }
        }, {
          key: "br",
          value: function br() {
            return this.options.xhtml ? "<br/>" : "<br>";
          }
        }, {
          key: "del",
          value: function del(e) {
            return "<del>".concat(e, "</del>");
          }
        }, {
          key: "link",
          value: function link(e, t, r) {
            if (null === (e = sr(this.options.sanitize, this.options.baseUrl, e))) return r;
            var n = '<a href="' + Kt(e) + '"';
            return t && (n += ' title="' + t + '"'), n += ">" + r + "</a>", n;
          }
        }, {
          key: "image",
          value: function image(e, t, r) {
            if (null === (e = sr(this.options.sanitize, this.options.baseUrl, e))) return r;
            var n = "<img src=\"".concat(e, "\" alt=\"").concat(r, "\"");
            return t && (n += " title=\"".concat(t, "\"")), n += this.options.xhtml ? "/>" : ">", n;
          }
        }, {
          key: "text",
          value: function text(e) {
            return e;
          }
        }]);

        return Er;
      }();

      var Sr = /*#__PURE__*/function () {
        function Sr() {
          _classCallCheck(this, Sr);
        }

        _createClass(Sr, [{
          key: "strong",
          value: function strong(e) {
            return e;
          }
        }, {
          key: "em",
          value: function em(e) {
            return e;
          }
        }, {
          key: "codespan",
          value: function codespan(e) {
            return e;
          }
        }, {
          key: "del",
          value: function del(e) {
            return e;
          }
        }, {
          key: "html",
          value: function html(e) {
            return e;
          }
        }, {
          key: "text",
          value: function text(e) {
            return e;
          }
        }, {
          key: "link",
          value: function link(e, t, r) {
            return "" + r;
          }
        }, {
          key: "image",
          value: function image(e, t, r) {
            return "" + r;
          }
        }, {
          key: "br",
          value: function br() {
            return "";
          }
        }]);

        return Sr;
      }();

      var $r = /*#__PURE__*/function () {
        function $r() {
          _classCallCheck(this, $r);

          this.seen = {};
        }

        _createClass($r, [{
          key: "serialize",
          value: function serialize(e) {
            return e.toLowerCase().trim().replace(/<[!\/a-z].*?>/gi, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
          }
        }, {
          key: "getNextSafeSlug",
          value: function getNextSafeSlug(e, t) {
            var r = e,
                n = 0;

            if (this.seen.hasOwnProperty(r)) {
              n = this.seen[e];

              do {
                n++, r = e + "-" + n;
              } while (this.seen.hasOwnProperty(r));
            }

            return t || (this.seen[e] = n, this.seen[r] = 0), r;
          }
        }, {
          key: "slug",
          value: function slug(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var r = this.serialize(e);
            return this.getNextSafeSlug(r, t.dryrun);
          }
        }]);

        return $r;
      }();

      var Rr = /*#__PURE__*/function () {
        function Rr(e) {
          _classCallCheck(this, Rr);

          this.options = e || Vt, this.options.renderer = this.options.renderer || new Er(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Sr(), this.slugger = new $r();
        }

        _createClass(Rr, [{
          key: "parse",
          value: function parse(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var r,
                n,
                o,
                i,
                s,
                a,
                l,
                c,
                p,
                u,
                d,
                h,
                m,
                f,
                g,
                y,
                b,
                x,
                v,
                w = "";
            var k = e.length;

            for (r = 0; r < k; r++) {
              if (u = e[r], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[u.type] && (v = this.options.extensions.renderers[u.type].call({
                parser: this
              }, u), !1 !== v || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(u.type))) w += v || "";else switch (u.type) {
                case "space":
                  continue;

                case "hr":
                  w += this.renderer.hr();
                  continue;

                case "heading":
                  w += this.renderer.heading(this.parseInline(u.tokens), u.depth, tr(this.parseInline(u.tokens, this.textRenderer)), this.slugger);
                  continue;

                case "code":
                  w += this.renderer.code(u.text, u.lang, u.escaped);
                  continue;

                case "table":
                  for (c = "", l = "", i = u.header.length, n = 0; n < i; n++) {
                    l += this.renderer.tablecell(this.parseInline(u.header[n].tokens), {
                      header: !0,
                      align: u.align[n]
                    });
                  }

                  for (c += this.renderer.tablerow(l), p = "", i = u.rows.length, n = 0; n < i; n++) {
                    for (a = u.rows[n], l = "", s = a.length, o = 0; o < s; o++) {
                      l += this.renderer.tablecell(this.parseInline(a[o].tokens), {
                        header: !1,
                        align: u.align[o]
                      });
                    }

                    p += this.renderer.tablerow(l);
                  }

                  w += this.renderer.table(c, p);
                  continue;

                case "blockquote":
                  p = this.parse(u.tokens), w += this.renderer.blockquote(p);
                  continue;

                case "list":
                  for (d = u.ordered, h = u.start, m = u.loose, i = u.items.length, p = "", n = 0; n < i; n++) {
                    g = u.items[n], y = g.checked, b = g.task, f = "", g.task && (x = this.renderer.checkbox(y), m ? g.tokens.length > 0 && "paragraph" === g.tokens[0].type ? (g.tokens[0].text = x + " " + g.tokens[0].text, g.tokens[0].tokens && g.tokens[0].tokens.length > 0 && "text" === g.tokens[0].tokens[0].type && (g.tokens[0].tokens[0].text = x + " " + g.tokens[0].tokens[0].text)) : g.tokens.unshift({
                      type: "text",
                      text: x
                    }) : f += x), f += this.parse(g.tokens, m), p += this.renderer.listitem(f, b, y);
                  }

                  w += this.renderer.list(p, d, h);
                  continue;

                case "html":
                  w += this.renderer.html(u.text);
                  continue;

                case "paragraph":
                  w += this.renderer.paragraph(this.parseInline(u.tokens));
                  continue;

                case "text":
                  for (p = u.tokens ? this.parseInline(u.tokens) : u.text; r + 1 < k && "text" === e[r + 1].type;) {
                    u = e[++r], p += "\n" + (u.tokens ? this.parseInline(u.tokens) : u.text);
                  }

                  w += t ? this.renderer.paragraph(p) : p;
                  continue;

                default:
                  {
                    var _e47 = 'Token with "' + u.type + '" type was not found.';

                    if (this.options.silent) return void console.error(_e47);
                    throw new Error(_e47);
                  }
              }
            }

            return w;
          }
        }, {
          key: "parseInline",
          value: function parseInline(e, t) {
            t = t || this.renderer;
            var r,
                n,
                o,
                i = "";
            var s = e.length;

            for (r = 0; r < s; r++) {
              if (n = e[r], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[n.type] && (o = this.options.extensions.renderers[n.type].call({
                parser: this
              }, n), !1 !== o || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(n.type))) i += o || "";else switch (n.type) {
                case "escape":
                case "text":
                  i += t.text(n.text);
                  break;

                case "html":
                  i += t.html(n.text);
                  break;

                case "link":
                  i += t.link(n.href, n.title, this.parseInline(n.tokens, t));
                  break;

                case "image":
                  i += t.image(n.href, n.title, n.text);
                  break;

                case "strong":
                  i += t.strong(this.parseInline(n.tokens, t));
                  break;

                case "em":
                  i += t.em(this.parseInline(n.tokens, t));
                  break;

                case "codespan":
                  i += t.codespan(n.text);
                  break;

                case "br":
                  i += t.br();
                  break;

                case "del":
                  i += t.del(this.parseInline(n.tokens, t));
                  break;

                default:
                  {
                    var _e48 = 'Token with "' + n.type + '" type was not found.';

                    if (this.options.silent) return void console.error(_e48);
                    throw new Error(_e48);
                  }
              }
            }

            return i;
          }
        }], [{
          key: "parse",
          value: function parse(e, t) {
            return new Rr(t).parse(e);
          }
        }, {
          key: "parseInline",
          value: function parseInline(e, t) {
            return new Rr(t).parseInline(e);
          }
        }]);

        return Rr;
      }();

      function jr(e, t, r) {
        if (null == e) throw new Error("marked(): input parameter is undefined or null");
        if ("string" != typeof e) throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected");

        if ("function" == typeof t && (r = t, t = null), fr(t = dr({}, jr.defaults, t || {})), r) {
          var _n45 = t.highlight;

          var _o18;

          try {
            _o18 = Or.lex(e, t);
          } catch (e) {
            return r(e);
          }

          var _i21 = function _i21(e) {
            var i;
            if (!e) try {
              t.walkTokens && jr.walkTokens(_o18, t.walkTokens), i = Rr.parse(_o18, t);
            } catch (t) {
              e = t;
            }
            return t.highlight = _n45, e ? r(e) : r(null, i);
          };

          if (!_n45 || _n45.length < 3) return _i21();
          if (delete t.highlight, !_o18.length) return _i21();
          var _s9 = 0;
          return jr.walkTokens(_o18, function (e) {
            "code" === e.type && (_s9++, setTimeout(function () {
              _n45(e.text, e.lang, function (t, r) {
                if (t) return _i21(t);
                null != r && r !== e.text && (e.text = r, e.escaped = !0), _s9--, 0 === _s9 && _i21();
              });
            }, 0));
          }), void (0 === _s9 && _i21());
        }

        try {
          var _r44 = Or.lex(e, t);

          return t.walkTokens && jr.walkTokens(_r44, t.walkTokens), Rr.parse(_r44, t);
        } catch (e) {
          if (e.message += "\nPlease report this to https://github.com/markedjs/marked.", t.silent) return "<p>An error occurred:</p><pre>" + Kt(e.message + "", !0) + "</pre>";
          throw e;
        }
      }

      jr.options = jr.setOptions = function (e) {
        var t;
        return dr(jr.defaults, e), t = jr.defaults, Vt = t, jr;
      }, jr.getDefaults = function () {
        return {
          baseUrl: null,
          breaks: !1,
          extensions: null,
          gfm: !0,
          headerIds: !0,
          headerPrefix: "",
          highlight: null,
          langPrefix: "language-",
          mangle: !0,
          pedantic: !1,
          renderer: null,
          sanitize: !1,
          sanitizer: null,
          silent: !1,
          smartLists: !1,
          smartypants: !1,
          tokenizer: null,
          walkTokens: null,
          xhtml: !1
        };
      }, jr.defaults = Vt, jr.use = function () {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }

        var t = dr.apply(void 0, [{}].concat(e)),
            r = jr.defaults.extensions || {
          renderers: {},
          childTokens: {}
        };
        var n;
        e.forEach(function (e) {
          if (e.extensions && (n = !0, e.extensions.forEach(function (e) {
            if (!e.name) throw new Error("extension name required");

            if (e.renderer) {
              var _t63 = r.renderers ? r.renderers[e.name] : null;

              r.renderers[e.name] = _t63 ? function () {
                for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  r[_key3] = arguments[_key3];
                }

                var n = e.renderer.apply(this, r);
                return !1 === n && (n = _t63.apply(this, r)), n;
              } : e.renderer;
            }

            if (e.tokenizer) {
              if (!e.level || "block" !== e.level && "inline" !== e.level) throw new Error("extension level must be 'block' or 'inline'");
              r[e.level] ? r[e.level].unshift(e.tokenizer) : r[e.level] = [e.tokenizer], e.start && ("block" === e.level ? r.startBlock ? r.startBlock.push(e.start) : r.startBlock = [e.start] : "inline" === e.level && (r.startInline ? r.startInline.push(e.start) : r.startInline = [e.start]));
            }

            e.childTokens && (r.childTokens[e.name] = e.childTokens);
          })), e.renderer) {
            (function () {
              var r = jr.defaults.renderer || new Er();

              var _loop4 = function _loop4(_t64) {
                var n = r[_t64];

                r[_t64] = function () {
                  for (var _len4 = arguments.length, o = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    o[_key4] = arguments[_key4];
                  }

                  var i = e.renderer[_t64].apply(r, o);

                  return !1 === i && (i = n.apply(r, o)), i;
                };
              };

              for (var _t64 in e.renderer) {
                _loop4(_t64);
              }

              t.renderer = r;
            })();
          }

          if (e.tokenizer) {
            (function () {
              var r = jr.defaults.tokenizer || new br();

              var _loop5 = function _loop5(_t65) {
                var n = r[_t65];

                r[_t65] = function () {
                  for (var _len5 = arguments.length, o = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                    o[_key5] = arguments[_key5];
                  }

                  var i = e.tokenizer[_t65].apply(r, o);

                  return !1 === i && (i = n.apply(r, o)), i;
                };
              };

              for (var _t65 in e.tokenizer) {
                _loop5(_t65);
              }

              t.tokenizer = r;
            })();
          }

          if (e.walkTokens) {
            var _r45 = jr.defaults.walkTokens;

            t.walkTokens = function (t) {
              e.walkTokens.call(this, t), _r45 && _r45.call(this, t);
            };
          }

          n && (t.extensions = r), jr.setOptions(t);
        });
      }, jr.walkTokens = function (e, t) {
        var _iterator25 = _createForOfIteratorHelper(e),
            _step25;

        try {
          var _loop6 = function _loop6() {
            var r = _step25.value;

            switch (t.call(jr, r), r.type) {
              case "table":
                var _iterator26 = _createForOfIteratorHelper(r.header),
                    _step26;

                try {
                  for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                    var _e49 = _step26.value;
                    jr.walkTokens(_e49.tokens, t);
                  }
                } catch (err) {
                  _iterator26.e(err);
                } finally {
                  _iterator26.f();
                }

                var _iterator27 = _createForOfIteratorHelper(r.rows),
                    _step27;

                try {
                  for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                    var _e50 = _step27.value;

                    var _iterator28 = _createForOfIteratorHelper(_e50),
                        _step28;

                    try {
                      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                        var _r46 = _step28.value;
                        jr.walkTokens(_r46.tokens, t);
                      }
                    } catch (err) {
                      _iterator28.e(err);
                    } finally {
                      _iterator28.f();
                    }
                  }
                } catch (err) {
                  _iterator27.e(err);
                } finally {
                  _iterator27.f();
                }

                break;

              case "list":
                jr.walkTokens(r.items, t);
                break;

              default:
                jr.defaults.extensions && jr.defaults.extensions.childTokens && jr.defaults.extensions.childTokens[r.type] ? jr.defaults.extensions.childTokens[r.type].forEach(function (e) {
                  jr.walkTokens(r[e], t);
                }) : r.tokens && jr.walkTokens(r.tokens, t);
            }
          };

          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            _loop6();
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }
      }, jr.parseInline = function (e, t) {
        if (null == e) throw new Error("marked.parseInline(): input parameter is undefined or null");
        if ("string" != typeof e) throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected");
        fr(t = dr({}, jr.defaults, t || {}));

        try {
          var _r47 = Or.lexInline(e, t);

          return t.walkTokens && jr.walkTokens(_r47, t.walkTokens), Rr.parseInline(_r47, t);
        } catch (e) {
          if (e.message += "\nPlease report this to https://github.com/markedjs/marked.", t.silent) return "<p>An error occurred:</p><pre>" + Kt(e.message + "", !0) + "</pre>";
          throw e;
        }
      }, jr.Parser = Rr, jr.parser = Rr.parse, jr.Renderer = Er, jr.TextRenderer = Sr, jr.Lexer = Or, jr.lexer = Or.lex, jr.Tokenizer = br, jr.Slugger = $r, jr.parse = jr, jr.options, jr.setOptions, jr.use, jr.walkTokens, jr.parseInline, Rr.parse, Or.lex;

      var Cr = Object.defineProperty,
          Ar = Object.defineProperties,
          Pr = Object.getOwnPropertyDescriptors,
          Ir = Object.getOwnPropertySymbols,
          Tr = Object.prototype.hasOwnProperty,
          _r = Object.prototype.propertyIsEnumerable,
          Lr = function Lr(e, t, r) {
        return t in e ? Cr(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Dr = function Dr(e, t) {
        for (var r in t || (t = {})) {
          Tr.call(t, r) && Lr(e, r, t[r]);
        }

        if (Ir) {
          var _iterator29 = _createForOfIteratorHelper(Ir(t)),
              _step29;

          try {
            for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
              var r = _step29.value;
              _r.call(t, r) && Lr(e, r, t[r]);
            }
          } catch (err) {
            _iterator29.e(err);
          } finally {
            _iterator29.f();
          }
        }

        return e;
      };

      var zr = new jr.Renderer();
      jr.setOptions({
        renderer: zr,
        highlight: function highlight(e, t) {
          return Ot(e, t);
        }
      });
      var Mr = "^ {0,3}\x3c!-- ReDoc-Inject:\\s+?<({component}).*?/?>\\s+?--\x3e\\s*$",
          Nr = "(?:^ {0,3}<({component})([\\s\\S]*?)>([\\s\\S]*?)</\\2>|^ {0,3}<({component})([\\s\\S]*?)(?:/>|\\n{2,}))",
          Fr = "(?:" + Mr + "|" + Nr + ")";

      function qr(e) {
        return "<!-- ReDoc-Inject: <".concat(e, "> -->");
      }

      var Br = /*#__PURE__*/function () {
        function Br(e, t) {
          var _this8 = this;

          _classCallCheck(this, Br);

          this.options = e, this.parentId = t, this.headings = [], this.headingRule = function (e, t, r, n) {
            return 1 === t ? _this8.currentTopHeading = _this8.saveHeading(e, t) : 2 === t && _this8.saveHeading(e, t, _this8.currentTopHeading && _this8.currentTopHeading.items, _this8.currentTopHeading && _this8.currentTopHeading.id), _this8.originalHeadingRule(e, t, r, n);
          }, this.parentId = t, this.parser = new jr.Parser(), this.headingEnhanceRenderer = new jr.Renderer(), this.originalHeadingRule = this.headingEnhanceRenderer.heading.bind(this.headingEnhanceRenderer), this.headingEnhanceRenderer.heading = this.headingRule;
        }

        _createClass(Br, [{
          key: "saveHeading",
          value: function saveHeading(e, t) {
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.headings;
            var n = arguments.length > 3 ? arguments[3] : undefined;
            e = C(e);
            var o = {
              id: n ? "".concat(n, "/").concat(w(e)) : "".concat(this.parentId || "section", "/").concat(w(e)),
              name: e,
              level: t,
              items: []
            };
            return r.push(o), o;
          }
        }, {
          key: "flattenHeadings",
          value: function flattenHeadings(e) {
            if (void 0 === e) return [];
            var t = [];

            var _iterator30 = _createForOfIteratorHelper(e),
                _step30;

            try {
              for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                var _r48 = _step30.value;
                t.push(_r48), t.push.apply(t, _toConsumableArray(this.flattenHeadings(_r48.items)));
              }
            } catch (err) {
              _iterator30.e(err);
            } finally {
              _iterator30.f();
            }

            return t;
          }
        }, {
          key: "attachHeadingsDescriptions",
          value: function attachHeadingsDescriptions(e) {
            var t = function t(e) {
              return new RegExp("##?\\s+".concat(e.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "s*(\n|\r\n|$|s*)"));
            },
                r = this.flattenHeadings(this.headings);

            if (r.length < 1) return;
            var n = r[0],
                o = t(n),
                i = e.search(o);

            for (var _s10 = 1; _s10 < r.length; _s10++) {
              var _a8 = r[_s10],
                  _l4 = t(_a8),
                  _c5 = e.substr(i + 1).search(_l4) + i + 1;

              n.description = e.substring(i, _c5).replace(o, "").trim(), n = _a8, o = _l4, i = _c5;
            }

            n.description = e.substring(i).replace(o, "").trim();
          }
        }, {
          key: "renderMd",
          value: function renderMd(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var r = t ? {
              renderer: this.headingEnhanceRenderer
            } : void 0;
            return jr(e.toString(), r);
          }
        }, {
          key: "extractHeadings",
          value: function extractHeadings(e) {
            this.renderMd(e, !0), this.attachHeadingsDescriptions(e);
            var t = this.headings;
            return this.headings = [], t;
          }
        }, {
          key: "renderMdWithComponents",
          value: function renderMdWithComponents(e) {
            var t = this.options && this.options.allowedMdComponents;
            if (!t || 0 === Object.keys(t).length) return [this.renderMd(e)];
            var r = Object.keys(t).join("|"),
                n = new RegExp(Fr.replace(/{component}/g, r), "mig"),
                o = [],
                i = [];
            var s = n.exec(e),
                a = 0;

            for (; s;) {
              o.push(e.substring(a, s.index)), a = n.lastIndex;

              var _r49 = t[s[1] || s[2] || s[5]],
                  _p5 = s[3] || s[6],
                  _u3 = s[4];

              _r49 && i.push({
                component: _r49.component,
                propsSelector: _r49.propsSelector,
                props: (l = Dr(Dr({}, Qr(_p5)), _r49.props), c = {
                  children: _u3
                }, Ar(l, Pr(c)))
              }), s = n.exec(e);
            }

            var l, c;
            o.push(e.substring(a));
            var p = [];

            for (var _e51 = 0; _e51 < o.length; _e51++) {
              var _t66 = o[_e51];
              _t66 && p.push(this.renderMd(_t66)), i[_e51] && p.push(i[_e51]);
            }

            return p;
          }
        }], [{
          key: "containsComponent",
          value: function containsComponent(e, t) {
            return new RegExp(Fr.replace(/{component}/g, t), "gmi").test(e);
          }
        }, {
          key: "getTextBeforeHading",
          value: function getTextBeforeHading(e, t) {
            var r = e.search(new RegExp("^##?\\s+".concat(t), "m"));
            return r > -1 ? e.substring(0, r) : e;
          }
        }]);

        return Br;
      }();

      function Qr(e) {
        if (!e) return {};
        var t = /([\w-]+)\s*=\s*(?:{([^}]+?)}|"([^"]+?)")/gim,
            r = {};
        var n;

        for (; null !== (n = t.exec(e));) {
          if (n[3]) r[n[1]] = n[3];else if (n[2]) {
            var _e52 = void 0;

            try {
              _e52 = JSON.parse(n[2]);
            } catch (e) {}

            r[n[1]] = _e52;
          }
        }

        return r;
      }

      var Ur = /*#__PURE__*/function () {
        function Ur(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new W({});

          _classCallCheck(this, Ur);

          this.parser = e, this.options = t, Object.assign(this, e.spec.info), this.description = e.spec.info.description || "", this.summary = e.spec.info.summary || "";
          var r = this.description.search(/^\s*##?\s+/m);
          r > -1 && (this.description = this.description.substring(0, r)), this.downloadLink = this.getDownloadLink(), this.downloadFileName = this.getDownloadFileName();
        }

        _createClass(Ur, [{
          key: "getDownloadLink",
          value: function getDownloadLink() {
            if (this.options.downloadDefinitionUrl) return this.options.downloadDefinitionUrl;
            if (this.parser.specUrl) return this.parser.specUrl;

            if (s && window.Blob && window.URL && window.URL.createObjectURL) {
              var _e53 = new Blob([JSON.stringify(this.parser.spec, null, 2)], {
                type: "application/json"
              });

              return window.URL.createObjectURL(_e53);
            }
          }
        }, {
          key: "getDownloadFileName",
          value: function getDownloadFileName() {
            return this.parser.specUrl || this.options.downloadDefinitionUrl ? this.options.downloadFileName : this.options.downloadFileName || "openapi.json";
          }
        }]);

        return Ur;
      }();

      var Wr = Object.defineProperty,
          Vr = Object.defineProperties,
          Hr = Object.getOwnPropertyDescriptors,
          Jr = Object.getOwnPropertySymbols,
          Yr = Object.prototype.hasOwnProperty,
          Zr = Object.prototype.propertyIsEnumerable,
          Gr = function Gr(e, t, r) {
        return t in e ? Wr(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Xr = /*#__PURE__*/_createClass(function Xr(e, t) {
        _classCallCheck(this, Xr);

        var r = t.spec.components && t.spec.components.securitySchemes || {};
        this.schemes = Object.keys(e || {}).map(function (n) {
          var _t$deref = t.deref(r[n]),
              o = _t$deref.resolved,
              i = e[n] || [];

          if (!o) return void console.warn("Non existing security scheme referenced: ".concat(n, ". Skipping"));
          var s = o["x-displayName"] || n;
          return a = function (e, t) {
            for (var r in t || (t = {})) {
              Yr.call(t, r) && Gr(e, r, t[r]);
            }

            if (Jr) {
              var _iterator31 = _createForOfIteratorHelper(Jr(t)),
                  _step31;

              try {
                for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                  var r = _step31.value;
                  Zr.call(t, r) && Gr(e, r, t[r]);
                }
              } catch (err) {
                _iterator31.e(err);
              } finally {
                _iterator31.f();
              }
            }

            return e;
          }({}, o), Vr(a, Hr({
            id: n,
            sectionId: n,
            displayName: s,
            scopes: i
          }));
          var a;
        }).filter(function (e) {
          return void 0 !== e;
        });
      });

      var Kr = Object.defineProperty,
          en = Object.defineProperties,
          tn = Object.getOwnPropertyDescriptor,
          rn = Object.getOwnPropertyDescriptors,
          nn = Object.getOwnPropertySymbols,
          on = Object.prototype.hasOwnProperty,
          sn = Object.prototype.propertyIsEnumerable,
          an = function an(e, t, r) {
        return t in e ? Kr(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          ln = function ln(e, t) {
        for (var r in t || (t = {})) {
          on.call(t, r) && an(e, r, t[r]);
        }

        if (nn) {
          var _iterator32 = _createForOfIteratorHelper(nn(t)),
              _step32;

          try {
            for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
              var r = _step32.value;
              sn.call(t, r) && an(e, r, t[r]);
            }
          } catch (err) {
            _iterator32.e(err);
          } finally {
            _iterator32.f();
          }
        }

        return e;
      },
          cn = function cn(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? tn(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && Kr(t, r, i), i;
      };

      var pn = /*#__PURE__*/function () {
        function pn(e, t, r, n, o) {
          _classCallCheck(this, pn);

          this.expanded = !1, this.operations = [], (0, de.makeObservable)(this), this.name = t;

          var _e$deref3 = e.deref(r),
              i = _e$deref3.resolved;

          for (var _i22 = 0, _Object$keys4 = Object.keys(i); _i22 < _Object$keys4.length; _i22++) {
            var _r50 = _Object$keys4[_i22];

            var _l5 = i[_r50],
                _c6 = Object.keys(_l5).filter(Me);

            var _iterator33 = _createForOfIteratorHelper(_c6),
                _step33;

            try {
              for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                var _i23 = _step33.value;

                var _c7 = _l5[_i23],
                    _p6 = new fo(e, (s = ln({}, _c7), a = {
                  pathName: _r50,
                  pointer: ke.compile([n, t, _r50, _i23]),
                  httpVerb: _i23,
                  pathParameters: _l5.parameters || [],
                  pathServers: _l5.servers
                }, en(s, rn(a))), void 0, o, !0);

                this.operations.push(_p6);
              }
            } catch (err) {
              _iterator33.e(err);
            } finally {
              _iterator33.f();
            }
          }

          var s, a;
        }

        _createClass(pn, [{
          key: "toggle",
          value: function toggle() {
            this.expanded = !this.expanded;
          }
        }]);

        return pn;
      }();

      cn([de.observable], pn.prototype, "expanded", 2), cn([de.action], pn.prototype, "toggle", 1);

      var un = Object.defineProperty,
          dn = Object.defineProperties,
          hn = Object.getOwnPropertyDescriptors,
          mn = Object.getOwnPropertySymbols,
          fn = Object.prototype.hasOwnProperty,
          gn = Object.prototype.propertyIsEnumerable,
          yn = function yn(e, t, r) {
        return t in e ? un(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          bn = function bn(e, t) {
        for (var r in t || (t = {})) {
          fn.call(t, r) && yn(e, r, t[r]);
        }

        if (mn) {
          var _iterator34 = _createForOfIteratorHelper(mn(t)),
              _step34;

          try {
            for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
              var r = _step34.value;
              gn.call(t, r) && yn(e, r, t[r]);
            }
          } catch (err) {
            _iterator34.e(err);
          } finally {
            _iterator34.f();
          }
        }

        return e;
      },
          xn = function xn(e, t) {
        return dn(e, hn(t));
      },
          vn = function vn(e, t) {
        var r = {};

        for (var n in e) {
          fn.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
        }

        if (null != e && mn) {
          var _iterator35 = _createForOfIteratorHelper(mn(e)),
              _step35;

          try {
            for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
              var n = _step35.value;
              t.indexOf(n) < 0 && gn.call(e, n) && (r[n] = e[n]);
            }
          } catch (err) {
            _iterator35.e(err);
          } finally {
            _iterator35.f();
          }
        }

        return r;
      };

      function wn(e, t) {
        return t && e[e.length - 1] !== t ? [].concat(_toConsumableArray(e), [t]) : e;
      }

      function kn(e, t) {
        return t ? e.concat(t) : e;
      }

      var On = /*#__PURE__*/function () {
        function On(e, t) {
          var _this9 = this;

          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new W({});

          _classCallCheck(this, On);

          this.options = r, this.allowMergeRefs = !1, this.byRef = function (e) {
            var t;

            if (_this9.spec) {
              "#" !== e.charAt(0) && (e = "#" + e), e = decodeURIComponent(e);

              try {
                t = ke.get(_this9.spec, e);
              } catch (e) {}

              return t || {};
            }
          }, this.validate(e), this.spec = e, this.allowMergeRefs = e.openapi.startsWith("3.1");
          var n = s ? window.location.href : "";
          "string" == typeof t && (this.specUrl = n ? new URL(t, n).href : t);
        }

        _createClass(On, [{
          key: "validate",
          value: function validate(e) {
            if (void 0 === e.openapi) throw new Error("Document must be valid OpenAPI 3.0.0 definition");
          }
        }, {
          key: "isRef",
          value: function isRef(e) {
            return !!e && void 0 !== e.$ref && null !== e.$ref;
          }
        }, {
          key: "deref",
          value: function deref(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            var n = null == e ? void 0 : e["x-refsStack"];

            if (t = kn(t, n), this.isRef(e)) {
              var _n46 = tt(e.$ref);

              if (_n46 && this.options.ignoreNamedSchemas.has(_n46)) return {
                resolved: {
                  type: "object",
                  title: _n46
                },
                refsStack: t
              };

              var _o19 = this.byRef(e.$ref);

              if (!_o19) throw new Error("Failed to resolve $ref \"".concat(e.$ref, "\""));
              var _i24 = t;
              if (t.includes(e.$ref) || t.length > 999) _o19 = Object.assign({}, _o19, {
                "x-circular-ref": !0
              });else if (this.isRef(_o19)) {
                var _e54 = this.deref(_o19, t, r);

                _i24 = _e54.refsStack, _o19 = _e54.resolved;
              }
              return _i24 = wn(t, e.$ref), _o19 = this.allowMergeRefs ? this.mergeRefs(e, _o19, r) : _o19, {
                resolved: _o19,
                refsStack: _i24
              };
            }

            return {
              resolved: e,
              refsStack: kn(t, n)
            };
          }
        }, {
          key: "mergeRefs",
          value: function mergeRefs(e, t, r) {
            var n = e,
                o = n.$ref,
                i = vn(n, ["$ref"]),
                s = Object.keys(i);
            if (0 === s.length) return t;

            if (r && s.some(function (e) {
              return !["description", "title", "externalDocs", "x-refsStack", "x-parentRefs", "readOnly", "writeOnly"].includes(e);
            })) {
              var _e55 = i,
                  _r51 = _e55.description,
                  _n47 = _e55.title,
                  _o20 = _e55.readOnly,
                  _s11 = _e55.writeOnly;
              return {
                allOf: [{
                  description: _r51,
                  title: _n47,
                  readOnly: _o20,
                  writeOnly: _s11
                }, t, vn(_e55, ["description", "title", "readOnly", "writeOnly"])]
              };
            }

            return bn(bn({}, t), i);
          }
        }, {
          key: "mergeAllOf",
          value: function mergeAllOf(e, t, r) {
            var _this10 = this;

            var n;
            if (e["x-circular-ref"]) return e;
            if (void 0 === (e = this.hoistOneOfs(e, r)).allOf) return e;
            var o = xn(bn({}, e), {
              "x-parentRefs": [],
              allOf: void 0,
              title: e.title || tt(t)
            });
            void 0 !== o.properties && "object" == typeof o.properties && (o.properties = bn({}, o.properties)), void 0 !== o.items && "object" == typeof o.items && (o.items = bn({}, o.items));

            var i = function (e, t) {
              var r = new Set();
              return e.filter(function (e) {
                var t = e.$ref;
                return !t || t && !r.has(t) && r.add(t);
              });
            }(e.allOf.map(function (e) {
              var _t67;

              var t;

              var _this10$deref = _this10.deref(e, r, !0),
                  n = _this10$deref.resolved,
                  i = _this10$deref.refsStack,
                  s = e.$ref || void 0,
                  a = _this10.mergeAllOf(n, s, i);

              if (!a["x-circular-ref"] || !a.allOf) return s && (null == (t = o["x-parentRefs"]) || (_t67 = t).push.apply(_t67, _toConsumableArray(a["x-parentRefs"] || []).concat([s]))), {
                $ref: s,
                refsStack: wn(i, s),
                schema: a
              };
            }).filter(function (e) {
              return void 0 !== e;
            }));

            var _iterator36 = _createForOfIteratorHelper(i),
                _step36;

            try {
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                var _step36$value = _step36.value,
                    _e56 = _step36$value.schema,
                    _r52 = _step36$value.refsStack;

                var _i25 = _e56,
                    _s12 = _i25.type,
                    _a9 = _i25.enum,
                    _l6 = _i25.properties,
                    _c8 = _i25.items,
                    _p7 = _i25.required,
                    _u4 = _i25.title,
                    _d2 = _i25.description,
                    _h2 = _i25.readOnly,
                    _m2 = _i25.writeOnly,
                    _f2 = _i25.oneOf,
                    _g2 = _i25.anyOf,
                    _y2 = _i25["x-circular-ref"],
                    _b2 = vn(_i25, ["type", "enum", "properties", "items", "required", "title", "description", "readOnly", "writeOnly", "oneOf", "anyOf", "x-circular-ref"]);

                if (o.type !== _s12 && void 0 !== o.type && void 0 !== _s12 && console.warn("Incompatible types in allOf at \"".concat(t, "\": \"").concat(o.type, "\" and \"").concat(_s12, "\"")), void 0 !== _s12 && (Array.isArray(_s12) && Array.isArray(o.type) ? o.type = [].concat(_toConsumableArray(_s12), _toConsumableArray(o.type)) : o.type = _s12), void 0 !== _a9 && (Array.isArray(_a9) && Array.isArray(o.enum) ? o.enum = Array.from(new Set([].concat(_toConsumableArray(_a9), _toConsumableArray(o.enum)))) : o.enum = _a9), void 0 !== _l6 && "object" == typeof _l6) {
                  o.properties = o.properties || {};

                  for (var _e57 in _l6) {
                    var _i26 = kn(_r52, null == (n = _l6[_e57]) ? void 0 : n["x-refsStack"]);

                    if (o.properties[_e57]) {
                      if (!_y2) {
                        var _r53 = this.mergeAllOf({
                          allOf: [o.properties[_e57], xn(bn({}, _l6[_e57]), {
                            "x-refsStack": _i26
                          })],
                          "x-refsStack": _i26
                        }, t + "/properties/" + _e57, _i26);

                        o.properties[_e57] = _r53;
                      }
                    } else o.properties[_e57] = xn(bn({}, _l6[_e57]), {
                      "x-refsStack": _i26
                    });
                  }
                }

                if (void 0 !== _c8 && !_y2) {
                  var _n48 = "boolean" == typeof o.items ? {} : Object.assign({}, o.items),
                      _i27 = "boolean" == typeof _e56.items ? {} : Object.assign({}, _e56.items);

                  o.items = this.mergeAllOf({
                    allOf: [_n48, _i27]
                  }, t + "/items", _r52);
                }

                void 0 !== _f2 && (o.oneOf = _f2), void 0 !== _g2 && (o.anyOf = _g2), void 0 !== _p7 && (o.required = [].concat(_toConsumableArray(o.required || []), _toConsumableArray(_p7))), o = bn(xn(bn({}, o), {
                  title: o.title || _u4,
                  description: o.description || _d2,
                  readOnly: void 0 !== o.readOnly ? o.readOnly : _h2,
                  writeOnly: void 0 !== o.writeOnly ? o.writeOnly : _m2,
                  "x-circular-ref": o["x-circular-ref"] || _y2
                }), _b2);
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }

            return o;
          }
        }, {
          key: "findDerived",
          value: function findDerived(e) {
            var t = {},
                r = this.spec.components && this.spec.components.schemas || {};

            for (var _n49 in r) {
              var _this$deref = this.deref(r[_n49]),
                  _o21 = _this$deref.resolved;

              void 0 !== _o21.allOf && _o21.allOf.find(function (t) {
                return void 0 !== t.$ref && e.indexOf(t.$ref) > -1;
              }) && (t["#/components/schemas/" + _n49] = [_o21["x-discriminator-value"] || _n49]);
            }

            return t;
          }
        }, {
          key: "hoistOneOfs",
          value: function hoistOneOfs(e, t) {
            if (void 0 === e.allOf) return e;
            var r = e.allOf;

            for (var _e58 = 0; _e58 < r.length; _e58++) {
              var _n50 = r[_e58];

              if (Array.isArray(_n50.oneOf)) {
                var _ret = function () {
                  var o = r.slice(0, _e58),
                      i = r.slice(_e58 + 1);
                  return {
                    v: {
                      oneOf: _n50.oneOf.map(function (e) {
                        return {
                          allOf: [].concat(_toConsumableArray(o), [e], _toConsumableArray(i)),
                          "x-refsStack": t
                        };
                      })
                    }
                  };
                }();

                if (typeof _ret === "object") return _ret.v;
              }
            }

            return e;
          }
        }]);

        return On;
      }();

      var En = Object.defineProperty,
          Sn = Object.defineProperties,
          $n = Object.getOwnPropertyDescriptor,
          Rn = Object.getOwnPropertyDescriptors,
          jn = Object.getOwnPropertySymbols,
          Cn = Object.prototype.hasOwnProperty,
          An = Object.prototype.propertyIsEnumerable,
          Pn = function Pn(e, t, r) {
        return t in e ? En(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          In = function In(e, t) {
        for (var r in t || (t = {})) {
          Cn.call(t, r) && Pn(e, r, t[r]);
        }

        if (jn) {
          var _iterator37 = _createForOfIteratorHelper(jn(t)),
              _step37;

          try {
            for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
              var r = _step37.value;
              An.call(t, r) && Pn(e, r, t[r]);
            }
          } catch (err) {
            _iterator37.e(err);
          } finally {
            _iterator37.f();
          }
        }

        return e;
      },
          Tn = function Tn(e, t) {
        return Sn(e, Rn(t));
      },
          _n = function _n(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? $n(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && En(t, r, i), i;
      };

      var Ln = /*#__PURE__*/function () {
        function Ln(e, t, r, n) {
          var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
          var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

          _classCallCheck(this, Ln);

          this.options = n, this.refsStack = i, this.typePrefix = "", this.isCircular = !1, this.activeOneOf = 0, (0, de.makeObservable)(this), this.pointer = t.$ref || r || "";

          var _e$deref4 = e.deref(t, i, !0),
              s = _e$deref4.resolved,
              a = _e$deref4.refsStack;

          this.refsStack = wn(a, this.pointer), this.rawSchema = s, this.schema = e.mergeAllOf(this.rawSchema, this.pointer, this.refsStack), this.init(e, o), n.showExtensions && (this.extensions = bt(this.schema, n.showExtensions));
        }

        _createClass(Ln, [{
          key: "activateOneOf",
          value: function activateOneOf(e) {
            this.activeOneOf = e;
          }
        }, {
          key: "hasType",
          value: function hasType(e) {
            return this.type === e || A(this.type) && this.type.includes(e);
          }
        }, {
          key: "init",
          value: function init(e, t) {
            var _this11 = this;

            var r, n, o, i, s, a, l, c;
            var p = this.schema;
            if (this.isCircular = !!p["x-circular-ref"], this.title = p.title || et(this.pointer) && ke.baseName(this.pointer) || "", this.description = p.description || "", this.type = p.type || qe(p), this.format = p.format, this.enum = p.enum || [], this.example = p.example, this.examples = p.examples, this.deprecated = !!p.deprecated, this.pattern = p.pattern, this.externalDocs = p.externalDocs, this.constraints = ot(p), this.displayFormat = this.format, this.isPrimitive = Be(p, this.type), this.default = p.default, this.readOnly = !!p.readOnly, this.writeOnly = !!p.writeOnly, this.const = p.const || "", this.contentEncoding = p.contentEncoding, this.contentMediaType = p.contentMediaType, this.minItems = p.minItems, this.maxItems = p.maxItems, (p.nullable || p["x-nullable"]) && (A(this.type) && !this.type.some(function (e) {
              return null === e || "null" === e;
            }) ? this.type = [].concat(_toConsumableArray(this.type), ["null"]) : A(this.type) || null === this.type && "null" === this.type || (this.type = [this.type, "null"])), this.displayType = A(this.type) ? this.type.map(function (e) {
              return null === e ? "null" : e;
            }).join(" or ") : this.type, !this.isCircular) if (p.if && p.then || p.if && p.else) this.initConditionalOperators(p, e);else if (t || void 0 === Mn(p)) {
              if (t && A(p.oneOf) && p.oneOf.find(function (e) {
                return e.$ref === _this11.pointer;
              }) && delete p.oneOf, void 0 !== p.oneOf) return this.initOneOf(p.oneOf, e), this.oneOfType = "One of", void (void 0 !== p.anyOf && console.warn("oneOf and anyOf are not supported on the same level. Skipping anyOf at ".concat(this.pointer)));
              if (void 0 !== p.anyOf) return this.initOneOf(p.anyOf, e), void (this.oneOfType = "Any of");
              if (this.hasType("object")) this.fields = zn(e, p, this.pointer, this.options, this.refsStack);else if (this.hasType("array") && (A(p.items) || A(p.prefixItems) ? this.fields = zn(e, p, this.pointer, this.options, this.refsStack) : p.items && (this.items = new Ln(e, p.items, this.pointer + "/items", this.options, !1, this.refsStack)), this.displayType = p.prefixItems || A(p.items) ? "items" : xt((null == (r = this.items) ? void 0 : r.displayType) || this.displayType), this.displayFormat = (null == (n = this.items) ? void 0 : n.format) || "", this.typePrefix = (null == (o = this.items) ? void 0 : o.typePrefix) || "" + T("arrayOf"), this.title = this.title || (null == (i = this.items) ? void 0 : i.title) || "", this.isPrimitive = void 0 !== (null == (s = this.items) ? void 0 : s.isPrimitive) ? null == (a = this.items) ? void 0 : a.isPrimitive : this.isPrimitive, void 0 === this.example && void 0 !== (null == (l = this.items) ? void 0 : l.example) && (this.example = [this.items.example]), (null == (c = this.items) ? void 0 : c.isPrimitive) && (this.enum = this.items.enum), A(this.type))) {
                var _e59 = this.type.filter(function (e) {
                  return "array" !== e;
                });

                _e59.length && (this.displayType += " or ".concat(_e59.join(" or ")));
              }
              this.enum.length && this.options.sortEnumValuesAlphabetically && this.enum.sort();
            } else this.initDiscriminator(p, e);
          }
        }, {
          key: "initOneOf",
          value: function initOneOf(e, t) {
            var _this12 = this;

            if (this.oneOf = e.map(function (e, r) {
              var _t$deref2 = t.deref(e, _this12.refsStack, !0),
                  n = _t$deref2.resolved,
                  o = _t$deref2.refsStack,
                  i = t.mergeAllOf(n, _this12.pointer + "/oneOf/" + r, o),
                  s = et(e.$ref) && !i.title ? ke.baseName(e.$ref) : "".concat(i.title || "").concat(i.const && JSON.stringify(i.const) || "");

              return new Ln(t, Tn(In({}, i), {
                title: s,
                allOf: [Tn(In({}, _this12.schema), {
                  oneOf: void 0,
                  anyOf: void 0
                })],
                discriminator: n.allOf ? void 0 : i.discriminator
              }), e.$ref || _this12.pointer + "/oneOf/" + r, _this12.options, !1, o);
            }), this.options.simpleOneOfTypeLabel) {
              var _e60 = function (e) {
                var t = new Set();
                return function e(r) {
                  var _iterator38 = _createForOfIteratorHelper(r.oneOf || []),
                      _step38;

                  try {
                    for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                      var _n51 = _step38.value;
                      _n51.oneOf ? e(_n51) : _n51.type && t.add(_n51.type);
                    }
                  } catch (err) {
                    _iterator38.e(err);
                  } finally {
                    _iterator38.f();
                  }
                }(e), Array.from(t.values());
              }(this);

              this.displayType = _e60.join(" or ");
            } else this.displayType = this.oneOf.map(function (e) {
              var t = e.typePrefix + (e.title ? "".concat(e.title, " (").concat(e.displayType, ")") : e.displayType);
              return t.indexOf(" or ") > -1 && (t = "(".concat(t, ")")), t;
            }).join(" or ");
          }
        }, {
          key: "initDiscriminator",
          value: function initDiscriminator(e, t) {
            var _this13 = this;

            var r = Mn(e);
            this.discriminatorProp = r.propertyName;
            var n = t.findDerived([].concat(_toConsumableArray(this.schema["x-parentRefs"] || []), [this.pointer]));

            if (e.oneOf) {
              var _iterator39 = _createForOfIteratorHelper(e.oneOf),
                  _step39;

              try {
                for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                  var _t68 = _step39.value;
                  if (void 0 === _t68.$ref) continue;

                  var _e61 = ke.baseName(_t68.$ref);

                  n[_t68.$ref] = _e61;
                }
              } catch (err) {
                _iterator39.e(err);
              } finally {
                _iterator39.f();
              }
            }

            var o = r.mapping || {};
            var i = r["x-explicitMappingOnly"] || !1;
            0 === Object.keys(o).length && (i = !1);
            var s = {};

            for (var _e62 in o) {
              var _t69 = o[_e62];
              A(s[_t69]) ? s[_t69].push(_e62) : s[_t69] = [_e62];
            }

            var a = In(i ? {} : In({}, n), s);
            var l = [];

            for (var _i28 = 0, _Object$keys5 = Object.keys(a); _i28 < _Object$keys5.length; _i28++) {
              var _e63 = _Object$keys5[_i28];
              var _t70 = a[_e63];

              if (A(_t70)) {
                var _iterator40 = _createForOfIteratorHelper(_t70),
                    _step40;

                try {
                  for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                    var _r54 = _step40.value;
                    l.push({
                      $ref: _e63,
                      name: _r54
                    });
                  }
                } catch (err) {
                  _iterator40.e(err);
                } finally {
                  _iterator40.f();
                }
              } else l.push({
                $ref: _e63,
                name: _t70
              });
            }

            var c = Object.keys(o);
            0 !== c.length && (l = l.sort(function (e, t) {
              var r = c.indexOf(e.name),
                  n = c.indexOf(t.name);
              return r < 0 && n < 0 ? e.name.localeCompare(t.name) : r < 0 ? 1 : n < 0 ? -1 : r - n;
            })), this.oneOf = l.map(function (_ref38) {
              var e = _ref38.$ref,
                  r = _ref38.name;
              var n = new Ln(t, {
                $ref: e
              }, e, _this13.options, !0, _this13.refsStack.slice(0, -1));
              return n.title = r, n;
            });
          }
        }, {
          key: "initConditionalOperators",
          value: function initConditionalOperators(e, t) {
            var _this14 = this;

            var r = e,
                n = r.if,
                _r$else = r.else,
                o = _r$else === void 0 ? {} : _r$else,
                _r$then = r.then,
                i = _r$then === void 0 ? {} : _r$then,
                s = function (e, t) {
              var r = {};

              for (var n in e) {
                Cn.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
              }

              if (null != e && jn) {
                var _iterator41 = _createForOfIteratorHelper(jn(e)),
                    _step41;

                try {
                  for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                    var n = _step41.value;
                    t.indexOf(n) < 0 && An.call(e, n) && (r[n] = e[n]);
                  }
                } catch (err) {
                  _iterator41.e(err);
                } finally {
                  _iterator41.f();
                }
              }

              return r;
            }(r, ["if", "else", "then"]),
                a = [{
              allOf: [s, i, n],
              title: n && n["x-displayName"] || (null == n ? void 0 : n.title) || "case 1"
            }, {
              allOf: [s, o],
              title: o && o["x-displayName"] || (null == o ? void 0 : o.title) || "case 2"
            }];

            this.oneOf = a.map(function (e, r) {
              return new Ln(t, In({}, e), _this14.pointer + "/oneOf/" + r, _this14.options, !1, _this14.refsStack);
            }), this.oneOfType = "One of";
          }
        }]);

        return Ln;
      }();

      var Dn = Ln;

      function zn(e, t, r, n, o) {
        var _p8, _p9;

        var i = t.properties || t.prefixItems || t.items || {},
            s = t.patternProperties || {},
            a = t.additionalProperties || t.unevaluatedProperties,
            l = t.prefixItems ? t.items : t.additionalItems,
            c = t.default;
        var p = Object.keys(i || []).map(function (s) {
          var a = i[s];
          a || (console.warn("Field \"".concat(s, "\" is invalid, skipping.\n Field must be an object but got ").concat(typeof a, " at \"").concat(r, "\"")), a = {});
          var l = void 0 !== t.required && t.required.indexOf(s) > -1;
          return new Wn(e, {
            name: t.properties ? s : "[".concat(s, "]"),
            required: l,
            schema: Tn(In({}, a), {
              default: void 0 === a.default && c ? c[s] : a.default
            })
          }, r + "/properties/" + s, n, o);
        });
        return n.sortPropsAlphabetically && (p = st(p, "name")), n.requiredPropsFirst && (p = it(p, n.sortPropsAlphabetically ? void 0 : t.required)), (_p8 = p).push.apply(_p8, _toConsumableArray(Object.keys(s).map(function (t) {
          var i = s[t];
          return i || (console.warn("Field \"".concat(t, "\" is invalid, skipping.\n Field must be an object but got ").concat(typeof i, " at \"").concat(r, "\"")), i = {}), new Wn(e, {
            name: t,
            required: !1,
            schema: i,
            kind: "patternProperties"
          }, "".concat(r, "/patternProperties/").concat(t), n, o);
        }))), "object" != typeof a && !0 !== a || p.push(new Wn(e, {
          name: ("object" == typeof a && a["x-additionalPropertiesName"] || "property name").concat("*"),
          required: !1,
          schema: !0 === a ? {} : a,
          kind: "additionalProperties"
        }, r + "/additionalProperties", n, o)), (_p9 = p).push.apply(_p9, _toConsumableArray(function (_ref39) {
          var e = _ref39.parser,
              _ref39$schema = _ref39.schema,
              t = _ref39$schema === void 0 ? !1 : _ref39$schema,
              r = _ref39.fieldsCount,
              n = _ref39.$ref,
              o = _ref39.options,
              i = _ref39.refsStack;
          return P(t) ? t ? [new Wn(e, {
            name: "[".concat(r, "...]"),
            schema: {}
          }, "".concat(n, "/additionalItems"), o, i)] : [] : A(t) ? _toConsumableArray(t.map(function (t, s) {
            return new Wn(e, {
              name: "[".concat(r + s, "]"),
              schema: t
            }, "".concat(n, "/additionalItems"), o, i);
          })) : x(t) ? [new Wn(e, {
            name: "[".concat(r, "...]"),
            schema: t
          }, "".concat(n, "/additionalItems"), o, i)] : [];
        }({
          parser: e,
          schema: l,
          fieldsCount: p.length,
          $ref: r,
          options: n,
          refsStack: o
        }))), p;
      }

      function Mn(e) {
        return e.discriminator || e["x-discriminator"];
      }

      _n([de.observable], Dn.prototype, "activeOneOf", 2), _n([de.action], Dn.prototype, "activateOneOf", 1);
      var Nn = {};

      var Fn = /*#__PURE__*/function () {
        function Fn(e, t, r, n) {
          _classCallCheck(this, Fn);

          this.mime = r;

          var _e$deref5 = e.deref(t),
              o = _e$deref5.resolved;

          this.value = o.value, this.summary = o.summary, this.description = o.description, o.externalValue && (this.externalValueUrl = new URL(o.externalValue, e.specUrl).href), Ue(r) && this.value && "object" == typeof this.value && (this.value = Je(this.value, n));
        }

        _createClass(Fn, [{
          key: "getExternalValue",
          value: function getExternalValue(e) {
            return this.externalValueUrl ? (this.externalValueUrl in Nn || (Nn[this.externalValueUrl] = fetch(this.externalValueUrl).then(function (t) {
              return t.text().then(function (r) {
                if (!t.ok) return Promise.reject(new Error(r));
                if (!Qe(e)) return r;

                try {
                  return JSON.parse(r);
                } catch (e) {
                  return r;
                }
              });
            })), Nn[this.externalValueUrl]) : Promise.resolve(void 0);
          }
        }]);

        return Fn;
      }();

      var qn = Object.defineProperty,
          Bn = Object.getOwnPropertyDescriptor,
          Qn = function Qn(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? Bn(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && qn(t, r, i), i;
      };

      var Un = {
        path: {
          style: "simple",
          explode: !1
        },
        query: {
          style: "form",
          explode: !0
        },
        header: {
          style: "simple",
          explode: !1
        },
        cookie: {
          style: "form",
          explode: !0
        }
      };

      var Wn = /*#__PURE__*/function () {
        function Wn(e, t, r, n, o) {
          _classCallCheck(this, Wn);

          var i, s, a, l, c;
          this.expanded = void 0, (0, de.makeObservable)(this);

          var _e$deref6 = e.deref(t),
              p = _e$deref6.resolved;

          this.kind = t.kind || "field", this.name = t.name || p.name, this.in = p.in, this.required = !!p.required;
          var u = p.schema,
              d = "";

          if (!u && p.in && p.content && (d = Object.keys(p.content)[0], u = p.content[d] && p.content[d].schema), this.schema = new Dn(e, u || {}, r, n, !1, o), this.description = void 0 === p.description ? this.schema.description || "" : p.description, this.example = p.example || this.schema.example, void 0 !== p.examples || void 0 !== this.schema.examples) {
            var _t71 = p.examples || this.schema.examples;

            this.examples = A(_t71) ? _t71 : h(_t71, function (t, r) {
              return new Fn(e, t, r, p.encoding);
            });
          }

          d ? this.serializationMime = d : p.style ? this.style = p.style : this.in && (this.style = null != (s = null == (i = Un[this.in]) ? void 0 : i.style) ? s : "form"), void 0 === p.explode && this.in ? this.explode = null == (l = null == (a = Un[this.in]) ? void 0 : a.explode) || l : this.explode = !!p.explode, this.deprecated = void 0 === p.deprecated ? !!this.schema.deprecated : p.deprecated, n.showExtensions && (this.extensions = bt(p, n.showExtensions)), this.const = (null == (c = this.schema) ? void 0 : c.const) || (null == p ? void 0 : p.const) || "";
        }

        _createClass(Wn, [{
          key: "toggle",
          value: function toggle() {
            this.expanded = !this.expanded;
          }
        }, {
          key: "collapse",
          value: function collapse() {
            this.expanded = !1;
          }
        }, {
          key: "expand",
          value: function expand() {
            this.expanded = !0;
          }
        }]);

        return Wn;
      }();

      Qn([de.observable], Wn.prototype, "expanded", 2), Qn([de.action], Wn.prototype, "toggle", 1), Qn([de.action], Wn.prototype, "collapse", 1), Qn([de.action], Wn.prototype, "expand", 1);

      var Vn = require("openapi-sampler");

      var Hn = /*#__PURE__*/function () {
        function Hn(e, t, r, n, o) {
          _classCallCheck(this, Hn);

          this.name = t, this.isRequestType = r, this.schema = n.schema && new Dn(e, n.schema, "", o), this.onlyRequiredInSamples = o.onlyRequiredInSamples, this.generatedPayloadSamplesMaxDepth = o.generatedPayloadSamplesMaxDepth, void 0 !== n.examples ? this.examples = h(n.examples, function (r) {
            return new Fn(e, r, t, n.encoding);
          }) : void 0 !== n.example ? this.examples = {
            default: new Fn(e, {
              value: e.deref(n.example).resolved
            }, t, n.encoding)
          } : Qe(t) && this.generateExample(e, n);
        }

        _createClass(Hn, [{
          key: "generateExample",
          value: function generateExample(e, t) {
            var r = {
              skipReadOnly: this.isRequestType,
              skipWriteOnly: !this.isRequestType,
              skipNonRequired: this.isRequestType && this.onlyRequiredInSamples,
              maxSampleDepth: this.generatedPayloadSamplesMaxDepth
            };

            if (this.schema && this.schema.oneOf) {
              this.examples = {};

              var _iterator42 = _createForOfIteratorHelper(this.schema.oneOf),
                  _step42;

              try {
                for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                  var _n52 = _step42.value;

                  var _o22 = Vn.sample(_n52.rawSchema, r, e.spec);

                  this.schema.discriminatorProp && "object" == typeof _o22 && _o22 && (_o22[this.schema.discriminatorProp] = _n52.title), this.examples[_n52.title] = new Fn(e, {
                    value: _o22
                  }, this.name, t.encoding);
                }
              } catch (err) {
                _iterator42.e(err);
              } finally {
                _iterator42.f();
              }
            } else this.schema && (this.examples = {
              default: new Fn(e, {
                value: Vn.sample(t.schema, r, e.spec)
              }, this.name, t.encoding)
            });
          }
        }]);

        return Hn;
      }();

      var Jn = Object.defineProperty,
          Yn = Object.getOwnPropertyDescriptor,
          Zn = function Zn(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? Yn(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && Jn(t, r, i), i;
      };

      var Gn = /*#__PURE__*/function () {
        function Gn(e, t, r, n) {
          _classCallCheck(this, Gn);

          this.isRequestType = r, this.activeMimeIdx = 0, (0, de.makeObservable)(this), n.unstable_ignoreMimeParameters && (t = lt(t)), this.mediaTypes = Object.keys(t).map(function (o) {
            var i = t[o];
            return new Hn(e, o, r, i, n);
          });
        }

        _createClass(Gn, [{
          key: "activate",
          value: function activate(e) {
            this.activeMimeIdx = e;
          }
        }, {
          key: "active",
          get: function get() {
            return this.mediaTypes[this.activeMimeIdx];
          }
        }, {
          key: "hasSample",
          get: function get() {
            return this.mediaTypes.filter(function (e) {
              return !!e.examples;
            }).length > 0;
          }
        }]);

        return Gn;
      }();

      Zn([de.observable], Gn.prototype, "activeMimeIdx", 2), Zn([de.action], Gn.prototype, "activate", 1), Zn([de.computed], Gn.prototype, "active", 1);

      var Xn = /*#__PURE__*/_createClass(function Xn(_ref40) {
        var e = _ref40.parser,
            t = _ref40.infoOrRef,
            r = _ref40.options,
            n = _ref40.isEvent;

        _classCallCheck(this, Xn);

        var o = !n,
            _e$deref7 = e.deref(t),
            i = _e$deref7.resolved;

        this.description = i.description || "", this.required = !!i.required;
        var s = vt(i);
        void 0 !== s && (this.content = new Gn(e, s, o, r));
      });

      var Kn = Object.defineProperty,
          eo = Object.defineProperties,
          to = Object.getOwnPropertyDescriptor,
          ro = Object.getOwnPropertyDescriptors,
          no = Object.getOwnPropertySymbols,
          oo = Object.prototype.hasOwnProperty,
          io = Object.prototype.propertyIsEnumerable,
          so = function so(e, t, r) {
        return t in e ? Kn(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          ao = function ao(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? to(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && Kn(t, r, i), i;
      };

      var lo = /*#__PURE__*/function () {
        function lo(_ref41) {
          var e = _ref41.parser,
              t = _ref41.code,
              r = _ref41.defaultAsError,
              n = _ref41.infoOrRef,
              o = _ref41.options,
              i = _ref41.isEvent;

          _classCallCheck(this, lo);

          this.expanded = !1, this.headers = [], (0, de.makeObservable)(this), this.expanded = "all" === o.expandResponses || o.expandResponses[t];

          var _e$deref8 = e.deref(n),
              s = _e$deref8.resolved;

          this.code = t, void 0 !== s.content && (this.content = new Gn(e, s.content, i, o)), void 0 !== s["x-summary"] ? (this.summary = s["x-summary"], this.description = s.description || "") : (this.summary = s.description || "", this.description = ""), this.type = De(t, r);
          var a = s.headers;
          void 0 !== a && (this.headers = Object.keys(a).map(function (t) {
            var r = a[t];
            return new Wn(e, (n = function (e, t) {
              for (var r in t || (t = {})) {
                oo.call(t, r) && so(e, r, t[r]);
              }

              if (no) {
                var _iterator43 = _createForOfIteratorHelper(no(t)),
                    _step43;

                try {
                  for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                    var r = _step43.value;
                    io.call(t, r) && so(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator43.e(err);
                } finally {
                  _iterator43.f();
                }
              }

              return e;
            }({}, r), eo(n, ro({
              name: t
            }))), "", o);
            var n;
          })), o.showExtensions && (this.extensions = bt(s, o.showExtensions));
        }

        _createClass(lo, [{
          key: "toggle",
          value: function toggle() {
            this.expanded = !this.expanded;
          }
        }]);

        return lo;
      }();

      ao([de.observable], lo.prototype, "expanded", 2), ao([de.action], lo.prototype, "toggle", 1);

      var co = Object.defineProperty,
          po = Object.getOwnPropertyDescriptor,
          uo = function uo(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? po(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && co(t, r, i), i;
      };

      function ho(e) {
        return "payload" === e.lang && e.requestBodyContent;
      }

      var mo = !1;

      var fo = /*#__PURE__*/function () {
        function fo(e, t, r, n) {
          var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

          _classCallCheck(this, fo);

          this.parser = e, this.operationSpec = t, this.options = n, this.type = "operation", this.items = [], this.ready = !0, this.active = !1, this.expanded = !1, (0, de.makeObservable)(this), this.pointer = t.pointer, this.description = t.description, this.parent = r, this.externalDocs = t.externalDocs, this.deprecated = !!t.deprecated, this.httpVerb = t.httpVerb, this.deprecated = !!t.deprecated, this.operationId = t.operationId, this.path = t.pathName, this.isCallback = o, this.isWebhook = t.isWebhook, this.isEvent = this.isCallback || this.isWebhook, this.name = Ne(t), this.sidebarLabel = n.sideNavStyle === _.IdOnly ? this.operationId || this.path : n.sideNavStyle === _.PathOnly ? this.path : this.name, this.isCallback ? (this.security = (t.security || []).map(function (t) {
            return new Xr(t, e);
          }), this.servers = pt("", t.servers || t.pathServers || [])) : (this.operationHash = t.operationId && "operation/" + t.operationId, this.id = void 0 !== t.operationId ? (r ? r.id + "/" : "") + this.operationHash : void 0 !== r ? r.id + this.pointer : this.pointer, this.security = (t.security || e.spec.security || []).map(function (t) {
            return new Xr(t, e);
          }), this.servers = pt(e.specUrl, t.servers || t.pathServers || e.spec.servers || [])), n.showExtensions && (this.extensions = bt(t, n.showExtensions));
        }

        _createClass(fo, [{
          key: "activate",
          value: function activate() {
            this.active = !0;
          }
        }, {
          key: "deactivate",
          value: function deactivate() {
            this.active = !1;
          }
        }, {
          key: "toggle",
          value: function toggle() {
            this.expanded = !this.expanded;
          }
        }, {
          key: "expand",
          value: function expand() {
            this.parent && this.parent.expand();
          }
        }, {
          key: "collapse",
          value: function collapse() {}
        }, {
          key: "requestBody",
          get: function get() {
            return this.operationSpec.requestBody && new Xn({
              parser: this.parser,
              infoOrRef: this.operationSpec.requestBody,
              options: this.options,
              isEvent: this.isEvent
            });
          }
        }, {
          key: "codeSamples",
          get: function get() {
            var e = this.operationSpec["x-codeSamples"] || this.operationSpec["x-code-samples"] || [];
            this.operationSpec["x-code-samples"] && !mo && (mo = !0, console.warn('"x-code-samples" is deprecated. Use "x-codeSamples" instead'));
            var t = this.requestBody && this.requestBody.content;

            if (t && t.hasSample) {
              var _r55 = Math.min(e.length, this.options.payloadSampleIdx);

              e = [].concat(_toConsumableArray(e.slice(0, _r55)), [{
                lang: "payload",
                label: "Payload",
                source: "",
                requestBodyContent: t
              }], _toConsumableArray(e.slice(_r55)));
            }

            return e;
          }
        }, {
          key: "parameters",
          get: function get() {
            var _this15 = this;

            var e = at(this.parser, this.operationSpec.pathParameters, this.operationSpec.parameters).map(function (e) {
              return new Wn(_this15.parser, e, _this15.pointer, _this15.options);
            });
            return this.options.sortPropsAlphabetically ? st(e, "name") : this.options.requiredPropsFirst ? it(e) : e;
          }
        }, {
          key: "responses",
          get: function get() {
            var _this16 = this;

            var e = !1;
            return Object.keys(this.operationSpec.responses || []).filter(function (t) {
              return "default" === t || ("success" === De(t) && (e = !0), Le(t));
            }).map(function (t) {
              return new lo({
                parser: _this16.parser,
                code: t,
                defaultAsError: e,
                infoOrRef: _this16.operationSpec.responses[t],
                options: _this16.options,
                isEvent: _this16.isEvent
              });
            });
          }
        }, {
          key: "callbacks",
          get: function get() {
            var _this17 = this;

            return Object.keys(this.operationSpec.callbacks || []).map(function (e) {
              return new pn(_this17.parser, e, _this17.operationSpec.callbacks[e], _this17.pointer, _this17.options);
            });
          }
        }]);

        return fo;
      }();

      uo([de.observable], fo.prototype, "ready", 2), uo([de.observable], fo.prototype, "active", 2), uo([de.observable], fo.prototype, "expanded", 2), uo([de.action], fo.prototype, "activate", 1), uo([de.action], fo.prototype, "deactivate", 1), uo([de.action], fo.prototype, "toggle", 1), uo([zt], fo.prototype, "requestBody", 1), uo([zt], fo.prototype, "codeSamples", 1), uo([zt], fo.prototype, "parameters", 1), uo([zt], fo.prototype, "responses", 1), uo([zt], fo.prototype, "callbacks", 1);

      var go = Object.defineProperty,
          yo = Object.defineProperties,
          bo = Object.getOwnPropertyDescriptors,
          xo = Object.getOwnPropertySymbols,
          vo = Object.prototype.hasOwnProperty,
          wo = Object.prototype.propertyIsEnumerable,
          ko = function ko(e, t, r) {
        return t in e ? go(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Oo = function Oo(e, t) {
        for (var r in t || (t = {})) {
          vo.call(t, r) && ko(e, r, t[r]);
        }

        if (xo) {
          var _iterator44 = _createForOfIteratorHelper(xo(t)),
              _step44;

          try {
            for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
              var r = _step44.value;
              wo.call(t, r) && ko(e, r, t[r]);
            }
          } catch (err) {
            _iterator44.e(err);
          } finally {
            _iterator44.f();
          }
        }

        return e;
      };

      var Eo = /*#__PURE__*/function () {
        function Eo(e, t, r) {
          _classCallCheck(this, Eo);

          this.operations = [];

          var _e$deref9 = e.deref(r || {}),
              n = _e$deref9.resolved;

          this.initWebhooks(e, n, t);
        }

        _createClass(Eo, [{
          key: "initWebhooks",
          value: function initWebhooks(e, t, r) {
            for (var _i29 = 0, _Object$keys6 = Object.keys(t); _i29 < _Object$keys6.length; _i29++) {
              var _o23 = _Object$keys6[_i29];

              var _i30 = t[_o23],
                  _s13 = Object.keys(_i30).filter(Me);

              var _iterator45 = _createForOfIteratorHelper(_s13),
                  _step45;

              try {
                for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                  var _t72 = _step45.value;
                  var _o24 = _i30[_t72];

                  if (_i30.$ref) {
                    var _n53 = e.deref(_i30 || {});

                    this.initWebhooks(e, _defineProperty({}, _t72, _n53), r);
                  }

                  if (!_o24) continue;

                  var _s14 = new fo(e, (n = Oo({}, _o24), yo(n, bo({
                    httpVerb: _t72
                  }))), void 0, r, !1);

                  this.operations.push(_s14);
                }
              } catch (err) {
                _iterator45.e(err);
              } finally {
                _iterator45.f();
              }
            }

            var n;
          }
        }]);

        return Eo;
      }();

      var So = /*#__PURE__*/_createClass(function So(e, t, r) {
        _classCallCheck(this, So);

        var _e$deref10 = e.deref(r),
            n = _e$deref10.resolved;

        this.id = t, this.sectionId = mt + t, this.type = n.type, this.displayName = n["x-displayName"] || t, this.description = n.description || "", "apiKey" === n.type && (this.apiKey = {
          name: n.name,
          in: n.in
        }), "http" === n.type && (this.http = {
          scheme: n.scheme,
          bearerFormat: n.bearerFormat
        }), "openIdConnect" === n.type && (this.openId = {
          connectUrl: n.openIdConnectUrl
        }), "oauth2" === n.type && n.flows && (this.flows = n.flows);
      });

      var $o = /*#__PURE__*/_createClass(function $o(e) {
        _classCallCheck(this, $o);

        var t = e.spec.components && e.spec.components.securitySchemes || {};
        this.schemes = Object.keys(t).map(function (r) {
          return new So(e, r, t[r]);
        });
      });

      var Ro = Object.defineProperty,
          jo = Object.getOwnPropertySymbols,
          Co = Object.prototype.hasOwnProperty,
          Ao = Object.prototype.propertyIsEnumerable,
          Po = function Po(e, t, r) {
        return t in e ? Ro(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Io = function Io(e, t) {
        for (var r in t || (t = {})) {
          Co.call(t, r) && Po(e, r, t[r]);
        }

        if (jo) {
          var _iterator46 = _createForOfIteratorHelper(jo(t)),
              _step46;

          try {
            for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
              var r = _step46.value;
              Ao.call(t, r) && Po(e, r, t[r]);
            }
          } catch (err) {
            _iterator46.e(err);
          } finally {
            _iterator46.f();
          }
        }

        return e;
      };

      var To = /*#__PURE__*/_createClass(function To(e, t, r) {
        _classCallCheck(this, To);

        var n, o, i;
        this.options = r, this.parser = new On(e, t, r), this.info = new Ur(this.parser, this.options), this.externalDocs = this.parser.spec.externalDocs, this.contentItems = Jo.buildStructure(this.parser, this.options), this.securitySchemes = new $o(this.parser);
        var s = Io(Io({}, null == (o = null == (n = this.parser) ? void 0 : n.spec) ? void 0 : o["x-webhooks"]), null == (i = this.parser) ? void 0 : i.spec.webhooks);
        this.webhooks = new Eo(this.parser, r, s);
      });

      var _o = Object.defineProperty,
          Lo = Object.getOwnPropertyDescriptor,
          Do = function Do(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? Lo(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && _o(t, r, i), i;
      };

      var zo = /*#__PURE__*/function () {
        function zo(e, t, r) {
          _classCallCheck(this, zo);

          this.items = [], this.active = !1, this.expanded = !1, (0, de.makeObservable)(this), this.id = t.id || e + "/" + w(t.name), this.type = e, this.name = t["x-displayName"] || t.name, this.level = t.level || 1, this.sidebarLabel = this.name, this.description = t.description || "";
          var n = t.items;
          n && n.length && (this.description = Br.getTextBeforeHading(this.description, n[0].name)), this.parent = r, this.externalDocs = t.externalDocs, "group" === this.type && (this.expanded = !0);
        }

        _createClass(zo, [{
          key: "activate",
          value: function activate() {
            this.active = !0;
          }
        }, {
          key: "expand",
          value: function expand() {
            this.parent && this.parent.expand(), this.expanded = !0;
          }
        }, {
          key: "collapse",
          value: function collapse() {
            "group" !== this.type && (this.expanded = !1);
          }
        }, {
          key: "deactivate",
          value: function deactivate() {
            this.active = !1;
          }
        }]);

        return zo;
      }();

      Do([de.observable], zo.prototype, "active", 2), Do([de.observable], zo.prototype, "expanded", 2), Do([de.action], zo.prototype, "activate", 1), Do([de.action], zo.prototype, "expand", 1), Do([de.action], zo.prototype, "collapse", 1), Do([de.action], zo.prototype, "deactivate", 1);

      var Mo = Object.defineProperty,
          No = Object.defineProperties,
          Fo = Object.getOwnPropertyDescriptors,
          qo = Object.getOwnPropertySymbols,
          Bo = Object.prototype.hasOwnProperty,
          Qo = Object.prototype.propertyIsEnumerable,
          Uo = function Uo(e, t, r) {
        return t in e ? Mo(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Wo = function Wo(e, t) {
        for (var r in t || (t = {})) {
          Bo.call(t, r) && Uo(e, r, t[r]);
        }

        if (qo) {
          var _iterator47 = _createForOfIteratorHelper(qo(t)),
              _step47;

          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var r = _step47.value;
              Qo.call(t, r) && Uo(e, r, t[r]);
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }
        }

        return e;
      },
          Vo = function Vo(e, t) {
        return No(e, Fo(t));
      };

      var Ho = 0;

      var Jo = /*#__PURE__*/function () {
        function Jo() {
          _classCallCheck(this, Jo);
        }

        _createClass(Jo, null, [{
          key: "buildStructure",
          value: function buildStructure(e, t) {
            var r = e.spec,
                n = [],
                o = Jo.getTagsWithOperations(e, r);
            return n.push.apply(n, _toConsumableArray(Jo.addMarkdownItems(r.info.description || "", void 0, 1, t))), r["x-tagGroups"] && r["x-tagGroups"].length > 0 ? n.push.apply(n, _toConsumableArray(Jo.getTagGroupsItems(e, void 0, r["x-tagGroups"], o, t))) : n.push.apply(n, _toConsumableArray(Jo.getTagsItems(e, o, void 0, void 0, t))), n;
          }
        }, {
          key: "addMarkdownItems",
          value: function addMarkdownItems(e, t, r, n) {
            var o = new Br(n, null == t ? void 0 : t.id).extractHeadings(e || "");
            o.length && t && t.description && (t.description = Br.getTextBeforeHading(t.description, o[0].name));

            var i = function i(e, t) {
              var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              return t.map(function (t) {
                var n = new zo("section", t, e);
                return n.depth = r, t.items && (n.items = i(n, t.items, r + 1)), n;
              });
            };

            return i(t, o, r);
          }
        }, {
          key: "getTagGroupsItems",
          value: function getTagGroupsItems(e, t, r, n, o) {
            var i = [];

            var _iterator48 = _createForOfIteratorHelper(r),
                _step48;

            try {
              for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                var _s15 = _step48.value;

                var _r56 = new zo("group", _s15, t);

                _r56.depth = Ho, _r56.items = Jo.getTagsItems(e, n, _r56, _s15, o), i.push(_r56);
              }
            } catch (err) {
              _iterator48.e(err);
            } finally {
              _iterator48.f();
            }

            return i;
          }
        }, {
          key: "getTagsItems",
          value: function getTagsItems(e, t, r, n, o) {
            var i;
            i = void 0 === n ? Object.keys(t) : n.tags;
            var s = i.map(function (e) {
              return t[e] ? (t[e].used = !0, t[e]) : (console.warn("Non-existing tag \"".concat(e, "\" is added to the group \"").concat(n.name, "\"")), null);
            }),
                a = [];

            var _iterator49 = _createForOfIteratorHelper(s),
                _step49;

            try {
              for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                var _t73 = _step49.value;
                if (!_t73) continue;

                var _n54 = new zo("tag", _t73, r);

                if (_n54.depth = Ho + 1, "" !== _t73.name) _n54.items = [].concat(_toConsumableArray(Jo.addMarkdownItems(_t73.description || "", _n54, _n54.depth + 1, o)), _toConsumableArray(this.getOperationsItems(e, _n54, _t73, _n54.depth + 1, o))), a.push(_n54);else {
                  var _r57 = [].concat(_toConsumableArray(Jo.addMarkdownItems(_t73.description || "", _n54, _n54.depth + 1, o)), _toConsumableArray(this.getOperationsItems(e, void 0, _t73, _n54.depth + 1, o)));

                  a.push.apply(a, _toConsumableArray(_r57));
                }
              }
            } catch (err) {
              _iterator49.e(err);
            } finally {
              _iterator49.f();
            }

            return o.sortTagsAlphabetically && a.sort(Mt("name")), a;
          }
        }, {
          key: "getOperationsItems",
          value: function getOperationsItems(e, t, r, n, o) {
            if (0 === r.operations.length) return [];
            var i = [];

            var _iterator50 = _createForOfIteratorHelper(r.operations),
                _step50;

            try {
              for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                var _s16 = _step50.value;

                var _r58 = new fo(e, _s16, t, o);

                _r58.depth = n, i.push(_r58);
              }
            } catch (err) {
              _iterator50.e(err);
            } finally {
              _iterator50.f();
            }

            return o.sortOperationsAlphabetically && i.sort(Mt("name")), i;
          }
        }, {
          key: "getTagsWithOperations",
          value: function getTagsWithOperations(e, t) {
            var r = {},
                n = t["x-webhooks"] || t.webhooks;

            var _iterator51 = _createForOfIteratorHelper(t.tags || []),
                _step51;

            try {
              for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
                var _e65 = _step51.value;
                r[_e65.name] = Vo(Wo({}, _e65), {
                  operations: []
                });
              }
            } catch (err) {
              _iterator51.e(err);
            } finally {
              _iterator51.f();
            }

            function o(e, t, n) {
              for (var _i31 = 0, _Object$keys7 = Object.keys(t); _i31 < _Object$keys7.length; _i31++) {
                var _i32 = _Object$keys7[_i31];

                var _s17 = t[_i32],
                    _a10 = Object.keys(_s17).filter(Me);

                var _iterator52 = _createForOfIteratorHelper(_a10),
                    _step52;

                try {
                  for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
                    var _t74 = _step52.value;
                    var _a11 = _s17[_t74];

                    if (_s17.$ref) {
                      var _e$deref11 = e.deref(_s17),
                          _t75 = _e$deref11.resolved;

                      o(e, _defineProperty({}, _i32, _t75), n);
                      continue;
                    }

                    var _l7 = null == _a11 ? void 0 : _a11.tags;

                    _l7 && _l7.length || (_l7 = [""]);

                    var _iterator53 = _createForOfIteratorHelper(_l7),
                        _step53;

                    try {
                      for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
                        var _e64 = _step53.value;
                        var _o26 = r[_e64];
                        void 0 === _o26 && (_o26 = {
                          name: _e64,
                          operations: []
                        }, r[_e64] = _o26), _o26["x-traitTag"] || _o26.operations.push(Vo(Wo({}, _a11), {
                          pathName: _i32,
                          pointer: ke.compile(["paths", _i32, _t74]),
                          httpVerb: _t74,
                          pathParameters: _s17.parameters || [],
                          pathServers: _s17.servers,
                          isWebhook: !!n
                        }));
                      }
                    } catch (err) {
                      _iterator53.e(err);
                    } finally {
                      _iterator53.f();
                    }
                  }
                } catch (err) {
                  _iterator52.e(err);
                } finally {
                  _iterator52.f();
                }
              }
            }

            return n && o(e, n, !0), t.paths && o(e, t.paths), r;
          }
        }]);

        return Jo;
      }();

      var Yo = Object.defineProperty,
          Zo = Object.getOwnPropertyDescriptor,
          Go = function Go(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? Zo(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && Yo(t, r, i), i;
      };

      var Xo = "data-section-id";

      var Ko = /*#__PURE__*/function () {
        function Ko(e, t, r) {
          var _this18 = this;

          _classCallCheck(this, Ko);

          this.scroll = t, this.history = r, this.activeItemIdx = -1, this.sideBarOpened = !1, this.updateOnScroll = function (e) {
            var t = e ? 1 : -1;
            var r = _this18.activeItemIdx;

            for (; (-1 !== r || e) && !(r >= _this18.flatItems.length - 1 && e);) {
              if (e) {
                var _e66 = _this18.getElementAtOrFirstChild(r + 1);

                if (_this18.scroll.isElementBellow(_e66)) break;
              } else {
                var _e67 = _this18.getElementAt(r);

                if (_this18.scroll.isElementAbove(_e67)) break;
              }

              r += t;
            }

            _this18.activate(_this18.flatItems[r], !0, !0);
          }, this.updateOnHistory = function () {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this18.history.currentId;
            if (!e) return;
            var t;
            t = _this18.flatItems.find(function (t) {
              return t.id === e;
            }), t ? _this18.activateAndScroll(t, !1) : (e.startsWith(mt) && (t = _this18.flatItems.find(function (e) {
              return mt.startsWith(e.id);
            }), _this18.activateAndScroll(t, !1)), _this18.scroll.scrollIntoViewBySelector("[".concat(Xo, "=\"").concat(j(e), "\"]")));
          }, this.getItemById = function (e) {
            return _this18.flatItems.find(function (t) {
              return t.id === e;
            });
          }, (0, de.makeObservable)(this), this.items = e.contentItems, this.flatItems = m(this.items || [], "items"), this.flatItems.forEach(function (e, t) {
            return e.absoluteIdx = t;
          }), this.subscribe();
        }

        _createClass(Ko, [{
          key: "subscribe",
          value: function subscribe() {
            this._unsubscribe = this.scroll.subscribe(this.updateOnScroll), this._hashUnsubscribe = this.history.subscribe(this.updateOnHistory);
          }
        }, {
          key: "toggleSidebar",
          value: function toggleSidebar() {
            this.sideBarOpened = !this.sideBarOpened;
          }
        }, {
          key: "closeSidebar",
          value: function closeSidebar() {
            this.sideBarOpened = !1;
          }
        }, {
          key: "getElementAt",
          value: function getElementAt(e) {
            var t = this.flatItems[e];
            return t && a("[".concat(Xo, "=\"").concat(j(t.id), "\"]")) || null;
          }
        }, {
          key: "getElementAtOrFirstChild",
          value: function getElementAtOrFirstChild(e) {
            var t = this.flatItems[e];
            return t && "group" === t.type && (t = t.items[0]), t && a("[".concat(Xo, "=\"").concat(j(t.id), "\"]")) || null;
          }
        }, {
          key: "activeItem",
          get: function get() {
            return this.flatItems[this.activeItemIdx] || void 0;
          }
        }, {
          key: "activate",
          value: function activate(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

            if ((this.activeItem && this.activeItem.id) !== (e && e.id) && (!e || "group" !== e.type)) {
              if (this.deactivate(this.activeItem), !e) return this.activeItemIdx = -1, void this.history.replace("", r);
              e.depth <= Ho || (this.activeItemIdx = e.absoluteIdx, t && this.history.replace(encodeURI(e.id), r), e.activate(), e.expand());
            }
          }
        }, {
          key: "deactivate",
          value: function deactivate(e) {
            if (void 0 !== e) for (e.deactivate(); void 0 !== e;) {
              e.collapse(), e = e.parent;
            }
          }
        }, {
          key: "activateAndScroll",
          value: function activateAndScroll(e, t, r) {
            var n = e && this.getItemById(e.id) || e;
            this.activate(n, t, r), this.scrollToActive(), n && n.items.length || this.closeSidebar();
          }
        }, {
          key: "scrollToActive",
          value: function scrollToActive() {
            this.scroll.scrollIntoView(this.getElementAt(this.activeItemIdx));
          }
        }, {
          key: "dispose",
          value: function dispose() {
            this._unsubscribe(), this._hashUnsubscribe();
          }
        }], [{
          key: "updateOnHistory",
          value: function updateOnHistory() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Qt.currentId;
            var t = arguments.length > 1 ? arguments[1] : undefined;
            e && t.scrollIntoViewBySelector("[".concat(Xo, "=\"").concat(j(e), "\"]"));
          }
        }]);

        return Ko;
      }();

      Go([de.observable], Ko.prototype, "activeItemIdx", 2), Go([de.observable], Ko.prototype, "sideBarOpened", 2), Go([de.action], Ko.prototype, "toggleSidebar", 1), Go([de.action], Ko.prototype, "closeSidebar", 1), Go([de.action], Ko.prototype, "activate", 1), Go([de.action.bound], Ko.prototype, "activateAndScroll", 1);
      var ei = Object.defineProperty,
          ti = Object.getOwnPropertyDescriptor;
      var ri = "scroll";

      var ni = /*#__PURE__*/function () {
        function ni(e) {
          _classCallCheck(this, ni);

          this.options = e, this._prevOffsetY = 0, this._scrollParent = s ? window : void 0, this._emiter = new xe(), this.bind();
        }

        _createClass(ni, [{
          key: "bind",
          value: function bind() {
            this._prevOffsetY = this.scrollY(), this._scrollParent && this._scrollParent.addEventListener("scroll", this.handleScroll);
          }
        }, {
          key: "dispose",
          value: function dispose() {
            this._scrollParent && this._scrollParent.removeEventListener("scroll", this.handleScroll), this._emiter.removeAllListeners(ri);
          }
        }, {
          key: "scrollY",
          value: function scrollY() {
            return "undefined" != typeof HTMLElement && this._scrollParent instanceof HTMLElement ? this._scrollParent.scrollTop : void 0 !== this._scrollParent ? this._scrollParent.pageYOffset : 0;
          }
        }, {
          key: "isElementBellow",
          value: function isElementBellow(e) {
            if (null !== e) return e.getBoundingClientRect().top > this.options.scrollYOffset();
          }
        }, {
          key: "isElementAbove",
          value: function isElementAbove(e) {
            if (null === e) return;
            var t = e.getBoundingClientRect().top;
            return (t > 0 ? Math.floor(t) : Math.ceil(t)) <= this.options.scrollYOffset();
          }
        }, {
          key: "subscribe",
          value: function subscribe(e) {
            var t = this._emiter.addListener(ri, e);

            return function () {
              return t.removeListener(ri, e);
            };
          }
        }, {
          key: "scrollIntoView",
          value: function scrollIntoView(e) {
            null !== e && (e.scrollIntoView(), this._scrollParent && this._scrollParent.scrollBy && this._scrollParent.scrollBy(0, 1 - this.options.scrollYOffset()));
          }
        }, {
          key: "scrollIntoViewBySelector",
          value: function scrollIntoViewBySelector(e) {
            var t = a(e);
            this.scrollIntoView(t);
          }
        }, {
          key: "handleScroll",
          value: function handleScroll() {
            var e = this.scrollY() - this._prevOffsetY > 0;
            this._prevOffsetY = this.scrollY(), this._emiter.emit(ri, e);
          }
        }]);

        return ni;
      }();

      (function (e, t, r, n) {
        for (var o, i = ti(t, r), s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(t, r, i) || i);
        }

        i && ei(t, r, i);
      })([be.bind, Et(100)], ni.prototype, "handleScroll");

      var oi = /*#__PURE__*/function () {
        function oi() {
          _classCallCheck(this, oi);

          this.searchWorker = function () {
            var e;
            if (s) try {
              e = r(980);
            } catch (t) {
              e = r(657).ZP;
            } else e = r(657).ZP;
            return new e();
          }();
        }

        _createClass(oi, [{
          key: "indexItems",
          value: function indexItems(e) {
            var _this19 = this;

            var t = function t(e) {
              e.forEach(function (e) {
                "group" !== e.type && _this19.add(e.name, (e.description || "").concat(" ", e.path || ""), e.id), t(e.items);
              });
            };

            t(e), this.searchWorker.done();
          }
        }, {
          key: "add",
          value: function add(e, t, r) {
            this.searchWorker.add(e, t, r);
          }
        }, {
          key: "dispose",
          value: function dispose() {
            this.searchWorker.terminate(), this.searchWorker.dispose();
          }
        }, {
          key: "search",
          value: function search(e) {
            return this.searchWorker.search(e);
          }
        }, {
          key: "toJS",
          value: function toJS() {
            return e = this, null, t = /*#__PURE__*/_regeneratorRuntime.mark(function t() {
              return _regeneratorRuntime.wrap(function t$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      return _context8.abrupt("return", this.searchWorker.toJS());

                    case 1:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, t, this);
            }), new Promise(function (r, n) {
              var o = function o(e) {
                try {
                  s(t.next(e));
                } catch (e) {
                  n(e);
                }
              },
                  i = function i(e) {
                try {
                  s(t.throw(e));
                } catch (e) {
                  n(e);
                }
              },
                  s = function s(e) {
                return e.done ? r(e.value) : Promise.resolve(e.value).then(o, i);
              };

              s((t = t.apply(e, null)).next());
            });
            var e, t;
          }
        }, {
          key: "load",
          value: function load(e) {
            this.searchWorker.load(e);
          }
        }, {
          key: "fromExternalJS",
          value: function fromExternalJS(e, t) {
            e && t && this.searchWorker.fromExternalJS(e, t);
          }
        }]);

        return oi;
      }();

      var ii = ee.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: calc(100% - ", ");\n  padding: 0 ", "px;\n\n  ", ";\n"])), function (e) {
        return e.theme.rightPanel.width;
      }, function (e) {
        return e.theme.spacing.sectionHorizontal;
      }, function (_ref42) {
        var e = _ref42.compact,
            t = _ref42.theme;
        return K.lessThan("medium", !0)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: ", ";\n  "])), "".concat(e ? 0 : t.spacing.sectionVertical, "px ").concat(t.spacing.sectionHorizontal, "px"));
      }),
          si = ee.div.attrs(function (e) {
        return _defineProperty({}, Xo, e.id);
      })(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: ", "px 0;\n\n  &:last-child {\n    min-height: calc(100vh + 1px);\n  }\n\n  & > &:last-child {\n    min-height: initial;\n  }\n\n  ", "\n  ", "\n"])), function (e) {
        return e.theme.spacing.sectionVertical;
      }, K.lessThan("medium", !0)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    padding: 0;\n  "]))), function (e) {
        return e.underlined ? "\n    position: relative;\n\n    &:not(:last-of-type):after {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      display: block;\n      content: '';\n      border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    }\n  " : "";
      }),
          ai = ee.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: ", ";\n  color: ", ";\n  background-color: ", ";\n  padding: 0 ", "px;\n\n  ", ";\n"])), function (e) {
        return e.theme.rightPanel.width;
      }, function (_ref44) {
        var e = _ref44.theme;
        return e.rightPanel.textColor;
      }, function (e) {
        return e.theme.rightPanel.backgroundColor;
      }, function (e) {
        return e.theme.spacing.sectionHorizontal;
      }, K.lessThan("medium", !0)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: ", ";\n  "])), function (e) {
        return "".concat(e.theme.spacing.sectionVertical, "px ").concat(e.theme.spacing.sectionHorizontal, "px");
      })),
          li = ee(ai)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (e) {
        return e.theme.rightPanel.backgroundColor;
      }),
          ci = ee.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 0;\n\n  ", ";\n"])), K.lessThan("medium", !0)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "])))),
          pi = {
        1: "1.85714em",
        2: "1.57143em",
        3: "1.27em"
      },
          ui = function ui(e) {
        return Y(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), function (_ref45) {
          var e = _ref45.theme;
          return e.typography.headings.fontFamily;
        }, function (_ref46) {
          var e = _ref46.theme;
          return e.typography.headings.fontWeight;
        }, pi[e], function (_ref47) {
          var e = _ref47.theme;
          return e.typography.headings.lineHeight;
        });
      },
          di = ee.h1(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n\n  ", ";\n"])), ui(1), function (_ref48) {
        var e = _ref48.theme;
        return e.colors.text.primary;
      }, te("H1")),
          hi = ee.h2(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 20px;\n\n  ", ";\n"])), ui(2), function (_ref49) {
        var e = _ref49.theme;
        return e.colors.text.primary;
      }, te("H2")),
          mi = (ee.h2(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n\n  ", ";\n"])), ui(3), function (_ref50) {
        var e = _ref50.theme;
        return e.colors.text.primary;
      }, te("H3")), ee.h3(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  ", ";\n"])), function (_ref51) {
        var e = _ref51.theme;
        return e.rightPanel.textColor;
      }, te("RightPanelHeader"))),
          fi = ee.h5(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid rgba(38, 50, 56, 0.3);\n  margin: 1em 0 1em 0;\n  color: rgba(38, 50, 56, 0.5);\n  font-weight: normal;\n  text-transform: uppercase;\n  font-size: 0.929em;\n  line-height: 20px;\n\n  ", ";\n"])), te("UnderlinedHeader")),
          gi = (0, e.createContext)(void 0),
          yi = gi.Provider,
          bi = gi.Consumer;

      function xi(t) {
        var r = t.spec,
            n = t.specUrl,
            o = t.options,
            i = t.onLoaded,
            s = t.children,
            _e$useState = e.useState(null),
            _e$useState2 = _slicedToArray(_e$useState, 2),
            a = _e$useState2[0],
            l = _e$useState2[1],
            _e$useState3 = e.useState(null),
            _e$useState4 = _slicedToArray(_e$useState3, 2),
            c = _e$useState4[0],
            p = _e$useState4[1];

        if (c) throw c;
        e.useEffect(function () {
          !function () {
            return e = this, null, t = /*#__PURE__*/_regeneratorRuntime.mark(function t() {
              var _e68;

              return _regeneratorRuntime.wrap(function t$(_context9) {
                while (1) {
                  switch (_context9.prev = _context9.next) {
                    case 0:
                      if (!(r || n)) {
                        _context9.next = 12;
                        break;
                      }

                      l(null);
                      _context9.prev = 2;
                      _context9.next = 5;
                      return ge(r || n);

                    case 5:
                      _e68 = _context9.sent;
                      l(_e68);
                      _context9.next = 12;
                      break;

                    case 9:
                      _context9.prev = 9;
                      _context9.t0 = _context9["catch"](2);
                      throw p(_context9.t0), _context9.t0;

                    case 12:
                    case "end":
                      return _context9.stop();
                  }
                }
              }, t, null, [[2, 9]]);
            }), new Promise(function (r, n) {
              var o = function o(e) {
                try {
                  s(t.next(e));
                } catch (e) {
                  n(e);
                }
              },
                  i = function i(e) {
                try {
                  s(t.throw(e));
                } catch (e) {
                  n(e);
                }
              },
                  s = function s(e) {
                return e.done ? r(e.value) : Promise.resolve(e.value).then(o, i);
              };

              s((t = t.apply(e, null)).next());
            });
            var e, t;
          }();
        }, [r, n]);
        var u = e.useMemo(function () {
          if (!a) return null;

          try {
            return new rc(a, n, o);
          } catch (e) {
            throw i && i(e), e;
          }
        }, [a, n, o]);
        return e.useEffect(function () {
          u && i && i();
        }, [u, i]), s({
          loading: !u,
          store: u
        });
      }

      function vi() {
        return (0, e.useContext)(gi);
      }

      var wi = function wi(e) {
        return Y(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  ", " {\n    cursor: pointer;\n    margin-left: -20px;\n    padding: 0;\n    line-height: 1;\n    width: 20px;\n    display: inline-block;\n    outline: 0;\n  }\n  ", ":before {\n    content: '';\n    width: 15px;\n    height: 15px;\n    background-size: contain;\n    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeD0iMCIgeT0iMCIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBmaWxsPSIjMDEwMTAxIiBkPSJNNDU5LjcgMjMzLjRsLTkwLjUgOTAuNWMtNTAgNTAtMTMxIDUwLTE4MSAwIC03LjktNy44LTE0LTE2LjctMTkuNC0yNS44bDQyLjEtNDIuMWMyLTIgNC41LTMuMiA2LjgtNC41IDIuOSA5LjkgOCAxOS4zIDE1LjggMjcuMiAyNSAyNSA2NS42IDI0LjkgOTAuNSAwbDkwLjUtOTAuNWMyNS0yNSAyNS02NS42IDAtOTAuNSAtMjQuOS0yNS02NS41LTI1LTkwLjUgMGwtMzIuMiAzMi4yYy0yNi4xLTEwLjItNTQuMi0xMi45LTgxLjYtOC45bDY4LjYtNjguNmM1MC01MCAxMzEtNTAgMTgxIDBDNTA5LjYgMTAyLjMgNTA5LjYgMTgzLjQgNDU5LjcgMjMzLjR6TTIyMC4zIDM4Mi4ybC0zMi4yIDMyLjJjLTI1IDI0LjktNjUuNiAyNC45LTkwLjUgMCAtMjUtMjUtMjUtNjUuNiAwLTkwLjVsOTAuNS05MC41YzI1LTI1IDY1LjUtMjUgOTAuNSAwIDcuOCA3LjggMTIuOSAxNy4yIDE1LjggMjcuMSAyLjQtMS40IDQuOC0yLjUgNi44LTQuNWw0Mi4xLTQyYy01LjQtOS4yLTExLjYtMTgtMTkuNC0yNS44IC01MC01MC0xMzEtNTAtMTgxIDBsLTkwLjUgOTAuNWMtNTAgNTAtNTAgMTMxIDAgMTgxIDUwIDUwIDEzMSA1MCAxODEgMGw2OC42LTY4LjZDMjc0LjYgMzk1LjEgMjQ2LjQgMzkyLjMgMjIwLjMgMzgyLjJ6Ii8+PC9zdmc+Cg==');\n    opacity: 0.5;\n    visibility: hidden;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  h1:hover > ", "::before, h2:hover > ", "::before, ", ":hover::before {\n    visibility: visible;\n  }\n"])), e, e, e, e, e);
      },
          ki = ee(function (t) {
        var r = e.useContext(gi),
            n = e.useCallback(function (e) {
          r && function (e, t, r) {
            t.defaultPrevented || 0 !== t.button || function (e) {
              return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
            }(t) || (t.preventDefault(), e.replace(encodeURI(r)));
          }(r.menu.history, e, t.to);
        }, [r, t.to]);
        return r ? e.createElement("a", {
          className: t.className,
          href: r.menu.history.linkForId(t.to),
          onClick: n,
          "aria-label": t.to
        }, t.children) : null;
      })(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  ", ";\n"])), wi("&"));

      function Oi(t) {
        return e.createElement(ki, {
          to: t.to
        });
      }

      var Ei = {
        left: "90deg",
        right: "-90deg",
        up: "-180deg",
        down: "0"
      },
          Si = ee(function (t) {
        return e.createElement("svg", {
          className: t.className,
          style: t.style,
          version: "1.1",
          viewBox: "0 0 24 24",
          x: "0",
          xmlns: "http://www.w3.org/2000/svg",
          y: "0",
          "aria-hidden": "true"
        }, e.createElement("polygon", {
          points: "17.3 8.3 12 13.6 6.7 8.3 5.3 9.7 12 16.4 18.7 9.7 "
        }));
      })(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  min-width: ", ";\n  vertical-align: middle;\n  float: ", ";\n  transition: transform 0.2s ease-out;\n  transform: rotateZ(", ");\n\n  polygon {\n    fill: ", ";\n  }\n"])), function (e) {
        return e.size || "18px";
      }, function (e) {
        return e.size || "18px";
      }, function (e) {
        return e.size || "18px";
      }, function (e) {
        return e.float || "";
      }, function (e) {
        return Ei[e.direction || "down"];
      }, function (_ref52) {
        var e = _ref52.color,
            t = _ref52.theme;
        return e && t.colors.responses[e] && t.colors.responses[e].color || e;
      }),
          $i = ee.span(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 2px 8px;\n  margin: 0;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  line-height: 1.6;\n  border-radius: 4px;\n  font-weight: ", ";\n  font-size: 12px;\n  + span[type] {\n    margin-left: 4px;\n  }\n"])), function (e) {
        return e.theme.colors[e.type].main;
      }, function (e) {
        return e.theme.colors[e.type].contrastText;
      }, function (e) {
        return e.theme.typography.code.fontSize;
      }, function (_ref53) {
        var e = _ref53.theme;
        return e.typography.fontWeightBold;
      }),
          Ri = Y(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n  color: #707070;\n"]))),
          ji = ee.caption(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  text-align: right;\n  font-size: 0.9em;\n  font-weight: normal;\n  color: ", ";\n"])), function (e) {
        return e.theme.colors.text.secondary;
      }),
          Ci = ee.td(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  border-left: 1px solid ", ";\n  box-sizing: border-box;\n  position: relative;\n  padding: 10px 10px 10px 0;\n\n  ", "\n\n  tr:first-of-type > &,\n  tr.last > & {\n    border-left-width: 0;\n    background-position: top left;\n    background-repeat: no-repeat;\n    background-size: 1px 100%;\n  }\n\n  tr:first-of-type > & {\n    background-image: linear-gradient(\n      to bottom,\n      transparent 0%,\n      transparent 22px,\n      ", " 22px,\n      ", " 100%\n    );\n  }\n\n  tr.last > & {\n    background-image: linear-gradient(\n      to bottom,\n      ", " 0%,\n      ", " 22px,\n      transparent 22px,\n      transparent 100%\n    );\n  }\n\n  tr.last + tr > & {\n    border-left-color: transparent;\n  }\n\n  tr.last:first-child > & {\n    background: none;\n    border-left-color: transparent;\n  }\n"])), function (e) {
        return e.theme.schema.linesColor;
      }, K.lessThan("small")(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    display: block;\n    overflow: hidden;\n  "]))), function (e) {
        return e.theme.schema.linesColor;
      }, function (e) {
        return e.theme.schema.linesColor;
      }, function (e) {
        return e.theme.schema.linesColor;
      }, function (e) {
        return e.theme.schema.linesColor;
      }),
          Ai = ee(Ci)(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
          Pi = ee(Ci)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  vertical-align: top;\n  line-height: 20px;\n  white-space: nowrap;\n  font-size: 13px;\n  font-family: ", ";\n\n  &.deprecated {\n    ", ";\n  }\n\n  ", "\n\n  ", ";\n\n  ", ";\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      }, Ri, function (_ref54) {
        var e = _ref54.kind;
        return "patternProperties" === e && Y(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n      > span.property-name {\n        display: inline-table;\n        white-space: break-spaces;\n        margin-right: 20px;\n\n        ::before,\n        ::after {\n          content: '/';\n          filter: opacity(0.2);\n        }\n      }\n    "])));
      }, function (_ref55) {
        var _ref55$kind = _ref55.kind,
            e = _ref55$kind === void 0 ? "" : _ref55$kind;
        return ["field", "additionalProperties", "patternProperties"].includes(e) ? "" : "font-style: italic";
      }, te("PropertyNameCell")),
          Ii = ee.td(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #9fb4be;\n  padding: 10px 0;\n  width: ", ";\n  box-sizing: border-box;\n\n  tr.expanded & {\n    border-bottom: none;\n  }\n\n  ", "\n\n  ", ";\n"])), function (e) {
        return e.theme.schema.defaultDetailsWidth;
      }, K.lessThan("small")(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n    padding: 0 20px;\n    border-bottom: none;\n    border-left: 1px solid ", ";\n\n    tr.last > & {\n      border-left: none;\n    }\n  "])), function (e) {
        return e.theme.schema.linesColor;
      }), te("PropertyDetailsCell")),
          Ti = ee.span(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  margin-right: 10px;\n\n  &::before {\n    content: '';\n    display: inline-block;\n    vertical-align: middle;\n    width: 10px;\n    height: 1px;\n    background: ", ";\n  }\n\n  &::after {\n    content: '';\n    display: inline-block;\n    vertical-align: middle;\n    width: 1px;\n    background: ", ";\n    height: 7px;\n  }\n"])), function (e) {
        return e.theme.schema.linesColor;
      }, function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (e) {
        return e.theme.schema.linesColor;
      }, function (e) {
        return e.theme.schema.linesColor;
      }),
          _i = ee.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (_ref56) {
        var e = _ref56.theme;
        return e.schema.nestingSpacing;
      }),
          Li = ee.table(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  border-collapse: separate;\n  border-radius: 3px;\n  font-size: ", ";\n\n  border-spacing: 0;\n  width: 100%;\n\n  > tr {\n    vertical-align: middle;\n  }\n\n  ", "\n\n  ", "\n\n  &\n    ", ",\n    &\n    ", "\n    ", "\n    ", ",\n    &\n    ", "\n    ", "\n    ", "\n    ", "\n    ", " {\n    margin: ", ";\n    margin-right: 0;\n    background: ", ";\n  }\n\n  &\n    ", "\n    ", ",\n    &\n    ", "\n    ", "\n    ", "\n    ", ",\n    &\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", " {\n    background: #ffffff;\n  }\n"])), function (e) {
        return e.theme.typography.fontSize;
      }, K.lessThan("small")(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n    display: block;\n    > tr, > tbody > tr {\n      display: block;\n    }\n  "]))), K.lessThan("small", !1, " and (-ms-high-contrast:none)")(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n    td {\n      float: left;\n      width: 100%;\n    }\n  "]))), _i, _i, _i, _i, _i, _i, _i, _i, _i, function (_ref57) {
        var e = _ref57.theme;
        return e.schema.nestingSpacing;
      }, function (_ref58) {
        var e = _ref58.theme;
        return e.schema.nestedBackground;
      }, _i, _i, _i, _i, _i, _i, _i, _i, _i, _i, _i, _i),
          Di = ee.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  margin: 0 0 3px 0;\n  display: inline-block;\n"]))),
          zi = ee.span(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  font-size: 0.9em;\n  margin-right: 10px;\n  color: ", ";\n  font-family: ", ";\n}\n"])), function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.typography.headings.fontFamily;
      }),
          Mi = ee.button(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: 10px;\n  margin-bottom: 5px;\n  font-size: 0.8em;\n  cursor: pointer;\n  border: 1px solid ", ";\n  padding: 2px 10px;\n  line-height: 1.5em;\n  outline: none;\n  &:focus {\n    box-shadow: 0 0 0 1px ", ";\n  }\n\n  ", ";\n\n  ", "\n"])), function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.colors.primary.main;
      }, function (_ref59) {
        var e = _ref59.deprecated;
        return e && Ri || "";
      }, function (e) {
        return e.active ? "\n      color: white;\n      background-color: ".concat(e.theme.colors.primary.main, ";\n      &:focus {\n        box-shadow: none;\n        background-color: ").concat((0, t.darken)(.15, e.theme.colors.primary.main), ";\n      }\n      ") : "\n        color: ".concat(e.theme.colors.primary.main, ";\n        background-color: white;\n      ");
      }),
          Ni = ee.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  font-size: 0.9em;\n  font-family: ", ";\n  &::after {\n    content: ' [';\n  }\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      }),
          Fi = ee.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  font-size: 0.9em;\n  font-family: ", ";\n  &::after {\n    content: ']';\n  }\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      });

      var qi = require("react-tabs");

      var Bi = ee(qi.Tabs)(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  > ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin: 0 -5px;\n\n    > li {\n      padding: 5px 10px;\n      display: inline-block;\n\n      background-color: ", ";\n      border-bottom: 1px solid rgba(0, 0, 0, 0.5);\n      cursor: pointer;\n      text-align: center;\n      outline: none;\n      color: ", ";\n      margin: 0\n        ", ";\n      border: 1px solid ", ";\n      border-radius: 5px;\n      min-width: 60px;\n      font-size: 0.9em;\n      font-weight: bold;\n\n      &.react-tabs__tab--selected {\n        color: ", ";\n        background: ", ";\n        &:focus {\n          outline: auto;\n        }\n      }\n\n      &:only-child {\n        flex: none;\n        min-width: 100px;\n      }\n\n      &.tab-success {\n        color: ", ";\n      }\n\n      &.tab-redirect {\n        color: ", ";\n      }\n\n      &.tab-info {\n        color: ", ";\n      }\n\n      &.tab-error {\n        color: ", ";\n      }\n    }\n  }\n  > .react-tabs__tab-panel {\n    background: ", ";\n    & > div,\n    & > pre {\n      padding: ", "px;\n      margin: 0;\n    }\n\n    & > div > pre {\n      padding: 0;\n    }\n  }\n"])), function (_ref60) {
        var e = _ref60.theme;
        return e.codeBlock.backgroundColor;
      }, function (_ref61) {
        var e = _ref61.theme;
        return (0, t.darken)(e.colors.tonalOffset, e.rightPanel.textColor);
      }, function (_ref62) {
        var e = _ref62.theme;
        return "".concat(e.spacing.unit, "px ").concat(e.spacing.unit, "px ").concat(e.spacing.unit, "px");
      }, function (_ref63) {
        var e = _ref63.theme;
        return (0, t.darken)(.05, e.codeBlock.backgroundColor);
      }, function (e) {
        return e.theme.colors.text.primary;
      }, function (_ref64) {
        var e = _ref64.theme;
        return e.rightPanel.textColor;
      }, function (e) {
        return e.theme.colors.responses.success.tabTextColor;
      }, function (e) {
        return e.theme.colors.responses.redirect.tabTextColor;
      }, function (e) {
        return e.theme.colors.responses.info.tabTextColor;
      }, function (e) {
        return e.theme.colors.responses.error.tabTextColor;
      }, function (_ref65) {
        var e = _ref65.theme;
        return e.codeBlock.backgroundColor;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      }),
          Qi = (ee(Bi)(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  > ul {\n    display: block;\n    > li {\n      padding: 2px 5px;\n      min-width: auto;\n      margin: 0 15px 0 0;\n      font-size: 13px;\n      font-weight: normal;\n      border-bottom: 1px dashed;\n      color: ", ";\n      border-radius: 0;\n      background: none;\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      &.react-tabs__tab--selected {\n        color: ", ";\n        background: none;\n      }\n    }\n  }\n  > .react-tabs__tab-panel {\n    & > div,\n    & > pre {\n      padding: ", "px 0;\n    }\n  }\n"])), function (_ref66) {
        var e = _ref66.theme;
        return (0, t.darken)(e.colors.tonalOffset, e.rightPanel.textColor);
      }, function (_ref67) {
        var e = _ref67.theme;
        return e.rightPanel.textColor;
      }, function (e) {
        return 2 * e.theme.spacing.unit;
      }), ee.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  /**\n  * Based on prism-dark.css\n  */\n\n  code[class*='language-'],\n  pre[class*='language-'] {\n    /* color: white;\n    background: none; */\n    text-shadow: 0 -0.1em 0.2em black;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    word-wrap: normal;\n    line-height: 1.5;\n\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n  }\n\n  @media print {\n    code[class*='language-'],\n    pre[class*='language-'] {\n      text-shadow: none;\n    }\n  }\n\n  /* Code blocks */\n  pre[class*='language-'] {\n    padding: 1em;\n    margin: 0.5em 0;\n    overflow: auto;\n  }\n\n  .token.comment,\n  .token.prolog,\n  .token.doctype,\n  .token.cdata {\n    color: hsl(30, 20%, 50%);\n  }\n\n  .token.punctuation {\n    opacity: 0.7;\n  }\n\n  .namespace {\n    opacity: 0.7;\n  }\n\n  .token.property,\n  .token.tag,\n  .token.number,\n  .token.constant,\n  .token.symbol {\n    color: #4a8bb3;\n  }\n\n  .token.boolean {\n    color: #e64441;\n  }\n\n  .token.selector,\n  .token.attr-name,\n  .token.string,\n  .token.char,\n  .token.builtin,\n  .token.inserted {\n    color: #a0fbaa;\n    & + a,\n    & + a:visited {\n      color: #4ed2ba;\n      text-decoration: underline;\n    }\n  }\n\n  .token.property.string {\n    color: white;\n  }\n\n  .token.operator,\n  .token.entity,\n  .token.url,\n  .token.variable {\n    color: hsl(40, 90%, 60%);\n  }\n\n  .token.atrule,\n  .token.attr-value,\n  .token.keyword {\n    color: hsl(350, 40%, 70%);\n  }\n\n  .token.regex,\n  .token.important {\n    color: #e90;\n  }\n\n  .token.important,\n  .token.bold {\n    font-weight: bold;\n  }\n  .token.italic {\n    font-style: italic;\n  }\n\n  .token.entity {\n    cursor: help;\n  }\n\n  .token.deleted {\n    color: red;\n  }\n\n  ", ";\n"])), te("Prism"))),
          Ui = ee.div(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  opacity: 0.7;\n  transition: opacity 0.3s ease;\n  text-align: right;\n  &:focus-within {\n    opacity: 1;\n  }\n  > button {\n    background-color: transparent;\n    border: 0;\n    color: inherit;\n    padding: 2px 10px;\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    cursor: pointer;\n    outline: 0;\n\n    :hover,\n    :focus {\n      background: rgba(255, 255, 255, 0.1);\n    }\n  }\n"])), function (_ref68) {
        var e = _ref68.theme;
        return e.typography.fontFamily;
      }, function (_ref69) {
        var e = _ref69.theme;
        return e.typography.fontSize;
      }, function (_ref70) {
        var e = _ref70.theme;
        return e.typography.lineHeight;
      }),
          Wi = ee.div(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  &:hover ", " {\n    opacity: 1;\n  }\n"])), Ui),
          Vi = ee(Qi.withComponent("pre"))(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  overflow-x: auto;\n  margin: 0;\n\n  white-space: ", ";\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (e) {
        return e.theme.typography.code.fontSize;
      }, function (_ref71) {
        var e = _ref71.theme;
        return e.typography.code.wrap ? "pre-wrap" : "pre";
      });

      var Hi = require("perfect-scrollbar"),
          Ji = r.n(Hi),
          Yi = Object.defineProperty,
          Zi = Object.getOwnPropertySymbols,
          Gi = Object.prototype.hasOwnProperty,
          Xi = Object.prototype.propertyIsEnumerable,
          Ki = function Ki(e, t, r) {
        return t in e ? Yi(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var es = Ji() || Hi;
      var ts = "";
      s && (ts = r(433), ts = "function" == typeof ts.toString && ts.toString() || "", ts = "[object Object]" === ts ? "" : ts);
      var rs = Z(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["", ""])), ts),
          ns = ee.div(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

      var os = /*#__PURE__*/function (_e$Component2) {
        _inherits(os, _e$Component2);

        var _super4 = _createSuper(os);

        function os() {
          var _this20;

          _classCallCheck(this, os);

          _this20 = _super4.apply(this, arguments), _this20.handleRef = function (e) {
            _this20._container = e;
          };
          return _this20;
        }

        _createClass(os, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var e = this._container.parentElement && this._container.parentElement.scrollTop || 0;
            this.inst = new es(this._container, this.props.options || {}), this._container.scrollTo && this._container.scrollTo(0, e);
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.inst.update();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.inst.destroy();
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props = this.props,
                t = _this$props.children,
                r = _this$props.className,
                n = _this$props.updateFn;
            return n && n(this.componentDidUpdate.bind(this)), e.createElement(e.Fragment, null, ts && e.createElement(rs, null), e.createElement(ns, {
              className: "scrollbar-container ".concat(r),
              ref: this.handleRef
            }, t));
          }
        }]);

        return os;
      }(e.Component);

      function is(t) {
        return e.createElement(ce.Consumer, null, function (r) {
          return r.nativeScrollbars ? e.createElement("div", {
            style: {
              overflow: "auto",
              overscrollBehavior: "contain",
              msOverflowStyle: "-ms-autohiding-scrollbar"
            }
          }, t.children) : e.createElement(os, function (e, t) {
            for (var r in t || (t = {})) {
              Gi.call(t, r) && Ki(e, r, t[r]);
            }

            if (Zi) {
              var _iterator54 = _createForOfIteratorHelper(Zi(t)),
                  _step54;

              try {
                for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
                  var r = _step54.value;
                  Xi.call(t, r) && Ki(e, r, t[r]);
                }
              } catch (err) {
                _iterator54.e(err);
              } finally {
                _iterator54.f();
              }
            }

            return e;
          }({}, t), t.children);
        });
      }

      var ss = ee(function (_ref72) {
        var t = _ref72.className,
            r = _ref72.style;
        return e.createElement("svg", {
          className: t,
          style: r,
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }, e.createElement("polyline", {
          points: "6 9 12 15 18 9"
        }));
      })(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  position: absolute;\n  pointer-events: none;\n  z-index: 1;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  right: 8px;\n  margin: auto;\n  text-align: center;\n  polyline {\n    color: ", ";\n  }\n"])), function (e) {
        return "dark" === e.variant && "white";
      }),
          as = e.memo(function (t) {
        var r = t.options,
            n = t.onChange,
            o = t.placeholder,
            _t$value = t.value,
            i = _t$value === void 0 ? "" : _t$value,
            s = t.variant,
            a = t.className;
        return e.createElement("div", {
          className: a
        }, e.createElement(ss, {
          variant: s
        }), e.createElement("select", {
          onChange: function onChange(e) {
            var t = e.target.selectedIndex;
            n(r[o ? t - 1 : t]);
          },
          value: i,
          className: "dropdown-select"
        }, o && e.createElement("option", {
          disabled: !0,
          hidden: !0,
          value: o
        }, o), r.map(function (_ref73, o) {
          var t = _ref73.idx,
              r = _ref73.value,
              n = _ref73.title;
          return e.createElement("option", {
            key: t || r + o,
            value: r
          }, n || r);
        })), e.createElement("label", null, i));
      }),
          ls = H()(as)(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  label {\n    box-sizing: border-box;\n    min-width: 100px;\n    outline: none;\n    display: inline-block;\n    font-family: ", ";\n    color: ", ";\n    vertical-align: bottom;\n    width: ", ";\n    text-transform: none;\n    padding: 0 22px 0 4px;\n\n    font-size: 0.929em;\n    line-height: 1.5em;\n    font-family: inherit;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n  .dropdown-select {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    border: none;\n    appearance: none;\n    cursor: pointer;\n\n    color: ", ";\n    line-height: inherit;\n    font-family: inherit;\n  }\n  box-sizing: border-box;\n  min-width: 100px;\n  outline: none;\n  display: inline-block;\n  border-radius: 2px;\n  border: 1px solid rgba(38, 50, 56, 0.5);\n  vertical-align: bottom;\n  padding: 2px 0px 2px 6px;\n  position: relative;\n  width: auto;\n  background: white;\n  color: #263238;\n  font-family: ", ";\n  font-size: 0.929em;\n  line-height: 1.5em;\n  cursor: pointer;\n  transition: border 0.25s ease, color 0.25s ease, box-shadow 0.25s ease;\n\n  &:hover,\n  &:focus-within {\n    border: 1px solid ", ";\n    color: ", ";\n    box-shadow: 0px 0px 0px 1px ", ";\n  }\n"])), function (e) {
        return e.theme.typography.headings.fontFamily;
      }, function (_ref74) {
        var e = _ref74.theme;
        return e.colors.text.primary;
      }, function (_ref75) {
        var e = _ref75.fullWidth;
        return e ? "100%" : "auto";
      }, function (_ref76) {
        var e = _ref76.theme;
        return e.colors.text.primary;
      }, function (e) {
        return e.theme.typography.headings.fontFamily;
      }, function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.colors.primary.main;
      }),
          cs = H()(ls)(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  text-transform: none;\n  font-size: 0.969em;\n\n  font-size: 1em;\n  border: none;\n  padding: 0 1.2em 0 0;\n  background: transparent;\n\n  &:hover,\n  &:focus-within {\n    border: none;\n    box-shadow: none;\n    label {\n      color: ", ";\n      text-shadow: 0px 0px 0px ", ";\n    }\n  }\n"])), function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.colors.primary.main;
      }),
          ps = H().span(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  text-transform: none;\n  font-size: 0.929em;\n  color: black;\n"])));

      var us = Object.defineProperty,
          ds = Object.getOwnPropertySymbols,
          hs = Object.prototype.hasOwnProperty,
          ms = Object.prototype.propertyIsEnumerable,
          fs = function fs(e, t, r) {
        return t in e ? us(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      function gs(t) {
        var _t$Label = t.Label,
            r = _t$Label === void 0 ? ps : _t$Label,
            _t$Dropdown = t.Dropdown,
            n = _t$Dropdown === void 0 ? cs : _t$Dropdown;
        return 1 === t.options.length ? e.createElement(r, null, t.options[0].value) : e.createElement(n, function (e, t) {
          for (var r in t || (t = {})) {
            hs.call(t, r) && fs(e, r, t[r]);
          }

          if (ds) {
            var _iterator55 = _createForOfIteratorHelper(ds(t)),
                _step55;

            try {
              for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                var r = _step55.value;
                ms.call(t, r) && fs(e, r, t[r]);
              }
            } catch (err) {
              _iterator55.e(err);
            } finally {
              _iterator55.f();
            }
          }

          return e;
        }({}, t));
      }

      var ys = require("dompurify");

      var bs = Y(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  a {\n    text-decoration: ", ";\n    color: ", ";\n\n    &:visited {\n      color: ", ";\n    }\n\n    &:hover {\n      color: ", ";\n      text-decoration: ", ";\n    }\n  }\n"])), function (e) {
        return e.theme.typography.links.textDecoration;
      }, function (e) {
        return e.theme.typography.links.color;
      }, function (e) {
        return e.theme.typography.links.visited;
      }, function (e) {
        return e.theme.typography.links.hover;
      }, function (e) {
        return e.theme.typography.links.hoverTextDecoration;
      }),
          xs = ee(Qi)(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n\n  p {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  ", "\n\n  ", "\n\n  h1 {\n    ", ";\n    color: ", ";\n    margin-top: 0;\n  }\n\n  h2 {\n    ", ";\n    color: ", ";\n  }\n\n  code {\n    color: ", ";\n    background-color: ", ";\n\n    font-family: ", ";\n    border-radius: 2px;\n    border: 1px solid rgba(38, 50, 56, 0.1);\n    padding: 0 ", "px;\n    font-size: ", ";\n    font-weight: ", ";\n\n    word-break: break-word;\n  }\n\n  pre {\n    font-family: ", ";\n    white-space: ", ";\n    background-color: ", ";\n    color: white;\n    padding: ", "px;\n    overflow-x: auto;\n    line-height: normal;\n    border-radius: 0px;\n    border: 1px solid rgba(38, 50, 56, 0.1);\n\n    code {\n      background-color: transparent;\n      color: white;\n      padding: 0;\n\n      &:before,\n      &:after {\n        content: none;\n      }\n    }\n  }\n\n  blockquote {\n    margin: 0;\n    margin-bottom: 1em;\n    padding: 0 15px;\n    color: #777;\n    border-left: 4px solid #ddd;\n  }\n\n  img {\n    max-width: 100%;\n    box-sizing: content-box;\n  }\n\n  ul,\n  ol {\n    padding-left: 2em;\n    margin: 0;\n    margin-bottom: 1em;\n\n    ul,\n    ol {\n      margin-bottom: 0;\n      margin-top: 0;\n    }\n  }\n\n  table {\n    display: block;\n    width: 100%;\n    overflow: auto;\n    word-break: normal;\n    word-break: keep-all;\n    border-collapse: collapse;\n    border-spacing: 0;\n    margin-top: 1.5em;\n    margin-bottom: 1.5em;\n  }\n\n  table tr {\n    background-color: #fff;\n    border-top: 1px solid #ccc;\n\n    &:nth-child(2n) {\n      background-color: ", ";\n    }\n  }\n\n  table th,\n  table td {\n    padding: 6px 13px;\n    border: 1px solid #ddd;\n  }\n\n  table th {\n    text-align: left;\n    font-weight: bold;\n  }\n\n  ", ";\n\n  ", "\n\n  ", ";\n"])), function (e) {
        return e.theme.typography.fontFamily;
      }, function (e) {
        return e.theme.typography.fontWeightRegular;
      }, function (e) {
        return e.theme.typography.lineHeight;
      }, function (_ref77) {
        var e = _ref77.compact;
        return e && "\n    p:first-child {\n      margin-top: 0;\n    }\n    p:last-child {\n      margin-bottom: 0;\n    }\n  ";
      }, function (_ref78) {
        var e = _ref78.inline;
        return e && " p {\n    display: inline-block;\n  }";
      }, ui(1), function (e) {
        return e.theme.colors.primary.main;
      }, ui(2), function (e) {
        return e.theme.colors.text.primary;
      }, function (_ref79) {
        var e = _ref79.theme;
        return e.typography.code.color;
      }, function (_ref80) {
        var e = _ref80.theme;
        return e.typography.code.backgroundColor;
      }, function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (_ref81) {
        var e = _ref81.theme;
        return e.spacing.unit;
      }, function (e) {
        return e.theme.typography.code.fontSize;
      }, function (_ref82) {
        var e = _ref82.theme;
        return e.typography.code.fontWeight;
      }, function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (_ref83) {
        var e = _ref83.theme;
        return e.typography.code.wrap ? "pre-wrap" : "pre";
      }, function (_ref84) {
        var e = _ref84.theme;
        return e.codeBlock.backgroundColor;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      }, function (_ref85) {
        var e = _ref85.theme;
        return e.schema.nestedBackground;
      }, wi(".share-link"), bs, te("Markdown"));

      var vs = Object.defineProperty,
          ws = Object.getOwnPropertySymbols,
          ks = Object.prototype.hasOwnProperty,
          Os = Object.prototype.propertyIsEnumerable,
          Es = function Es(e, t, r) {
        return t in e ? vs(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Ss = xs.withComponent("span");

      function $s(t) {
        var r = t.inline ? Ss : xs;
        return e.createElement(ue, null, function (n) {
          return e.createElement(r, function (e, t) {
            for (var r in t || (t = {})) {
              ks.call(t, r) && Es(e, r, t[r]);
            }

            if (ws) {
              var _iterator56 = _createForOfIteratorHelper(ws(t)),
                  _step56;

              try {
                for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
                  var r = _step56.value;
                  Os.call(t, r) && Es(e, r, t[r]);
                }
              } catch (err) {
                _iterator56.e(err);
              } finally {
                _iterator56.f();
              }
            }

            return e;
          }({
            className: "redoc-markdown " + (t.className || ""),
            dangerouslySetInnerHTML: {
              __html: (o = n.untrustedSpec, i = t.html, o ? ys.sanitize(i) : i)
            },
            "data-role": t["data-role"]
          }, t));
          var o, i;
        });
      }

      var Rs = /*#__PURE__*/function (_e$Component3) {
        _inherits(Rs, _e$Component3);

        var _super5 = _createSuper(Rs);

        function Rs() {
          _classCallCheck(this, Rs);

          return _super5.apply(this, arguments);
        }

        _createClass(Rs, [{
          key: "render",
          value: function render() {
            var _this$props2 = this.props,
                t = _this$props2.source,
                r = _this$props2.inline,
                n = _this$props2.compact,
                o = _this$props2.className,
                i = _this$props2["data-role"],
                s = new Br();
            return e.createElement($s, {
              html: s.renderMd(t),
              inline: r,
              compact: n,
              className: o,
              "data-role": i
            });
          }
        }]);

        return Rs;
      }(e.Component);

      var js = ee.div(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  position: relative;\n"]))),
          Cs = ee.div(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  position: absolute;\n  min-width: 80px;\n  max-width: 500px;\n  background: #fff;\n  bottom: 100%;\n  left: 50%;\n  margin-bottom: 10px;\n  transform: translateX(-50%);\n\n  border-radius: 4px;\n  padding: 0.3em 0.6em;\n  text-align: center;\n  box-shadow: 0px 0px 5px 0px rgba(204, 204, 204, 1);\n"]))),
          As = ee.div(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  background: #fff;\n  color: #000;\n  display: inline;\n  font-size: 0.85em;\n  white-space: nowrap;\n"]))),
          Ps = ee.div(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  bottom: -5px;\n  left: 50%;\n  margin-left: -5px;\n  border-left: solid transparent 5px;\n  border-right: solid transparent 5px;\n  border-top: solid #fff 5px;\n"]))),
          Is = ee.div(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 20px;\n  bottom: -20px;\n"])));

      var Ts = /*#__PURE__*/function (_e$Component4) {
        _inherits(Ts, _e$Component4);

        var _super6 = _createSuper(Ts);

        function Ts() {
          _classCallCheck(this, Ts);

          return _super6.apply(this, arguments);
        }

        _createClass(Ts, [{
          key: "render",
          value: function render() {
            var _this$props3 = this.props,
                t = _this$props3.open,
                r = _this$props3.title,
                n = _this$props3.children;
            return e.createElement(js, null, n, t && e.createElement(Cs, null, e.createElement(As, null, r), e.createElement(Ps, null), e.createElement(Is, null)));
          }
        }]);

        return Ts;
      }(e.Component);

      var _s = "undefined" != typeof document && document.queryCommandSupported && document.queryCommandSupported("copy");

      var Ls = /*#__PURE__*/function () {
        function Ls() {
          _classCallCheck(this, Ls);
        }

        _createClass(Ls, null, [{
          key: "isSupported",
          value: function isSupported() {
            return _s;
          }
        }, {
          key: "selectElement",
          value: function selectElement(e) {
            var t, r;
            document.body.createTextRange ? (t = document.body.createTextRange(), t.moveToElementText(e), t.select()) : document.createRange && window.getSelection && (r = window.getSelection(), t = document.createRange(), t.selectNodeContents(e), r.removeAllRanges(), r.addRange(t));
          }
        }, {
          key: "deselect",
          value: function deselect() {
            if (document.selection) document.selection.empty();else if (window.getSelection) {
              var _e69 = window.getSelection();

              _e69 && _e69.removeAllRanges();
            }
          }
        }, {
          key: "copySelected",
          value: function copySelected() {
            var e;

            try {
              e = document.execCommand("copy");
            } catch (t) {
              e = !1;
            }

            return e;
          }
        }, {
          key: "copyElement",
          value: function copyElement(e) {
            Ls.selectElement(e);
            var t = Ls.copySelected();
            return t && Ls.deselect(), t;
          }
        }, {
          key: "copyCustom",
          value: function copyCustom(e) {
            var t = document.createElement("textarea");
            t.style.position = "fixed", t.style.top = "0", t.style.left = "0", t.style.width = "2em", t.style.height = "2em", t.style.padding = "0", t.style.border = "none", t.style.outline = "none", t.style.boxShadow = "none", t.style.background = "transparent", t.value = e, document.body.appendChild(t), t.select();
            var r = Ls.copySelected();
            return document.body.removeChild(t), r;
          }
        }]);

        return Ls;
      }();

      var Ds = function Ds(t) {
        var _e$useState5 = e.useState(!1),
            _e$useState6 = _slicedToArray(_e$useState5, 2),
            r = _e$useState6[0],
            n = _e$useState6[1],
            o = function o() {
          var e = "string" == typeof t.data ? t.data : JSON.stringify(t.data, null, 2);
          Ls.copyCustom(e), i();
        },
            i = function i() {
          n(!0), setTimeout(function () {
            n(!1);
          }, 1500);
        };

        return t.children({
          renderCopyButton: function renderCopyButton() {
            return e.createElement("button", {
              onClick: o
            }, e.createElement(Ts, {
              title: Ls.isSupported() ? "Copied" : "Not supported in your browser",
              open: r
            }, "Copy"));
          }
        });
      };

      var zs = 1;

      function Ms(e, t) {
        zs = 1;
        var r = "";
        return r += '<div class="redoc-json">', r += "<code>", r += Qs(e, t), r += "</code>", r += "</div>", r;
      }

      function Ns(e) {
        return void 0 !== e ? e.toString().replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : "";
      }

      function Fs(e) {
        return JSON.stringify(e).slice(1, -1);
      }

      function qs(e, t) {
        return '<span class="' + t + '">' + Ns(e) + "</span>";
      }

      function Bs(e) {
        return '<span class="token punctuation">' + e + "</span>";
      }

      function Qs(e, t) {
        var r = typeof e;
        var n = "";
        return null == e ? n += qs("null", "token keyword") : e && e.constructor === Array ? (zs++, n += function (e, t) {
          var r = zs > t ? "collapsed" : "";
          var n = "<button class=\"collapser\" aria-label=\"".concat(zs > t + 1 ? "expand" : "collapse", "\"></button>").concat(Bs("["), "<span class=\"ellipsis\"></span><ul class=\"array collapsible\">"),
              o = !1;
          var i = e.length;

          for (var _s18 = 0; _s18 < i; _s18++) {
            o = !0, n += '<li><div class="hoverable ' + r + '">', n += Qs(e[_s18], t), _s18 < i - 1 && (n += ","), n += "</div></li>";
          }

          return n += "</ul>".concat(Bs("]")), o || (n = Bs("[ ]")), n;
        }(e, t), zs--) : e && e.constructor === Date ? n += qs('"' + e.toISOString() + '"', "token string") : "object" === r ? (zs++, n += function (e, t) {
          var r = zs > t ? "collapsed" : "",
              n = Object.keys(e),
              o = n.length;
          var i = "<button class=\"collapser\" aria-label=\"".concat(zs > t + 1 ? "expand" : "collapse", "\"></button>").concat(Bs("{"), "<span class=\"ellipsis\"></span><ul class=\"obj collapsible\">"),
              s = !1;

          for (var _a12 = 0; _a12 < o; _a12++) {
            var _l8 = n[_a12];
            s = !0, i += '<li><div class="hoverable ' + r + '">', i += '<span class="property token string">"' + Ns(_l8) + '"</span>: ', i += Qs(e[_l8], t), _a12 < o - 1 && (i += Bs(",")), i += "</div></li>";
          }

          return i += "</ul>".concat(Bs("}")), s || (i = Bs("{ }")), i;
        }(e, t), zs--) : "number" === r ? n += qs(e, "token number") : "string" === r ? /^(http|https):\/\/[^\s]+$/.test(e) ? n += qs('"', "token string") + '<a href="' + encodeURI(e) + '">' + Ns(Fs(e)) + "</a>" + qs('"', "token string") : n += qs('"' + Fs(e) + '"', "token string") : "boolean" === r && (n += qs(e, "token boolean")), n;
      }

      var Us = Y(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  .redoc-json code > .collapser {\n    display: none;\n    pointer-events: none;\n  }\n\n  font-family: ", ";\n  font-size: ", ";\n\n  white-space: ", ";\n  contain: content;\n  overflow-x: auto;\n\n  .callback-function {\n    color: gray;\n  }\n\n  .collapser:after {\n    content: '-';\n    cursor: pointer;\n  }\n\n  .collapsed > .collapser:after {\n    content: '+';\n    cursor: pointer;\n  }\n\n  .ellipsis:after {\n    content: ' \u2026 ';\n  }\n\n  .collapsible {\n    margin-left: 2em;\n  }\n\n  .hoverable {\n    padding-top: 1px;\n    padding-bottom: 1px;\n    padding-left: 2px;\n    padding-right: 2px;\n    border-radius: 2px;\n  }\n\n  .hovered {\n    background-color: rgba(235, 238, 249, 1);\n  }\n\n  .collapser {\n    background-color: transparent;\n    border: 0;\n    color: #fff;\n    font-family: ", ";\n    font-size: ", ";\n    padding-right: 6px;\n    padding-left: 6px;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    top: 4px;\n    left: -1.5em;\n    cursor: default;\n    user-select: none;\n    -webkit-user-select: none;\n    padding: 2px;\n    &:focus {\n      outline-color: #fff;\n      outline-style: dotted;\n      outline-width: 1px;\n    }\n  }\n\n  ul {\n    list-style-type: none;\n    padding: 0px;\n    margin: 0px 0px 0px 26px;\n  }\n\n  li {\n    position: relative;\n    display: block;\n  }\n\n  .hoverable {\n    display: inline-block;\n  }\n\n  .selected {\n    outline-style: solid;\n    outline-width: 1px;\n    outline-style: dotted;\n  }\n\n  .collapsed > .collapsible {\n    display: none;\n  }\n\n  .ellipsis {\n    display: none;\n  }\n\n  .collapsed > .ellipsis {\n    display: inherit;\n  }\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (e) {
        return e.theme.typography.code.fontSize;
      }, function (_ref86) {
        var e = _ref86.theme;
        return e.typography.code.wrap ? "pre-wrap" : "pre";
      }, function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (e) {
        return e.theme.typography.code.fontSize;
      }),
          Ws = ee.div(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  &:hover > ", " {\n    opacity: 1;\n  }\n"])), Ui),
          Vs = ee(function (t) {
        var _e$useState7 = e.useState(),
            _e$useState8 = _slicedToArray(_e$useState7, 2),
            r = _e$useState8[0],
            n = _e$useState8[1],
            o = function o(_ref87) {
          var r = _ref87.renderCopyButton;
          var o = t.data && Object.values(t.data).some(function (e) {
            return "object" == typeof e && null !== e;
          });
          return e.createElement(Ws, null, e.createElement(Ui, null, r(), o && e.createElement(e.Fragment, null, e.createElement("button", {
            onClick: i
          }, " Expand all "), e.createElement("button", {
            onClick: s
          }, " Collapse all "))), e.createElement(ce.Consumer, null, function (r) {
            return e.createElement(Qi, {
              className: t.className,
              ref: function ref(e) {
                return n(e);
              },
              dangerouslySetInnerHTML: {
                __html: Ms(t.data, r.jsonSampleExpandLevel)
              }
            });
          }));
        },
            i = function i() {
          var e = null == r ? void 0 : r.getElementsByClassName("collapsible");

          var _iterator57 = _createForOfIteratorHelper(Array.prototype.slice.call(e)),
              _step57;

          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var _t76 = _step57.value;
              var _e70 = _t76.parentNode;
              _e70.classList.remove("collapsed"), _e70.querySelector(".collapser").setAttribute("aria-label", "collapse");
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }
        },
            s = function s() {
          var e = null == r ? void 0 : r.getElementsByClassName("collapsible"),
              t = Array.prototype.slice.call(e, 1);

          var _iterator58 = _createForOfIteratorHelper(t),
              _step58;

          try {
            for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
              var _e71 = _step58.value;
              var _t77 = _e71.parentNode;
              _t77.classList.add("collapsed"), _t77.querySelector(".collapser").setAttribute("aria-label", "expand");
            }
          } catch (err) {
            _iterator58.e(err);
          } finally {
            _iterator58.f();
          }
        },
            a = function a(e) {
          var t;
          "collapser" === e.className && (t = e.parentElement.getElementsByClassName("collapsible")[0], t.parentElement.classList.contains("collapsed") ? (t.parentElement.classList.remove("collapsed"), e.setAttribute("aria-label", "collapse")) : (t.parentElement.classList.add("collapsed"), e.setAttribute("aria-label", "expand")));
        },
            l = e.useCallback(function (e) {
          a(e.target);
        }, []),
            c = e.useCallback(function (e) {
          "Enter" === e.key && a(e.target);
        }, []);

        return e.useEffect(function () {
          return null == r || r.addEventListener("click", l), null == r || r.addEventListener("focus", c), function () {
            null == r || r.removeEventListener("click", l), null == r || r.removeEventListener("focus", c);
          };
        }, [l, c, r]), e.createElement(Ds, {
          data: t.data
        }, o);
      })(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  ", ";\n"])), Us),
          Hs = function Hs(t) {
        var r = t.source,
            n = t.lang;
        return e.createElement(Vi, {
          dangerouslySetInnerHTML: {
            __html: Ot(r, n)
          }
        });
      },
          Js = function Js(t) {
        var r = t.source,
            n = t.lang;
        return e.createElement(Ds, {
          data: r
        }, function (_ref88) {
          var t = _ref88.renderCopyButton;
          return e.createElement(Wi, null, e.createElement(Ui, null, t()), e.createElement(Hs, {
            lang: n,
            source: r
          }));
        });
      };

      function Ys(_ref89) {
        var t = _ref89.value,
            r = _ref89.mimeType;
        return Qe(r) ? e.createElement(Vs, {
          data: t
        }) : ("object" == typeof t && (t = JSON.stringify(t, null, 2)), e.createElement(Js, {
          lang: Xe(r),
          source: t
        }));
      }

      function Zs(_ref90) {
        var t = _ref90.example,
            r = _ref90.mimeType;
        return void 0 === t.value && t.externalValueUrl ? e.createElement(Gs, {
          example: t,
          mimeType: r
        }) : e.createElement(Ys, {
          value: t.value,
          mimeType: r
        });
      }

      function Gs(_ref91) {
        var t = _ref91.example,
            r = _ref91.mimeType;

        var n = function (t, r) {
          var _this21 = this;

          var _ref92 = (0, e.useState)(!0),
              _ref93 = _slicedToArray(_ref92, 2),
              n = _ref93[1],
              o = (0, e.useRef)(void 0),
              i = (0, e.useRef)(void 0);

          return i.current !== t && (o.current = void 0), i.current = t, (0, e.useEffect)(function () {
            (function () {
              return e = _this21, i = /*#__PURE__*/_regeneratorRuntime.mark(function i() {
                return _regeneratorRuntime.wrap(function i$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        n(!0);
                        _context10.prev = 1;
                        _context10.next = 4;
                        return t.getExternalValue(r);

                      case 4:
                        o.current = _context10.sent;
                        _context10.next = 10;
                        break;

                      case 7:
                        _context10.prev = 7;
                        _context10.t0 = _context10["catch"](1);
                        o.current = _context10.t0;

                      case 10:
                        n(!1);

                      case 11:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, i, null, [[1, 7]]);
              }), new Promise(function (t, r) {
                var n = function n(e) {
                  try {
                    s(i.next(e));
                  } catch (e) {
                    r(e);
                  }
                },
                    o = function o(e) {
                  try {
                    s(i.throw(e));
                  } catch (e) {
                    r(e);
                  }
                },
                    s = function s(e) {
                  return e.done ? t(e.value) : Promise.resolve(e.value).then(n, o);
                };

                s((i = i.apply(e, null)).next());
              });
              var e, i;
            })();
          }, [t, r]), o.current;
        }(t, r);

        return void 0 === n ? e.createElement("span", null, "Loading...") : n instanceof Error ? e.createElement(Vi, null, "Error loading external example: ", e.createElement("br", null), e.createElement("a", {
          className: "token string",
          href: t.externalValueUrl,
          target: "_blank",
          rel: "noopener noreferrer"
        }, t.externalValueUrl)) : e.createElement(Ys, {
          value: n,
          mimeType: r
        });
      }

      var Xs = ee.div(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  padding: 0.9em;\n  background-color: ", ";\n  margin: 0 0 10px 0;\n  display: block;\n  font-family: ", ";\n  font-size: 0.929em;\n  line-height: 1.5em;\n"])), function (_ref94) {
        var e = _ref94.theme;
        return (0, t.transparentize)(.6, e.rightPanel.backgroundColor);
      }, function (_ref95) {
        var e = _ref95.theme;
        return e.typography.headings.fontFamily;
      }),
          Ks = ee.span(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  position: absolute;\n  z-index: 1;\n  top: -11px;\n  left: 12px;\n  font-weight: ", ";\n  color: ", ";\n"])), function (_ref96) {
        var e = _ref96.theme;
        return e.typography.headings.fontFamily;
      }, function (_ref97) {
        var e = _ref97.theme;
        return e.typography.fontWeightBold;
      }, function (_ref98) {
        var e = _ref98.theme;
        return (0, t.transparentize)(.3, e.rightPanel.textColor);
      }),
          ea = ee.div(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  position: relative;\n"]))),
          ta = ee(ls)(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  label {\n    color: ", ";\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    font-size: 1em;\n    text-transform: none;\n    border: none;\n  }\n  margin: 0 0 10px 0;\n  display: block;\n  background-color: ", ";\n  border: none;\n  padding: 0.9em 1.6em 0.9em 0.9em;\n  box-shadow: none;\n  &:hover,\n  &:focus-within {\n    border: none;\n    box-shadow: none;\n    background-color: ", ";\n  }\n"])), function (_ref99) {
        var e = _ref99.theme;
        return e.rightPanel.textColor;
      }, function (_ref100) {
        var e = _ref100.theme;
        return (0, t.transparentize)(.6, e.rightPanel.backgroundColor);
      }, function (_ref101) {
        var e = _ref101.theme;
        return (0, t.transparentize)(.3, e.rightPanel.backgroundColor);
      }),
          ra = ee.div(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  color: #ee807f;\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      });

      var na = /*#__PURE__*/function (_e$Component5) {
        _inherits(na, _e$Component5);

        var _super7 = _createSuper(na);

        function na() {
          var _this22;

          _classCallCheck(this, na);

          _this22 = _super7.apply(this, arguments), _this22.state = {
            activeIdx: 0
          }, _this22.switchMedia = function (_ref102) {
            var e = _ref102.idx;
            void 0 !== e && _this22.setState({
              activeIdx: e
            });
          };
          return _this22;
        }

        _createClass(na, [{
          key: "render",
          value: function render() {
            var t = this.state.activeIdx,
                r = this.props.mediaType.examples || {},
                n = this.props.mediaType.name,
                o = e.createElement(ra, null, "No sample"),
                i = Object.keys(r);
            if (0 === i.length) return o;

            if (i.length > 1) {
              var _o27 = i.map(function (e, t) {
                return {
                  value: r[e].summary || e,
                  idx: t
                };
              }),
                  _s19 = r[i[t]],
                  _a13 = _s19.description;

              return e.createElement(oa, null, e.createElement(ea, null, e.createElement(Ks, null, "Example"), this.props.renderDropdown({
                value: _o27[t].value,
                options: _o27,
                onChange: this.switchMedia,
                ariaLabel: "Example"
              })), e.createElement("div", null, _a13 && e.createElement(Rs, {
                source: _a13
              }), e.createElement(Zs, {
                example: _s19,
                mimeType: n
              })));
            }

            {
              var _t78 = r[i[0]];
              return e.createElement(oa, null, _t78.description && e.createElement(Rs, {
                source: _t78.description
              }), e.createElement(Zs, {
                example: _t78,
                mimeType: n
              }));
            }
          }
        }]);

        return na;
      }(e.Component);

      var oa = ee.div(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  margin-top: 15px;\n"])));

      var ia = require("mobx-react");

      var sa = ee(Pi)(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  button {\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    font-size: 13px;\n    font-family: ", ";\n    cursor: pointer;\n    padding: 0;\n    color: ", ";\n    &:focus {\n      font-weight: ", ";\n    }\n    ", "\n  }\n  ", " {\n    height: ", ";\n    width: ", ";\n    polygon {\n      fill: ", ";\n    }\n  }\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      }, function (e) {
        return e.theme.colors.text.primary;
      }, function (_ref103) {
        var e = _ref103.theme;
        return e.typography.fontWeightBold;
      }, function (_ref104) {
        var e = _ref104.kind;
        return "patternProperties" === e && Y(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n        display: inline-flex;\n        margin-right: 20px;\n\n        > span.property-name {\n          white-space: break-spaces;\n          text-align: left;\n\n          ::before,\n          ::after {\n            content: '/';\n            filter: opacity(0.2);\n          }\n        }\n\n        > svg {\n          align-self: center;\n        }\n      "])));
      }, Si, function (_ref105) {
        var e = _ref105.theme;
        return e.schema.arrow.size;
      }, function (_ref106) {
        var e = _ref106.theme;
        return e.schema.arrow.size;
      }, function (_ref107) {
        var e = _ref107.theme;
        return e.schema.arrow.color;
      }),
          aa = ee.span(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  font-size: ", ";\n  line-height: 20px;\n"])), function (_ref108) {
        var e = _ref108.theme;
        return e.typography.code.fontSize;
      }),
          la = ee(aa)(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
        return (0, t.transparentize)(.1, e.theme.schema.typeNameColor);
      }),
          ca = ee(aa)(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
        return e.theme.schema.typeNameColor;
      }),
          pa = ee(aa)(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  color: ", ";\n  word-break: break-word;\n"])), function (e) {
        return e.theme.schema.typeTitleColor;
      }),
          ua = ca,
          da = ee(aa.withComponent("div"))(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: normal;\n  margin-left: 20px;\n  line-height: 1;\n"])), function (e) {
        return e.theme.schema.requireLabelColor;
      }, function (e) {
        return e.theme.schema.labelsTextSize;
      }),
          ha = ee(da)(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
        return e.theme.colors.primary.light;
      }),
          ma = ee(aa)(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 13px;\n"])), function (_ref109) {
        var e = _ref109.theme;
        return e.colors.warning.main;
      }),
          fa = ee(aa)(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  color: #0e7c86;\n  &::before,\n  &::after {\n    font-weight: bold;\n  }\n"]))),
          ga = ee(aa)(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  border-radius: 2px;\n  word-break: break-word;\n  ", ";\n  & + & {\n    margin-left: 0;\n  }\n  ", ";\n"])), function (_ref110) {
        var e = _ref110.theme;
        return "\n    background-color: ".concat((0, t.transparentize)(.95, e.colors.text.primary), ";\n    color: ").concat((0, t.transparentize)(.1, e.colors.text.primary), ";\n\n    padding: 0 ").concat(e.spacing.unit, "px;\n    border: 1px solid ").concat((0, t.transparentize)(.9, e.colors.text.primary), ";\n    font-family: ").concat(e.typography.code.fontFamily, ";\n}");
      }, te("ExampleValue")),
          ya = ee(ga)(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral([""]))),
          ba = ee(aa)(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  border-radius: 2px;\n  ", ";\n  & + & {\n    margin-left: 0;\n  }\n  ", ";\n"])), function (_ref111) {
        var e = _ref111.theme;
        return "\n    background-color: ".concat((0, t.transparentize)(.95, e.colors.primary.light), ";\n    color: ").concat((0, t.transparentize)(.1, e.colors.primary.main), ";\n\n    margin: 0 ").concat(e.spacing.unit, "px;\n    padding: 0 ").concat(e.spacing.unit, "px;\n    border: 1px solid ").concat((0, t.transparentize)(.9, e.colors.primary.main), ";\n}");
      }, te("ConstraintItem")),
          xa = ee.button(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: 0;\n  color: ", ";\n  margin-left: ", "px;\n  border-radius: 2px;\n  cursor: pointer;\n  outline-color: ", ";\n  font-size: 12px;\n"])), function (_ref112) {
        var e = _ref112.theme;
        return e.colors.text.secondary;
      }, function (_ref113) {
        var e = _ref113.theme;
        return e.spacing.unit;
      }, function (_ref114) {
        var e = _ref114.theme;
        return e.colors.text.secondary;
      });
      Object.defineProperty, Object.getOwnPropertyDescriptor;
      var va = ee.div(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), bs, function (_ref115) {
        var e = _ref115.compact;
        return e ? "" : "margin: 1em 0";
      });

      var wa = /*#__PURE__*/function (_e$Component6) {
        _inherits(wa, _e$Component6);

        var _super8 = _createSuper(wa);

        function wa() {
          _classCallCheck(this, wa);

          return _super8.apply(this, arguments);
        }

        _createClass(wa, [{
          key: "render",
          value: function render() {
            var t = this.props.externalDocs;
            return t && t.url ? e.createElement(va, {
              compact: this.props.compact
            }, e.createElement("a", {
              href: t.url
            }, t.description || t.url)) : null;
          }
        }]);

        return wa;
      }(e.Component);

      wa = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], wa);

      var ka = /*#__PURE__*/function (_e$PureComponent2) {
        _inherits(ka, _e$PureComponent2);

        var _super9 = _createSuper(ka);

        function ka() {
          var _this23;

          _classCallCheck(this, ka);

          _this23 = _super9.apply(this, arguments), _this23.state = {
            collapsed: !0
          };
          return _this23;
        }

        _createClass(ka, [{
          key: "toggle",
          value: function toggle() {
            this.setState({
              collapsed: !this.state.collapsed
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this24 = this;

            var _this$props4 = this.props,
                t = _this$props4.values,
                r = _this$props4.isArrayType,
                n = this.state.collapsed,
                _this$context = this.context,
                o = _this$context.enumSkipQuotes,
                i = _this$context.maxDisplayedEnumValues;
            if (!t.length) return null;
            var s = this.state.collapsed && i ? t.slice(0, i) : t,
                a = !!i && t.length > i,
                l = i ? n ? "\u2026 ".concat(t.length - i, " more") : "Hide" : "";
            return e.createElement("div", null, e.createElement(aa, null, r ? T("enumArray") : "", " ", 1 === t.length ? T("enumSingleValue") : T("enum"), ":"), " ", s.map(function (t, r) {
              var n = o ? String(t) : JSON.stringify(t);
              return e.createElement(e.Fragment, {
                key: r
              }, e.createElement(ga, null, n), " ");
            }), a ? e.createElement(Oa, {
              onClick: function onClick() {
                _this24.toggle();
              }
            }, l) : null);
          }
        }]);

        return ka;
      }(e.PureComponent);

      ka.contextType = ce;
      var Oa = ee.span(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n  color: ", ";\n  vertical-align: middle;\n  font-size: 13px;\n  line-height: 20px;\n  padding: 0 5px;\n  cursor: pointer;\n"])), function (e) {
        return e.theme.colors.primary.main;
      }),
          Ea = ee(xs)(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n  margin: 2px 0;\n"])));

      var Sa = /*#__PURE__*/function (_e$PureComponent3) {
        _inherits(Sa, _e$PureComponent3);

        var _super10 = _createSuper(Sa);

        function Sa() {
          _classCallCheck(this, Sa);

          return _super10.apply(this, arguments);
        }

        _createClass(Sa, [{
          key: "render",
          value: function render() {
            var t = this.props.extensions;
            return e.createElement(ce.Consumer, null, function (r) {
              return e.createElement(e.Fragment, null, r.showExtensions && Object.keys(t).map(function (r) {
                return e.createElement(Ea, {
                  key: r
                }, e.createElement(aa, null, " ", r.substring(2), ": "), " ", e.createElement(ya, null, "string" == typeof t[r] ? t[r] : JSON.stringify(t[r])));
              }));
            });
          }
        }]);

        return Sa;
      }(e.PureComponent);

      function $a(_ref116) {
        var t = _ref116.field;
        return t.examples ? e.createElement(e.Fragment, null, e.createElement(aa, null, " ", T("examples"), ": "), A(t.examples) ? t.examples.map(function (r, n) {
          var o = Ge(t, r),
              i = t.in ? String(o) : JSON.stringify(o);
          return e.createElement(e.Fragment, {
            key: n
          }, e.createElement(ga, null, i), " ");
        }) : e.createElement(Ra, null, Object.values(t.examples).map(function (r, n) {
          return e.createElement("li", {
            key: n + r.value
          }, e.createElement(ga, null, Ge(t, r.value)), " -", " ", r.summary || r.description);
        }))) : null;
      }

      var Ra = ee.ul(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n  margin-top: 1em;\n  list-style-position: outside;\n"])));

      var ja = /*#__PURE__*/function (_e$PureComponent4) {
        _inherits(ja, _e$PureComponent4);

        var _super11 = _createSuper(ja);

        function ja() {
          _classCallCheck(this, ja);

          return _super11.apply(this, arguments);
        }

        _createClass(ja, [{
          key: "render",
          value: function render() {
            return 0 === this.props.constraints.length ? null : e.createElement("span", null, " ", this.props.constraints.map(function (t) {
              return e.createElement(ba, {
                key: t
              }, " ", t, " ");
            }));
          }
        }]);

        return ja;
      }(e.PureComponent);

      var Ca = e.memo(function (_ref117) {
        var t = _ref117.value,
            r = _ref117.label,
            n = _ref117.raw;
        if (void 0 === t) return null;
        var o = n ? String(t) : JSON.stringify(t);
        return e.createElement("div", null, e.createElement(aa, null, " ", r, " "), " ", e.createElement(ga, null, o));
      });

      function Aa(t) {
        var r = t.schema.pattern,
            _e$useContext = e.useContext(ce),
            n = _e$useContext.hideSchemaPattern,
            _e$useState9 = e.useState(!1),
            _e$useState10 = _slicedToArray(_e$useState9, 2),
            o = _e$useState10[0],
            i = _e$useState10[1],
            s = e.useCallback(function () {
          return i(!o);
        }, [o]);

        return !r || n ? null : e.createElement(e.Fragment, null, e.createElement(fa, null, o || r.length < 45 ? r : "".concat(r.substr(0, 45), "...")), r.length > 45 && e.createElement(xa, {
          onClick: s
        }, o ? "Hide pattern" : "Show pattern"));
      }

      function Pa(_ref118) {
        var t = _ref118.schema;

        var _e$useContext2 = e.useContext(ce),
            r = _e$useContext2.hideSchemaPattern;

        return t && ("string" !== t.type || t.constraints.length) && ((null == t ? void 0 : t.pattern) && !r || t.items || t.displayFormat || t.constraints.length) ? e.createElement(Ia, null, "[ items", t.displayFormat && e.createElement(ua, null, " <", t.displayFormat, " >"), e.createElement(ja, {
          constraints: t.constraints
        }), e.createElement(Aa, {
          schema: t
        }), t.items && e.createElement(Pa, {
          schema: t.items
        }), " ]") : null;
      }

      var Ia = ee(la)(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n  margin: 0 5px;\n  vertical-align: text-top;\n"])));

      var Ta = Object.defineProperty,
          _a = Object.getOwnPropertySymbols,
          La = Object.prototype.hasOwnProperty,
          Da = Object.prototype.propertyIsEnumerable,
          za = function za(e, t, r) {
        return t in e ? Ta(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Ma = function Ma(e, t) {
        for (var r in t || (t = {})) {
          La.call(t, r) && za(e, r, t[r]);
        }

        if (_a) {
          var _iterator59 = _createForOfIteratorHelper(_a(t)),
              _step59;

          try {
            for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
              var r = _step59.value;
              Da.call(t, r) && za(e, r, t[r]);
            }
          } catch (err) {
            _iterator59.e(err);
          } finally {
            _iterator59.f();
          }
        }

        return e;
      };

      var Na = (0, ia.observer)(function (t) {
        var _e$useContext3 = e.useContext(ce),
            r = _e$useContext3.enumSkipQuotes,
            n = _e$useContext3.hideSchemaTitles,
            o = t.showExamples,
            i = t.field,
            s = t.renderDiscriminatorSwitch,
            a = i.schema,
            l = i.description,
            c = i.deprecated,
            p = i.extensions,
            u = i.in,
            d = i.const,
            h = "array" === a.type,
            m = r || "header" === u,
            f = e.useMemo(function () {
          return !o || void 0 === i.example && void 0 === i.examples ? null : void 0 !== i.examples ? e.createElement($a, {
            field: i
          }) : e.createElement(Ca, {
            label: T("example") + ":",
            value: Ge(i, i.example),
            raw: Boolean(i.in)
          });
        }, [i, o]);

        return e.createElement("div", null, e.createElement("div", null, e.createElement(la, null, a.typePrefix), e.createElement(ca, null, a.displayType), a.displayFormat && e.createElement(ua, null, " ", "<", a.displayFormat, ">", " "), a.contentEncoding && e.createElement(ua, null, " ", "<", a.contentEncoding, ">", " "), a.contentMediaType && e.createElement(ua, null, " ", "<", a.contentMediaType, ">", " "), a.title && !n && e.createElement(pa, null, " (", a.title, ") "), e.createElement(ja, {
          constraints: a.constraints
        }), e.createElement(Aa, {
          schema: a
        }), a.isCircular && e.createElement(ma, null, " ", T("recursive"), " "), h && a.items && e.createElement(Pa, {
          schema: a.items
        })), c && e.createElement("div", null, e.createElement($i, {
          type: "warning"
        }, " ", T("deprecated"), " ")), e.createElement(Ca, {
          raw: m,
          label: T("default") + ":",
          value: a.default
        }), !s && e.createElement(ka, {
          isArrayType: h,
          values: a.enum
        }), " ", f, e.createElement(Sa, {
          extensions: Ma(Ma({}, p), a.extensions)
        }), e.createElement("div", null, e.createElement(Rs, {
          compact: !0,
          source: l
        })), a.externalDocs && e.createElement(wa, {
          externalDocs: a.externalDocs,
          compact: !0
        }), s && s(t) || null, d && e.createElement(Ca, {
          label: T("const") + ":",
          value: d
        }) || null);
      }),
          Fa = e.memo(Na);

      var qa = Object.defineProperty,
          Ba = (Object.getOwnPropertyDescriptor, Object.getOwnPropertySymbols),
          Qa = Object.prototype.hasOwnProperty,
          Ua = Object.prototype.propertyIsEnumerable,
          Wa = function Wa(e, t, r) {
        return t in e ? qa(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Va = /*#__PURE__*/function (_e$Component7) {
        _inherits(Va, _e$Component7);

        var _super12 = _createSuper(Va);

        function Va() {
          var _this25;

          _classCallCheck(this, Va);

          _this25 = _super12.apply(this, arguments), _this25.toggle = function () {
            void 0 === _this25.props.field.expanded && _this25.props.expandByDefault ? _this25.props.field.collapse() : _this25.props.field.toggle();
          }, _this25.handleKeyPress = function (e) {
            "Enter" === e.key && (e.preventDefault(), _this25.toggle());
          };
          return _this25;
        }

        _createClass(Va, [{
          key: "render",
          value: function render() {
            var _this$props5 = this.props,
                _this$props5$classNam = _this$props5.className,
                t = _this$props5$classNam === void 0 ? "" : _this$props5$classNam,
                r = _this$props5.field,
                n = _this$props5.isLast,
                o = _this$props5.expandByDefault,
                i = r.name,
                s = r.deprecated,
                a = r.required,
                l = r.kind,
                c = !r.schema.isPrimitive && !r.schema.isCircular,
                p = void 0 === r.expanded ? o : r.expanded,
                u = e.createElement(e.Fragment, null, "additionalProperties" === l && e.createElement(ha, null, "additional property"), "patternProperties" === l && e.createElement(ha, null, "pattern property"), a && e.createElement(da, null, "required")),
                d = c ? e.createElement(sa, {
              className: s ? "deprecated" : "",
              kind: l,
              title: i
            }, e.createElement(Ti, null), e.createElement("button", {
              onClick: this.toggle,
              onKeyPress: this.handleKeyPress,
              "aria-label": "expand properties"
            }, e.createElement("span", {
              className: "property-name"
            }, i), e.createElement(Si, {
              direction: p ? "down" : "right"
            })), u) : e.createElement(Pi, {
              className: s ? "deprecated" : void 0,
              kind: l,
              title: i
            }, e.createElement(Ti, null), e.createElement("span", {
              className: "property-name"
            }, i), u);
            return e.createElement(e.Fragment, null, e.createElement("tr", {
              className: n ? "last " + t : t
            }, d, e.createElement(Ii, null, e.createElement(Fa, function (e, t) {
              for (var r in t || (t = {})) {
                Qa.call(t, r) && Wa(e, r, t[r]);
              }

              if (Ba) {
                var _iterator60 = _createForOfIteratorHelper(Ba(t)),
                    _step60;

                try {
                  for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
                    var r = _step60.value;
                    Ua.call(t, r) && Wa(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator60.e(err);
                } finally {
                  _iterator60.f();
                }
              }

              return e;
            }({}, this.props)))), p && c && e.createElement("tr", {
              key: r.name + "inner"
            }, e.createElement(Ai, {
              colSpan: 2
            }, e.createElement(_i, null, e.createElement(Rl, {
              schema: r.schema,
              skipReadOnly: this.props.skipReadOnly,
              skipWriteOnly: this.props.skipWriteOnly,
              showTitle: this.props.showTitle,
              level: this.props.level
            })))));
          }
        }]);

        return Va;
      }(e.Component);

      Va = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Va);

      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Ha = /*#__PURE__*/function (_e$Component8) {
        _inherits(Ha, _e$Component8);

        var _super13 = _createSuper(Ha);

        function Ha() {
          var _this26;

          _classCallCheck(this, Ha);

          _this26 = _super13.apply(this, arguments), _this26.changeActiveChild = function (e) {
            void 0 !== e.idx && _this26.props.parent.activateOneOf(e.idx);
          };
          return _this26;
        }

        _createClass(Ha, [{
          key: "sortOptions",
          value: function sortOptions(e, t) {
            if (0 === t.length) return;
            var r = {};
            t.forEach(function (e, t) {
              r[e] = t;
            }), e.sort(function (e, t) {
              return r[e.value] > r[t.value] ? 1 : -1;
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props6 = this.props,
                t = _this$props6.parent,
                r = _this$props6.enumValues;
            if (void 0 === t.oneOf) return null;
            var n = t.oneOf.map(function (e, t) {
              return {
                value: e.title,
                idx: t
              };
            }),
                o = n[t.activeOneOf].value;
            return this.sortOptions(n, r), e.createElement(ls, {
              value: o,
              options: n,
              onChange: this.changeActiveChild,
              ariaLabel: "Example"
            });
          }
        }]);

        return Ha;
      }(e.Component);

      Ha = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Ha);

      var Ja = (0, ia.observer)(function (_ref119) {
        var _ref119$schema = _ref119.schema,
            _ref119$schema$fields = _ref119$schema.fields,
            t = _ref119$schema$fields === void 0 ? [] : _ref119$schema$fields,
            r = _ref119$schema.title,
            n = _ref119.showTitle,
            o = _ref119.discriminator,
            i = _ref119.skipReadOnly,
            s = _ref119.skipWriteOnly,
            a = _ref119.level;

        var _e$useContext4 = e.useContext(ce),
            l = _e$useContext4.expandSingleSchemaField,
            c = _e$useContext4.showObjectSchemaExamples,
            p = _e$useContext4.schemaExpansionLevel,
            u = e.useMemo(function () {
          return i || s ? t.filter(function (e) {
            return !(i && e.schema.readOnly || s && e.schema.writeOnly);
          }) : t;
        }, [i, s, t]),
            h = l && 1 === u.length || p >= a;

        return e.createElement(Li, null, n && e.createElement(ji, null, r), e.createElement("tbody", null, d(u, function (t, r) {
          return e.createElement(Va, {
            key: t.name,
            isLast: r,
            field: t,
            expandByDefault: h,
            renderDiscriminatorSwitch: (null == o ? void 0 : o.fieldName) === t.name ? function () {
              return e.createElement(Ha, {
                parent: o.parentSchema,
                enumValues: t.schema.enum
              });
            } : void 0,
            className: t.expanded ? "expanded" : void 0,
            showExamples: c,
            skipReadOnly: i,
            skipWriteOnly: s,
            showTitle: n,
            level: a
          });
        })));
      });

      var Ya = Object.defineProperty,
          Za = Object.defineProperties,
          Ga = Object.getOwnPropertyDescriptors,
          Xa = Object.getOwnPropertySymbols,
          Ka = Object.prototype.hasOwnProperty,
          el = Object.prototype.propertyIsEnumerable,
          tl = function tl(e, t, r) {
        return t in e ? Ya(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          rl = function rl(e, t) {
        for (var r in t || (t = {})) {
          Ka.call(t, r) && tl(e, r, t[r]);
        }

        if (Xa) {
          var _iterator61 = _createForOfIteratorHelper(Xa(t)),
              _step61;

          try {
            for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
              var r = _step61.value;
              el.call(t, r) && tl(e, r, t[r]);
            }
          } catch (err) {
            _iterator61.e(err);
          } finally {
            _iterator61.f();
          }
        }

        return e;
      },
          nl = function nl(e, t) {
        return Za(e, Ga(t));
      };

      var ol = ee.div(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n  padding-left: ", "px;\n"])), function (_ref120) {
        var e = _ref120.theme;
        return 2 * e.spacing.unit;
      });

      var il = /*#__PURE__*/function (_e$PureComponent5) {
        _inherits(il, _e$PureComponent5);

        var _super14 = _createSuper(il);

        function il() {
          _classCallCheck(this, il);

          return _super14.apply(this, arguments);
        }

        _createClass(il, [{
          key: "render",
          value: function render() {
            var t = this.props.schema,
                r = t.items,
                n = void 0 === t.minItems && void 0 === t.maxItems ? "" : "(".concat(ot(t), ")");
            return t.fields ? e.createElement(Ja, nl(rl({}, this.props), {
              level: this.props.level
            })) : !t.displayType || r || n.length ? e.createElement("div", null, e.createElement(Ni, null, " Array ", n), e.createElement(ol, null, e.createElement(Rl, nl(rl({}, this.props), {
              schema: r
            }))), e.createElement(Fi, null)) : e.createElement("div", null, e.createElement(ca, null, t.displayType));
          }
        }]);

        return il;
      }(e.PureComponent);

      var sl = Object.defineProperty,
          al = Object.defineProperties,
          ll = Object.getOwnPropertyDescriptor,
          cl = Object.getOwnPropertyDescriptors,
          pl = Object.getOwnPropertySymbols,
          ul = Object.prototype.hasOwnProperty,
          dl = Object.prototype.propertyIsEnumerable,
          hl = function hl(e, t, r) {
        return t in e ? sl(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          ml = function ml(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? ll(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && sl(t, r, i), i;
      };

      var fl = /*#__PURE__*/function (_e$Component9) {
        _inherits(fl, _e$Component9);

        var _super15 = _createSuper(fl);

        function fl() {
          var _this27;

          _classCallCheck(this, fl);

          _this27 = _super15.apply(this, arguments), _this27.activateOneOf = function () {
            _this27.props.schema.activateOneOf(_this27.props.idx);
          };
          return _this27;
        }

        _createClass(fl, [{
          key: "render",
          value: function render() {
            var _this$props7 = this.props,
                t = _this$props7.idx,
                r = _this$props7.schema,
                n = _this$props7.subSchema;
            return e.createElement(Mi, {
              deprecated: n.deprecated,
              active: t === r.activeOneOf,
              onClick: this.activateOneOf
            }, n.title || n.typePrefix + n.displayType);
          }
        }]);

        return fl;
      }(e.Component);

      fl = ml([ia.observer], fl);

      var gl = /*#__PURE__*/function (_e$Component10) {
        _inherits(gl, _e$Component10);

        var _super16 = _createSuper(gl);

        function gl() {
          _classCallCheck(this, gl);

          return _super16.apply(this, arguments);
        }

        _createClass(gl, [{
          key: "render",
          value: function render() {
            var _this$props8 = this.props,
                t = _this$props8.schema.oneOf,
                r = _this$props8.schema;
            if (void 0 === t) return null;
            var n = t[r.activeOneOf];
            return e.createElement("div", null, e.createElement(zi, null, " ", r.oneOfType, " "), e.createElement(Di, null, t.map(function (t, n) {
              return e.createElement(fl, {
                key: t.pointer,
                schema: r,
                subSchema: t,
                idx: n
              });
            })), e.createElement("div", null, t[r.activeOneOf].deprecated && e.createElement($i, {
              type: "warning"
            }, "Deprecated")), e.createElement(ja, {
              constraints: n.constraints
            }), e.createElement(Rl, (o = function (e, t) {
              for (var r in t || (t = {})) {
                ul.call(t, r) && hl(e, r, t[r]);
              }

              if (pl) {
                var _iterator62 = _createForOfIteratorHelper(pl(t)),
                    _step62;

                try {
                  for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                    var r = _step62.value;
                    dl.call(t, r) && hl(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator62.e(err);
                } finally {
                  _iterator62.f();
                }
              }

              return e;
            }({}, this.props), al(o, cl({
              schema: n
            })))));
            var o;
          }
        }]);

        return gl;
      }(e.Component);

      gl = ml([ia.observer], gl);
      var yl = (0, ia.observer)(function (_ref121) {
        var t = _ref121.schema;
        return e.createElement("div", null, e.createElement(ca, null, t.displayType), t.title && e.createElement(pa, null, " ", t.title, " "), e.createElement(ma, null, " ", T("recursive"), " "));
      });

      var bl = Object.defineProperty,
          xl = Object.defineProperties,
          vl = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors),
          wl = Object.getOwnPropertySymbols,
          kl = Object.prototype.hasOwnProperty,
          Ol = Object.prototype.propertyIsEnumerable,
          El = function El(e, t, r) {
        return t in e ? bl(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          Sl = function Sl(e, t) {
        for (var r in t || (t = {})) {
          kl.call(t, r) && El(e, r, t[r]);
        }

        if (wl) {
          var _iterator63 = _createForOfIteratorHelper(wl(t)),
              _step63;

          try {
            for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
              var r = _step63.value;
              Ol.call(t, r) && El(e, r, t[r]);
            }
          } catch (err) {
            _iterator63.e(err);
          } finally {
            _iterator63.f();
          }
        }

        return e;
      },
          $l = function $l(e, t) {
        return xl(e, vl(t));
      };

      var Rl = /*#__PURE__*/function (_e$Component11) {
        _inherits(Rl, _e$Component11);

        var _super17 = _createSuper(Rl);

        function Rl() {
          _classCallCheck(this, Rl);

          return _super17.apply(this, arguments);
        }

        _createClass(Rl, [{
          key: "render",
          value: function render() {
            var t;

            var r = this.props,
                n = r.schema,
                o = function (e, t) {
              var r = {};

              for (var n in e) {
                kl.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
              }

              if (null != e && wl) {
                var _iterator64 = _createForOfIteratorHelper(wl(e)),
                    _step64;

                try {
                  for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
                    var n = _step64.value;
                    t.indexOf(n) < 0 && Ol.call(e, n) && (r[n] = e[n]);
                  }
                } catch (err) {
                  _iterator64.e(err);
                } finally {
                  _iterator64.f();
                }
              }

              return r;
            }(r, ["schema"]),
                i = (o.level || 0) + 1;

            if (!n) return e.createElement("em", null, " Schema not provided ");
            var s = n.type,
                a = n.oneOf,
                l = n.discriminatorProp,
                c = n.isCircular;
            if (c) return e.createElement(yl, {
              schema: n
            });

            if (void 0 !== l) {
              if (!a || !a.length) return console.warn("Looks like you are using discriminator wrong: you don't have any definition inherited from the ".concat(n.title)), null;
              var _t79 = a[n.activeOneOf];
              return _t79.isCircular ? e.createElement(yl, {
                schema: _t79
              }) : e.createElement(Ja, $l(Sl({}, o), {
                level: i,
                schema: _t79,
                discriminator: {
                  fieldName: l,
                  parentSchema: n
                }
              }));
            }

            if (void 0 !== a) return e.createElement(gl, Sl({
              schema: n
            }, o));
            var p = A(s) ? s : [s];

            if (p.includes("object")) {
              if (null == (t = n.fields) ? void 0 : t.length) return e.createElement(Ja, $l(Sl({}, this.props), {
                level: i
              }));
            } else if (p.includes("array")) return e.createElement(il, $l(Sl({}, this.props), {
              level: i
            }));

            var u = {
              schema: n,
              name: "",
              required: !1,
              description: n.description,
              externalDocs: n.externalDocs,
              deprecated: !1,
              toggle: function toggle() {
                return null;
              },
              expanded: !1
            };
            return e.createElement("div", null, e.createElement(Fa, {
              field: u
            }));
          }
        }]);

        return Rl;
      }(e.Component);

      Rl = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Rl);

      var jl = Object.defineProperty,
          Cl = Object.defineProperties,
          Al = Object.getOwnPropertyDescriptors,
          Pl = Object.getOwnPropertySymbols,
          Il = Object.prototype.hasOwnProperty,
          Tl = Object.prototype.propertyIsEnumerable,
          _l = function _l(e, t, r) {
        return t in e ? jl(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Ll = /*#__PURE__*/function (_e$PureComponent6) {
        _inherits(Ll, _e$PureComponent6);

        var _super18 = _createSuper(Ll);

        function Ll() {
          var _this28;

          _classCallCheck(this, Ll);

          _this28 = _super18.apply(this, arguments), _this28.renderDropdown = function (t) {
            return e.createElement(gs, (r = function (e, t) {
              for (var r in t || (t = {})) {
                Il.call(t, r) && _l(e, r, t[r]);
              }

              if (Pl) {
                var _iterator65 = _createForOfIteratorHelper(Pl(t)),
                    _step65;

                try {
                  for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
                    var r = _step65.value;
                    Tl.call(t, r) && _l(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator65.e(err);
                } finally {
                  _iterator65.f();
                }
              }

              return e;
            }({
              Label: ps,
              Dropdown: ta
            }, t), Cl(r, Al({
              variant: "dark"
            }))));
            var r;
          };
          return _this28;
        }

        _createClass(Ll, [{
          key: "mediaModel",
          get: function get() {
            var _this$props9 = this.props,
                e = _this$props9.parser,
                t = _this$props9.schemaRef,
                r = _this$props9.exampleRef,
                n = _this$props9.options;
            return this._mediaModel || (this._mediaModel = new Hn(e, "json", !1, Ll.getMediaType(t, r), n)), this._mediaModel;
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props10 = this.props,
                _this$props10$showRea = _this$props10.showReadOnly,
                t = _this$props10$showRea === void 0 ? !0 : _this$props10$showRea,
                _this$props10$showWri = _this$props10.showWriteOnly,
                r = _this$props10$showWri === void 0 ? !1 : _this$props10$showWri;
            return e.createElement(si, null, e.createElement(ci, null, e.createElement(ii, null, e.createElement(Rl, {
              skipWriteOnly: !r,
              skipReadOnly: !t,
              schema: this.mediaModel.schema
            })), e.createElement(li, null, e.createElement(Dl, null, e.createElement(na, {
              renderDropdown: this.renderDropdown,
              mediaType: this.mediaModel
            })))));
          }
        }], [{
          key: "getMediaType",
          value: function getMediaType(e, t) {
            if (!e) return {};
            var r = {
              schema: {
                $ref: e
              }
            };
            return t && (r.examples = {
              example: {
                $ref: t
              }
            }), r;
          }
        }]);

        return Ll;
      }(e.PureComponent);

      var Dl = ee.div(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n  background: ", ";\n  & > div,\n  & > pre {\n    padding: ", "px;\n    margin: 0;\n  }\n\n  & > div > pre {\n    padding: 0;\n  }\n"])), function (_ref122) {
        var e = _ref122.theme;
        return e.codeBlock.backgroundColor;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      }),
          zl = (H().div(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n  background-color: #e4e7eb;\n"]))), H().ul(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n  display: inline;\n  list-style: none;\n  padding: 0;\n\n  li {\n    display: inherit;\n\n    &:after {\n      content: ',';\n    }\n    &:last-child:after {\n      content: none;\n    }\n  }\n"]))), H().code(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-family: ", ";\n  margin: 0 3px;\n  padding: 0.2em;\n  display: inline-block;\n  line-height: 1;\n\n  &:after {\n    content: ',';\n    font-weight: normal;\n  }\n\n  &:last-child:after {\n    content: none;\n  }\n"])), function (e) {
        return e.theme.typography.code.fontSize;
      }, function (e) {
        return e.theme.typography.code.fontFamily;
      })),
          Ml = H().span(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n  &:after {\n    content: ' and ';\n    font-weight: normal;\n  }\n\n  &:last-child:after {\n    content: none;\n  }\n\n  ", ";\n"])), bs),
          Nl = H().span(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n  ", "\n  &:after {\n    content: ' or ';\n    ", "\n    white-space: pre;\n  }\n\n  &:last-child:after,\n  &:only-child:after {\n    content: none;\n  }\n\n  ", ";\n"])), function (e) {
        return !e.expanded && "white-space: nowrap;";
      }, function (e) {
        return e.expanded && "content: ' or \\a';";
      }, bs),
          Fl = H().div(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  cursor: pointer;\n"]))),
          ql = H().div(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n  width: ", ";\n  text-overflow: ellipsis;\n  border-radius: 4px;\n  overflow: hidden;\n  ", ";\n  ", "\n"])), function (e) {
        return e.theme.schema.defaultDetailsWidth;
      }, function (e) {
        return e.expanded && "background: ".concat(e.theme.colors.gray[100], ";\n     padding: 8px 9.6px;\n     margin: 20px 0;\n     width: 100%;\n    ");
      }, K.lessThan("small")(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n    margin-top: 10px;\n  "])))),
          Bl = H()(fi)(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: 0;\n"]))),
          Ql = H().div(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  margin: 1em 0;\n  flex-direction: ", ";\n  ", "\n"])), function (e) {
        return e.expanded ? "column" : "row";
      }, K.lessThan("small")(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "])))),
          Ul = H().div(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n  margin: 0.5em 0;\n"]))),
          Wl = H().div(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  margin-bottom: 1.5em;\n  padding-bottom: 0.7em;\n\n  h5 {\n    line-height: 1em;\n    margin: 0 0 0.6em;\n    font-size: ", ";\n  }\n\n  .redoc-markdown p:first-child {\n    display: inline;\n  }\n"])), function (_ref123) {
        var e = _ref123.theme;
        return e.colors.border.dark;
      }, function (_ref124) {
        var e = _ref124.theme;
        return e.typography.fontSize;
      });

      function Vl(_ref125) {
        var t = _ref125.children,
            r = _ref125.height;

        var n = e.createRef(),
            _e$useState11 = e.useState(!1),
            _e$useState12 = _slicedToArray(_e$useState11, 2),
            o = _e$useState12[0],
            i = _e$useState12[1],
            _e$useState13 = e.useState(!1),
            _e$useState14 = _slicedToArray(_e$useState13, 2),
            s = _e$useState14[0],
            a = _e$useState14[1];

        return e.useEffect(function () {
          n.current && n.current.clientHeight + 20 < n.current.scrollHeight && a(!0);
        }, [n]), e.createElement(e.Fragment, null, e.createElement(Hl, {
          ref: n,
          className: o ? "" : "container",
          style: {
            height: o ? "auto" : r
          }
        }, t), e.createElement(Jl, {
          dimmed: !o
        }, s && e.createElement(Yl, {
          onClick: function onClick() {
            i(!o);
          }
        }, o ? "See less" : "See more")));
      }

      var Hl = H().div(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n  overflow-y: hidden;\n"]))),
          Jl = H().div(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n  text-align: center;\n  line-height: 1.5em;\n  ", "\n"])), function (_ref126) {
        var e = _ref126.dimmed;
        return e && "background-image: linear-gradient(to bottom, transparent,rgb(255 255 255));\n     position: relative;\n     top: -0.5em;\n     padding-top: 0.5em;\n     background-position-y: -1em;\n    ";
      }),
          Yl = H().a(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]))),
          Zl = e.memo(function (t) {
        var r = t.type,
            n = t.flow,
            o = t.RequiredScopes,
            i = Object.keys((null == n ? void 0 : n.scopes) || {});
        return e.createElement(e.Fragment, null, e.createElement(Ul, null, e.createElement("b", null, "Flow type: "), e.createElement("code", null, r, " ")), ("implicit" === r || "authorizationCode" === r) && e.createElement(Ul, null, e.createElement("strong", null, " Authorization URL: "), e.createElement("code", null, e.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: n.authorizationUrl
        }, n.authorizationUrl))), ("password" === r || "clientCredentials" === r || "authorizationCode" === r) && e.createElement(Ul, null, e.createElement("b", null, " Token URL: "), e.createElement("code", null, n.tokenUrl)), n.refreshUrl && e.createElement(Ul, null, e.createElement("strong", null, " Refresh URL: "), n.refreshUrl), !!i.length && e.createElement(e.Fragment, null, o || null, e.createElement(Ul, null, e.createElement("b", null, " Scopes: ")), e.createElement(Vl, {
          height: "4em"
        }, e.createElement("ul", null, i.map(function (t) {
          return e.createElement("li", {
            key: t
          }, e.createElement("code", null, t), " -", " ", e.createElement(Rs, {
            className: "redoc-markdown",
            inline: !0,
            source: n.scopes[t] || ""
          }));
        })))));
      });

      function Gl(t) {
        var r = t.RequiredScopes,
            n = t.scheme;
        return e.createElement(xs, null, n.apiKey ? e.createElement(e.Fragment, null, e.createElement(Ul, null, e.createElement("b", null, S(n.apiKey.in || ""), " parameter name: "), e.createElement("code", null, n.apiKey.name)), r) : n.http ? e.createElement(e.Fragment, null, e.createElement(Ul, null, e.createElement("b", null, "HTTP Authorization Scheme: "), e.createElement("code", null, n.http.scheme)), e.createElement(Ul, null, "bearer" === n.http.scheme && n.http.bearerFormat && e.createElement(e.Fragment, null, e.createElement("b", null, "Bearer format: "), e.createElement("code", null, n.http.bearerFormat))), r) : n.openId ? e.createElement(e.Fragment, null, e.createElement(Ul, null, e.createElement("b", null, "Connect URL: "), e.createElement("code", null, e.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: n.openId.connectUrl
        }, n.openId.connectUrl))), r) : n.flows ? Object.keys(n.flows).map(function (t) {
          return e.createElement(Zl, {
            key: t,
            type: t,
            RequiredScopes: r,
            flow: n.flows[t]
          });
        }) : null);
      }

      var Xl = {
        oauth2: "OAuth2",
        apiKey: "API Key",
        http: "HTTP",
        openIdConnect: "OpenID Connect"
      };

      var Kl = /*#__PURE__*/function (_e$PureComponent7) {
        _inherits(Kl, _e$PureComponent7);

        var _super19 = _createSuper(Kl);

        function Kl() {
          _classCallCheck(this, Kl);

          return _super19.apply(this, arguments);
        }

        _createClass(Kl, [{
          key: "render",
          value: function render() {
            return this.props.securitySchemes.schemes.map(function (t) {
              return e.createElement(si, {
                id: t.sectionId,
                key: t.id
              }, e.createElement(ci, null, e.createElement(ii, null, e.createElement(hi, null, e.createElement(Oi, {
                to: t.sectionId
              }), t.displayName), e.createElement(Rs, {
                source: t.description || ""
              }), e.createElement(Wl, null, e.createElement(Ul, null, e.createElement("b", null, "Security Scheme Type: "), e.createElement("span", null, Xl[t.type] || t.type)), e.createElement(Gl, {
                scheme: t
              })))));
            });
          }
        }]);

        return Kl;
      }(e.PureComponent);

      var ec = function ec(e, t, r) {
        return new Promise(function (n, o) {
          var i = function i(e) {
            try {
              a(r.next(e));
            } catch (e) {
              o(e);
            }
          },
              s = function s(e) {
            try {
              a(r.throw(e));
            } catch (e) {
              o(e);
            }
          },
              a = function a(e) {
            return e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
          };

          a((r = r.apply(e, t)).next());
        });
      };

      function tc(e, t) {
        return ec(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, t) {
          var r,
              n,
              _args11 = arguments;
          return _regeneratorRuntime.wrap(function _callee7$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  r = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {};
                  _context11.next = 3;
                  return ge(e || t);

                case 3:
                  n = _context11.sent;
                  return _context11.abrupt("return", new rc(n, t, r));

                case 5:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee7);
        }));
      }

      var rc = /*#__PURE__*/function () {
        function rc(e, t) {
          var _this29 = this;

          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;

          _classCallCheck(this, rc);

          this.marker = new Wt(), this.disposer = null, this.rawOptions = r, this.options = new W(r, nc), this.scroll = new ni(this.options), Ko.updateOnHistory(Qt.currentId, this.scroll), this.spec = new To(e, t, this.options), this.menu = new Ko(this.spec, this.scroll, Qt), this.options.disableSearch || (this.search = new oi(), n && this.search.indexItems(this.menu.items), this.disposer = (0, de.observe)(this.menu, "activeItemIdx", function (e) {
            _this29.updateMarkOnMenu(e.newValue);
          }));
        }

        _createClass(rc, [{
          key: "onDidMount",
          value: function onDidMount() {
            this.menu.updateOnHistory(), this.updateMarkOnMenu(this.menu.activeItemIdx);
          }
        }, {
          key: "dispose",
          value: function dispose() {
            this.scroll.dispose(), this.menu.dispose(), this.search && this.search.dispose(), null != this.disposer && this.disposer();
          }
        }, {
          key: "toJS",
          value: function toJS() {
            return ec(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
              return _regeneratorRuntime.wrap(function _callee8$(_context12) {
                while (1) {
                  switch (_context12.prev = _context12.next) {
                    case 0:
                      _context12.t0 = {
                        activeItemIdx: this.menu.activeItemIdx
                      };
                      _context12.t1 = {
                        url: this.spec.parser.specUrl,
                        data: this.spec.parser.spec
                      };

                      if (!this.search) {
                        _context12.next = 8;
                        break;
                      }

                      _context12.next = 5;
                      return this.search.toJS();

                    case 5:
                      _context12.t2 = _context12.sent;
                      _context12.next = 9;
                      break;

                    case 8:
                      _context12.t2 = void 0;

                    case 9:
                      _context12.t3 = _context12.t2;
                      _context12.t4 = this.rawOptions;
                      return _context12.abrupt("return", {
                        menu: _context12.t0,
                        spec: _context12.t1,
                        searchIndex: _context12.t3,
                        options: _context12.t4
                      });

                    case 12:
                    case "end":
                      return _context12.stop();
                  }
                }
              }, _callee8, this);
            }));
          }
        }, {
          key: "updateMarkOnMenu",
          value: function updateMarkOnMenu(e) {
            var t = Math.max(0, e),
                r = Math.min(this.menu.flatItems.length, t + 5),
                n = [];

            for (var _e72 = t; _e72 < r; _e72++) {
              var _t80 = this.menu.getElementAt(_e72);

              _t80 && n.push(_t80);
            }

            if (-1 === e && s) {
              var _e73 = document.querySelector('[data-role="redoc-description"]'),
                  _t81 = document.querySelector('[data-role="redoc-summary"]');

              _e73 && n.push(_e73), _t81 && n.push(_t81);
            }

            this.marker.addOnly(n), this.marker.mark();
          }
        }], [{
          key: "fromJS",
          value: function fromJS(e) {
            var t = new rc(e.spec.data, e.spec.url, e.options, !1);
            return t.menu.activeItemIdx = e.menu.activeItemIdx || 0, t.menu.activate(t.menu.flatItems[t.menu.activeItemIdx]), t.options.disableSearch || t.search.load(e.searchIndex), t;
          }
        }]);

        return rc;
      }();

      var nc = {
        allowedMdComponents: (_allowedMdComponents = {}, _defineProperty(_allowedMdComponents, ut, {
          component: Kl,
          propsSelector: function propsSelector(e) {
            return {
              securitySchemes: e.spec.securitySchemes
            };
          }
        }), _defineProperty(_allowedMdComponents, dt, {
          component: Kl,
          propsSelector: function propsSelector(e) {
            return {
              securitySchemes: e.spec.securitySchemes
            };
          }
        }), _defineProperty(_allowedMdComponents, ht, {
          component: Ll,
          propsSelector: function propsSelector(e) {
            return {
              parser: e.spec.parser,
              options: e.options
            };
          }
        }), _allowedMdComponents)
      },
          oc = ee(di)(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n  margin-top: 0;\n  margin-bottom: 0.5em;\n\n  ", ";\n"])), te("ApiHeader")),
          ic = ee.a(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  color: ", ";\n  font-weight: normal;\n  margin-left: 0.5em;\n  padding: 4px 8px 4px;\n  display: inline-block;\n  text-decoration: none;\n  cursor: pointer;\n\n  ", ";\n"])), function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.colors.primary.main;
      }, te("DownloadButton")),
          sc = ee.span(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n  &::before {\n    content: '|';\n    display: inline-block;\n    opacity: 0.5;\n    width: ", "px;\n    text-align: center;\n  }\n\n  &:last-child::after {\n    display: none;\n  }\n"])), 15),
          ac = ee.div(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["\n  overflow: hidden;\n"]))),
          lc = ee.div(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  // hide separator on new lines: idea from https://stackoverflow.com/a/31732902/1749888\n  margin-left: -", "px;\n"])), 15);
      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var cc = /*#__PURE__*/function (_e$Component12) {
        _inherits(cc, _e$Component12);

        var _super20 = _createSuper(cc);

        function cc() {
          var _this30;

          _classCallCheck(this, cc);

          _this30 = _super20.apply(this, arguments), _this30.handleDownloadClick = function (e) {
            e.target.href || (e.target.href = _this30.props.store.spec.info.downloadLink);
          };
          return _this30;
        }

        _createClass(cc, [{
          key: "render",
          value: function render() {
            var t = this.props.store,
                _t$spec = t.spec,
                r = _t$spec.info,
                n = _t$spec.externalDocs,
                o = t.options.hideDownloadButton,
                i = r.downloadFileName,
                s = r.downloadLink,
                a = r.license && e.createElement(sc, null, "License:", " ", r.license.identifier ? r.license.identifier : e.createElement("a", {
              href: r.license.url
            }, r.license.name)) || null,
                l = r.contact && r.contact.url && e.createElement(sc, null, "URL: ", e.createElement("a", {
              href: r.contact.url
            }, r.contact.url)) || null,
                c = r.contact && r.contact.email && e.createElement(sc, null, r.contact.name || "E-mail", ":", " ", e.createElement("a", {
              href: "mailto:" + r.contact.email
            }, r.contact.email)) || null,
                p = r.termsOfService && e.createElement(sc, null, e.createElement("a", {
              href: r.termsOfService
            }, "Terms of Service")) || null,
                u = r.version && e.createElement("span", null, "(", r.version, ")") || null;
            return e.createElement(si, null, e.createElement(ci, null, e.createElement(ii, {
              className: "api-info"
            }, e.createElement(oc, null, r.title, " ", u), !o && e.createElement("p", null, T("downloadSpecification"), ":", e.createElement(ic, {
              download: i || !0,
              target: "_blank",
              href: s,
              onClick: this.handleDownloadClick
            }, T("download"))), e.createElement(xs, null, (r.license || r.contact || r.termsOfService) && e.createElement(ac, null, e.createElement(lc, null, c, " ", l, " ", a, " ", p)) || null), e.createElement(Rs, {
              source: t.spec.info.summary,
              "data-role": "redoc-summary"
            }), e.createElement(Rs, {
              source: t.spec.info.description,
              "data-role": "redoc-description"
            }), n && e.createElement(wa, {
              externalDocs: n
            }))));
          }
        }]);

        return cc;
      }(e.Component);

      cc = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], cc);

      var pc = ee.img(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n  max-height: ", ";\n  max-width: ", ";\n  padding: ", ";\n  width: 100%;\n  display: block;\n"])), function (e) {
        return e.theme.logo.maxHeight;
      }, function (e) {
        return e.theme.logo.maxWidth;
      }, function (e) {
        return e.theme.logo.gutter;
      }),
          uc = ee.div(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n  text-align: center;\n"]))),
          dc = ee.a(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var hc = /*#__PURE__*/function (_e$Component13) {
        _inherits(hc, _e$Component13);

        var _super21 = _createSuper(hc);

        function hc() {
          _classCallCheck(this, hc);

          return _super21.apply(this, arguments);
        }

        _createClass(hc, [{
          key: "render",
          value: function render() {
            var t = this.props.info,
                r = t["x-logo"];
            if (!r || !r.url) return null;
            var n = r.href || t.contact && t.contact.url,
                o = r.altText ? r.altText : "logo",
                i = e.createElement(pc, {
              src: r.url,
              alt: o
            });
            return e.createElement(uc, {
              style: {
                backgroundColor: r.backgroundColor
              }
            }, n ? (s = n, function (t) {
              return e.createElement(dc, {
                href: s
              }, t);
            })(i) : i);
            var s;
          }
        }]);

        return hc;
      }(e.Component);

      hc = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], hc);

      var mc = Object.defineProperty,
          fc = Object.getOwnPropertySymbols,
          gc = Object.prototype.hasOwnProperty,
          yc = Object.prototype.propertyIsEnumerable,
          bc = function bc(e, t, r) {
        return t in e ? mc(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          xc = function xc(e, t) {
        for (var r in t || (t = {})) {
          gc.call(t, r) && bc(e, r, t[r]);
        }

        if (fc) {
          var _iterator66 = _createForOfIteratorHelper(fc(t)),
              _step66;

          try {
            for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
              var r = _step66.value;
              yc.call(t, r) && bc(e, r, t[r]);
            }
          } catch (err) {
            _iterator66.e(err);
          } finally {
            _iterator66.f();
          }
        }

        return e;
      };

      var vc = /*#__PURE__*/function (_e$Component14) {
        _inherits(vc, _e$Component14);

        var _super22 = _createSuper(vc);

        function vc() {
          _classCallCheck(this, vc);

          return _super22.apply(this, arguments);
        }

        _createClass(vc, [{
          key: "render",
          value: function render() {
            var _this31 = this;

            return e.createElement(ue, null, function (t) {
              return e.createElement(bi, null, function (e) {
                return _this31.renderWithOptionsAndStore(t, e);
              });
            });
          }
        }, {
          key: "renderWithOptionsAndStore",
          value: function renderWithOptionsAndStore(t, r) {
            var _this$props11 = this.props,
                n = _this$props11.source,
                _this$props11$htmlWra = _this$props11.htmlWrap,
                o = _this$props11$htmlWra === void 0 ? function (e) {
              return e;
            } : _this$props11$htmlWra;
            if (!r) throw new Error("When using components in markdown, store prop must be provided");
            var i = new Br(t, this.props.parentId).renderMdWithComponents(n);
            return i.length ? i.map(function (t, n) {
              if ("string" == typeof t) return e.cloneElement(o(e.createElement($s, {
                html: t,
                inline: !1,
                compact: !1
              })), {
                key: n
              });
              var i = t.component;
              return e.createElement(i, xc({
                key: n
              }, xc(xc({}, t.props), t.propsSelector(r))));
            }) : null;
          }
        }]);

        return vc;
      }(e.Component);

      var wc = require("classnames"),
          kc = r.n(wc);

      var Oc = ee.span.attrs(function (e) {
        return {
          className: "operation-type ".concat(e.type)
        };
      })(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n  width: 9ex;\n  display: inline-block;\n  height: ", ";\n  line-height: ", ";\n  background-color: #333;\n  border-radius: 3px;\n  background-repeat: no-repeat;\n  background-position: 6px 4px;\n  font-size: 7px;\n  font-family: Verdana, sans-serif; // web-safe\n  color: white;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: bold;\n  vertical-align: middle;\n  margin-right: 6px;\n  margin-top: 2px;\n\n  &.get {\n    background-color: ", ";\n  }\n\n  &.post {\n    background-color: ", ";\n  }\n\n  &.put {\n    background-color: ", ";\n  }\n\n  &.options {\n    background-color: ", ";\n  }\n\n  &.patch {\n    background-color: ", ";\n  }\n\n  &.delete {\n    background-color: ", ";\n  }\n\n  &.basic {\n    background-color: ", ";\n  }\n\n  &.link {\n    background-color: ", ";\n  }\n\n  &.head {\n    background-color: ", ";\n  }\n\n  &.hook {\n    background-color: ", ";\n  }\n"])), function (e) {
        return e.theme.typography.code.fontSize;
      }, function (e) {
        return e.theme.typography.code.fontSize;
      }, function (e) {
        return e.theme.colors.http.get;
      }, function (e) {
        return e.theme.colors.http.post;
      }, function (e) {
        return e.theme.colors.http.put;
      }, function (e) {
        return e.theme.colors.http.options;
      }, function (e) {
        return e.theme.colors.http.patch;
      }, function (e) {
        return e.theme.colors.http.delete;
      }, function (e) {
        return e.theme.colors.http.basic;
      }, function (e) {
        return e.theme.colors.http.link;
      }, function (e) {
        return e.theme.colors.http.head;
      }, function (e) {
        return e.theme.colors.primary.main;
      });

      function Ec(e, _ref127, r) {
        var t = _ref127.theme;
        return e > 1 ? t.sidebar.level1Items[r] : 1 === e ? t.sidebar.groupItems[r] : "";
      }

      var Sc = ee.ul(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  &:first-child {\n    padding-bottom: 32px;\n  }\n\n  & & {\n    font-size: 0.929em;\n  }\n\n  ", ";\n"])), function (e) {
        return e.expanded ? "" : "display: none;";
      }),
          $c = ee.li(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n  list-style: none inside none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0;\n  ", ";\n"])), function (e) {
        return 0 === e.depth ? "margin-top: 15px" : "";
      }),
          Rc = {
        0: Y(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n    opacity: 0.7;\n    text-transform: ", ";\n    font-size: 0.8em;\n    padding-bottom: 0;\n    cursor: default;\n  "])), function (_ref128) {
          var e = _ref128.theme;
          return e.sidebar.groupItems.textTransform;
        }),
        1: Y(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n    font-size: 0.929em;\n    text-transform: ", ";\n  "])), function (_ref129) {
          var e = _ref129.theme;
          return e.sidebar.level1Items.textTransform;
        })
      },
          jc = ee.label.attrs(function (e) {
        return {
          role: "menuitem",
          className: kc()("-depth" + e.depth, {
            active: e.active
          })
        };
      })(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  color: ", ";\n  margin: 0;\n  padding: 12.5px ", "px;\n  ", "\n  display: flex;\n  justify-content: space-between;\n  font-family: ", ";\n  ", ";\n  background-color: ", ";\n\n  ", ";\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", " {\n    height: ", ";\n    width: ", ";\n    polygon {\n      fill: ", ";\n    }\n  }\n"])), function (e) {
        return e.active ? Ec(e.depth, e, "activeTextColor") : e.theme.sidebar.textColor;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      }, function (_ref130) {
        var e = _ref130.depth,
            t = _ref130.type,
            r = _ref130.theme;
        return "section" === t && e > 1 && "padding-left: " + 8 * r.spacing.unit + "px;" || "";
      }, function (e) {
        return e.theme.typography.headings.fontFamily;
      }, function (e) {
        return Rc[e.depth];
      }, function (e) {
        return e.active ? Ec(e.depth, e, "activeBackgroundColor") : e.theme.sidebar.backgroundColor;
      }, function (e) {
        return e.deprecated && Ri || "";
      }, function (e) {
        return Ec(e.depth, e, "activeTextColor");
      }, function (e) {
        return Ec(e.depth, e, "activeBackgroundColor");
      }, Si, function (_ref131) {
        var e = _ref131.theme;
        return e.sidebar.arrow.size;
      }, function (_ref132) {
        var e = _ref132.theme;
        return e.sidebar.arrow.size;
      }, function (_ref133) {
        var e = _ref133.theme;
        return e.sidebar.arrow.color;
      }),
          Cc = ee.span(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (e) {
        return e.width ? e.width : "auto";
      }),
          Ac = ee.div(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["\n  ", ";\n  img {\n    width: 15px;\n    margin-right: 5px;\n  }\n\n  ", ";\n"])), function (_ref134) {
        var e = _ref134.theme;
        return Y(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["\n    font-size: 0.8em;\n    margin-top: ", "px;\n    text-align: center;\n    position: fixed;\n    width: ", ";\n    bottom: 0;\n    background: ", ";\n\n    a,\n    a:visited,\n    a:hover {\n      color: ", " !important;\n      padding: ", "px 0;\n      border-top: 1px solid ", ";\n      text-decoration: none;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  "])), 2 * e.spacing.unit, e.sidebar.width, e.sidebar.backgroundColor, e.sidebar.textColor, e.spacing.unit, (0, t.darken)(.1, e.sidebar.backgroundColor));
      }, K.lessThan("small")(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral(["\n    width: 100%;\n  "])))),
          Pc = ee.button(_templateObject129 || (_templateObject129 = _taggedTemplateLiteral(["\n  border: 0;\n  width: 100%;\n  text-align: left;\n  & > * {\n    vertical-align: middle;\n  }\n\n  ", " {\n    polygon {\n      fill: ", ";\n    }\n  }\n"])), Si, function (_ref135) {
        var e = _ref135.theme;
        return (0, t.darken)(e.colors.tonalOffset, e.colors.gray[100]);
      }),
          Ic = ee.span(_templateObject130 || (_templateObject130 = _taggedTemplateLiteral(["\n  text-decoration: ", ";\n  margin-right: 8px;\n"])), function (e) {
        return e.deprecated ? "line-through" : "none";
      }),
          Tc = ee(Oc)(_templateObject131 || (_templateObject131 = _taggedTemplateLiteral(["\n  margin: 0 5px 0 0;\n"]))),
          _c = ee(function (t) {
        var r = t.name,
            n = t.opened,
            o = t.className,
            i = t.onClick,
            s = t.httpVerb,
            a = t.deprecated;
        return e.createElement(Pc, {
          className: o,
          onClick: i || void 0
        }, e.createElement(Tc, {
          type: s
        }, gt(s)), e.createElement(Si, {
          size: "1.5em",
          direction: n ? "down" : "right",
          float: "left"
        }), e.createElement(Ic, {
          deprecated: a
        }, r), a ? e.createElement($i, {
          type: "warning"
        }, " ", T("deprecated"), " ") : null);
      })(_templateObject132 || (_templateObject132 = _taggedTemplateLiteral(["\n  padding: 10px;\n  border-radius: 2px;\n  margin-bottom: 4px;\n  line-height: 1.5em;\n  background-color: ", ";\n  cursor: pointer;\n  outline-color: ", ";\n"])), function (_ref136) {
        var e = _ref136.theme;
        return e.colors.gray[100];
      }, function (_ref137) {
        var e = _ref137.theme;
        return (0, t.darken)(e.colors.tonalOffset, e.colors.gray[100]);
      }),
          Lc = ee.div(_templateObject133 || (_templateObject133 = _taggedTemplateLiteral(["\n  padding: 10px 25px;\n  background-color: ", ";\n  margin-bottom: 5px;\n  margin-top: 5px;\n"])), function (_ref138) {
        var e = _ref138.theme;
        return e.colors.gray[50];
      });

      var Dc = /*#__PURE__*/function (_e$PureComponent8) {
        _inherits(Dc, _e$PureComponent8);

        var _super23 = _createSuper(Dc);

        function Dc() {
          var _this32;

          _classCallCheck(this, Dc);

          _this32 = _super23.apply(this, arguments), _this32.selectElement = function () {
            Ls.selectElement(_this32.child);
          };
          return _this32;
        }

        _createClass(Dc, [{
          key: "render",
          value: function render() {
            var _this33 = this;

            var t = this.props.children;
            return e.createElement("div", {
              ref: function ref(e) {
                return _this33.child = e;
              },
              onClick: this.selectElement,
              onFocus: this.selectElement,
              tabIndex: 0,
              role: "button"
            }, t);
          }
        }]);

        return Dc;
      }(e.PureComponent);

      var zc = ee.div(_templateObject134 || (_templateObject134 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  margin-bottom: 5px;\n"]))),
          Mc = ee.span(_templateObject135 || (_templateObject135 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  margin-left: 10px;\n  flex: 1;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n"])), function (e) {
        return e.theme.typography.code.fontFamily;
      }),
          Nc = ee.button(_templateObject136 || (_templateObject136 = _taggedTemplateLiteral(["\n  outline: 0;\n  color: inherit;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  padding: 10px 30px 10px ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  border: ", ";\n  border-bottom: ", ";\n  transition: border-color 0.25s ease;\n\n  ", "\n\n  .", " {\n    color: ", ";\n  }\n  &:focus {\n    box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.45), 0 2px 0 rgba(128, 128, 128, 0.25);\n  }\n"])), function (e) {
        return e.inverted ? "10px" : "20px";
      }, function (e) {
        return e.inverted ? "0" : "4px 4px 0 0";
      }, function (e) {
        return e.inverted ? "transparent" : e.theme.codeBlock.backgroundColor;
      }, function (e) {
        return e.inverted ? "0" : "1px solid transparent";
      }, function (e) {
        return e.inverted ? "1px solid #ccc" : "0";
      }, function (e) {
        return e.expanded && !e.inverted && "border-color: ".concat(e.theme.colors.border.dark, ";") || "";
      }, Mc, function (e) {
        return e.inverted ? e.theme.colors.text.primary : "#ffffff";
      }),
          Fc = ee.span.attrs(function (e) {
        return {
          className: "http-verb ".concat(e.type)
        };
      })(_templateObject137 || (_templateObject137 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  background-color: ", ";\n  color: #ffffff;\n  padding: ", ";\n  text-transform: uppercase;\n  font-family: ", ";\n  margin: 0;\n"])), function (e) {
        return e.compact ? "0.8em" : "0.929em";
      }, function (e) {
        return e.compact ? "18px" : "20px";
      }, function (e) {
        return e.theme.colors.http[e.type] || "#999999";
      }, function (e) {
        return e.compact ? "2px 8px" : "3px 10px";
      }, function (e) {
        return e.theme.typography.headings.fontFamily;
      }),
          qc = ee.div(_templateObject138 || (_templateObject138 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  z-index: 100;\n  background: ", ";\n  color: ", ";\n  box-sizing: border-box;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.33);\n  overflow: hidden;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  transition: all 0.25s ease;\n  visibility: hidden;\n  ", "\n"])), function (e) {
        return e.theme.rightPanel.servers.overlay.backgroundColor;
      }, function (e) {
        return e.theme.rightPanel.servers.overlay.textColor;
      }, function (e) {
        return e.expanded ? "visibility: visible;" : "transform: translateY(-50%) scaleY(0);";
      }),
          Bc = ee.div(_templateObject139 || (_templateObject139 = _taggedTemplateLiteral(["\n  padding: 10px;\n"]))),
          Qc = ee.div(_templateObject140 || (_templateObject140 = _taggedTemplateLiteral(["\n  padding: 5px;\n  border: 1px solid #ccc;\n  background: ", ";\n  word-break: break-all;\n  color: ", ";\n  > span {\n    color: ", ";\n  }\n"])), function (e) {
        return e.theme.rightPanel.servers.url.backgroundColor;
      }, function (e) {
        return e.theme.colors.primary.main;
      }, function (e) {
        return e.theme.colors.text.primary;
      });

      var Uc = /*#__PURE__*/function (_e$Component15) {
        _inherits(Uc, _e$Component15);

        var _super24 = _createSuper(Uc);

        function Uc(e) {
          var _this34;

          _classCallCheck(this, Uc);

          _this34 = _super24.call(this, e), _this34.toggle = function () {
            _this34.setState({
              expanded: !_this34.state.expanded
            });
          }, _this34.state = {
            expanded: !1
          };
          return _this34;
        }

        _createClass(Uc, [{
          key: "render",
          value: function render() {
            var _this35 = this;

            var _this$props12 = this.props,
                t = _this$props12.operation,
                r = _this$props12.inverted,
                n = _this$props12.hideHostname,
                o = this.state.expanded;
            return e.createElement(ce.Consumer, null, function (i) {
              return e.createElement(zc, null, e.createElement(Nc, {
                onClick: _this35.toggle,
                expanded: o,
                inverted: r
              }, e.createElement(Fc, {
                type: t.httpVerb,
                compact: _this35.props.compact
              }, t.httpVerb), e.createElement(Mc, null, t.path), e.createElement(Si, {
                float: "right",
                color: r ? "black" : "white",
                size: "20px",
                direction: o ? "up" : "down",
                style: {
                  marginRight: "-25px"
                }
              })), e.createElement(qc, {
                expanded: o,
                "aria-hidden": !o
              }, t.servers.map(function (r) {
                var o = i.expandDefaultServerVariables ? ct(r.url, r.variables) : r.url,
                    s = E(o);
                return e.createElement(Bc, {
                  key: o
                }, e.createElement(Rs, {
                  source: r.description || "",
                  compact: !0
                }), e.createElement(Dc, null, e.createElement(Qc, null, e.createElement("span", null, n || i.hideHostname ? "/" === s ? "" : s : o), t.path)));
              })));
            });
          }
        }]);

        return Uc;
      }(e.Component);

      var Wc = /*#__PURE__*/function (_e$PureComponent9) {
        _inherits(Wc, _e$PureComponent9);

        var _super25 = _createSuper(Wc);

        function Wc() {
          _classCallCheck(this, Wc);

          return _super25.apply(this, arguments);
        }

        _createClass(Wc, [{
          key: "render",
          value: function render() {
            var _this$props13 = this.props,
                t = _this$props13.place,
                r = _this$props13.parameters;
            return r && r.length ? e.createElement("div", {
              key: t
            }, e.createElement(fi, null, t, " Parameters"), e.createElement(Li, null, e.createElement("tbody", null, d(r, function (t, r) {
              return e.createElement(Va, {
                key: t.name,
                isLast: r,
                field: t,
                showExamples: !0
              });
            })))) : null;
          }
        }]);

        return Wc;
      }(e.PureComponent);

      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Vc = /*#__PURE__*/function (_e$Component16) {
        _inherits(Vc, _e$Component16);

        var _super26 = _createSuper(Vc);

        function Vc() {
          var _this36;

          _classCallCheck(this, Vc);

          _this36 = _super26.apply(this, arguments), _this36.switchMedia = function (_ref139) {
            var e = _ref139.idx;
            _this36.props.content && void 0 !== e && _this36.props.content.activate(e);
          };
          return _this36;
        }

        _createClass(Vc, [{
          key: "render",
          value: function render() {
            var _this37 = this;

            var t = this.props.content;
            if (!t || !t.mediaTypes || !t.mediaTypes.length) return null;

            var r = t.activeMimeIdx,
                n = t.mediaTypes.map(function (e, t) {
              return {
                value: e.name,
                idx: t
              };
            }),
                o = function o(_ref140) {
              var t = _ref140.children;
              return _this37.props.withLabel ? e.createElement(ea, null, e.createElement(Ks, null, "Content type"), t) : t;
            };

            return e.createElement(e.Fragment, null, e.createElement(o, null, this.props.renderDropdown({
              value: n[r].value,
              options: n,
              onChange: this.switchMedia,
              ariaLabel: "Content type"
            })), this.props.children(t.active));
          }
        }]);

        return Vc;
      }(e.Component);

      Vc = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Vc);

      var Hc = Object.defineProperty,
          Jc = Object.getOwnPropertySymbols,
          Yc = Object.prototype.hasOwnProperty,
          Zc = Object.prototype.propertyIsEnumerable,
          Gc = function Gc(e, t, r) {
        return t in e ? Hc(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Xc = ["path", "query", "cookie", "header"];

      var Kc = /*#__PURE__*/function (_e$PureComponent10) {
        _inherits(Kc, _e$PureComponent10);

        var _super27 = _createSuper(Kc);

        function Kc() {
          _classCallCheck(this, Kc);

          return _super27.apply(this, arguments);
        }

        _createClass(Kc, [{
          key: "orderParams",
          value: function orderParams(e) {
            var t = {};
            return e.forEach(function (e) {
              var r, n, o;
              o = e, (r = t)[n = e.in] || (r[n] = []), r[n].push(o);
            }), t;
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props14 = this.props,
                t = _this$props14.body,
                _this$props14$paramet = _this$props14.parameters,
                r = _this$props14$paramet === void 0 ? [] : _this$props14$paramet;
            if (void 0 === t && void 0 === r) return null;
            var n = this.orderParams(r),
                o = r.length > 0 ? Xc : [],
                i = t && t.content,
                s = t && t.description;
            return e.createElement(e.Fragment, null, o.map(function (t) {
              return e.createElement(Wc, {
                key: t,
                place: t,
                parameters: n[t]
              });
            }), i && e.createElement(tp, {
              content: i,
              description: s
            }));
          }
        }]);

        return Kc;
      }(e.PureComponent);

      function ep(t) {
        return e.createElement(fi, {
          key: "header"
        }, "Request Body schema: ", e.createElement(gs, function (e, t) {
          for (var r in t || (t = {})) {
            Yc.call(t, r) && Gc(e, r, t[r]);
          }

          if (Jc) {
            var _iterator67 = _createForOfIteratorHelper(Jc(t)),
                _step67;

            try {
              for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                var r = _step67.value;
                Zc.call(t, r) && Gc(e, r, t[r]);
              }
            } catch (err) {
              _iterator67.e(err);
            } finally {
              _iterator67.f();
            }
          }

          return e;
        }({}, t)));
      }

      function tp(t) {
        var r = t.content,
            n = t.description,
            o = r.isRequestType;
        return e.createElement(Vc, {
          content: r,
          renderDropdown: ep
        }, function (_ref141) {
          var t = _ref141.schema;
          return e.createElement(e.Fragment, null, void 0 !== n && e.createElement(Rs, {
            source: n
          }), "object" === (null == t ? void 0 : t.type) && e.createElement(ja, {
            constraints: (null == t ? void 0 : t.constraints) || []
          }), e.createElement(Rl, {
            skipReadOnly: o,
            skipWriteOnly: !o,
            key: "schema",
            schema: t
          }));
        });
      }

      var rp = e.memo(function (_ref142) {
        var t = _ref142.title,
            r = _ref142.type,
            n = _ref142.empty,
            o = _ref142.code,
            i = _ref142.opened,
            s = _ref142.className,
            a = _ref142.onClick;
        return e.createElement("button", {
          className: s,
          onClick: !n && a || void 0,
          "aria-expanded": i,
          disabled: n
        }, !n && e.createElement(Si, {
          size: "1.5em",
          color: r,
          direction: i ? "down" : "right",
          float: "left"
        }), e.createElement(sp, null, o, " "), e.createElement(Rs, {
          compact: !0,
          inline: !0,
          source: t
        }));
      }),
          np = ee(rp)(_templateObject141 || (_templateObject141 = _taggedTemplateLiteral(["\n  display: block;\n  border: 0;\n  width: 100%;\n  text-align: left;\n  padding: 10px;\n  border-radius: 2px;\n  margin-bottom: 4px;\n  line-height: 1.5em;\n  cursor: pointer;\n\n  color: ", ";\n  background-color: ", ";\n  &:focus {\n    outline: auto ", ";\n  }\n  ", ";\n"])), function (e) {
        return e.theme.colors.responses[e.type].color;
      }, function (e) {
        return e.theme.colors.responses[e.type].backgroundColor;
      }, function (e) {
        return e.theme.colors.responses[e.type].color;
      }, function (e) {
        return e.empty ? '\ncursor: default;\n&::before {\n  content: "—";\n  font-weight: bold;\n  width: 1.5em;\n  text-align: center;\n  display: inline-block;\n  vertical-align: top;\n}\n&:focus {\n  outline: 0;\n}\n' : "";
      }),
          op = ee.div(_templateObject142 || (_templateObject142 = _taggedTemplateLiteral(["\n  padding: 10px;\n"]))),
          ip = ee(fi.withComponent("caption"))(_templateObject143 || (_templateObject143 = _taggedTemplateLiteral(["\n  text-align: left;\n  margin-top: 1em;\n  caption-side: top;\n"]))),
          sp = ee.strong(_templateObject144 || (_templateObject144 = _taggedTemplateLiteral(["\n  vertical-align: top;\n"])));

      var ap = /*#__PURE__*/function (_e$PureComponent11) {
        _inherits(ap, _e$PureComponent11);

        var _super28 = _createSuper(ap);

        function ap() {
          _classCallCheck(this, ap);

          return _super28.apply(this, arguments);
        }

        _createClass(ap, [{
          key: "render",
          value: function render() {
            var t = this.props.headers;
            return void 0 === t || 0 === t.length ? null : e.createElement(Li, null, e.createElement(ip, null, " Response Headers "), e.createElement("tbody", null, d(t, function (t, r) {
              return e.createElement(Va, {
                isLast: r,
                key: t.name,
                field: t,
                showExamples: !0
              });
            })));
          }
        }]);

        return ap;
      }(e.PureComponent);

      var lp = Object.defineProperty,
          cp = Object.getOwnPropertySymbols,
          pp = Object.prototype.hasOwnProperty,
          up = Object.prototype.propertyIsEnumerable,
          dp = function dp(e, t, r) {
        return t in e ? lp(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var hp = /*#__PURE__*/function (_e$PureComponent12) {
        _inherits(hp, _e$PureComponent12);

        var _super29 = _createSuper(hp);

        function hp() {
          var _this38;

          _classCallCheck(this, hp);

          _this38 = _super29.apply(this, arguments), _this38.renderDropdown = function (t) {
            return e.createElement(fi, {
              key: "header"
            }, "Response Schema: ", e.createElement(gs, function (e, t) {
              for (var r in t || (t = {})) {
                pp.call(t, r) && dp(e, r, t[r]);
              }

              if (cp) {
                var _iterator68 = _createForOfIteratorHelper(cp(t)),
                    _step68;

                try {
                  for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                    var r = _step68.value;
                    up.call(t, r) && dp(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator68.e(err);
                } finally {
                  _iterator68.f();
                }
              }

              return e;
            }({}, t)));
          };
          return _this38;
        }

        _createClass(hp, [{
          key: "render",
          value: function render() {
            var _this$props$response = this.props.response,
                t = _this$props$response.description,
                r = _this$props$response.extensions,
                n = _this$props$response.headers,
                o = _this$props$response.content;
            return e.createElement(e.Fragment, null, t && e.createElement(Rs, {
              source: t
            }), e.createElement(Sa, {
              extensions: r
            }), e.createElement(ap, {
              headers: n
            }), e.createElement(Vc, {
              content: o,
              renderDropdown: this.renderDropdown
            }, function (_ref143) {
              var t = _ref143.schema;
              return e.createElement(e.Fragment, null, "object" === (null == t ? void 0 : t.type) && e.createElement(ja, {
                constraints: (null == t ? void 0 : t.constraints) || []
              }), e.createElement(Rl, {
                skipWriteOnly: !0,
                key: "schema",
                schema: t
              }));
            }));
          }
        }]);

        return hp;
      }(e.PureComponent);

      var mp = (0, ia.observer)(function (_ref144) {
        var t = _ref144.response;
        var r = t.extensions,
            n = t.headers,
            o = t.type,
            i = t.summary,
            s = t.description,
            a = t.code,
            l = t.expanded,
            c = t.content,
            p = e.useMemo(function () {
          return void 0 === c ? [] : c.mediaTypes.filter(function (e) {
            return void 0 !== e.schema;
          });
        }, [c]),
            u = e.useMemo(function () {
          return !(r && 0 !== Object.keys(r).length || 0 !== n.length || 0 !== p.length || s);
        }, [r, n, p, s]);
        return e.createElement("div", null, e.createElement(np, {
          onClick: function onClick() {
            return t.toggle();
          },
          type: o,
          empty: u,
          title: i || "",
          code: a,
          opened: l
        }), l && !u && e.createElement(op, null, e.createElement(hp, {
          response: t
        })));
      }),
          fp = ee.h3(_templateObject145 || (_templateObject145 = _taggedTemplateLiteral(["\n  font-size: 1.3em;\n  padding: 0.2em 0;\n  margin: 3em 0 1.1em;\n  color: ", ";\n  font-weight: normal;\n"])), function (_ref145) {
        var e = _ref145.theme;
        return e.colors.text.primary;
      });

      var gp = /*#__PURE__*/function (_e$PureComponent13) {
        _inherits(gp, _e$PureComponent13);

        var _super30 = _createSuper(gp);

        function gp() {
          _classCallCheck(this, gp);

          return _super30.apply(this, arguments);
        }

        _createClass(gp, [{
          key: "render",
          value: function render() {
            var _this$props15 = this.props,
                t = _this$props15.responses,
                r = _this$props15.isCallback;
            return t && 0 !== t.length ? e.createElement("div", null, e.createElement(fp, null, T(r ? "callbackResponses" : "responses")), t.map(function (t) {
              return e.createElement(mp, {
                key: t.code,
                response: t
              });
            })) : null;
          }
        }]);

        return gp;
      }(e.PureComponent);

      function yp(t) {
        var r = t.security,
            n = t.showSecuritySchemeType,
            o = t.expanded,
            i = r.schemes.length > 1;
        return 0 === r.schemes.length ? e.createElement(Nl, {
          expanded: o
        }, "None") : e.createElement(Nl, {
          expanded: o
        }, i && "(", r.schemes.map(function (t) {
          return e.createElement(Ml, {
            key: t.id
          }, n && "".concat(Xl[t.type] || t.type, ": "), e.createElement("i", null, t.displayName), o && t.scopes.length ? [" (", t.scopes.map(function (t) {
            return e.createElement(zl, {
              key: t
            }, t);
          }), ") "] : null);
        }), i && ") ");
      }

      var bp = function bp(_ref146) {
        var t = _ref146.scopes;
        return t.length ? e.createElement("div", null, e.createElement("b", null, "Required scopes: "), t.map(function (t, r) {
          return e.createElement(e.Fragment, {
            key: r
          }, e.createElement("code", null, t), " ");
        })) : null;
      };

      function xp(t) {
        var r = vi(),
            n = null == r ? void 0 : r.options.showSecuritySchemeType,
            _ref147 = (0, e.useState)(!1),
            _ref148 = _slicedToArray(_ref147, 2),
            o = _ref148[0],
            i = _ref148[1],
            s = t.securities;

        if (!(null == s ? void 0 : s.length) || (null == r ? void 0 : r.options.hideSecuritySection)) return null;
        var a = null == r ? void 0 : r.spec.securitySchemes.schemes.filter(function (_ref149) {
          var e = _ref149.id;
          return s.find(function (t) {
            return t.schemes.find(function (t) {
              return t.id === e;
            });
          });
        });
        return e.createElement(e.Fragment, null, e.createElement(Ql, {
          expanded: o
        }, e.createElement(Fl, {
          onClick: function onClick() {
            return i(!o);
          }
        }, e.createElement(Bl, null, "Authorizations:"), e.createElement(Si, {
          size: "1.3em",
          direction: o ? "down" : "right"
        })), e.createElement(ql, {
          expanded: o
        }, s.map(function (t, r) {
          return e.createElement(yp, {
            key: r,
            expanded: o,
            showSecuritySchemeType: n,
            security: t
          });
        }))), o && (null == a ? void 0 : a.length) && a.map(function (t, r) {
          return e.createElement(Wl, {
            key: r
          }, e.createElement("h5", null, e.createElement(vp, null), " ", Xl[t.type] || t.type, ": ", t.id), e.createElement(Rs, {
            source: t.description || ""
          }), e.createElement(Gl, {
            key: t.id,
            scheme: t,
            RequiredScopes: e.createElement(bp, {
              scopes: wp(t.id, s)
            })
          }));
        }));
      }

      var vp = function vp() {
        return e.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "11",
          height: "11"
        }, e.createElement("path", {
          fill: "currentColor",
          d: "M18 10V6A6 6 0 0 0 6 6v4H3v14h18V10h-3zM8 6c0-2.206 1.794-4 4-4s4 1.794 4 4v4H8V6zm11 16H5V12h14v10z"
        }));
      };

      function wp(e, t) {
        var r = [];
        var n = t.length;

        for (; n--;) {
          var _o28 = t[n];
          var _i33 = _o28.schemes.length;

          for (; _i33--;) {
            var _t82 = _o28.schemes[_i33];
            _t82.id === e && Array.isArray(_t82.scopes) && r.push.apply(r, _toConsumableArray(_t82.scopes));
          }
        }

        return Array.from(new Set(r));
      }

      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var kp = /*#__PURE__*/function (_e$Component17) {
        _inherits(kp, _e$Component17);

        var _super31 = _createSuper(kp);

        function kp() {
          _classCallCheck(this, kp);

          return _super31.apply(this, arguments);
        }

        _createClass(kp, [{
          key: "render",
          value: function render() {
            var t = this.props.operation,
                r = t.description,
                n = t.externalDocs,
                o = !(!r && !n);
            return e.createElement(Lc, null, o && e.createElement(Op, null, void 0 !== r && e.createElement(Rs, {
              source: r
            }), n && e.createElement(wa, {
              externalDocs: n
            })), e.createElement(Uc, {
              operation: this.props.operation,
              inverted: !0,
              compact: !0
            }), e.createElement(Sa, {
              extensions: t.extensions
            }), e.createElement(xp, {
              securities: t.security
            }), e.createElement(Kc, {
              parameters: t.parameters,
              body: t.requestBody
            }), e.createElement(gp, {
              responses: t.responses,
              isCallback: t.isCallback
            }));
          }
        }]);

        return kp;
      }(e.Component);

      kp = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], kp);

      var Op = ee.div(_templateObject146 || (_templateObject146 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"])), function (_ref150) {
        var e = _ref150.theme;
        return 3 * e.spacing.unit;
      });
      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Ep = /*#__PURE__*/function (_e$Component18) {
        _inherits(Ep, _e$Component18);

        var _super32 = _createSuper(Ep);

        function Ep() {
          var _this39;

          _classCallCheck(this, Ep);

          _this39 = _super32.apply(this, arguments), _this39.toggle = function () {
            _this39.props.callbackOperation.toggle();
          };
          return _this39;
        }

        _createClass(Ep, [{
          key: "render",
          value: function render() {
            var _this$props$callbackO = this.props.callbackOperation,
                t = _this$props$callbackO.name,
                r = _this$props$callbackO.expanded,
                n = _this$props$callbackO.httpVerb,
                o = _this$props$callbackO.deprecated;
            return e.createElement(e.Fragment, null, e.createElement(_c, {
              onClick: this.toggle,
              name: t,
              opened: r,
              httpVerb: n,
              deprecated: o
            }), r && e.createElement(kp, {
              operation: this.props.callbackOperation
            }));
          }
        }]);

        return Ep;
      }(e.Component);

      Ep = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Ep);

      var Sp = /*#__PURE__*/function (_e$PureComponent14) {
        _inherits(Sp, _e$PureComponent14);

        var _super33 = _createSuper(Sp);

        function Sp() {
          _classCallCheck(this, Sp);

          return _super33.apply(this, arguments);
        }

        _createClass(Sp, [{
          key: "render",
          value: function render() {
            var t = this.props.callbacks;
            return t && 0 !== t.length ? e.createElement("div", null, e.createElement($p, null, " Callbacks "), t.map(function (t) {
              return t.operations.map(function (r, n) {
                return e.createElement(Ep, {
                  key: "".concat(t.name, "_").concat(n),
                  callbackOperation: r
                });
              });
            })) : null;
          }
        }]);

        return Sp;
      }(e.PureComponent);

      var $p = ee.h3(_templateObject147 || (_templateObject147 = _taggedTemplateLiteral(["\n  font-size: 1.3em;\n  padding: 0.2em 0;\n  margin: 3em 0 1.1em;\n  color: ", ";\n  font-weight: normal;\n"])), function (_ref151) {
        var e = _ref151.theme;
        return e.colors.text.primary;
      });
      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Rp = /*#__PURE__*/function (_e$Component19) {
        _inherits(Rp, _e$Component19);

        var _super34 = _createSuper(Rp);

        function Rp(e) {
          var _this40;

          _classCallCheck(this, Rp);

          _this40 = _super34.call(this, e), _this40.switchItem = function (_ref152) {
            var e = _ref152.idx;
            _this40.props.items && void 0 !== e && _this40.setState({
              activeItemIdx: e
            });
          }, _this40.state = {
            activeItemIdx: 0
          };
          return _this40;
        }

        _createClass(Rp, [{
          key: "render",
          value: function render() {
            var _this41 = this;

            var t = this.props.items;
            if (!t || !t.length) return null;

            var r = function r(_ref153) {
              var t = _ref153.children;
              return _this41.props.label ? e.createElement(ea, null, e.createElement(Ks, null, _this41.props.label), t) : t;
            };

            return e.createElement(e.Fragment, null, e.createElement(r, null, this.props.renderDropdown({
              value: this.props.options[this.state.activeItemIdx].value,
              options: this.props.options,
              onChange: this.switchItem,
              ariaLabel: this.props.label || "Callback"
            })), this.props.children(t[this.state.activeItemIdx]));
          }
        }]);

        return Rp;
      }(e.Component);

      Rp = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Rp);

      var jp = Object.defineProperty,
          Cp = Object.defineProperties,
          Ap = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors),
          Pp = Object.getOwnPropertySymbols,
          Ip = Object.prototype.hasOwnProperty,
          Tp = Object.prototype.propertyIsEnumerable,
          _p = function _p(e, t, r) {
        return t in e ? jp(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Lp = /*#__PURE__*/function (_e$Component20) {
        _inherits(Lp, _e$Component20);

        var _super35 = _createSuper(Lp);

        function Lp() {
          var _this42;

          _classCallCheck(this, Lp);

          _this42 = _super35.apply(this, arguments), _this42.renderDropdown = function (t) {
            return e.createElement(gs, (r = function (e, t) {
              for (var r in t || (t = {})) {
                Ip.call(t, r) && _p(e, r, t[r]);
              }

              if (Pp) {
                var _iterator69 = _createForOfIteratorHelper(Pp(t)),
                    _step69;

                try {
                  for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
                    var r = _step69.value;
                    Tp.call(t, r) && _p(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator69.e(err);
                } finally {
                  _iterator69.f();
                }
              }

              return e;
            }({
              Label: Xs,
              Dropdown: ta
            }, t), Cp(r, Ap({
              variant: "dark"
            }))));
            var r;
          };
          return _this42;
        }

        _createClass(Lp, [{
          key: "render",
          value: function render() {
            var _this43 = this;

            var t = this.props.content;
            return void 0 === t ? null : e.createElement(Vc, {
              content: t,
              renderDropdown: this.renderDropdown,
              withLabel: !0
            }, function (t) {
              return e.createElement(na, {
                key: "samples",
                mediaType: t,
                renderDropdown: _this43.renderDropdown
              });
            });
          }
        }]);

        return Lp;
      }(e.Component);

      Lp = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Lp);

      var Dp = /*#__PURE__*/function (_e$Component21) {
        _inherits(Dp, _e$Component21);

        var _super36 = _createSuper(Dp);

        function Dp() {
          _classCallCheck(this, Dp);

          return _super36.apply(this, arguments);
        }

        _createClass(Dp, [{
          key: "render",
          value: function render() {
            var t = this.props.callback.codeSamples.find(function (e) {
              return ho(e);
            });
            return t ? e.createElement(zp, null, e.createElement(Lp, {
              content: t.requestBodyContent
            })) : null;
          }
        }]);

        return Dp;
      }(e.Component);

      var zp = ee.div(_templateObject148 || (_templateObject148 = _taggedTemplateLiteral(["\n  margin-top: 15px;\n"])));

      var Mp = Object.defineProperty,
          Np = Object.defineProperties,
          Fp = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors),
          qp = Object.getOwnPropertySymbols,
          Bp = Object.prototype.hasOwnProperty,
          Qp = Object.prototype.propertyIsEnumerable,
          Up = function Up(e, t, r) {
        return t in e ? Mp(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Wp = /*#__PURE__*/function (_e$Component22) {
        _inherits(Wp, _e$Component22);

        var _super37 = _createSuper(Wp);

        function Wp() {
          var _this44;

          _classCallCheck(this, Wp);

          _this44 = _super37.apply(this, arguments), _this44.renderDropdown = function (t) {
            return e.createElement(gs, (r = function (e, t) {
              for (var r in t || (t = {})) {
                Bp.call(t, r) && Up(e, r, t[r]);
              }

              if (qp) {
                var _iterator70 = _createForOfIteratorHelper(qp(t)),
                    _step70;

                try {
                  for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                    var r = _step70.value;
                    Qp.call(t, r) && Up(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator70.e(err);
                } finally {
                  _iterator70.f();
                }
              }

              return e;
            }({
              Label: Xs,
              Dropdown: ta
            }, t), Np(r, Fp({
              variant: "dark"
            }))));
            var r;
          };
          return _this44;
        }

        _createClass(Wp, [{
          key: "render",
          value: function render() {
            var _this45 = this;

            var t = this.props.callbacks;
            if (!t || 0 === t.length) return null;
            var r = t.map(function (e) {
              return e.operations.map(function (e) {
                return e;
              });
            }).reduce(function (e, t) {
              return e.concat(t);
            }, []);
            if (!r.some(function (e) {
              return e.codeSamples.length > 0;
            })) return null;
            var n = r.map(function (e, t) {
              return {
                value: "".concat(e.httpVerb.toUpperCase(), ": ").concat(e.name),
                idx: t
              };
            });
            return e.createElement("div", null, e.createElement(mi, null, " Callback payload samples "), e.createElement(Vp, null, e.createElement(Rp, {
              items: r,
              renderDropdown: this.renderDropdown,
              label: "Callback",
              options: n
            }, function (t) {
              return e.createElement(Dp, {
                key: "callbackPayloadSample",
                callback: t,
                renderDropdown: _this45.renderDropdown
              });
            })));
          }
        }]);

        return Wp;
      }(e.Component);

      Wp.contextType = ce, Wp = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Wp);
      var Vp = ee.div(_templateObject149 || (_templateObject149 = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: ", "px;\n"])), function (_ref154) {
        var e = _ref154.theme;
        return e.codeBlock.backgroundColor;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      });
      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Hp = /*#__PURE__*/function (_e$Component23) {
        _inherits(Hp, _e$Component23);

        var _super38 = _createSuper(Hp);

        function Hp() {
          _classCallCheck(this, Hp);

          return _super38.apply(this, arguments);
        }

        _createClass(Hp, [{
          key: "render",
          value: function render() {
            var t = this.props.operation,
                r = t.codeSamples,
                n = r.length > 0,
                o = 1 === r.length && this.context.hideSingleRequestSampleTab;
            return n && e.createElement("div", null, e.createElement(mi, null, " ", T("requestSamples"), " "), e.createElement(Bi, {
              defaultIndex: 0
            }, e.createElement(qi.TabList, {
              hidden: o
            }, r.map(function (t) {
              return e.createElement(qi.Tab, {
                key: t.lang + "_" + (t.label || "")
              }, void 0 !== t.label ? t.label : t.lang);
            })), r.map(function (t) {
              return e.createElement(qi.TabPanel, {
                key: t.lang + "_" + (t.label || "")
              }, ho(t) ? e.createElement("div", null, e.createElement(Lp, {
                content: t.requestBodyContent
              })) : e.createElement(Js, {
                lang: t.lang,
                source: t.source
              }));
            }))) || null;
          }
        }]);

        return Hp;
      }(e.Component);

      Hp.contextType = ce, Hp = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Hp);
      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Jp = /*#__PURE__*/function (_e$Component24) {
        _inherits(Jp, _e$Component24);

        var _super39 = _createSuper(Jp);

        function Jp() {
          _classCallCheck(this, Jp);

          return _super39.apply(this, arguments);
        }

        _createClass(Jp, [{
          key: "render",
          value: function render() {
            var t = this.props.operation,
                r = t.responses.filter(function (e) {
              return e.content && e.content.hasSample;
            });
            return r.length > 0 && e.createElement("div", null, e.createElement(mi, null, " ", T("responseSamples"), " "), e.createElement(Bi, {
              defaultIndex: 0
            }, e.createElement(qi.TabList, null, r.map(function (t) {
              return e.createElement(qi.Tab, {
                className: "tab-" + t.type,
                key: t.code
              }, t.code);
            })), r.map(function (t) {
              return e.createElement(qi.TabPanel, {
                key: t.code
              }, e.createElement("div", null, e.createElement(Lp, {
                content: t.content
              })));
            }))) || null;
          }
        }]);

        return Jp;
      }(e.Component);

      Jp = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Jp);

      var Yp = Object.defineProperty,
          Zp = Object.defineProperties,
          Gp = Object.getOwnPropertyDescriptors,
          Xp = Object.getOwnPropertySymbols,
          Kp = Object.prototype.hasOwnProperty,
          eu = Object.prototype.propertyIsEnumerable,
          tu = function tu(e, t, r) {
        return t in e ? Yp(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var ru = ee.div(_templateObject150 || (_templateObject150 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"])), function (_ref155) {
        var e = _ref155.theme;
        return 6 * e.spacing.unit;
      }),
          nu = (0, ia.observer)(function (_ref156) {
        var t = _ref156.operation;

        var r = t.name,
            n = t.description,
            o = t.deprecated,
            i = t.externalDocs,
            s = t.isWebhook,
            a = t.httpVerb,
            l = !(!n && !i),
            _e$useContext5 = e.useContext(ce),
            c = _e$useContext5.showWebhookVerb;

        return e.createElement(ce.Consumer, null, function (p) {
          return e.createElement(ci, (u = function (e, t) {
            for (var r in t || (t = {})) {
              Kp.call(t, r) && tu(e, r, t[r]);
            }

            if (Xp) {
              var _iterator71 = _createForOfIteratorHelper(Xp(t)),
                  _step71;

              try {
                for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
                  var r = _step71.value;
                  eu.call(t, r) && tu(e, r, t[r]);
                }
              } catch (err) {
                _iterator71.e(err);
              } finally {
                _iterator71.f();
              }
            }

            return e;
          }({}, _defineProperty({}, Xo, t.operationHash)), d = {
            id: t.operationHash
          }, Zp(u, Gp(d))), e.createElement(ii, null, e.createElement(hi, null, e.createElement(Oi, {
            to: t.id
          }), r, " ", o && e.createElement($i, {
            type: "warning"
          }, " Deprecated "), s && e.createElement($i, {
            type: "primary"
          }, " ", "Webhook ", c && a && "| " + a.toUpperCase())), p.pathInMiddlePanel && !s && e.createElement(Uc, {
            operation: t,
            inverted: !0
          }), l && e.createElement(ru, null, void 0 !== n && e.createElement(Rs, {
            source: n
          }), i && e.createElement(wa, {
            externalDocs: i
          })), e.createElement(Sa, {
            extensions: t.extensions
          }), e.createElement(xp, {
            securities: t.security
          }), e.createElement(Kc, {
            parameters: t.parameters,
            body: t.requestBody
          }), e.createElement(gp, {
            responses: t.responses
          }), e.createElement(Sp, {
            callbacks: t.callbacks
          })), e.createElement(li, null, !p.pathInMiddlePanel && !s && e.createElement(Uc, {
            operation: t
          }), e.createElement(Hp, {
            operation: t
          }), e.createElement(Jp, {
            operation: t
          }), e.createElement(Wp, {
            callbacks: t.callbacks
          })));
          var u, d;
        });
      });

      var ou = Object.defineProperty,
          iu = Object.getOwnPropertyDescriptor,
          su = Object.getOwnPropertySymbols,
          au = Object.prototype.hasOwnProperty,
          lu = Object.prototype.propertyIsEnumerable,
          cu = function cu(e, t, r) {
        return t in e ? ou(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      },
          pu = function pu(e, t, r, n) {
        for (var o, i = n > 1 ? void 0 : n ? iu(t, r) : t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
        }

        return n && i && ou(t, r, i), i;
      };

      var uu = /*#__PURE__*/function (_e$Component25) {
        _inherits(uu, _e$Component25);

        var _super40 = _createSuper(uu);

        function uu() {
          _classCallCheck(this, uu);

          return _super40.apply(this, arguments);
        }

        _createClass(uu, [{
          key: "render",
          value: function render() {
            var t = this.props.items;
            return 0 === t.length ? null : t.map(function (t) {
              return e.createElement(du, {
                key: t.id,
                item: t
              });
            });
          }
        }]);

        return uu;
      }(e.Component);

      uu = pu([ia.observer], uu);

      var du = /*#__PURE__*/function (_e$Component26) {
        _inherits(du, _e$Component26);

        var _super41 = _createSuper(du);

        function du() {
          _classCallCheck(this, du);

          return _super41.apply(this, arguments);
        }

        _createClass(du, [{
          key: "render",
          value: function render() {
            var t = this.props.item;
            var r;
            var n = t.type;

            switch (n) {
              case "group":
                r = null;
                break;

              case "tag":
              case "section":
              default:
                r = e.createElement(mu, function (e, t) {
                  for (var r in t || (t = {})) {
                    au.call(t, r) && cu(e, r, t[r]);
                  }

                  if (su) {
                    var _iterator72 = _createForOfIteratorHelper(su(t)),
                        _step72;

                    try {
                      for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
                        var r = _step72.value;
                        lu.call(t, r) && cu(e, r, t[r]);
                      }
                    } catch (err) {
                      _iterator72.e(err);
                    } finally {
                      _iterator72.f();
                    }
                  }

                  return e;
                }({}, this.props));
                break;

              case "operation":
                r = e.createElement(fu, {
                  item: t
                });
            }

            return e.createElement(e.Fragment, null, r && e.createElement(si, {
              id: t.id,
              underlined: "operation" === t.type
            }, r), t.items && e.createElement(uu, {
              items: t.items
            }));
          }
        }]);

        return du;
      }(e.Component);

      du = pu([ia.observer], du);

      var hu = function hu(t) {
        return e.createElement(ii, {
          compact: !0
        }, t);
      };

      var mu = /*#__PURE__*/function (_e$Component27) {
        _inherits(mu, _e$Component27);

        var _super42 = _createSuper(mu);

        function mu() {
          _classCallCheck(this, mu);

          return _super42.apply(this, arguments);
        }

        _createClass(mu, [{
          key: "render",
          value: function render() {
            var _this$props$item = this.props.item,
                t = _this$props$item.name,
                r = _this$props$item.description,
                n = _this$props$item.externalDocs,
                o = _this$props$item.level,
                i = 2 === o ? hi : di;
            return e.createElement(e.Fragment, null, e.createElement(ci, null, e.createElement(ii, {
              compact: !1
            }, e.createElement(i, null, e.createElement(Oi, {
              to: this.props.item.id
            }), t))), e.createElement(vc, {
              parentId: this.props.item.id,
              source: r || "",
              htmlWrap: hu
            }), n && e.createElement(ci, null, e.createElement(ii, null, e.createElement(wa, {
              externalDocs: n
            }))));
          }
        }]);

        return mu;
      }(e.Component);

      mu = pu([ia.observer], mu);

      var fu = /*#__PURE__*/function (_e$Component28) {
        _inherits(fu, _e$Component28);

        var _super43 = _createSuper(fu);

        function fu() {
          _classCallCheck(this, fu);

          return _super43.apply(this, arguments);
        }

        _createClass(fu, [{
          key: "render",
          value: function render() {
            return e.createElement(nu, {
              operation: this.props.item
            });
          }
        }]);

        return fu;
      }(e.Component);

      fu = pu([ia.observer], fu);

      var gu = Object.defineProperty,
          yu = Object.defineProperties,
          bu = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors),
          xu = Object.getOwnPropertySymbols,
          vu = Object.prototype.hasOwnProperty,
          wu = Object.prototype.propertyIsEnumerable,
          ku = function ku(e, t, r) {
        return t in e ? gu(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Ou = /*#__PURE__*/function (_e$Component29) {
        _inherits(Ou, _e$Component29);

        var _super44 = _createSuper(Ou);

        function Ou() {
          var _this46;

          _classCallCheck(this, Ou);

          _this46 = _super44.apply(this, arguments), _this46.ref = e.createRef(), _this46.activate = function (e) {
            _this46.props.onActivate(_this46.props.item), e.stopPropagation();
          };
          return _this46;
        }

        _createClass(Ou, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.scrollIntoViewIfActive();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.scrollIntoViewIfActive();
          }
        }, {
          key: "scrollIntoViewIfActive",
          value: function scrollIntoViewIfActive() {
            this.props.item.active && this.ref.current && c(this.ref.current);
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props16 = this.props,
                t = _this$props16.item,
                r = _this$props16.withoutChildren;
            return e.createElement($c, {
              onClick: this.activate,
              depth: t.depth,
              "data-item-id": t.id
            }, "operation" === t.type ? e.createElement(Eu, (n = function (e, t) {
              for (var r in t || (t = {})) {
                vu.call(t, r) && ku(e, r, t[r]);
              }

              if (xu) {
                var _iterator73 = _createForOfIteratorHelper(xu(t)),
                    _step73;

                try {
                  for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                    var r = _step73.value;
                    wu.call(t, r) && ku(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator73.e(err);
                } finally {
                  _iterator73.f();
                }
              }

              return e;
            }({}, this.props), yu(n, bu({
              item: t
            })))) : e.createElement(jc, {
              depth: t.depth,
              active: t.active,
              type: t.type,
              ref: this.ref
            }, e.createElement(Cc, {
              title: t.sidebarLabel
            }, t.sidebarLabel, this.props.children), t.depth > 0 && t.items.length > 0 && e.createElement(Si, {
              float: "right",
              direction: t.expanded ? "down" : "right"
            }) || null), !r && t.items && t.items.length > 0 && e.createElement(Au, {
              expanded: t.expanded,
              items: t.items,
              onActivate: this.props.onActivate
            }));
            var n;
          }
        }]);

        return Ou;
      }(e.Component);

      Ou = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Ou);

      var Eu = (0, ia.observer)(function (t) {
        var r = t.item,
            n = e.createRef(),
            _e$useContext6 = e.useContext(ce),
            o = _e$useContext6.showWebhookVerb;

        return e.useEffect(function () {
          t.item.active && n.current && c(n.current);
        }, [t.item.active, n]), e.createElement(jc, {
          depth: r.depth,
          active: r.active,
          deprecated: r.deprecated,
          ref: n
        }, r.isWebhook ? e.createElement(Oc, {
          type: "hook"
        }, o ? r.httpVerb : T("webhook")) : e.createElement(Oc, {
          type: r.httpVerb
        }, gt(r.httpVerb)), e.createElement(Cc, {
          width: "calc(100% - 38px)"
        }, r.sidebarLabel, t.children));
      });

      var Su = Object.defineProperty,
          $u = (Object.getOwnPropertyDescriptor, Object.getOwnPropertySymbols),
          Ru = Object.prototype.hasOwnProperty,
          ju = Object.prototype.propertyIsEnumerable,
          Cu = function Cu(e, t, r) {
        return t in e ? Su(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: r
        }) : e[t] = r;
      };

      var Au = /*#__PURE__*/function (_e$Component30) {
        _inherits(Au, _e$Component30);

        var _super45 = _createSuper(Au);

        function Au() {
          _classCallCheck(this, Au);

          return _super45.apply(this, arguments);
        }

        _createClass(Au, [{
          key: "render",
          value: function render() {
            var _this47 = this;

            var _this$props17 = this.props,
                t = _this$props17.items,
                r = _this$props17.root,
                n = _this$props17.className,
                o = null == this.props.expanded || this.props.expanded;
            return e.createElement(Sc, function (e, t) {
              for (var r in t || (t = {})) {
                Ru.call(t, r) && Cu(e, r, t[r]);
              }

              if ($u) {
                var _iterator74 = _createForOfIteratorHelper($u(t)),
                    _step74;

                try {
                  for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                    var r = _step74.value;
                    ju.call(t, r) && Cu(e, r, t[r]);
                  }
                } catch (err) {
                  _iterator74.e(err);
                } finally {
                  _iterator74.f();
                }
              }

              return e;
            }({
              className: n,
              style: this.props.style,
              expanded: o
            }, r ? {
              role: "menu"
            } : {}), t.map(function (t, r) {
              return e.createElement(Ou, {
                key: r,
                item: t,
                onActivate: _this47.props.onActivate
              });
            }));
          }
        }]);

        return Au;
      }(e.Component);

      function Pu() {
        var _ref158 = (0, e.useState)(!1),
            _ref159 = _slicedToArray(_ref158, 2),
            t = _ref159[0],
            r = _ref159[1];

        return (0, e.useEffect)(function () {
          r(!0);
        }, []), t ? e.createElement("img", {
          alt: "redocly logo",
          onError: function onError() {
            return r(!1);
          },
          src: "https://cdn.redoc.ly/redoc/logo-mini.svg"
        }) : null;
      }

      Au = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Au);

      Object.defineProperty, Object.getOwnPropertyDescriptor;

      var Iu = /*#__PURE__*/function (_e$Component31) {
        _inherits(Iu, _e$Component31);

        var _super46 = _createSuper(Iu);

        function Iu() {
          var _this48;

          _classCallCheck(this, Iu);

          _this48 = _super46.apply(this, arguments), _this48.activate = function (e) {
            if (e && e.active && _this48.context.menuToggle) return e.expanded ? e.collapse() : e.expand();
            _this48.props.menu.activateAndScroll(e, !0), setTimeout(function () {
              _this48._updateScroll && _this48._updateScroll();
            });
          }, _this48.saveScrollUpdate = function (e) {
            _this48._updateScroll = e;
          };
          return _this48;
        }

        _createClass(Iu, [{
          key: "render",
          value: function render() {
            var t = this.props.menu;
            return e.createElement(is, {
              updateFn: this.saveScrollUpdate,
              className: this.props.className,
              options: {
                wheelPropagation: !1
              }
            }, e.createElement(Au, {
              items: t.items,
              onActivate: this.activate,
              root: !0
            }), e.createElement(Ac, null, e.createElement("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              href: "https://redocly.com/redoc/"
            }, e.createElement(Pu, null), "API docs by Redocly")));
          }
        }]);

        return Iu;
      }(e.Component);

      Iu.contextType = ce, Iu = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Iu);

      var Tu = function Tu(_ref160) {
        var t = _ref160.open;
        var r = t ? 8 : -4;
        return e.createElement(Lu, null, e.createElement(_u, {
          size: 15,
          style: {
            transform: "translate(2px, ".concat(r, "px) rotate(180deg)"),
            transition: "transform 0.2s ease"
          }
        }), e.createElement(_u, {
          size: 15,
          style: {
            transform: "translate(2px, ".concat(0 - r, "px)"),
            transition: "transform 0.2s ease"
          }
        }));
      },
          _u = function _u(_ref161) {
        var _ref161$size = _ref161.size,
            t = _ref161$size === void 0 ? 10 : _ref161$size,
            _ref161$className = _ref161.className,
            r = _ref161$className === void 0 ? "" : _ref161$className,
            n = _ref161.style;
        return e.createElement("svg", {
          className: r,
          style: n || {},
          viewBox: "0 0 926.23699 573.74994",
          version: "1.1",
          x: "0px",
          y: "0px",
          width: t,
          height: t
        }, e.createElement("g", {
          transform: "translate(904.92214,-879.1482)"
        }, e.createElement("path", {
          d: "\n          m -673.67664,1221.6502 -231.2455,-231.24803 55.6165,\n          -55.627 c 30.5891,-30.59485 56.1806,-55.627 56.8701,-55.627 0.6894,\n          0 79.8637,78.60862 175.9427,174.68583 l 174.6892,174.6858 174.6892,\n          -174.6858 c 96.079,-96.07721 175.253196,-174.68583 175.942696,\n          -174.68583 0.6895,0 26.281,25.03215 56.8701,\n          55.627 l 55.6165,55.627 -231.245496,231.24803 c -127.185,127.1864\n          -231.5279,231.248 -231.873,231.248 -0.3451,0 -104.688,\n          -104.0616 -231.873,-231.248 z\n        ",
          fill: "currentColor"
        })));
      },
          Lu = ee.div(_templateObject151 || (_templateObject151 = _taggedTemplateLiteral(["\n  user-select: none;\n  width: 20px;\n  height: 20px;\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n"])), function (e) {
        return e.theme.colors.primary.main;
      });

      Object.defineProperty, Object.getOwnPropertyDescriptor;
      var Du;
      s && (Du = r(322));
      var zu = Du && Du(),
          Mu = ee.div(_templateObject152 || (_templateObject152 = _taggedTemplateLiteral(["\n  width: ", ";\n  background-color: ", ";\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  backface-visibility: hidden;\n  /* contain: strict; TODO: breaks layout since Chrome 80*/\n\n  height: 100vh;\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n\n  ", ";\n\n  @media print {\n    display: none;\n  }\n"])), function (e) {
        return e.theme.sidebar.width;
      }, function (e) {
        return e.theme.sidebar.backgroundColor;
      }, K.lessThan("small")(_templateObject153 || (_templateObject153 = _taggedTemplateLiteral(["\n    position: fixed;\n    z-index: 20;\n    width: 100%;\n    background: ", ";\n    display: ", ";\n  "])), function (_ref162) {
        var e = _ref162.theme;
        return e.sidebar.backgroundColor;
      }, function (e) {
        return e.open ? "flex" : "none";
      })),
          Nu = ee.div(_templateObject154 || (_templateObject154 = _taggedTemplateLiteral(["\n  outline: none;\n  user-select: none;\n  background-color: ", ";\n  color: ", ";\n  display: none;\n  cursor: pointer;\n  position: fixed;\n  right: 20px;\n  z-index: 100;\n  border-radius: 50%;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n  ", ";\n\n  bottom: 44px;\n\n  width: 60px;\n  height: 60px;\n  padding: 0 20px;\n  svg {\n    color: ", ";\n  }\n\n  @media print {\n    display: none;\n  }\n"])), function (_ref163) {
        var e = _ref163.theme;
        return e.fab.backgroundColor;
      }, function (e) {
        return e.theme.colors.primary.main;
      }, K.lessThan("small")(_templateObject155 || (_templateObject155 = _taggedTemplateLiteral(["\n    display: flex;\n  "]))), function (_ref164) {
        var e = _ref164.theme;
        return e.fab.color;
      });

      var Fu = /*#__PURE__*/function (_e$Component32) {
        _inherits(Fu, _e$Component32);

        var _super47 = _createSuper(Fu);

        function Fu() {
          var _this49;

          _classCallCheck(this, Fu);

          _this49 = _super47.apply(this, arguments), _this49.state = {
            offsetTop: "0px"
          }, _this49.toggleNavMenu = function () {
            _this49.props.menu.toggleSidebar();
          };
          return _this49;
        }

        _createClass(Fu, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            zu && zu.add(this.stickyElement), this.setState({
              offsetTop: this.getScrollYOffset(this.context)
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            zu && zu.remove(this.stickyElement);
          }
        }, {
          key: "getScrollYOffset",
          value: function getScrollYOffset(e) {
            var t;
            return t = void 0 !== this.props.scrollYOffset ? W.normalizeScrollYOffset(this.props.scrollYOffset)() : e.scrollYOffset(), t + "px";
          }
        }, {
          key: "render",
          value: function render() {
            var _this50 = this;

            var t = this.props.menu.sideBarOpened,
                r = this.state.offsetTop;
            return e.createElement(e.Fragment, null, e.createElement(Mu, {
              open: t,
              className: this.props.className,
              style: {
                top: r,
                height: "calc(100vh - ".concat(r, ")")
              },
              ref: function ref(e) {
                _this50.stickyElement = e;
              }
            }, this.props.children), !this.context.hideFab && e.createElement(Nu, {
              onClick: this.toggleNavMenu
            }, e.createElement(Tu, {
              open: t
            })));
          }
        }]);

        return Fu;
      }(e.Component);

      Fu.contextType = ce, Fu = function (e, t, r, n) {
        for (var o, i = t, s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(i) || i);
        }

        return i;
      }([ia.observer], Fu);
      var qu = ee.div(_templateObject156 || (_templateObject156 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref165) {
        var e = _ref165.theme;
        return "\n  font-family: ".concat(e.typography.fontFamily, ";\n  font-size: ").concat(e.typography.fontSize, ";\n  font-weight: ").concat(e.typography.fontWeightRegular, ";\n  line-height: ").concat(e.typography.lineHeight, ";\n  color: ").concat(e.colors.text.primary, ";\n  display: flex;\n  position: relative;\n  text-align: left;\n\n  -webkit-font-smoothing: ").concat(e.typography.smoothing, ";\n  font-smoothing: ").concat(e.typography.smoothing, ";\n  ").concat(e.typography.optimizeSpeed ? "text-rendering: optimizeSpeed !important" : "", ";\n\n  tap-highlight-color: rgba(0, 0, 0, 0);\n  text-size-adjust: 100%;\n\n  * {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  }\n");
      }),
          Bu = ee.div(_templateObject157 || (_templateObject157 = _taggedTemplateLiteral(["\n  z-index: 1;\n  position: relative;\n  overflow: hidden;\n  width: calc(100% - ", ");\n  ", ";\n\n  contain: layout;\n"])), function (e) {
        return e.theme.sidebar.width;
      }, K.lessThan("small", !0)(_templateObject158 || (_templateObject158 = _taggedTemplateLiteral(["\n    width: 100%;\n  "])))),
          Qu = ee.div(_templateObject159 || (_templateObject159 = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: ", ";\n  ", ";\n"])), function (_ref166) {
        var e = _ref166.theme;
        return e.rightPanel.backgroundColor;
      }, function (_ref167) {
        var e = _ref167.theme;

        if (e.rightPanel.width.endsWith("%")) {
          var _t83 = parseInt(e.rightPanel.width, 10);

          return "calc((100% - ".concat(e.sidebar.width, ") * ").concat(_t83 / 100, ")");
        }

        return e.rightPanel.width;
      }, K.lessThan("medium", !0)(_templateObject160 || (_templateObject160 = _taggedTemplateLiteral(["\n    display: none;\n  "])))),
          Uu = ee.div(_templateObject161 || (_templateObject161 = _taggedTemplateLiteral(["\n  padding: 5px 0;\n"]))),
          Wu = ee.input.attrs(function () {
        return {
          className: "search-input"
        };
      })(_templateObject162 || (_templateObject162 = _taggedTemplateLiteral(["\n  width: calc(100% - ", "px);\n  box-sizing: border-box;\n  margin: 0 ", "px;\n  padding: 5px ", "px 5px\n    ", "px;\n  border: 0;\n  border-bottom: 1px solid\n    ", ";\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 13px;\n  color: ", ";\n  background-color: transparent;\n  outline: none;\n"])), function (e) {
        return 8 * e.theme.spacing.unit;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      }, function (e) {
        return 2 * e.theme.spacing.unit;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      }, function (_ref168) {
        var e = _ref168.theme;
        return ((0, t.getLuminance)(e.sidebar.backgroundColor) > .5 ? t.darken : t.lighten)(.1, e.sidebar.backgroundColor);
      }, function (_ref169) {
        var e = _ref169.theme;
        return e.typography.fontFamily;
      }, function (e) {
        return e.theme.sidebar.textColor;
      }),
          Vu = ee(function (t) {
        return e.createElement("svg", {
          className: t.className,
          version: "1.1",
          viewBox: "0 0 1000 1000",
          x: "0px",
          xmlns: "http://www.w3.org/2000/svg",
          y: "0px"
        }, e.createElement("path", {
          d: "M968.2,849.4L667.3,549c83.9-136.5,66.7-317.4-51.7-435.6C477.1-25,252.5-25,113.9,113.4c-138.5,138.3-138.5,362.6,0,501C219.2,730.1,413.2,743,547.6,666.5l301.9,301.4c43.6,43.6,76.9,14.9,104.2-12.4C981,928.3,1011.8,893,968.2,849.4z M524.5,522c-88.9,88.7-233,88.7-321.8,0c-88.9-88.7-88.9-232.6,0-321.3c88.9-88.7,233-88.7,321.8,0C613.4,289.4,613.4,433.3,524.5,522z"
        }));
      }).attrs({
        className: "search-icon"
      })(_templateObject163 || (_templateObject163 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", "px;\n  height: 1.8em;\n  width: 0.9em;\n\n  path {\n    fill: ", ";\n  }\n"])), function (e) {
        return 4 * e.theme.spacing.unit;
      }, function (e) {
        return e.theme.sidebar.textColor;
      }),
          Hu = ee.div(_templateObject164 || (_templateObject164 = _taggedTemplateLiteral(["\n  padding: ", "px 0;\n  background-color: ", "};\n  color: ", ";\n  min-height: 150px;\n  max-height: 250px;\n  border-top: ", "};\n  border-bottom: ", "};\n  margin-top: 10px;\n  line-height: 1.4;\n  font-size: 0.9em;\n  \n  li {\n    background-color: inherit;\n  }\n\n  ", " {\n    padding-top: 6px;\n    padding-bottom: 6px;\n\n    &:hover,\n    &.active {\n      background-color: ", ";\n    }\n\n    > svg {\n      display: none;\n    }\n  }\n"])), function (e) {
        return e.theme.spacing.unit;
      }, function (_ref170) {
        var e = _ref170.theme;
        return (0, t.darken)(.05, e.sidebar.backgroundColor);
      }, function (e) {
        return e.theme.sidebar.textColor;
      }, function (_ref171) {
        var e = _ref171.theme;
        return (0, t.darken)(.1, e.sidebar.backgroundColor);
      }, function (_ref172) {
        var e = _ref172.theme;
        return (0, t.darken)(.1, e.sidebar.backgroundColor);
      }, jc, function (_ref173) {
        var e = _ref173.theme;
        return (0, t.darken)(.1, e.sidebar.backgroundColor);
      }),
          Ju = ee.i(_templateObject165 || (_templateObject165 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-block;\n  width: ", "px;\n  text-align: center;\n  right: ", "px;\n  line-height: 2em;\n  vertical-align: middle;\n  margin-right: 2px;\n  cursor: pointer;\n  font-style: normal;\n  color: '#666';\n"])), function (e) {
        return 2 * e.theme.spacing.unit;
      }, function (e) {
        return 4 * e.theme.spacing.unit;
      });
      var Yu = Object.defineProperty,
          Zu = Object.getOwnPropertyDescriptor;

      var Gu = /*#__PURE__*/function (_e$PureComponent15) {
        _inherits(Gu, _e$PureComponent15);

        var _super48 = _createSuper(Gu);

        function Gu(e) {
          var _this51;

          _classCallCheck(this, Gu);

          _this51 = _super48.call(this, e), _this51.activeItemRef = null, _this51.clear = function () {
            _this51.setState({
              results: [],
              noResults: !1,
              term: "",
              activeItemIdx: -1
            }), _this51.props.marker.unmark();
          }, _this51.handleKeyDown = function (e) {
            if (27 === e.keyCode && _this51.clear(), 40 === e.keyCode && (_this51.setState({
              activeItemIdx: Math.min(_this51.state.activeItemIdx + 1, _this51.state.results.length - 1)
            }), e.preventDefault()), 38 === e.keyCode && (_this51.setState({
              activeItemIdx: Math.max(0, _this51.state.activeItemIdx - 1)
            }), e.preventDefault()), 13 === e.keyCode) {
              var _e74 = _this51.state.results[_this51.state.activeItemIdx];

              if (_e74) {
                var _t84 = _this51.props.getItemById(_e74.meta);

                _t84 && _this51.props.onActivate(_t84);
              }
            }
          }, _this51.search = function (e) {
            var t = _this51.context.minCharacterLengthToInitSearch,
                r = e.target.value;
            r.length < t ? _this51.clearResults(r) : _this51.setState({
              term: r
            }, function () {
              return _this51.searchCallback(_this51.state.term);
            });
          }, _this51.state = {
            results: [],
            noResults: !1,
            term: "",
            activeItemIdx: -1
          };
          return _this51;
        }

        _createClass(Gu, [{
          key: "clearResults",
          value: function clearResults(e) {
            this.setState({
              results: [],
              noResults: !1,
              term: e
            }), this.props.marker.unmark();
          }
        }, {
          key: "setResults",
          value: function setResults(e, t) {
            this.setState({
              results: e,
              noResults: 0 === e.length
            }), this.props.marker.mark(t);
          }
        }, {
          key: "searchCallback",
          value: function searchCallback(e) {
            var _this52 = this;

            this.props.search.search(e).then(function (t) {
              _this52.setResults(t, e);
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this53 = this;

            var t = this.state.activeItemIdx,
                r = this.state.results.filter(function (e) {
              return _this53.props.getItemById(e.meta);
            }).map(function (e) {
              return {
                item: _this53.props.getItemById(e.meta),
                score: e.score
              };
            }).sort(function (e, t) {
              return t.score - e.score;
            });
            return e.createElement(Uu, {
              role: "search"
            }, this.state.term && e.createElement(Ju, {
              onClick: this.clear
            }, "×"), e.createElement(Vu, null), e.createElement(Wu, {
              value: this.state.term,
              onKeyDown: this.handleKeyDown,
              placeholder: "Search...",
              "aria-label": "Search",
              type: "text",
              onChange: this.search
            }), r.length > 0 && e.createElement(is, {
              options: {
                wheelPropagation: !1
              }
            }, e.createElement(Hu, {
              "data-role": "search:results"
            }, r.map(function (r, n) {
              return e.createElement(Ou, {
                item: Object.create(r.item, {
                  active: {
                    value: n === t
                  }
                }),
                onActivate: _this53.props.onActivate,
                withoutChildren: !0,
                key: r.item.id,
                "data-role": "search:result"
              });
            }))), this.state.term && this.state.noResults ? e.createElement(Hu, {
              "data-role": "search:results"
            }, T("noResultsFound")) : null);
          }
        }]);

        return Gu;
      }(e.PureComponent);

      Gu.contextType = ce, function (e, t, r, n) {
        for (var o, i = Zu(t, r), s = e.length - 1; s >= 0; s--) {
          (o = e[s]) && (i = o(t, r, i) || i);
        }

        i && Yu(t, r, i);
      }([be.bind, (0, be.debounce)(400)], Gu.prototype, "searchCallback");

      var Xu = /*#__PURE__*/function (_e$Component33) {
        _inherits(Xu, _e$Component33);

        var _super49 = _createSuper(Xu);

        function Xu() {
          _classCallCheck(this, Xu);

          return _super49.apply(this, arguments);
        }

        _createClass(Xu, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.store.onDidMount();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.props.store.dispose();
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props$store = this.props.store,
                t = _this$props$store.spec,
                r = _this$props$store.menu,
                n = _this$props$store.options,
                o = _this$props$store.search,
                i = _this$props$store.marker,
                s = this.props.store;
            return e.createElement(X, {
              theme: n.theme
            }, e.createElement(yi, {
              value: s
            }, e.createElement(pe, {
              value: n
            }, e.createElement(qu, {
              className: "redoc-wrap"
            }, e.createElement(Fu, {
              menu: r,
              className: "menu-content"
            }, e.createElement(hc, {
              info: t.info
            }), !n.disableSearch && e.createElement(Gu, {
              search: o,
              marker: i,
              getItemById: r.getItemById,
              onActivate: r.activateAndScroll
            }) || null, e.createElement(Iu, {
              menu: r
            })), e.createElement(Bu, {
              className: "api-content"
            }, e.createElement(cc, {
              store: s
            }), e.createElement(uu, {
              items: r.items
            })), e.createElement(Qu, null)))));
          }
        }]);

        return Xu;
      }(e.Component);

      Xu.propTypes = {
        store: le.instanceOf(rc).isRequired
      };

      var Ku = function Ku(t) {
        var n = t.spec,
            o = t.specUrl,
            _t$options = t.options,
            i = _t$options === void 0 ? {} : _t$options,
            s = t.onLoaded,
            a = Q(i.hideLoading, !1),
            l = new W(i);
        if (void 0 !== l.nonce) try {
          r.nc = l.nonce;
        } catch (e) {}
        return e.createElement(ne, null, e.createElement(xi, {
          spec: n,
          specUrl: o,
          options: i,
          onLoaded: s
        }, function (_ref174) {
          var t = _ref174.loading,
              r = _ref174.store;
          return t ? a ? null : e.createElement(ae, {
            color: l.theme.colors.primary.main
          }) : e.createElement(Xu, {
            store: r
          });
        }));
      };
    }(), n;
  }();
});